const HIGH_SCHOOL_RANKS = [
    {
        "guid": "78cbf457-1820-4472-acb6-51d665791449",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 1,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.399542,
                "lon": -122.132553
            },
            "entity": {
                "abbreviation": "Henry M. Gunn High School",
                "alternates": {
                    "ceeb": "052347",
                    "nces": "062961004587"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "78cbf457-1820-4472-acb6-51d665791449",
                "isClaimed": true,
                "isPremium": false,
                "location": "Palo Alto, CA",
                "name": "Henry M. Gunn High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "a2aa95a4-b9dc-4f5b-8b95-a5d3c3bf6a74",
                    "parent": "5ebd9221-9432-4680-b498-f32d7ec76533",
                    "schoolDistrict": "5ebd9221-9432-4680-b498-f32d7ec76533",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "1b26fe96-6bbf-45ea-b1bf-9c682db0b352",
                    "zipCode": "c46624af-208c-421d-8b97-5338480b17d3"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "PAUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5ebd9221-9432-4680-b498-f32d7ec76533",
                        "location": "Palo Alto, CA",
                        "name": "Palo Alto Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "1b26fe96-6bbf-45ea-b1bf-9c682db0b352",
                            "zipCode": "c46624af-208c-421d-8b97-5338480b17d3"
                        },
                        "premium": false,
                        "shortName": "Palo Alto Unified School District",
                        "tagline": [
                            "School District",
                            "Palo Alto, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "palo-alto-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Henry M. Gunn High School",
                "tagline": [
                    "Palo Alto Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "henry-m-gunn-high-school-palo-alto-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2006
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "I miss registering for and attending classes at Gunn. Registration was so stress-free (especially with the Jacoubowsky's assistance). Classes were engaging--almost every teacher was enthusiastic, knowledgeable, and willing to learn if they were new to a subject. Just remembering them brings a smile to my face. They were so quirky!\n\nThere were some horrible teachers. If they were better, this school would be excellent. One was outwardly dismissive of certain political views. One never returned assignments and was rumored to pick course grades out of hat--she got fired. One admitted she was crushing our dreams by giving low grades. One would not post course material online. One gave only one lecture.\n\nMany of my peers made up a group of the most inclusive, intelligent, and accomplished individuals I know. The administration should listen to students more. These students are experts about their own mental health and their personal lives and concerns.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-01-04T04:23:34.925324Z",
                "guid": "d9d49114-129b-49f6-aa1d-0df1d55e0e22",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.135,37.4031,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.135,37.4031,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.825082508250825,
                "count": 303
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94306"
            }
        ]
    },
    {
        "guid": "ffc74741-462d-49b9-861b-646b29310155",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 2,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.267314,
                "lon": -122.031189
            },
            "entity": {
                "abbreviation": "SHS",
                "alternates": {
                    "ceeb": "053343",
                    "nces": "062280003487"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "ffc74741-462d-49b9-861b-646b29310155",
                "isClaimed": true,
                "isPremium": false,
                "location": "Saratoga, CA",
                "name": "Saratoga High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "fd137f35-b012-41c7-a9cb-31e3ba0dd821",
                    "schoolDistrict": "fd137f35-b012-41c7-a9cb-31e3ba0dd821",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "e0be8fef-526c-4910-9500-3b4b953963dd",
                    "zipCode": "d862ebf1-2d26-4072-bc4b-528805062a62"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "LGSUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "fd137f35-b012-41c7-a9cb-31e3ba0dd821",
                        "location": "Los Gatos, CA",
                        "name": "Los Gatos-Saratoga Joint Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "3c3feaf1-4124-4b7a-acde-a86df9bd11e7",
                            "zipCode": "c738c179-3382-4e23-acb0-8960870c64d9"
                        },
                        "premium": false,
                        "shortName": "Los Gatos-Saratoga Joint Union High School District",
                        "tagline": [
                            "School District",
                            "Los Gatos, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "los-gatos-saratoga-joint-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Saratoga High School",
                "tagline": [
                    "Los Gatos-Saratoga Joint Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "saratoga-high-school-saratoga-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1371
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "This school’s actually amazing academically, but when you take a look at the school beyond that, it’s a terrible environment. It’s no single individual’s fault- not the administration or the students. But the pressure put on an individual when they attend this school, it’s crippling. Every student wants to attend the best college it seems like, its highly competitive but also so stressful. It makes everyone feel like they aren’t good enough. Not to mention the diversity issues- there’s terrible diversity which creates a racial divide- I personally felt often uncomfortable. Many students use race as a factor to judge others, because stereotyping is such a real thing at Saratoga High. Maybe because of the small campus, or the pressure academically, or the diversity, it is unknown. Also: the teachers are terribly inconsistent. I have some terrible teachers who make me want them fired over anything in the world and also hate the courses, but then some wonderful teachers.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-06-28T17:33:05.945639Z",
                "guid": "35fcc980-9863-48ad-986f-a8267d0acb25",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.028772,37.265929,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.028772,37.265929,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.9261083743842367,
                "count": 203
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95070"
            }
        ]
    },
    {
        "guid": "f303bd04-9b1e-4e59-9013-8367e150e219",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 3,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.437791,
                "lon": -122.158192
            },
            "entity": {
                "abbreviation": "Palo Alto High School",
                "alternates": {
                    "ceeb": "052350",
                    "nces": "062961004596"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "f303bd04-9b1e-4e59-9013-8367e150e219",
                "isClaimed": true,
                "isPremium": false,
                "location": "Palo Alto, CA",
                "name": "Palo Alto High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5ebd9221-9432-4680-b498-f32d7ec76533",
                    "schoolDistrict": "5ebd9221-9432-4680-b498-f32d7ec76533",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "1b26fe96-6bbf-45ea-b1bf-9c682db0b352",
                    "zipCode": "c46624af-208c-421d-8b97-5338480b17d3"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "PAUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5ebd9221-9432-4680-b498-f32d7ec76533",
                        "location": "Palo Alto, CA",
                        "name": "Palo Alto Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "1b26fe96-6bbf-45ea-b1bf-9c682db0b352",
                            "zipCode": "c46624af-208c-421d-8b97-5338480b17d3"
                        },
                        "premium": false,
                        "shortName": "Palo Alto Unified School District",
                        "tagline": [
                            "School District",
                            "Palo Alto, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "palo-alto-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Palo Alto High School",
                "tagline": [
                    "Palo Alto Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "palo-alto-high-school-palo-alto-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2124
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Paly High is one of the most unique high schools in the nation. It is very academically focused, and pushes students to the next level. It opens doors for collegiate and career opportunities, and adequately prepares students for college. Although it is a great school, there is a toxic environment ever present on campus between students, as there are times when students view each other as competition and not classmates or friends. I personally enjoy sports over academics, so this school has been a unique experience, as I was new to the school my junior year. However notwithstanding, Paly High is a great school and I am proud to call myself a Viking. SKO VIKES!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-27T18:42:44.602738Z",
                "guid": "fa835566-cc1d-4cde-8329-4a3ebb9c7488",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.158,37.4377,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.158,37.4377,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.9388379204892967,
                "count": 327
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94301"
            }
        ]
    },
    {
        "guid": "0d15e77e-5bed-416f-a73f-3f59b282416e",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 4,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.300828,
                "lon": -122.006605
            },
            "entity": {
                "abbreviation": "Lynbrook High School",
                "alternates": {
                    "ceeb": "053463",
                    "nces": "061443001698"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "0d15e77e-5bed-416f-a73f-3f59b282416e",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Lynbrook High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "2af26fb6-2239-44b4-be58-b0e8e46b2a61",
                    "parent": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                    "schoolDistrict": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "ca7b746e-cd3c-474a-a264-ac5c6e4ff339"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                        "location": "Sunnyvale, CA",
                        "name": "Fremont Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "cd0684fb-f68d-419b-8bf5-6500062b6af5",
                            "zipCode": "12ede258-9fa8-4ba5-9e1e-4d80c11aa22e"
                        },
                        "premium": false,
                        "shortName": "Fremont Union High School District",
                        "tagline": [
                            "School District",
                            "Sunnyvale, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Lynbrook High School",
                "tagline": [
                    "Fremont Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "lynbrook-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1880
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Lynbrook High School is an excellent high school with outstanding academics and superb resources for college readiness. Students here are committed to studying, and they engage in extracurriculars and anything related to college admissions with great energy. The most popular clubs are mostly pre-professional or service-oriented. Students here have peer-pressure to succeed. The teachers are all very supportive of students, and they ensure that the classroom environment allows for success by any student if they put the work in. While students in the school's area may be known for stress, it is mostly an exaggeration. If students manage their time well, even the most rigorous curriculum is manageable. There is almost no diversity among the students, and there is a dominant school culture of pursuing elite colleges acceptances, pre-professionalism, practical majors, and STEM. Lynbrook High School is a place that guarantees success if the student is willing to work hard throughout 4 years.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-12-27T16:56:33.668521Z",
                "guid": "2c75b3ff-1849-4f85-87a4-dd2001977404",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.004,37.3002,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.004,37.3002,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7682403433476397,
                "count": 466
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95129"
            }
        ]
    },
    {
        "guid": "0a8f8992-de0b-4f68-a5a3-f20ce0ab5896",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 5,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.384989,
                "lon": -122.10942
            },
            "entity": {
                "abbreviation": "Los Altos High School",
                "alternates": {
                    "ceeb": "051510",
                    "nces": "062631003929"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "0a8f8992-de0b-4f68-a5a3-f20ce0ab5896",
                "isClaimed": true,
                "isPremium": false,
                "location": "Los Altos, CA",
                "name": "Los Altos High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "61f38639-718b-403d-8aa9-dfcc7e1ed5f6",
                    "schoolDistrict": "61f38639-718b-403d-8aa9-dfcc7e1ed5f6",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "146c32c3-5786-4267-a136-7014ebeea05d",
                    "zipCode": "518d850a-d6a6-4bdc-9dfb-0f338f1c7264"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Mountain View-Los Altos Union High School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "61f38639-718b-403d-8aa9-dfcc7e1ed5f6",
                        "location": "Mountain View, CA",
                        "name": "Mountain View-Los Altos Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "829d17a3-f1df-4505-8ff2-57bda4794f1c",
                            "zipCode": "e8a55ab4-9bff-4942-821c-369c0c98966c"
                        },
                        "premium": false,
                        "shortName": "Mountain View-Los Altos Union High School District",
                        "tagline": [
                            "School District",
                            "Mountain View, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mountain-view-los-altos-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Los Altos High School",
                "tagline": [
                    "Mountain View-Los Altos Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "los-altos-high-school-los-altos-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2227
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "I've moved to this school very recently, I used to attend Great Oak High school and moved recently. This school by far has been amazing. Everything from the Teachers to the schools facility are great. All of my teachers are amazing and very helpful and very engaged with their students. The students at this school are very kind and were willing to go out of way to help me around and even give me a tour of the school. The school also offers programs like counseling, collage help and free tutoring too. As far as academics and sports the school is very competitive. Facilities here are very well maintained and kept in excellent condition. The student body is also very diverse. Overall I really like my school and I know for a fact that anyone else that might transfer here would too. GO LAHS!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-03T01:03:16.318319Z",
                "guid": "116b27f0-a2b4-48ea-b65e-2f75cb6661c3",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.109,37.385,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.109,37.385,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.9012738853503186,
                "count": 314
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94022"
            }
        ]
    },
    {
        "guid": "93a7d142-e188-4cbf-900c-37880ffa7078",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 6,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.35676,
                "lon": -122.06866
            },
            "entity": {
                "abbreviation": "Mountain View High School",
                "alternates": {
                    "ceeb": "052075",
                    "nces": "062631003930"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "93a7d142-e188-4cbf-900c-37880ffa7078",
                "isClaimed": true,
                "isPremium": false,
                "location": "Mountain View, CA",
                "name": "Mountain View High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "61f38639-718b-403d-8aa9-dfcc7e1ed5f6",
                    "schoolDistrict": "61f38639-718b-403d-8aa9-dfcc7e1ed5f6",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Mountain View-Los Altos Union High School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "61f38639-718b-403d-8aa9-dfcc7e1ed5f6",
                        "location": "Mountain View, CA",
                        "name": "Mountain View-Los Altos Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "829d17a3-f1df-4505-8ff2-57bda4794f1c",
                            "zipCode": "e8a55ab4-9bff-4942-821c-369c0c98966c"
                        },
                        "premium": false,
                        "shortName": "Mountain View-Los Altos Union High School District",
                        "tagline": [
                            "School District",
                            "Mountain View, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mountain-view-los-altos-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Mountain View High School",
                "tagline": [
                    "Mountain View-Los Altos Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "mountain-view-high-school-mountain-view-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2062
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "At MVHS, I have been an active member of multiple clubs, sports, and a wide range of classes. I have had my ups and downs in experiences with a few teachers and students but with the support from other faculty and my parents, I have had a great experience! MVHS is a fantastic school and I am proud to be a Spartant!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-11-19T00:55:13.314245Z",
                "guid": "b61c6420-f871-4d49-ac3d-c2726bc9b776",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.067,37.3591,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.067,37.3591,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8916967509025273,
                "count": 277
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94040"
            }
        ]
    },
    {
        "guid": "3b747afa-2299-4070-9ca7-331f4ba7ce34",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 7,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.670507,
                "lon": -121.872898
            },
            "entity": {
                "abbreviation": "Amador Valley High School",
                "alternates": {
                    "ceeb": "052495",
                    "nces": "060002009282"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "3b747afa-2299-4070-9ca7-331f4ba7ce34",
                "isClaimed": true,
                "isPremium": false,
                "location": "Pleasanton, CA",
                "name": "Amador Valley High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "1bae5f83-6724-4fb2-b9cd-88002e8e2add",
                    "parent": "c831a26c-bfd8-400a-9df2-b2bcdbc75eb3",
                    "schoolDistrict": "c831a26c-bfd8-400a-9df2-b2bcdbc75eb3",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "6a69cf51-74d9-4871-a020-7a26cc1e03a8",
                    "zipCode": "e7654ec4-7c93-4d2e-a586-048286d02972"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "PUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "c831a26c-bfd8-400a-9df2-b2bcdbc75eb3",
                        "location": "Pleasanton, CA",
                        "name": "Pleasanton Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "29f69694-5146-4bfb-b2b3-aa52956e3114",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "6a69cf51-74d9-4871-a020-7a26cc1e03a8",
                            "zipCode": "e7654ec4-7c93-4d2e-a586-048286d02972"
                        },
                        "premium": false,
                        "shortName": "Pleasanton Unified School District",
                        "tagline": [
                            "School District",
                            "Pleasanton, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "pleasanton-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Amador Valley High School",
                "tagline": [
                    "Pleasanton Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "amador-valley-high-school-pleasanton-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2713
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "The school spirit is fantastic. Students are excited to learn and follow the rules accordingly. Most teachers make learning fun. Even if we are online, they continue to spread their positive attitude to help students learn. Although few teachers do not teach quite well, most students are A and B students. Moreover, for students who have a disability, have a caring staff available waiting for them. They are calm and patient and they care for us students. This school is academically/athletically doing very well!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-20T00:52:19.649871Z",
                "guid": "8f8ee60b-2976-49d8-a7f7-5ce7378233d1",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.875,37.6684,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.875,37.6684,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.068627450980392,
                "count": 510
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94566"
            }
        ]
    },
    {
        "guid": "f2fa0845-2614-42b6-866b-71b72a1e7521",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 8,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.937987,
                "lon": -122.534751
            },
            "entity": {
                "abbreviation": "Redwood High School",
                "alternates": {
                    "ceeb": "051361",
                    "nces": "063879006523"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "f2fa0845-2614-42b6-866b-71b72a1e7521",
                "isClaimed": false,
                "isPremium": false,
                "location": "Larkspur, CA",
                "name": "Redwood High School",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "7fb983ef-9045-46a8-beff-5675b1357340",
                    "schoolDistrict": "7fb983ef-9045-46a8-beff-5675b1357340",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "db131da3-37dc-42cf-aad2-15024d364e4d",
                    "zipCode": "f981dbb9-3c01-40c1-97a3-f476d8291c9a"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "TUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "7fb983ef-9045-46a8-beff-5675b1357340",
                        "location": "Larkspur, CA",
                        "name": "Tamalpais Union High School District",
                        "parentGUIDs": {
                            "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "db131da3-37dc-42cf-aad2-15024d364e4d",
                            "zipCode": "f981dbb9-3c01-40c1-97a3-f476d8291c9a"
                        },
                        "premium": false,
                        "shortName": "Tamalpais Union High School District",
                        "tagline": [
                            "School District",
                            "Larkspur, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "tamalpais-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Redwood High School",
                "tagline": [
                    "Tamalpais Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "redwood-high-school-larkspur-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1928
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "If you go to this school, I promise you, you find your place here.  Most teachers care about your success so long as you are willing to put in some work. Of course, you will find teachers that most people dislike. On the other hand, the quality of education you will receive is 100% top notch. Although it's academics and teachers are amazing, it lacks a bit of diversity, considering the area, makes sense.  The campus is well maintained and quite clean. The most dangerous thing I have witnessed is a fight. Out of my four years being there, there were only three. Our security guards resolve those as soon as it came to their attention. In the past, some of the office ladies in were extremely disrespectful to you but it seems this year, those ladies were replaced with much better people. For juniors and seniors, there is a college and career center to find job postings and ask questions about your plans and college questions. Becky in the college and career center is amazingly helpful!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-25T07:01:33.468306Z",
                "guid": "02d0e747-660f-40cb-9e39-8bb073c777d4",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.523,37.9381,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.523,37.9381,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.9910714285714284,
                "count": 224
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94939"
            }
        ]
    },
    {
        "guid": "e6502559-92bb-48ed-8e83-18449a377e07",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 9,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.676843,
                "lon": -121.921655
            },
            "entity": {
                "abbreviation": "Foothill High School",
                "alternates": {
                    "ceeb": "052497",
                    "nces": "060002009279"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "e6502559-92bb-48ed-8e83-18449a377e07",
                "isClaimed": true,
                "isPremium": false,
                "location": "Pleasanton, CA",
                "name": "Foothill High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "c831a26c-bfd8-400a-9df2-b2bcdbc75eb3",
                    "schoolDistrict": "c831a26c-bfd8-400a-9df2-b2bcdbc75eb3",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "6a69cf51-74d9-4871-a020-7a26cc1e03a8",
                    "zipCode": "4000a419-f29e-4c0c-b086-d53791b6f956"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "PUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "c831a26c-bfd8-400a-9df2-b2bcdbc75eb3",
                        "location": "Pleasanton, CA",
                        "name": "Pleasanton Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "29f69694-5146-4bfb-b2b3-aa52956e3114",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "6a69cf51-74d9-4871-a020-7a26cc1e03a8",
                            "zipCode": "e7654ec4-7c93-4d2e-a586-048286d02972"
                        },
                        "premium": false,
                        "shortName": "Pleasanton Unified School District",
                        "tagline": [
                            "School District",
                            "Pleasanton, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "pleasanton-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Foothill High School",
                "tagline": [
                    "Pleasanton Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "foothill-high-school-pleasanton-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2178
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "I enjoy the the community-feel of my school; the teachers are very invested in providing the best education they can give to the students, which is so refreshing to see, especially during distanced learning. However, the school is very competative, so many students want take honors and AP courses, but there isn't enough space in classes to give everyone thos kinds of oppurtunities!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-25T05:57:52.382766Z",
                "guid": "9ece47de-ba94-41fd-aa51-3d845d6c00d0",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.92,37.673,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.92,37.673,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8266331658291457,
                "count": 398
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94588"
            }
        ]
    },
    {
        "guid": "3fad2dab-8169-47e8-8dfd-d39a0f46b5c5",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 10,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.73108,
                "lon": -122.483544
            },
            "entity": {
                "abbreviation": "Lowell High School",
                "alternates": {
                    "ceeb": "052970",
                    "nces": "063441005643"
                },
                "character": "Public, Magnet",
                "claimed": false,
                "displayable": true,
                "genus": "Magnet School",
                "guid": "3fad2dab-8169-47e8-8dfd-d39a0f46b5c5",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Lowell High School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "5efebd04-a1e2-40d5-8e4a-7d27d149ec16",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "0d98457f-33f6-4c34-ba1e-34f6f778475c"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Lowell High School",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "lowell-high-school-san-francisco-ca",
                "variation": 52
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2774
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Although my time at Lowell high school has not been long, it has been satisfactory. The people here are all great but that may be due to the fact that most of the student’s academic levels are similar. There is a bit of a competition when it comes to studies because this school is known for it’s “smarts”. The amount of assignments I’ve received has not been overloading because my I had all the right teachers. As long as you know how to balance yourself, you’ll do fine here.\nThere are many unique clubs to join and sports you can try out for! All Lowellites are welcoming to new members! There’s volunteering clubs such as Red Cross, or cultural clubs like Phil-Am and many more! We also have multiple sports such as football, soccer, volleyball, lacrosse, badminton, basketball, etc! Being a part of a club or team is what’ll make your time worthwhile in my opinion.\nOverall Lowell is a great school to attend! You’ll meet all the right people and gain a meaningful experience.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-07-04T08:09:49.446723Z",
                "guid": "16e1c09b-e99e-4d45-9249-67eb0dfc7d14",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.483,37.7304,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.483,37.7304,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.797073170731707,
                "count": 1025
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94132"
            }
        ]
    },
    {
        "guid": "d8c46c8e-9ebc-4c4a-b5bc-dd63c5a3875e",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 11,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.55187,
                "lon": -122.329079
            },
            "entity": {
                "abbreviation": "Aragon High School",
                "alternates": {
                    "ceeb": "053163",
                    "nces": "063498005919"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "d8c46c8e-9ebc-4c4a-b5bc-dd63c5a3875e",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Mateo, CA",
                "name": "Aragon High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "schoolDistrict": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "2e248a4c-74bf-4d82-8538-a83219eb322b",
                    "zipCode": "062f4806-af97-4d46-8d31-2a26304d0e2f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SMUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                        "location": "San Mateo, CA",
                        "name": "San Mateo Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "2e248a4c-74bf-4d82-8538-a83219eb322b",
                            "zipCode": "3435a379-835e-44ad-a67d-683bc7ef6fc8"
                        },
                        "premium": false,
                        "shortName": "San Mateo Union High School District",
                        "tagline": [
                            "School District",
                            "San Mateo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-mateo-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Aragon High School",
                "tagline": [
                    "San Mateo Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "aragon-high-school-san-mateo-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1675
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I loved the diversity of Aragon High School. It really helped me to respect other cultures more as well as explore my own, because I'd never gotten the opportunity to go to school with other Polynesians. I felt the deepest sense of community I have ever felt, especially in the theater and basketball programs which are both headed by amazing leaders who were like my second fathers. However, my AP English Lang teacher once said, \"The air we breathe at Aragon is competition\" and that could not be more true. Students here strive to be the best of the best, many taking oceans of AP classes, diving into intense extracurriculars, and perfecting their college applications. The pressure can get deafening, but Aragon's support services like the counselors are beyond amazing people who can help you better yourself. Admin are a bit polarized because they can be wonderful or unleash their wrath upon you, just depends who you are.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-22T18:38:47.075996Z",
                "guid": "60d14e7a-5a5b-453f-8dba-0dde0461cc8a",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.33,37.5498,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.33,37.5498,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.9429657794676807,
                "count": 263
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94402"
            }
        ]
    },
    {
        "guid": "0aa8796b-cecd-47df-a4f2-9be67b2e265b",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 12,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.867887,
                "lon": -122.125258
            },
            "entity": {
                "abbreviation": "Campolindo High School",
                "alternates": {
                    "ceeb": "052058",
                    "nces": "060165000033"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "0aa8796b-cecd-47df-a4f2-9be67b2e265b",
                "isClaimed": false,
                "isPremium": false,
                "location": "Moraga, CA",
                "name": "Campolindo High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                    "schoolDistrict": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "5352c423-bafe-4a84-a5f2-d30a97406aed",
                    "zipCode": "162d00a8-92bc-4205-9037-3a00dcac6d50"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "AUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                        "location": "Lafayette, CA",
                        "name": "Acalanes Union High School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "e4e259e3-74e6-485c-8a9b-9d48c8298442",
                            "zipCode": "3bbdf3eb-e3f7-45ec-a476-cd13a4bb1d7f"
                        },
                        "premium": false,
                        "shortName": "Acalanes Union High School District",
                        "tagline": [
                            "School District",
                            "Lafayette, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "acalanes-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Campolindo High School",
                "tagline": [
                    "Acalanes Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "campolindo-high-school-moraga-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1406
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I made my best friends at Campo! Like any school, it truly depends on what teachers you get and how much you like the subjects. Our English teachers are very good, and I personally have had good experiences with language, social science, and science. Our math department is also good, but sometimes you may need to seek out extra help. The environment is very high achieving and many students have good grades and take many APs along with playing a sport. Our sports teams are quite good. Speaking from experience, our swim team is ranked very highly and has won NCS multiple times. Campo also has an incredible aquatic facility. Furthermore, Campolindo is one of the few schools to offer German, so you can take advantage of a unique language learning opportunity. If you ever have any problems, it is easy to get in contact with your teachers, and they are generally very supportive.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-10T21:59:31.028932Z",
                "guid": "08399565-2d74-43b8-9d51-76b8f3a583e5",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.128,37.8668,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.128,37.8668,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.9926470588235294,
                "count": 272
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94556"
            }
        ]
    },
    {
        "guid": "b508f015-7ced-4884-a695-1c959260568f",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 13,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.594656,
                "lon": -122.38798
            },
            "entity": {
                "abbreviation": "Mills High School",
                "alternates": {
                    "ceeb": "051972",
                    "nces": "063498005924"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "b508f015-7ced-4884-a695-1c959260568f",
                "isClaimed": false,
                "isPremium": false,
                "location": "Millbrae, CA",
                "name": "Mills High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "schoolDistrict": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "a22149ca-7510-485b-b4ab-2f8db3bd4a65",
                    "zipCode": "4fba468a-9eb7-49d5-b87f-036348d35412"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SMUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                        "location": "San Mateo, CA",
                        "name": "San Mateo Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "2e248a4c-74bf-4d82-8538-a83219eb322b",
                            "zipCode": "3435a379-835e-44ad-a67d-683bc7ef6fc8"
                        },
                        "premium": false,
                        "shortName": "San Mateo Union High School District",
                        "tagline": [
                            "School District",
                            "San Mateo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-mateo-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Mills High School",
                "tagline": [
                    "San Mateo Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "mills-high-school-millbrae-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1182
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "It is magnificent! Not including all, but at least the ones I know are highly productive and keen. Students here also have passion in contributing to the community; they have participated in various types of volunteer works. The most common one is the Mills American Red Cross Club. This club is a chapter of American Red Cross in school.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-12-30T19:51:42.588163Z",
                "guid": "09255f85-c3b8-48b0-99e4-c16d6057129e",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.391,37.5943,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.391,37.5943,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.788679245283019,
                "count": 265
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94030"
            }
        ]
    },
    {
        "guid": "f9afb00f-75c5-4879-9841-75dc8da21516",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 14,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.337464,
                "lon": -122.049281
            },
            "entity": {
                "abbreviation": "Homestead High School",
                "alternates": {
                    "ceeb": "053462",
                    "nces": "061443001697"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "f9afb00f-75c5-4879-9841-75dc8da21516",
                "isClaimed": false,
                "isPremium": false,
                "location": "Cupertino, CA",
                "name": "Homestead High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                    "schoolDistrict": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "a367781a-1e4e-4262-aa1f-0d6e438d54b8",
                    "zipCode": "57188a78-9608-47e7-ad49-c14bdbdb567f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                        "location": "Sunnyvale, CA",
                        "name": "Fremont Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "cd0684fb-f68d-419b-8bf5-6500062b6af5",
                            "zipCode": "12ede258-9fa8-4ba5-9e1e-4d80c11aa22e"
                        },
                        "premium": false,
                        "shortName": "Fremont Union High School District",
                        "tagline": [
                            "School District",
                            "Sunnyvale, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Homestead High School",
                "tagline": [
                    "Fremont Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "homestead-high-school-cupertino-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2425
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Parent",
                "body": "Homestead High School is excellent in terms of academics and extracurricular activities. Students fair well in all the fields and stand first when it comes to a dedication in general. Staff efforts are much appreciated in general and children excel well and in general, it is an excellent school and facilities provided are extraordinary. Homestead is a school that always follows unity in diversity and children study from all walks of life. Clubs and other activities conducted at school premises and also sports play an important role at school and lots of competitions are conducted and students are benefitted through this type of friendly competition. Students here get into prestigious universities and are placed in a recognized company and get a good carrier opportunity throughout the US and other countries. Our kid had a good experience and is a happy Graduate, Graduating from HOMESTEAD soon. Thank You!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-22T01:57:25.486007Z",
                "guid": "5106430f-d3bd-497e-a51a-dc2d8cef475d",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.048,37.3359,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.048,37.3359,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7310195227765726,
                "count": 461
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95014"
            }
        ]
    },
    {
        "guid": "5c583c16-d8e7-477c-8828-0d4393025a65",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 15,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.21694,
                "lon": -121.96634
            },
            "entity": {
                "abbreviation": "Los Gatos High School",
                "alternates": {
                    "ceeb": "051855",
                    "nces": "062280003486"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "5c583c16-d8e7-477c-8828-0d4393025a65",
                "isClaimed": false,
                "isPremium": false,
                "location": "Los Gatos, CA",
                "name": "Los Gatos High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "fd137f35-b012-41c7-a9cb-31e3ba0dd821",
                    "schoolDistrict": "fd137f35-b012-41c7-a9cb-31e3ba0dd821",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "3c3feaf1-4124-4b7a-acde-a86df9bd11e7",
                    "zipCode": "c738c179-3382-4e23-acb0-8960870c64d9"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "LGSUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "fd137f35-b012-41c7-a9cb-31e3ba0dd821",
                        "location": "Los Gatos, CA",
                        "name": "Los Gatos-Saratoga Joint Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "3c3feaf1-4124-4b7a-acde-a86df9bd11e7",
                            "zipCode": "c738c179-3382-4e23-acb0-8960870c64d9"
                        },
                        "premium": false,
                        "shortName": "Los Gatos-Saratoga Joint Union High School District",
                        "tagline": [
                            "School District",
                            "Los Gatos, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "los-gatos-saratoga-joint-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Los Gatos High School",
                "tagline": [
                    "Los Gatos-Saratoga Joint Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "los-gatos-high-school-los-gatos-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2138
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Los Gatos High School is a school with abundant resources and funding for students to pursue extracurriculars, particularly sports. There are a variety of activities from varsity sports to music programs to clubs. However, while there are multiple activities to pursue, each one is isolated from the other. Athletes stick with one another, band kids stick with each other, and so on. For this reason, I can't give a 5/5 review. There are fewer school activities that promote student mingling across niche interests other than the initial freshman orientation. For the most part, groups are up to the students. Clubs are created by friend groups, and the members are typically acquainted with one another already. There are plenty of options on the surface, but every student essentially sticks with the program they are comfortable with and have no outward incentive to expand their scope of interest. If they do pursue a greater variety of activities, it has little to do with the school.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-10-06T18:24:00.333807Z",
                "guid": "a5af1b4b-8aa4-4850-8361-30c48050a878",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.976,37.2233,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.976,37.2233,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.060483870967742,
                "count": 248
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95030"
            }
        ]
    },
    {
        "guid": "1c0ed7a5-20c3-47e3-9a0d-26c8f1282342",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 16,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.7693741,
                "lon": -121.9016176
            },
            "entity": {
                "abbreviation": "Dougherty Valley High School",
                "alternates": {
                    "ceeb": "053218",
                    "nces": "063513011990"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "1c0ed7a5-20c3-47e3-9a0d-26c8f1282342",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Ramon, CA",
                "name": "Dougherty Valley High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                    "schoolDistrict": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "a7847108-2b53-4853-a24b-81c86d5c49b0",
                    "zipCode": "5efca495-caa8-45de-bcaf-bb99171be0a7"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SRVUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                        "location": "Danville, CA",
                        "name": "San Ramon Valley Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "fcc57eee-ebde-443a-b77d-e10bbde2f779",
                            "zipCode": "bd3e7c23-836c-470d-ab71-7f4963ad582c"
                        },
                        "premium": false,
                        "shortName": "San Ramon Valley Unified School District",
                        "tagline": [
                            "School District",
                            "Danville, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-ramon-valley-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Dougherty Valley High School",
                "tagline": [
                    "San Ramon Valley Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "dougherty-valley-high-school-san-ramon-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 3331
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Dougherty Valley High School offers a great education to its students, as well as many opportunities. DVHS has a variety of clubs and sports programs, it is very easy to find your niche and whatever suits your interests. I had a very memorable experience at Dougherty Valley and enjoyed my time as a student there. There are good amenities and resources that can help you be successful and the classrooms are well equipped. There are also many on-campus events, from college fairs to dance shows, and sometimes they even bring shelter dogs to aid with student stress during finals week!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-17T06:06:36.162725Z",
                "guid": "b1301314-ce12-4e65-a308-c904b8b2f4e1",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.9016176,37.7693741,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.9016176,37.7693741,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.763425253991292,
                "count": 689
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94582"
            }
        ]
    },
    {
        "guid": "c7a8eda2-2218-40f1-846f-bc6ccfe1e28c",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 17,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.5832,
                "lon": -122.347
            },
            "entity": {
                "abbreviation": "Burlingame High School",
                "alternates": {
                    "ceeb": "050410",
                    "nces": "063498005920"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "c7a8eda2-2218-40f1-846f-bc6ccfe1e28c",
                "isClaimed": false,
                "isPremium": false,
                "location": "Burlingame, CA",
                "name": "Burlingame High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "schoolDistrict": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "1a87cc05-15c2-4905-a5e0-7218bf42bae4",
                    "zipCode": "1772eca3-601d-475d-ba5b-465907251d74"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SMUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                        "location": "San Mateo, CA",
                        "name": "San Mateo Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "2e248a4c-74bf-4d82-8538-a83219eb322b",
                            "zipCode": "3435a379-835e-44ad-a67d-683bc7ef6fc8"
                        },
                        "premium": false,
                        "shortName": "San Mateo Union High School District",
                        "tagline": [
                            "School District",
                            "San Mateo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-mateo-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Burlingame High School",
                "tagline": [
                    "San Mateo Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "burlingame-high-school-burlingame-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1492
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "Burlingame High School has become the place for the kids of many wealthy families to compete, yes compete, to get into high level universities. There is a lot of pressure to score extremely high on standardized testing, take as many AP classes as possible, participate in internships and extracurriculars, and try to have a social life like any teenager should. The school campus is very beautiful and there's always great weather. The school is not very diverse but it is very accommodating to people of any socioeconomic background. The faculty are great and the sports programs are mediocre (mostly due to the general focus on academics over athletics). The arts programs are well funded and see a lot of participation year in and year out. The universities that people are accepted into are usually very high ranking, although the school does have a tendency to hand out A grades.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-15T21:26:07.468458Z",
                "guid": "4e48b47b-f922-40c3-8702-e48a921c61cb",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.347,37.5832,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.347,37.5832,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.841880341880342,
                "count": 234
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94010"
            }
        ]
    },
    {
        "guid": "64cf95ec-e4ed-417f-864f-cc939b1b4998",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 18,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.315454,
                "lon": -122.056975
            },
            "entity": {
                "abbreviation": "Monta Vista High School",
                "alternates": {
                    "ceeb": "053466",
                    "nces": "061443001699"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "64cf95ec-e4ed-417f-864f-cc939b1b4998",
                "isClaimed": false,
                "isPremium": false,
                "location": "Cupertino, CA",
                "name": "Monta Vista High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                    "schoolDistrict": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "a367781a-1e4e-4262-aa1f-0d6e438d54b8",
                    "zipCode": "57188a78-9608-47e7-ad49-c14bdbdb567f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                        "location": "Sunnyvale, CA",
                        "name": "Fremont Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "cd0684fb-f68d-419b-8bf5-6500062b6af5",
                            "zipCode": "12ede258-9fa8-4ba5-9e1e-4d80c11aa22e"
                        },
                        "premium": false,
                        "shortName": "Fremont Union High School District",
                        "tagline": [
                            "School District",
                            "Sunnyvale, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Monta Vista High School",
                "tagline": [
                    "Fremont Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "monta-vista-high-school-cupertino-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2274
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "MVHS no doubt prepares you for your college academics and has an incredibly strong STEM-focused program. Alumni have said AP/honors-level courses at MVHS is at the intro level courses of top schools (HYPSM). With the immense work-load students are trained to manage their time properly and will be ready for college. However, the student body lacks diversity (90% of students are Asians at this public school( and so does the pursuit of diverse interests, particularly in the arts and humanities. Most teachers are eager to teach (cannot say for all though) but are definitely harsh graders. Students are extremely competitive (even school spirit is revolved around competition) and guaranteed most feel imposter syndrome and a ton of academic stress. Overall, I gave a good review because in terms of academic preparation, for a STEM kid like myself, MVHS definitely helped me on the path to my future goals.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-20T16:19:42.51646Z",
                "guid": "7da09dcc-6388-4ec4-8a0f-6435fea7e766",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.056,37.3154,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.056,37.3154,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.4010282776349614,
                "count": 389
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95014"
            }
        ]
    },
    {
        "guid": "aa3a9c53-2861-4ed3-92e1-6bbb97570f4a",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 19,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.321544,
                "lon": -122.010403
            },
            "entity": {
                "abbreviation": "Cupertino High School",
                "alternates": {
                    "ceeb": "050718",
                    "nces": "061443001695"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "aa3a9c53-2861-4ed3-92e1-6bbb97570f4a",
                "isClaimed": false,
                "isPremium": false,
                "location": "Cupertino, CA",
                "name": "Cupertino High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                    "schoolDistrict": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "a367781a-1e4e-4262-aa1f-0d6e438d54b8",
                    "zipCode": "57188a78-9608-47e7-ad49-c14bdbdb567f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                        "location": "Sunnyvale, CA",
                        "name": "Fremont Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "cd0684fb-f68d-419b-8bf5-6500062b6af5",
                            "zipCode": "12ede258-9fa8-4ba5-9e1e-4d80c11aa22e"
                        },
                        "premium": false,
                        "shortName": "Fremont Union High School District",
                        "tagline": [
                            "School District",
                            "Sunnyvale, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Cupertino High School",
                "tagline": [
                    "Fremont Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "cupertino-high-school-cupertino-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2305
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "I really like the diversity and welcoming spirit of Tino. Tino’s courses are definitely challenging and will prepare you for College. At times, it can be overwhelming but the teachers make it a habit to make class engaging and interactive. I also appreciate the support I have received from the teachers in the past years and I don’t think I could have hoped to have gone to a better school than Tino! Go Pioneers!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-22T05:33:24.032704Z",
                "guid": "fd486786-2278-455a-b57a-7b8747e83a24",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.009,37.3194,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.009,37.3194,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7794432548179873,
                "count": 467
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95014"
            }
        ]
    },
    {
        "guid": "fb408ddd-648e-48c1-b6f5-db3e52d4e80c",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 20,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.507665,
                "lon": -122.289566
            },
            "entity": {
                "abbreviation": "Carlmont High School",
                "alternates": {
                    "ceeb": "050270",
                    "nces": "063639006194"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "fb408ddd-648e-48c1-b6f5-db3e52d4e80c",
                "isClaimed": false,
                "isPremium": false,
                "location": "Belmont, CA",
                "name": "Carlmont High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                    "schoolDistrict": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "9d0d3391-77b3-4daf-98b4-a4ec0b501c56",
                    "zipCode": "2da9315f-286f-4929-a588-2ca31ff945e2"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                        "location": "Redwood City, CA",
                        "name": "Sequoia Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a5dafe95-b00a-4d53-8912-9559cbb65dd9",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "5ca486a6-52a6-4b83-aeda-db4b437b4d7f",
                            "zipCode": "7d773137-7242-4cc9-91c9-d3770c1b9f33"
                        },
                        "premium": false,
                        "shortName": "Sequoia Union High School District",
                        "tagline": [
                            "School District",
                            "Redwood City, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "sequoia-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Carlmont High School",
                "tagline": [
                    "Sequoia Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "carlmont-high-school-belmont-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2216
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Carlmont offers many opportunities for every type of student. Academic wise, Carlmont offers many AP and honors classes for those wanting more of a challenge. The school even has unique courses only found at Carlmont! Regarding the teachers, it is apparent all want the students to succeed, however, like any school, not all teachers are the best at teaching the material and keeping the students engaged.  Overall, Carlmont has a good school culture, strong academics, and plenty of support when needed.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-03T03:07:19.11795Z",
                "guid": "9e1c4ab8-e618-413b-b5e6-7dfa7e7abc34",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.288,37.5054,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.288,37.5054,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8892508143322475,
                "count": 307
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94002"
            }
        ]
    },
    {
        "guid": "312a2565-3ac4-4b9e-8ed9-6d850bccf4f6",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 21,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.823132,
                "lon": -122.234725
            },
            "entity": {
                "abbreviation": "Piedmont High School",
                "alternates": {
                    "ceeb": "052462",
                    "nces": "063033004731"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "312a2565-3ac4-4b9e-8ed9-6d850bccf4f6",
                "isClaimed": false,
                "isPremium": false,
                "location": "Piedmont, CA",
                "name": "Piedmont High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "ffc793dc-426b-4df9-8bd2-7250f0309363",
                    "schoolDistrict": "ffc793dc-426b-4df9-8bd2-7250f0309363",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "56749142-fea1-470f-b296-912a61cb1169",
                    "zipCode": "c2e42d78-53d8-4353-a489-378eab873ee1"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "PUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ffc793dc-426b-4df9-8bd2-7250f0309363",
                        "location": "Piedmont, CA",
                        "name": "Piedmont City Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "56749142-fea1-470f-b296-912a61cb1169",
                            "zipCode": "c2e42d78-53d8-4353-a489-378eab873ee1"
                        },
                        "premium": false,
                        "shortName": "Piedmont City Unified School District",
                        "tagline": [
                            "School District",
                            "Piedmont, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "piedmont-city-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Piedmont High School",
                "tagline": [
                    "Piedmont City Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "piedmont-high-school-piedmont-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 855
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I'm so excited for our new STEAM building! It's going to open so many doors for classes in the sciences/maths/technology. Overall, my time at the school was really great.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-12-28T07:19:29.477033Z",
                "guid": "80f6a87e-86b1-40fd-a948-1558aa81d87f",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.233,37.8237,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.233,37.8237,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7471264367816093,
                "count": 87
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94611"
            }
        ]
    },
    {
        "guid": "8520733f-a1ad-4d91-80a7-ee4ac79b6339",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 22,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.890348,
                "lon": -122.525642
            },
            "entity": {
                "abbreviation": "Tamalpais High School",
                "alternates": {
                    "ceeb": "051975",
                    "nces": "063879006526"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "8520733f-a1ad-4d91-80a7-ee4ac79b6339",
                "isClaimed": false,
                "isPremium": false,
                "location": "Mill Valley, CA",
                "name": "Tamalpais High School",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "7fb983ef-9045-46a8-beff-5675b1357340",
                    "schoolDistrict": "7fb983ef-9045-46a8-beff-5675b1357340",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "de53e6f6-0d45-4f4d-b256-501d43b52c81",
                    "zipCode": "637c14ef-772f-434e-a25d-6ef7f24e7cd3"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "TUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "7fb983ef-9045-46a8-beff-5675b1357340",
                        "location": "Larkspur, CA",
                        "name": "Tamalpais Union High School District",
                        "parentGUIDs": {
                            "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "db131da3-37dc-42cf-aad2-15024d364e4d",
                            "zipCode": "f981dbb9-3c01-40c1-97a3-f476d8291c9a"
                        },
                        "premium": false,
                        "shortName": "Tamalpais Union High School District",
                        "tagline": [
                            "School District",
                            "Larkspur, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "tamalpais-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Tamalpais High School",
                "tagline": [
                    "Tamalpais Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "tamalpais-high-school-mill-valley-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1591
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "I could not have asked for a better high school experience. Tam High School was where I met some of my life long friends. My experience was that everyone was fun, friendly and down to earth and less flashy than some of the other schools in Marin Country. Tam also tended to be more diverse than some of the other schools since its a feeder from Stinson, Bolinas, and Marin City. I got a great education and every single one of my friends went to a reputable school!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-07-16T00:33:20.143011Z",
                "guid": "c749e1ea-05ce-420a-a47d-0997bcaf3f0c",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.53,37.8912,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.53,37.8912,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.98974358974359,
                "count": 195
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94941"
            }
        ]
    },
    {
        "guid": "0b04815a-5b95-4b90-ab62-3993537e96fa",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 23,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.842445,
                "lon": -122.144919
            },
            "entity": {
                "abbreviation": "Miramonte High School",
                "alternates": {
                    "ceeb": "052282",
                    "nces": "060165000036"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "0b04815a-5b95-4b90-ab62-3993537e96fa",
                "isClaimed": true,
                "isPremium": false,
                "location": "Orinda, CA",
                "name": "Miramonte High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                    "schoolDistrict": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "4c4dba65-4ae5-4d4e-916e-4bcaac578f8b",
                    "zipCode": "9056b24a-6431-4b5e-aede-11f6b12c170e"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "AUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                        "location": "Lafayette, CA",
                        "name": "Acalanes Union High School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "e4e259e3-74e6-485c-8a9b-9d48c8298442",
                            "zipCode": "3bbdf3eb-e3f7-45ec-a476-cd13a4bb1d7f"
                        },
                        "premium": false,
                        "shortName": "Acalanes Union High School District",
                        "tagline": [
                            "School District",
                            "Lafayette, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "acalanes-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Miramonte High School",
                "tagline": [
                    "Acalanes Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "miramonte-high-school-orinda-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1286
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I have loved attending Miramonte High School! Over the past few years, there have been significant improvements in our school with the adaptation of block scheduling and moving finals to be before winter break. Miramonte has extremely rigorous academics, though the school has been implementing more support resources for students.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-11-25T18:06:30.004255Z",
                "guid": "85399679-173d-4914-a765-21c262995835",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.146,37.841,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.146,37.841,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.962085308056872,
                "count": 211
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94563"
            }
        ]
    },
    {
        "guid": "b2c0e2e6-1933-47c7-afcb-993726669929",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 24,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.72186,
                "lon": -121.926506
            },
            "entity": {
                "abbreviation": "Dublin High School",
                "alternates": {
                    "ceeb": "050784",
                    "nces": "060001909273"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "b2c0e2e6-1933-47c7-afcb-993726669929",
                "isClaimed": true,
                "isPremium": false,
                "location": "Dublin, CA",
                "name": "Dublin High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "1eb7d1e3-3645-4686-b9c1-1f8cde48db34",
                    "schoolDistrict": "1eb7d1e3-3645-4686-b9c1-1f8cde48db34",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "9b40368d-b46b-4aea-bc65-0b503ad7997e",
                    "zipCode": "bdff8a37-efb0-409f-87de-4220f60652e9"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "DUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "1eb7d1e3-3645-4686-b9c1-1f8cde48db34",
                        "location": "Dublin, CA",
                        "name": "Dublin Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "9b40368d-b46b-4aea-bc65-0b503ad7997e",
                            "zipCode": "bdff8a37-efb0-409f-87de-4220f60652e9"
                        },
                        "premium": false,
                        "shortName": "Dublin Unified School District",
                        "tagline": [
                            "School District",
                            "Dublin, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "dublin-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Dublin High School",
                "tagline": [
                    "Dublin Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "dublin-high-school-dublin-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2978
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "Dublin High is a great school to be apart of. There are over 100 student made clubs that are open to anyone and everyone. All the teachers at DHS go out of their way to make sure every student gets the help/attention they need. Recently, DHS opened a wellness center! It was designed by students at my school. You can go there when you are feeling stressed/overwhelmed or even if you're just having a bad day. There, they have counselors that are there between 7AM and 4:00PM EVERYDAY! Dublin high really values the mental and physical state of all their students.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-21T01:55:44.360444Z",
                "guid": "c2c77df2-9899-4318-bde1-6542805375f3",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.927,37.722,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.927,37.722,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7967667436489605,
                "count": 433
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94568"
            }
        ]
    },
    {
        "guid": "9e9c615d-d457-4eb0-b969-01fbd53351e5",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 25,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.545048,
                "lon": -121.931816
            },
            "entity": {
                "abbreviation": "Mission San Jose High School",
                "alternates": {
                    "ceeb": "050970",
                    "nces": "061440001678"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "9e9c615d-d457-4eb0-b969-01fbd53351e5",
                "isClaimed": false,
                "isPremium": false,
                "location": "Fremont, CA",
                "name": "Mission San Jose High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "schoolDistrict": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "36041593-134d-436a-b83b-4c4244f6a447",
                    "zipCode": "f8323aa0-74a4-4cb1-84e3-cfe331752916"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                        "location": "Fremont, CA",
                        "name": "Fremont Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "36041593-134d-436a-b83b-4c4244f6a447",
                            "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                        },
                        "premium": false,
                        "shortName": "Fremont Unified School District",
                        "tagline": [
                            "School District",
                            "Fremont, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Mission San Jose High School",
                "tagline": [
                    "Fremont Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "mission-san-jose-high-school-fremont-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2046
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Freshman",
                "body": "Ever since covid has started, perhaps, the first thing on my mind was starting high school. And, now that I am in high school, I do have to mention that it is quite weird without being there in person, or having people around you while you dash to your lockers in between periods. However, covid has definitely eased my way into 9th grade, with the teachers being so supportive and hard-working. If you are a student, you probably have either felt really bad and guilty as the teacher pleads (for the 100th time) to unmute and speak up or when breakouts are so awkward and can really relate to the uneasiness in the beginning of the school year. But, hats off to the teachers! They are so dedicated and helpful. School during covid is definitely not easy, but my respect has grown remarkably for the teachers who make it happen every day!\nAlso, shoutout to all the leadership students, who keep us entertained and energetic throughout the day with fun concepts, events, and fundraisers!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-31T00:12:22.250941Z",
                "guid": "313b87bf-3ee9-423d-8063-cbab5ded8d1a",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.936,37.5449,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.936,37.5449,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.368556701030928,
                "count": 388
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94539"
            }
        ]
    },
    {
        "guid": "78e91716-2bfd-4bb5-9789-85920c6fbd0b",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 26,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.576327,
                "lon": -122.330212
            },
            "entity": {
                "abbreviation": "San Mateo High School",
                "alternates": {
                    "ceeb": "053175",
                    "nces": "063498005926"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "78e91716-2bfd-4bb5-9789-85920c6fbd0b",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Mateo, CA",
                "name": "San Mateo High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "schoolDistrict": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "2e248a4c-74bf-4d82-8538-a83219eb322b",
                    "zipCode": "3435a379-835e-44ad-a67d-683bc7ef6fc8"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SMUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                        "location": "San Mateo, CA",
                        "name": "San Mateo Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "2e248a4c-74bf-4d82-8538-a83219eb322b",
                            "zipCode": "3435a379-835e-44ad-a67d-683bc7ef6fc8"
                        },
                        "premium": false,
                        "shortName": "San Mateo Union High School District",
                        "tagline": [
                            "School District",
                            "San Mateo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-mateo-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "San Mateo High School",
                "tagline": [
                    "San Mateo Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "san-mateo-high-school-san-mateo-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1713
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "San Mateo High School is a very diverse school that tries to make all students feel welcomed and safe. Teachers and administrators are very caring and always do what is best for their students. Also, I love how spirited San Mateo is! Students participate during spirit week, wear orange and black on Friday's, and are engaged at rallies and other school events. Everyone encourages one another to do their best. There is so much support and resources offered to students. Overall, this is a great school!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-03-28T06:47:49.612398Z",
                "guid": "2637541f-82b0-4359-b7aa-d6ed8e1a3791",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.33,37.5772,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.33,37.5772,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.068825910931174,
                "count": 247
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94401"
            }
        ]
    },
    {
        "guid": "fe2ebaba-6c77-4130-8ffe-4f9bf41cf9c9",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 27,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.292926,
                "lon": -121.874517
            },
            "entity": {
                "abbreviation": "University Preparatory Academy Charter School",
                "alternates": {
                    "ceeb": "054245",
                    "nces": "060223312016"
                },
                "character": "Public, Magnet, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "fe2ebaba-6c77-4130-8ffe-4f9bf41cf9c9",
                "isClaimed": true,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "University Preparatory Academy Charter School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "9bed7cde-76c6-4ed3-9076-f48cade709d3",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "0f5f9ca7-0382-4b2d-8697-36994f2fddf7"
                },
                "premium": false,
                "shortName": "UPA",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "7-12"
                ],
                "type": "School",
                "url": "university-preparatory-academy-charter-school-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 684
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Middle School Student",
                "body": "I am a incoming freshman and I attended 7th and 8th grade at UPA. My experience with the teachers and staff was very good. My teachers always made me feel like my education was important and they always did their best at teaching the material. Every single administrator within this school cares about their students, and I can promise you that. The only issue I have is with the high stress culture surrounding academics. UPA students are high achievers, but many should learn that getting higher grades than your classmates is not the most important thing. I hope that toxic aspect of UPA's environment changes!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-06T05:58:53.635171Z",
                "guid": "ec3ca416-0043-49e7-8a05-84319c4041df",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.874,37.291,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.874,37.291,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.798882681564246,
                "count": 179
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95125"
            }
        ]
    },
    {
        "guid": "c9de91ce-87ca-47e7-908b-cbcab94ff415",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 28,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.220469,
                "lon": -121.847173
            },
            "entity": {
                "abbreviation": "Leland High School",
                "alternates": {
                    "ceeb": "053091",
                    "nces": "063459005725"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "c9de91ce-87ca-47e7-908b-cbcab94ff415",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Leland High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "76f228c2-291e-4ea6-839a-447faaa4a145",
                    "parent": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "schoolDistrict": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "67602db5-a16e-4627-8133-9f3d9f61c732"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SJUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                        "location": "San Jose, CA",
                        "name": "San Jose Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "0a781906-f3cb-42ec-b08b-9acfcaf63aaa",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "763f10c1-8ad0-4832-90b4-5bad39b6e93f"
                        },
                        "premium": false,
                        "shortName": "San Jose Unified School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-jose-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Leland High School",
                "tagline": [
                    "San Jose Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "leland-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1917
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 26
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "The teachers, academic counselors, and admins have no idea what's going on but the students are really eager to learn and get into colleges, which makes Leland a good environment to learn in. However, the academics and resources here are NOT the best. You have to be prepared to self-learn for a lot of AP classes and find out things about college on your own. However, very few teachers are the most caring, smart, and amazing people you'll ever meet!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-06T01:29:08.323174Z",
                "guid": "150b491a-492b-42c0-953f-d454d8016e06",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.845,37.2181,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.845,37.2181,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.449044585987261,
                "count": 314
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95120"
            }
        ]
    },
    {
        "guid": "6f735a5a-a538-4514-a89a-4acca11e5025",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 29,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.845075,
                "lon": -121.9792
            },
            "entity": {
                "abbreviation": "Monte Vista High School",
                "alternates": {
                    "ceeb": "050727",
                    "nces": "063513005952"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "6f735a5a-a538-4514-a89a-4acca11e5025",
                "isClaimed": false,
                "isPremium": false,
                "location": "Danville, CA",
                "name": "Monte Vista High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                    "schoolDistrict": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "fcc57eee-ebde-443a-b77d-e10bbde2f779",
                    "zipCode": "bd3e7c23-836c-470d-ab71-7f4963ad582c"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SRVUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                        "location": "Danville, CA",
                        "name": "San Ramon Valley Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "fcc57eee-ebde-443a-b77d-e10bbde2f779",
                            "zipCode": "bd3e7c23-836c-470d-ab71-7f4963ad582c"
                        },
                        "premium": false,
                        "shortName": "San Ramon Valley Unified School District",
                        "tagline": [
                            "School District",
                            "Danville, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-ramon-valley-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Monte Vista High School",
                "tagline": [
                    "San Ramon Valley Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "monte-vista-high-school-danville-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2448
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "I love that Monte Vista has amazing academics, facilities, activities and clubs, and so much more! Although the environment can be quite competitive at times and it’s hard not to compare oneself to other successful students, I definitely love this school and being involved with it’s activities.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-05T21:08:38.926072Z",
                "guid": "415868c4-7cc1-432c-adf7-3784db1cfc18",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.981,37.8428,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.981,37.8428,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.86231884057971,
                "count": 276
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94526"
            }
        ]
    },
    {
        "guid": "71508b08-6818-4c83-b4b7-f91e6b6a39d3",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 30,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.902169,
                "lon": -122.098
            },
            "entity": {
                "abbreviation": "Acalanes High School",
                "alternates": {
                    "ceeb": "051315",
                    "nces": "060165000032"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "71508b08-6818-4c83-b4b7-f91e6b6a39d3",
                "isClaimed": false,
                "isPremium": false,
                "location": "Lafayette, CA",
                "name": "Acalanes High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                    "schoolDistrict": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "e4e259e3-74e6-485c-8a9b-9d48c8298442",
                    "zipCode": "3bbdf3eb-e3f7-45ec-a476-cd13a4bb1d7f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "AUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                        "location": "Lafayette, CA",
                        "name": "Acalanes Union High School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "e4e259e3-74e6-485c-8a9b-9d48c8298442",
                            "zipCode": "3bbdf3eb-e3f7-45ec-a476-cd13a4bb1d7f"
                        },
                        "premium": false,
                        "shortName": "Acalanes Union High School District",
                        "tagline": [
                            "School District",
                            "Lafayette, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "acalanes-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Acalanes High School",
                "tagline": [
                    "Acalanes Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "acalanes-high-school-lafayette-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1335
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "These past fours years have been the best experience. The teachers are incredibly kind and helpful. Many of them spend long hours outside of class time to provide support to the students. Acalanes High School also has many programs that help students engage in school. Some programs include, Leadership, Blueprint (school news paper), Yearbook, Drama, Visual Arts, Garden Club, Peer Tutoring, and so many more clubs! While academics are very important, the school also emphasizes community and showing up for one another. The best way to have a great experience is to involve yourself in anything that speaks to you. You’ll have a blast!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-01-02T22:43:13.375396Z",
                "guid": "cd02513f-6cb7-4bb1-8c78-98f81f75bc1c",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.097,37.9046,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.097,37.9046,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8177083333333335,
                "count": 192
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94549"
            }
        ]
    },
    {
        "guid": "0d3551e1-a5a4-4318-a25c-2782c41200de",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 31,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.460767,
                "lon": -122.1751142
            },
            "entity": {
                "abbreviation": "Menlo-Atherton High School",
                "alternates": {
                    "ceeb": "050170",
                    "nces": "063639006195"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "0d3551e1-a5a4-4318-a25c-2782c41200de",
                "isClaimed": false,
                "isPremium": false,
                "location": "Atherton, CA",
                "name": "Menlo-Atherton High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                    "schoolDistrict": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "4443e3e1-84f5-48f0-a699-fe081d5e632a",
                    "zipCode": "76bdf085-4e2e-442f-87dd-d98dbedc0d18"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                        "location": "Redwood City, CA",
                        "name": "Sequoia Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a5dafe95-b00a-4d53-8912-9559cbb65dd9",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "5ca486a6-52a6-4b83-aeda-db4b437b4d7f",
                            "zipCode": "7d773137-7242-4cc9-91c9-d3770c1b9f33"
                        },
                        "premium": false,
                        "shortName": "Sequoia Union High School District",
                        "tagline": [
                            "School District",
                            "Redwood City, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "sequoia-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Menlo-Atherton High School",
                "tagline": [
                    "Sequoia Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "menlo-atherton-high-school-atherton-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2498
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "It was a fun experience! I played Varsity football all 4 years. Friday Night lights were the best! Our football games brought the whole community together. Also, the teachers were very helpful. They always reached out whenever they would think something was wrong. Rallies would be full of laughter and good memories. Lunch was also fun. Just spending time with friends. It was a big school so you could literally meet someone new everyday. Menlo Atherton was very fun!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-23T03:34:11.038326Z",
                "guid": "7aefdc13-d510-4a3e-8af9-137f3872a4fa",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.175,37.4614,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.175,37.4614,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.681318681318681,
                "count": 273
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94027"
            }
        ]
    },
    {
        "guid": "a20398d7-0bcb-4431-b3bc-bd345f2f46f6",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 32,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.892268,
                "lon": -122.058037
            },
            "entity": {
                "abbreviation": "Las Lomas High School",
                "alternates": {
                    "ceeb": "053680",
                    "nces": "060165000035"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "a20398d7-0bcb-4431-b3bc-bd345f2f46f6",
                "isClaimed": false,
                "isPremium": false,
                "location": "Walnut Creek, CA",
                "name": "Las Lomas High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                    "schoolDistrict": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "e3c4436c-7dc9-4c55-8ef7-d47f7a932ba9",
                    "zipCode": "f9bfff9c-5a50-47e2-923e-5a7528a271bf"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "AUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                        "location": "Lafayette, CA",
                        "name": "Acalanes Union High School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "e4e259e3-74e6-485c-8a9b-9d48c8298442",
                            "zipCode": "3bbdf3eb-e3f7-45ec-a476-cd13a4bb1d7f"
                        },
                        "premium": false,
                        "shortName": "Acalanes Union High School District",
                        "tagline": [
                            "School District",
                            "Lafayette, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "acalanes-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Las Lomas High School",
                "tagline": [
                    "Acalanes Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "las-lomas-high-school-walnut-creek-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1601
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Overall, Las Lomas High School has left a positive impact on me and the students are very kind and accepting of one another. However, as a student who has taken over 11 honors/AP classes I have noticed the major grade discrepancies and course discrepancies between teachers of the same subject. For instance, If two students take AP Environmental Science, one student is guaranteed no homework and is permitted retakes for every test. However, the student who received a different teacher receives a minimum of two hours of homework per night and only one test retake per semester. This applies to many courses at this school and the administration has done little to change it. Yet, I am thankful for the numerous resources and support that counselors and administration has provided. This past year  I struggled with my health due to being diagnosed with an auto-immune disease. The administration was very empathetic helpful with organizing certain accommodations, while I was in the hospital.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-01-31T19:03:51.640934Z",
                "guid": "8878b9c1-de0d-43ee-8453-1f77ebe57780",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.055,37.8909,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.055,37.8909,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.88212927756654,
                "count": 263
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94596"
            }
        ]
    },
    {
        "guid": "b16e4252-c005-4b44-a44e-4bc1e097d16b",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 33,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.563873,
                "lon": -122.018575
            },
            "entity": {
                "abbreviation": "American High School",
                "alternates": {
                    "ceeb": "050974",
                    "nces": "061440001654"
                },
                "character": "Public, Magnet",
                "claimed": false,
                "displayable": true,
                "genus": "Magnet School",
                "guid": "b16e4252-c005-4b44-a44e-4bc1e097d16b",
                "isClaimed": false,
                "isPremium": false,
                "location": "Fremont, CA",
                "name": "American High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "schoolDistrict": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "36041593-134d-436a-b83b-4c4244f6a447",
                    "zipCode": "4dc14d8f-c3ed-4d52-abca-3f8a107886e5"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                        "location": "Fremont, CA",
                        "name": "Fremont Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "36041593-134d-436a-b83b-4c4244f6a447",
                            "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                        },
                        "premium": false,
                        "shortName": "Fremont Unified School District",
                        "tagline": [
                            "School District",
                            "Fremont, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "American High School",
                "tagline": [
                    "Fremont Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "american-high-school-fremont-ca",
                "variation": 52
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2448
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Freshman",
                "body": "I love that my school has a ton of school spirit. American High has many spirit days where we dress up and sometimes support a cause. The leadership class holds many events to make school a more enjoyable place. For example, one week we had a \"service week\", where all the service clubs, including Unicef, American Red Cross, Giveability, etc. held an event each day to raise money for different foundations. Each day after school people were eligible to earn service hours and at the end of the week there was a fun banquet planned! I also admire the efforts my teachers go to in order to give them extra support. I can tell that my teachers genuinely care about my learning. I also like that we have late start every Monday. This gives us much needed rest and makes the weeks just a little bit easier. The one thing that can be changed at American is the club activity. Smaller clubs need to make more of an effort to be involved.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-04T22:13:25.436189Z",
                "guid": "54fd2c9d-80ad-482a-aa65-7acaf4ac12b7",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.018,37.5637,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.018,37.5637,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.4325,
                "count": 400
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94536"
            }
        ]
    },
    {
        "guid": "68708cfe-9398-4e35-8ef4-217498ba94f5",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 34,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.779833,
                "lon": -122.2809
            },
            "entity": {
                "abbreviation": "Alameda Science and Technology Institute",
                "alternates": {
                    "ceeb": "050029",
                    "nces": "060177010547"
                },
                "character": "Public, Magnet, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Magnet School",
                "guid": "68708cfe-9398-4e35-8ef4-217498ba94f5",
                "isClaimed": true,
                "isPremium": false,
                "location": "Alameda, CA",
                "name": "Alameda Science and Technology Institute",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "3bfe75ba-c072-458a-a742-96bca1544408",
                    "schoolDistrict": "3bfe75ba-c072-458a-a742-96bca1544408",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "54a953dd-3bdc-47b1-b465-0e4d3705637e",
                    "zipCode": "a2b1830b-98f1-4ebd-83e1-b3e0b4fdffcb"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "AUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "3bfe75ba-c072-458a-a742-96bca1544408",
                        "location": "Alameda, CA",
                        "name": "Alameda Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "54a953dd-3bdc-47b1-b465-0e4d3705637e",
                            "zipCode": "a2b1830b-98f1-4ebd-83e1-b3e0b4fdffcb"
                        },
                        "premium": false,
                        "shortName": "Alameda City Unified School District",
                        "tagline": [
                            "School District",
                            "Alameda, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "alameda-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Alameda Science and Tech",
                "tagline": [
                    "Alameda Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "alameda-science-and-technology-institute-alameda-ca",
                "variation": 52
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 192
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 31
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I loved having the freedom to take what I was interested in! I thought that the school has changed a bit since I started going there. When I went, it was hard work, but I learned a lot. I would recommend this school if you are a self starter, who will challenge yourself to learn. My  favorite aspect was that it was a small school so I got to know all of my peers better.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-02T06:49:59.348558Z",
                "guid": "079cd4c6-0a94-442e-a221-9be67aebb915",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.281,37.7799,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.281,37.7799,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.9615384615384617,
                "count": 78
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94501"
            }
        ]
    },
    {
        "guid": "a060a901-5815-4bea-b401-13b5fc311c8c",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 35,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.532287,
                "lon": -122.315156
            },
            "entity": {
                "abbreviation": "Hillsdale High School",
                "alternates": {
                    "ceeb": "053165",
                    "nces": "063498005923"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "a060a901-5815-4bea-b401-13b5fc311c8c",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Mateo, CA",
                "name": "Hillsdale High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "schoolDistrict": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "2e248a4c-74bf-4d82-8538-a83219eb322b",
                    "zipCode": "2ab8d452-5509-4d81-a858-86685b2bc951"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SMUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                        "location": "San Mateo, CA",
                        "name": "San Mateo Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "2e248a4c-74bf-4d82-8538-a83219eb322b",
                            "zipCode": "3435a379-835e-44ad-a67d-683bc7ef6fc8"
                        },
                        "premium": false,
                        "shortName": "San Mateo Union High School District",
                        "tagline": [
                            "School District",
                            "San Mateo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-mateo-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Hillsdale High School",
                "tagline": [
                    "San Mateo Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "hillsdale-high-school-san-mateo-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1569
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "This school is a super spirited, positive, and welcoming community environment. The administration, staff, teachers, and students are supportive and work to build stronger connections & education! This school really cares about it's students and has amazing opportunities! There are many athletics, extracurriculars, and activities students are involved in which help them strive in their academics, team work, and overall self development/growth. With small learning communities, students have lots of attention & assistance on their overall academic experience. Hillsdale is super spirited with lots of rallies, dances, outside community events, and so much more! This place really cares about its students and cares so much that the community becomes such a tight knit community. The campus is also beautiful as it is outdoor with lots of grass and nature. There's lots of parking available and street parking, along the street there's also the Hillsdale mall & the Laurelwood Shopping Center",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-13T07:39:00.119015Z",
                "guid": "c5b7222a-f746-4b1c-bfed-623a6793544f",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.312,37.5323,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.312,37.5323,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.863157894736842,
                "count": 285
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94403"
            }
        ]
    },
    {
        "guid": "6636de16-209f-42ff-b4df-72118b7b7a9d",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 36,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.896667,
                "lon": -122.292587
            },
            "entity": {
                "abbreviation": "Albany High School",
                "alternates": {
                    "ceeb": "050035",
                    "nces": "060186000059"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "6636de16-209f-42ff-b4df-72118b7b7a9d",
                "isClaimed": false,
                "isPremium": false,
                "location": "Albany, CA",
                "name": "Albany High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "9b6d044b-dcd0-4c7e-a3c5-43c7aca51d99",
                    "schoolDistrict": "9b6d044b-dcd0-4c7e-a3c5-43c7aca51d99",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "f3a34422-94be-42dd-b22b-9ec647ebed62",
                    "zipCode": "b0469f0b-b037-4ab0-9a8e-d888278d5110"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Albany City Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "9b6d044b-dcd0-4c7e-a3c5-43c7aca51d99",
                        "location": "Berkeley, CA",
                        "name": "Albany City Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "4eb8fec9-8de0-46a9-b898-75cc913b8cef",
                            "zipCode": "39b2df86-684a-467f-9c95-5540b32110f5"
                        },
                        "premium": false,
                        "shortName": "Albany City Unified School District",
                        "tagline": [
                            "School District",
                            "Berkeley, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "albany-city-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Albany High",
                "tagline": [
                    "Albany City Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "albany-high-school-albany-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1168
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Albany High School is a fine public high school offering a wide array of classes, a safe community, and numerous clubs and sports. In my experience, I would say I had a fun and enjoyable time in school learning courses in math, science, english, world languages, tech, and more. Teachers have been helpful and encouraging. A diverse student body has allowed me to interact with people of similar and different backgrounds. Outside of the classroom, the many sports and clubs allow students to continue their passions.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-26T07:09:53.592179Z",
                "guid": "90b2797f-3974-427e-b6f9-4ec61113633c",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.291,37.8955,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.291,37.8955,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7183098591549295,
                "count": 284
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94706"
            }
        ]
    },
    {
        "guid": "9c6680c8-5af3-43be-ab87-ae6bf526dac2",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 37,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.523145,
                "lon": -121.96441
            },
            "entity": {
                "abbreviation": "Irvington High School",
                "alternates": {
                    "ceeb": "050968",
                    "nces": "061440001671"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "9c6680c8-5af3-43be-ab87-ae6bf526dac2",
                "isClaimed": false,
                "isPremium": false,
                "location": "Fremont, CA",
                "name": "Irvington High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "schoolDistrict": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "36041593-134d-436a-b83b-4c4244f6a447",
                    "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                        "location": "Fremont, CA",
                        "name": "Fremont Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "36041593-134d-436a-b83b-4c4244f6a447",
                            "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                        },
                        "premium": false,
                        "shortName": "Fremont Unified School District",
                        "tagline": [
                            "School District",
                            "Fremont, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Irvington High School",
                "tagline": [
                    "Fremont Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "irvington-high-school-fremont-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2294
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Irvington is a great school that will set you up for success. It has wonderful academics, dedicated teachers, and peers that will consistently motivate you to do better. The clubs are a great example of that. Irvington has many academic and performing arts clubs that reflect the willingness and drive of the student body. Clubs like debate, DECA, FBLA, science bowl, and many more are extremely compititively successful. However, the district is vastly underfunded and cannot afford to provide facilities for sports and clubs. Irvington makes the best of this situation and always strives to provide better for its students. Being in Fremont, it is very very competitive. Not to the extent of other Fremont schools, but you definitely have some toxic people that will want to bring you down. Overall, Irvington prepares you very well for college and life beyong high school.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-03T18:16:57.430032Z",
                "guid": "2d647e78-79fb-4706-8069-699daadfd29d",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.967,37.525,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.967,37.525,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.55316091954023,
                "count": 696
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94538"
            }
        ]
    },
    {
        "guid": "1b1ed3b2-9273-4d30-803c-103c3835d964",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 38,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.764235,
                "lon": -122.248243
            },
            "entity": {
                "abbreviation": "Alameda High School",
                "alternates": {
                    "ceeb": "050005",
                    "nces": "060177000041"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "1b1ed3b2-9273-4d30-803c-103c3835d964",
                "isClaimed": false,
                "isPremium": false,
                "location": "Alameda, CA",
                "name": "Alameda High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "3bfe75ba-c072-458a-a742-96bca1544408",
                    "schoolDistrict": "3bfe75ba-c072-458a-a742-96bca1544408",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "54a953dd-3bdc-47b1-b465-0e4d3705637e",
                    "zipCode": "a2b1830b-98f1-4ebd-83e1-b3e0b4fdffcb"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "AUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "3bfe75ba-c072-458a-a742-96bca1544408",
                        "location": "Alameda, CA",
                        "name": "Alameda Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "54a953dd-3bdc-47b1-b465-0e4d3705637e",
                            "zipCode": "a2b1830b-98f1-4ebd-83e1-b3e0b4fdffcb"
                        },
                        "premium": false,
                        "shortName": "Alameda City Unified School District",
                        "tagline": [
                            "School District",
                            "Alameda, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "alameda-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Alameda High School",
                "tagline": [
                    "Alameda Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "alameda-high-school-alameda-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1767
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Alameda High School is an exceptional public school as it places an emphasis on academics and has a progressive and inclusive student body and faculty. Along with that, it has a beautiful campus!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-01T07:12:49.788971Z",
                "guid": "24200690-7506-4e65-b8a4-9295a6b3f631",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.247,37.7647,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.247,37.7647,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.681265206812652,
                "count": 411
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94501"
            }
        ]
    },
    {
        "guid": "5e546747-45c5-44f9-923a-330b74856ce4",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 39,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.367041,
                "lon": -121.985851
            },
            "entity": {
                "abbreviation": "Adrian Wilcox High School",
                "alternates": {
                    "ceeb": "053276",
                    "nces": "063543006055"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "5e546747-45c5-44f9-923a-330b74856ce4",
                "isClaimed": true,
                "isPremium": false,
                "location": "Santa Clara, CA",
                "name": "Adrian Wilcox High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                    "schoolDistrict": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "44b1c9d0-0773-4aa7-aaeb-c04dda704fc1",
                    "zipCode": "d1fd4c8f-758c-4371-b58b-7ac5e13d8df8"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Santa Clara Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                        "location": "Santa Clara, CA",
                        "name": "Santa Clara Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "44b1c9d0-0773-4aa7-aaeb-c04dda704fc1",
                            "zipCode": "d1fd4c8f-758c-4371-b58b-7ac5e13d8df8"
                        },
                        "premium": false,
                        "shortName": "Santa Clara Unified School District",
                        "tagline": [
                            "School District",
                            "Santa Clara, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "santa-clara-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Adrian Wilcox High School",
                "tagline": [
                    "Santa Clara Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "adrian-wilcox-high-school-santa-clara-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1961
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Wilcox High School is one of a kind. There is no other high school where you will find a more relaxed atmosphere with an academic emphasis on studying for mastery, rather than standardized tests and exams. The teachers are kind and love to devote their time and experiences to extracurriculars. Nearly every teacher is involved with the campus outside of the subjects they teach. Some teachers are coaches while others are advisors for clubs and student government. The administration and front office staff are welcoming and care about the success of each student. Over 4 years, I had been able to work with quite a few guidance and wellness counselors at the school. They have an unimaginable amount of enthusiasm directed towards helping students find a career path that is right for them with their interests and grades in mind.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-17T06:14:58.406947Z",
                "guid": "17e82ad2-6ce0-475b-81e8-eaea8eb271dd",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.985,37.3654,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.985,37.3654,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.808193668528864,
                "count": 537
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95051"
            }
        ]
    },
    {
        "guid": "7335e340-d7fc-44e2-b80b-06ac4470d24e",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 40,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.984054,
                "lon": -122.57194
            },
            "entity": {
                "abbreviation": "Sir Francis Drake High School",
                "alternates": {
                    "ceeb": "052770",
                    "nces": "063879006525"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "7335e340-d7fc-44e2-b80b-06ac4470d24e",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Anselmo, CA",
                "name": "Sir Francis Drake High School",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "7fb983ef-9045-46a8-beff-5675b1357340",
                    "schoolDistrict": "7fb983ef-9045-46a8-beff-5675b1357340",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "0db5806d-7d26-41a5-8300-2d00fc0dfd2c",
                    "zipCode": "0455b370-2ddd-4cd1-ae84-32c046dba7fb"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "TUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "7fb983ef-9045-46a8-beff-5675b1357340",
                        "location": "Larkspur, CA",
                        "name": "Tamalpais Union High School District",
                        "parentGUIDs": {
                            "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "db131da3-37dc-42cf-aad2-15024d364e4d",
                            "zipCode": "f981dbb9-3c01-40c1-97a3-f476d8291c9a"
                        },
                        "premium": false,
                        "shortName": "Tamalpais Union High School District",
                        "tagline": [
                            "School District",
                            "Larkspur, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "tamalpais-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Drake",
                "tagline": [
                    "Tamalpais Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "sir-francis-drake-high-school-san-anselmo-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1301
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "For me overall it is still a good school with wonderful people and amazing teachers to help us get the best education possible! I am still there, going to be a senior, but so far I have met amazing people, made great friends and peers. The campus is really beautiful with the wonderful nature life we have growing and the nice facilities we have access to use with sports and such. We have an outstanding custodial staff who works super hard to make the school a wonderful and bright place to come to everyday! The one objective that needs to be improved is our diverse culture in the Drake community. We are struggling to find ways to improve this dilemma and we have a class on campus that are able to tackle these issues that happen to sometimes arise in our school district. It should be our job to promote a school where every human no matter race, etc to come to this school to feel safe, welcomed, appreciated, and so on. The most important is building a positive/supporting community!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-07-02T06:52:44.874931Z",
                "guid": "4c055a85-4d33-4d71-98d8-3b21639e2dd1",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.573,37.9834,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.573,37.9834,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8307086614173227,
                "count": 254
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94960"
            }
        ]
    },
    {
        "guid": "7cfc23b6-64b9-470a-a984-c87aedc38119",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 41,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.745623,
                "lon": -121.947337
            },
            "entity": {
                "abbreviation": "California High School",
                "alternates": {
                    "ceeb": "053229",
                    "nces": "063513005943"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "7cfc23b6-64b9-470a-a984-c87aedc38119",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Ramon, CA",
                "name": "California High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "54c77220-1c02-48f7-a584-28d7571918f4",
                    "parent": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                    "schoolDistrict": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "a7847108-2b53-4853-a24b-81c86d5c49b0",
                    "zipCode": "d01e8b5d-d2aa-452e-a5e1-1f9fac6d6870"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SRVUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                        "location": "Danville, CA",
                        "name": "San Ramon Valley Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "fcc57eee-ebde-443a-b77d-e10bbde2f779",
                            "zipCode": "bd3e7c23-836c-470d-ab71-7f4963ad582c"
                        },
                        "premium": false,
                        "shortName": "San Ramon Valley Unified School District",
                        "tagline": [
                            "School District",
                            "Danville, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-ramon-valley-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Cal High",
                "tagline": [
                    "San Ramon Valley Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "california-high-school-san-ramon-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2777
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I had always grown up with the idea that high school was going to be where every student would shed their free time and give it their all - after all, this was where competition would thrive, right? My preconception proved faulty, as while high school is undoubtedly a decisive time for many, the setting I found myself made for a pleasant experience. I found myself in the company of great teachers who really cared about both their chosen specialty and the well-being and education of the students, especially in the last years. Administration was helpful and fairly responsive, and the school boasted a wide variety of clubs, sports, activities, and events that students could involve themselves with. The general air around campus wasn’t always as amicable as most would hope, but I did get the feeling that faculty tried to make it as comfortable and inclusive as it could be. Overall, I’m glad that my experience in high school, while unusual because of the conditions, was pleasant.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-09T04:23:20.040852Z",
                "guid": "ba48c6fc-aa06-41dc-a849-feae923d3d28",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.945,37.7479,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.945,37.7479,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.708818635607321,
                "count": 601
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94583"
            }
        ]
    },
    {
        "guid": "af7cace6-3395-4acc-82dd-ece1e5c7a3fe",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 42,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.868942,
                "lon": -122.270916
            },
            "entity": {
                "abbreviation": "Berkeley High School",
                "alternates": {
                    "ceeb": "050290",
                    "nces": "060474000432"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "af7cace6-3395-4acc-82dd-ece1e5c7a3fe",
                "isClaimed": false,
                "isPremium": false,
                "location": "Berkeley, CA",
                "name": "Berkeley High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "08c9fae1-71c5-433d-815b-f87f6237cca5",
                    "parent": "a80d0954-768b-4a61-af13-29460f542800",
                    "schoolDistrict": "a80d0954-768b-4a61-af13-29460f542800",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "4eb8fec9-8de0-46a9-b898-75cc913b8cef",
                    "zipCode": "5cca1363-a484-4cdd-b565-6aafb910c062"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "BUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "a80d0954-768b-4a61-af13-29460f542800",
                        "location": "Berkeley, CA",
                        "name": "Berkeley Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "62e9b88d-c1c2-4def-a030-dd9fa0106676",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "4eb8fec9-8de0-46a9-b898-75cc913b8cef",
                            "zipCode": "40657545-f7b8-4dad-aab4-1f71e29d13b4"
                        },
                        "premium": false,
                        "shortName": "Berkley Public Schools",
                        "tagline": [
                            "School District",
                            "Berkeley, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "berkeley-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Berkeley High School",
                "tagline": [
                    "Berkeley Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "berkeley-high-school-berkeley-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 3154
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "It is a great school. It is very diverse, it is very big, you get the golden opportunity to meet lots and lots of people, the teachers are very good and they really care about their students. We have off campus lunch which means, at lunch time you can go to any food place around our school and buy your own lunch. It's like college inside of a high school. We have very very good school spirit. We have these days called rally day. It is every single year at the beginning of the school year. On this day everyone at the school wears our school colors which is red and gold or yellow. On this day, the students are allowed to go wild and yell and scream in the hallways, and act like a crazy teenager. This day is safe only if you make it, for example, if you choose to do very very stupid things then you will most likely face the consequences of the very stupid thing that you did. This day is the day that students get to be spirited students! This is by far the most unique thing about school.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-06-03T04:42:10.535714Z",
                "guid": "32d4ee98-d0be-497a-b8e6-5411e57c4b3b",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.271,37.8662,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.271,37.8662,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8131212723658052,
                "count": 503
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94704"
            }
        ]
    },
    {
        "guid": "da60c034-7983-42c3-9c53-1ce434c965e7",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 43,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.828064,
                "lon": -122.007147
            },
            "entity": {
                "abbreviation": "San Ramon Valley High School",
                "alternates": {
                    "ceeb": "050725",
                    "nces": "063513005957"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "da60c034-7983-42c3-9c53-1ce434c965e7",
                "isClaimed": false,
                "isPremium": false,
                "location": "Danville, CA",
                "name": "San Ramon Valley High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                    "schoolDistrict": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "fcc57eee-ebde-443a-b77d-e10bbde2f779",
                    "zipCode": "bd3e7c23-836c-470d-ab71-7f4963ad582c"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SRVUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                        "location": "Danville, CA",
                        "name": "San Ramon Valley Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "fcc57eee-ebde-443a-b77d-e10bbde2f779",
                            "zipCode": "bd3e7c23-836c-470d-ab71-7f4963ad582c"
                        },
                        "premium": false,
                        "shortName": "San Ramon Valley Unified School District",
                        "tagline": [
                            "School District",
                            "Danville, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-ramon-valley-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "San Ramon Valley High School",
                "tagline": [
                    "San Ramon Valley Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "san-ramon-valley-high-school-danville-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2094
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I have loved my experience at San Ramon Valley! From my Freshman to Senior I have been taught by outstanding teachers who are clearly dedicated to their students and their subject. Some of the best friends I have made as a student are with my teachers.  With such great support from my teachers and the administration and a wide variety of rigorous courses, I definitely feel I am prepared for college and life. In addition to the amazing academics, SRV is home to most of the top sports teams in the surrounding districts. Also, SRV hosts many amazing dances, rallies, parades, activities, and community events with the help of the school leadership team.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-25T07:17:57.76053Z",
                "guid": "16d26b59-4a69-4377-9164-d1e6ba74f725",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.007,37.826,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.007,37.826,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8240223463687153,
                "count": 358
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94526"
            }
        ]
    },
    {
        "guid": "a936dd57-fb73-4f1c-9f75-a1477205010e",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 44,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.403941,
                "lon": -121.849003
            },
            "entity": {
                "abbreviation": "Piedmont Hills High School",
                "alternates": {
                    "ceeb": "051976",
                    "nces": "061182001307"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "a936dd57-fb73-4f1c-9f75-a1477205010e",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Piedmont Hills High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "73dbbbce-3862-46d6-b375-4abe156d1210",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "f9b10c5e-36dc-4824-9185-338678030da4"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Piedmont Hills High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "piedmont-hills-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2058
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Piedmont Hills High School has a unique setting and aspects. Academically, it can be quite competitive especially with the high stats throughout the Bay Area. The school itself doesn't offer as many ap classes or electives compared to Independence or Evergreen. However, those schools are very overpopulated and bigger. Piedmont Hills has a smaller setting and during break/lunch everyone hangouts outside. PHHS is mostly populated with Asians but there are many cultures expressed through dances, showcases, clubs, etc. The food isn't necessarily health but a good amount of students tend to go out to eat since the food can be pricey. The teachers can be a hit or miss but overall are pretty understanding. The counseling department(academically/student support) is pretty useful. The counseling department provides help with a four-year plan throughout high school as well as host workshops for seniors in preparation for college.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-18T21:13:39.943952Z",
                "guid": "fbc88039-ccf1-4f05-b390-6d37907cd5c6",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.851,37.4016,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.851,37.4016,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7264150943396226,
                "count": 636
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95132"
            }
        ]
    },
    {
        "guid": "fbcd0ff6-3b6f-4c5a-92a0-45fb0d5d8906",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 45,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.908259,
                "lon": -122.00703
            },
            "entity": {
                "abbreviation": "Northgate High School",
                "alternates": {
                    "ceeb": "050666",
                    "nces": "062637003961"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "fbcd0ff6-3b6f-4c5a-92a0-45fb0d5d8906",
                "isClaimed": false,
                "isPremium": false,
                "location": "Walnut Creek, CA",
                "name": "Northgate High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "schoolDistrict": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "e3c4436c-7dc9-4c55-8ef7-d47f7a932ba9",
                    "zipCode": "047384f0-7981-4f9a-bed7-6c8444ca2013"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "MDUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                        "location": "Concord, CA",
                        "name": "Mt. Diablo Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "187f89d7-6963-49c2-b924-426631dae88f",
                            "zipCode": "fca2caaa-dbcc-472c-be69-c07f58b2a359"
                        },
                        "premium": false,
                        "shortName": "Mt. Diablo Unified School District",
                        "tagline": [
                            "School District",
                            "Concord, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mt-diablo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Northgate High School",
                "tagline": [
                    "Mt. Diablo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "northgate-high-school-walnut-creek-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1490
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Northgate High School is full of passionate teachers who truly care about their students, and are almost always willing to help. This is especially true of their Advanced Placement and ROP programs, which are stellar, and always taught by teachers who truly care about the subject. Northgate offers a variety of wonderful courses that allow students to explore and see what they are interested in. The students are always supported wholeheartedly by the administration and are taught to push themselves to achieve greatness. However, unlike most schools, Northgate puts an emphasis on mental health, mindfulness, and wellness. The atmosphere is competitive but still friendly, making it a perfect environment to test oneself and see how much you can achieve.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-20T03:00:49.828229Z",
                "guid": "8274e646-aebc-42ab-8605-58519ec1d1ce",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.008,37.908,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.008,37.908,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5217391304347827,
                "count": 230
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94598"
            }
        ]
    },
    {
        "guid": "eaca2d42-1f84-4a69-b00e-1d4e0e92f53e",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 46,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.352518,
                "lon": -122.032478
            },
            "entity": {
                "abbreviation": "Fremont High School",
                "alternates": {
                    "ceeb": "053460",
                    "nces": "061443001696"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "eaca2d42-1f84-4a69-b00e-1d4e0e92f53e",
                "isClaimed": false,
                "isPremium": false,
                "location": "Sunnyvale, CA",
                "name": "Fremont High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                    "schoolDistrict": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "cd0684fb-f68d-419b-8bf5-6500062b6af5",
                    "zipCode": "12ede258-9fa8-4ba5-9e1e-4d80c11aa22e"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "8e71df00-f090-4dd6-8f3d-3e373d911882",
                        "location": "Sunnyvale, CA",
                        "name": "Fremont Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "cd0684fb-f68d-419b-8bf5-6500062b6af5",
                            "zipCode": "12ede258-9fa8-4ba5-9e1e-4d80c11aa22e"
                        },
                        "premium": false,
                        "shortName": "Fremont Union High School District",
                        "tagline": [
                            "School District",
                            "Sunnyvale, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Fremont High School",
                "tagline": [
                    "Fremont Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "fremont-high-school-sunnyvale-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2081
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "It was ok at best. They keep it very organized and clean. They never let bulling happen and the teachers are very nice. As far as schools go Fremont is fine.\nHowever the school never really let you express yourself. A very strict dress code, rules for everything anyone was doing, and no real support for the arts. We may have been a good school academically but there really wasn't much else. They are also know as the hardest school to work with because they make everything harder then it needs to be. They also put way too much pressure on their teachers. Being the daughter of  a teacher who works there, I know a lot. It's a good school, but could be better.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-05-06T19:41:03.370049Z",
                "guid": "c31c9ed0-c4da-411b-8795-997e52e8b8de",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.035,37.3538,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.035,37.3538,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.903314917127072,
                "count": 362
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94087"
            }
        ]
    },
    {
        "guid": "a20e759b-6ce7-48b5-a0fb-a80ef7ce6403",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 47,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.669066,
                "lon": -122.480134
            },
            "entity": {
                "abbreviation": "Summit Public School - Shasta Campus",
                "alternates": {
                    "ceeb": "054815",
                    "nces": "060164813354"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "a20e759b-6ce7-48b5-a0fb-a80ef7ce6403",
                "isClaimed": true,
                "isPremium": false,
                "location": "Daly City, CA",
                "name": "Summit Public School - Shasta Campus",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "schoolNetwork": "2ed1eb64-2cd2-4b6a-8f49-20b86f2fe1ca",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "41a99124-6b7c-496d-9635-39a33c683883",
                    "zipCode": "6e76147a-b88b-4659-93c4-fe720003e7e7"
                },
                "premium": false,
                "shortName": "Summit Shasta",
                "tagline": [
                    "Public School",
                    "Daly City, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "summit-public-school---shasta-campus-daly-city-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 491
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Honestly, I really loved Shasta the minute I arrived on campus my freshman year; however, things have changed in the three years since.\n\nFor the first couple of years, you really felt heard as a student if the vast majority agreed with you. Workshops? You got it. More study time? Mhm! Since the new head of Summit Schools took over, we as a community have not felt acknowledged or respected as students because of how ignored our complaints have gone. Don't get me wrong, I absolutely LOVE this school and everything it has to offer. The teachers actually listen to you and help you whenever and wherever possible, but the heads of Summit (all schools) don't help. \n\nAcademics are amazing and I feel I'm ready for college as a Senior. Here, I found many of my passions and have grown as a better, more confident individual. Every student can find someone they trust and something they love about the school.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-11-14T18:31:16.755971Z",
                "guid": "09e28dfa-0da5-419a-b389-3aff23b0d64e",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.477,37.668,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.477,37.668,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.078125,
                "count": 64
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94015"
            }
        ]
    },
    {
        "guid": "bd1b921a-5e23-4d0c-a0f8-51c5a9c15935",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 48,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.243308,
                "lon": -121.922592
            },
            "entity": {
                "abbreviation": "Leigh High School",
                "alternates": {
                    "ceeb": "053092",
                    "nces": "060723008122"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "bd1b921a-5e23-4d0c-a0f8-51c5a9c15935",
                "isClaimed": true,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Leigh High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "5750507d-5a3f-47db-a00c-b8ac64163449",
                    "parent": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                    "schoolDistrict": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "c051b239-374c-4f96-b426-d3be11c6ef67"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Campbell Union High School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                        "location": "San Jose, CA",
                        "name": "Campbell Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "5750507d-5a3f-47db-a00c-b8ac64163449",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "c051b239-374c-4f96-b426-d3be11c6ef67"
                        },
                        "premium": false,
                        "shortName": "Campbell Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "campbell-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Leigh High School",
                "tagline": [
                    "Campbell Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "leigh-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1772
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "The part I love most about Leigh is the atmosphere. The relationships between students and teachers is all about respect and I always feel listened to and actively involved in my classes. The staff really cares about the students at Leigh and wants to make sure they are using their high school years to the fullest. I also love the relationships between students and their peers, where I feel like there is still a lot of respect. However I would love to see more school spirit!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-21T01:01:18.90417Z",
                "guid": "17b46647-185c-423e-a4a8-a3eb89ac9726",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.92,37.2415,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.92,37.2415,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.514469453376206,
                "count": 311
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95124"
            }
        ]
    },
    {
        "guid": "0bd802ef-dec4-4340-a338-2608fc9ad3c1",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 49,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.324967,
                "lon": -121.782141
            },
            "entity": {
                "abbreviation": "Evergreen Valley High School",
                "alternates": {
                    "ceeb": "053169",
                    "nces": "061182010665"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "0bd802ef-dec4-4340-a338-2608fc9ad3c1",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Evergreen Valley High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "8809e41c-e338-454f-bcbb-c2a7fc64460b",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "a1b0b88c-ce08-4016-8f40-ad4d3f830ea0"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Evergreen Valley High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "evergreen-valley-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2961
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 26
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "My experience here was definitely great. The counselors and teachers are nice and you can always come to them for resources or help on many school materials. However, there are teachers who can’t teach and their students would often complain about not learning anything while earning a low test score. I participated in a lot of school events and got to meet a lot of new people and had so fun much through dance practices. Classrooms are very nice and there are a lot of fun activities to participate in every day at lunch. If you’re a low-income student like me, then definitely look out for all of the available resources such as asking your counselor for a fee waiver on SAT Tests or for a reduced price on prom ticket. I had grown so much from attending EVHS and I hope that many more incoming students will be able to grow as much as I did. I’m a proud graduate of class of 2020!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-06-06T00:04:38.944011Z",
                "guid": "b229c92c-2474-42a1-8756-775dbb2629e5",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.779,37.324,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.779,37.324,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.492857142857143,
                "count": 560
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95148"
            }
        ]
    },
    {
        "guid": "21d604de-2627-4006-b9fa-c06978d15076",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 50,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.74575,
                "lon": -122.450792
            },
            "entity": {
                "abbreviation": "Ruth Asawa San Francisco School of the Arts",
                "alternates": {
                    "ceeb": "053033",
                    "nces": "063441001276"
                },
                "character": "Public, Magnet, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Magnet School",
                "guid": "21d604de-2627-4006-b9fa-c06978d15076",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Ruth Asawa San Francisco School of the Arts",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "554d2930-0795-4eee-a305-65351bba79b6",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "ee205ed4-1f3f-448a-8f17-065ffce55d35"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Ruth Asawa SOTA",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "ruth-asawa-san-francisco-school-of-the-arts-san-francisco-ca",
                "variation": 52
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 795
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 27
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I loved the structure of the school's non-traditional classrooms and hyper-focus on the arts. The school has lots of strong support programs from mental health counseling to academic support. As a student with an IEP, SOTA was very helpful in making sure I had the support I needed through teachers that would fight for me and made me feel very welcome and supported. However, the school environment  had a severe lack of structure, and most of the administration and many teachers were new and didn't have the proper experience to support the student body as a whole.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-01T16:59:43.894721Z",
                "guid": "1a847c01-69d8-4473-bb7d-2df90254798d",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.449,37.7451,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.449,37.7451,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.58974358974359,
                "count": 156
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94131"
            }
        ]
    },
    {
        "guid": "4f0b358f-1d29-41fa-966e-772d2275b996",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 51,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.255414,
                "lon": -121.898344
            },
            "entity": {
                "abbreviation": "Branham High School",
                "alternates": {
                    "ceeb": "053082",
                    "nces": "060723008350"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "4f0b358f-1d29-41fa-966e-772d2275b996",
                "isClaimed": true,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Branham High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "5750507d-5a3f-47db-a00c-b8ac64163449",
                    "parent": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                    "schoolDistrict": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Campbell Union High School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                        "location": "San Jose, CA",
                        "name": "Campbell Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "5750507d-5a3f-47db-a00c-b8ac64163449",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "c051b239-374c-4f96-b426-d3be11c6ef67"
                        },
                        "premium": false,
                        "shortName": "Campbell Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "campbell-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Branham High School",
                "tagline": [
                    "Campbell Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "branham-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1802
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Branham is a diverse and comforting campus. As the walk you do not see people seperated into different groups;consequently, they are merged and no one feels left out. Personally, my family was facing struggles not having the technology at home that was needed. Branham heard me out! They annually have the \"make a wish\" rally and I along with many others were granted gifts that were very much needed. Branham allows supports their students and make sure they do not miss opportunities simply because of money. Not only do they help money wise but emotionally as well.Branham has great staff that are always checking up on you. Even with distance learning we have a specific teacher that checks up on us once a week. Overall, Branham has great staff and an amazing support system.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-10-02T02:32:08.607411Z",
                "guid": "794d7a0b-961d-46a5-ba84-a331381def88",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.899,37.2538,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.899,37.2538,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6288659793814433,
                "count": 291
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95118"
            }
        ]
    },
    {
        "guid": "5c48ebcf-c48e-44c9-a0c4-949e1e4b8138",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 52,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.551982,
                "lon": -121.995013
            },
            "entity": {
                "abbreviation": "Washington High School",
                "alternates": {
                    "ceeb": "050972",
                    "nces": "061440001692"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "5c48ebcf-c48e-44c9-a0c4-949e1e4b8138",
                "isClaimed": false,
                "isPremium": false,
                "location": "Fremont, CA",
                "name": "Washington High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "schoolDistrict": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "36041593-134d-436a-b83b-4c4244f6a447",
                    "zipCode": "4dc14d8f-c3ed-4d52-abca-3f8a107886e5"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                        "location": "Fremont, CA",
                        "name": "Fremont Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "36041593-134d-436a-b83b-4c4244f6a447",
                            "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                        },
                        "premium": false,
                        "shortName": "Fremont Unified School District",
                        "tagline": [
                            "School District",
                            "Fremont, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Washington High",
                "tagline": [
                    "Fremont Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "washington-high-school-fremont-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1918
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "Compared to other schools in the Fremont School District, Washington High School is among the best because of the programs that are available to students within the school. Washington itself is very diverse in terms of its students and teachers, allowing for connections on every level of interaction. They have a pretty decent set of academics and diverse classes for students. The counseling staff at Washington may be a little below average, but the teachers make up for this as most will go above and beyond to help you to achieve your goals. Also, the sports teams at Washington are worth mentioning, as they have great coaches and teams! My favorite aspect of Washington High School was the art programs that were made available to students.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-06-25T01:04:44.499676Z",
                "guid": "bb3ace5b-4d0b-4eab-b61e-9bf4584efe19",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.995,37.5518,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.995,37.5518,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.466076696165192,
                "count": 339
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94536"
            }
        ]
    },
    {
        "guid": "51c57703-440b-4374-aef6-64615e1bfd01",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 53,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.705657,
                "lon": -122.07837
            },
            "entity": {
                "abbreviation": "Castro Valley High School",
                "alternates": {
                    "ceeb": "050500",
                    "nces": "060780000742"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "51c57703-440b-4374-aef6-64615e1bfd01",
                "isClaimed": false,
                "isPremium": false,
                "location": "Castro Valley, CA",
                "name": "Castro Valley High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "3707b90b-92ee-4fe1-b360-2afce14889fb",
                    "schoolDistrict": "3707b90b-92ee-4fe1-b360-2afce14889fb",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "3b63d4f5-8c5d-4908-9952-1529e9a9dcee",
                    "zipCode": "ca87fa67-ecae-4bbb-a27b-22324f3483bc"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Castro Valley Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "3707b90b-92ee-4fe1-b360-2afce14889fb",
                        "location": "Castro Valley, CA",
                        "name": "Castro Valley Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "3b63d4f5-8c5d-4908-9952-1529e9a9dcee",
                            "zipCode": "ca87fa67-ecae-4bbb-a27b-22324f3483bc"
                        },
                        "premium": false,
                        "shortName": "Castro Valley Unified School District",
                        "tagline": [
                            "School District",
                            "Castro Valley, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "castro-valley-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Castro Valley High School",
                "tagline": [
                    "Castro Valley Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "castro-valley-high-school-castro-valley-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2834
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Throughout my three years at CVHS, it was a pleasant experience. Some of my teachers were really helpful and the school offers a lot. The Wellness Center is an awesome resource to have for mental health or if you need to talk to a counselor. Staff and custodians do a really great job to keep our school clean and safe! So sad to be graduating this year.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-04-16T04:44:24.521148Z",
                "guid": "a07722d5-17d7-4099-8534-9f2352c213b8",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.076,37.705,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.076,37.705,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6538461538461537,
                "count": 754
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94546"
            }
        ]
    },
    {
        "guid": "30b6d92c-f0a2-48ca-87e0-48c2f822c1ec",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 54,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.486081,
                "lon": -122.237415
            },
            "entity": {
                "abbreviation": "Sequoia High School",
                "alternates": {
                    "ceeb": "052605",
                    "nces": "063639006198"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "30b6d92c-f0a2-48ca-87e0-48c2f822c1ec",
                "isClaimed": false,
                "isPremium": false,
                "location": "Redwood City, CA",
                "name": "Sequoia High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "a5dafe95-b00a-4d53-8912-9559cbb65dd9",
                    "parent": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                    "schoolDistrict": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "5ca486a6-52a6-4b83-aeda-db4b437b4d7f",
                    "zipCode": "7d773137-7242-4cc9-91c9-d3770c1b9f33"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                        "location": "Redwood City, CA",
                        "name": "Sequoia Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a5dafe95-b00a-4d53-8912-9559cbb65dd9",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "5ca486a6-52a6-4b83-aeda-db4b437b4d7f",
                            "zipCode": "7d773137-7242-4cc9-91c9-d3770c1b9f33"
                        },
                        "premium": false,
                        "shortName": "Sequoia Union High School District",
                        "tagline": [
                            "School District",
                            "Redwood City, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "sequoia-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Sequoia High School",
                "tagline": [
                    "Sequoia Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "sequoia-high-school-redwood-city-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2067
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "I love the higher level classes at Sequoia. Having IB classes at Sequoia is extremely useful because it consistently challenges me and allows me to push myself. In addition, there are a wide-range of extracurricular classes at Sequoia including draw/paint, ceramics, journalism, digital media, and many more. There is also an amazing social scene at Sequoia because everyone is friendly and the teachers clearly care for their students well-being.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-27T00:43:43.239358Z",
                "guid": "b35de1e7-d594-4eac-947b-d223749ac957",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.236,37.4839,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.236,37.4839,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.918300653594771,
                "count": 306
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94062"
            }
        ]
    },
    {
        "guid": "4108c657-259b-4dac-96f3-d904483eb01b",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 55,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.646436,
                "lon": -122.119949
            },
            "entity": {
                "abbreviation": "Heritage High School",
                "alternates": {
                    "ceeb": "050386",
                    "nces": "062160010755"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "4108c657-259b-4dac-96f3-d904483eb01b",
                "isClaimed": false,
                "isPremium": false,
                "location": "Brentwood, CA",
                "name": "Heritage High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "c7e723f0-78fc-4ba9-aa90-a97d95040134",
                    "parent": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                    "schoolDistrict": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Liberty Union High School District (Brentwood)",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                        "location": "Brentwood, CA",
                        "name": "Liberty Union High School District (Brentwood)",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "8c697687-c0ec-469c-98e8-e0a06e72a35a",
                            "zipCode": "fea44aef-6d39-4c1c-9267-b5b70ebd1cf5"
                        },
                        "premium": false,
                        "shortName": "Liberty Union High School District (Brentwood)",
                        "tagline": [
                            "School District",
                            "Brentwood, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "liberty-union-high-school-district-brentwood-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Heritage High School",
                "tagline": [
                    "Liberty Union High School District (Brentwood), CA",
                    "9-12"
                ],
                "type": "School",
                "url": "heritage-high-school-brentwood-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2589
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "I think Heritage is a great school that goes beyond the average public school. It has a large variety of clubs and classes that explore unique topics and career pathways. The diversity of the school really stands out with its multiple cultural clubs and people. The teachers, academics, and sports provided I found to be really great. The only thing I would like to see improve is their technology resources. The wifi and computers have shown to be unreliable at times, so I would suggest a replacement. Other than that, so far I have been satisfied with my high school experience and college readiness. Thanks, Heritage!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-02T17:32:51.707744Z",
                "guid": "9de75c71-2be3-4fc6-89fd-4a2d8d620389",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.756,37.9229,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.756,37.9229,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.738970588235294,
                "count": 544
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94513"
            }
        ]
    },
    {
        "guid": "b9fbfdd2-2035-4d43-acdd-d7efedbf7524",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 56,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.537956,
                "lon": -121.991933
            },
            "entity": {
                "abbreviation": "Circle of Independent Learning Charter School",
                "alternates": {
                    "ceeb": "051061",
                    "nces": "061440007479"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "b9fbfdd2-2035-4d43-acdd-d7efedbf7524",
                "isClaimed": false,
                "isPremium": false,
                "location": "Fremont, CA",
                "name": "Circle of Independent Learning Charter School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "schoolDistrict": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "36041593-134d-436a-b83b-4c4244f6a447",
                    "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                        "location": "Fremont, CA",
                        "name": "Fremont Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "36041593-134d-436a-b83b-4c4244f6a447",
                            "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                        },
                        "premium": false,
                        "shortName": "Fremont Unified School District",
                        "tagline": [
                            "School District",
                            "Fremont, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Circle of Independent Learning Charter School",
                "tagline": [
                    "Fremont Unified School District, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "circle-of-independent-learning-charter-school-fremont-ca",
                "variation": 52
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 368
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Parent",
                "body": "Advanced students are allowed to take college classes at community colleges and AP classes online.  For club and activities, students can join their home high school in their district.  The teachers genuinely care about students and their education.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-09-27T00:05:51.672693Z",
                "guid": "b4c81095-ad5a-49a6-8368-a436368eeda4",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.991,37.5383,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.991,37.5383,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.25,
                "count": 28
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94538"
            }
        ]
    },
    {
        "guid": "b69da3be-0ad6-4d48-a58a-96681e93b343",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 57,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.672989,
                "lon": -121.789855
            },
            "entity": {
                "abbreviation": "Granada High School",
                "alternates": {
                    "ceeb": "051423",
                    "nces": "062211002626"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "b69da3be-0ad6-4d48-a58a-96681e93b343",
                "isClaimed": true,
                "isPremium": false,
                "location": "Livermore, CA",
                "name": "Granada High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "19cd8fd6-2e3f-4241-bb82-be4e992de8bf",
                    "schoolDistrict": "19cd8fd6-2e3f-4241-bb82-be4e992de8bf",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "fc27d7f3-833b-4d0b-bced-8aa3c3c99758",
                    "zipCode": "0a020eaf-ab20-4a50-8308-d60ca74bd07f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Livermore Valley Joint Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "19cd8fd6-2e3f-4241-bb82-be4e992de8bf",
                        "location": "Livermore, CA",
                        "name": "Livermore Valley Joint Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "fc27d7f3-833b-4d0b-bced-8aa3c3c99758",
                            "zipCode": "c06482ed-5084-4a24-95f9-0ab50e7042b2"
                        },
                        "premium": false,
                        "shortName": "Livermore Valley Joint Unified School District",
                        "tagline": [
                            "School District",
                            "Livermore, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "livermore-valley-joint-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Granada High School",
                "tagline": [
                    "Livermore Valley Joint Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "granada-high-school-livermore-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2282
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "Granada High School provided me with the best high school experience I could ask for! Whether if it was teachers who have paid much attention to my questions or a student body and administration that helped me with anything that I needed, Granada High School was one of the best chapters in my life.\n\nAlthough the environment is not as diverse as I would imagine the average American school is, the environment and atmosphere was great, along with an excellent athletics department and overachieving students, GHS is a great school!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-06-29T06:07:01.230756Z",
                "guid": "42f77072-69d7-4e20-85d5-ab3509e001c9",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.787,37.6743,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.787,37.6743,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8036363636363637,
                "count": 275
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94550"
            }
        ]
    },
    {
        "guid": "363dcee4-d2c0-4d10-9256-de245a66b8b2",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 58,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.779598,
                "lon": -122.28794
            },
            "entity": {
                "abbreviation": "ACLC",
                "alternates": {
                    "ceeb": "050011",
                    "nces": "060166408673"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "363dcee4-d2c0-4d10-9256-de245a66b8b2",
                "isClaimed": true,
                "isPremium": true,
                "location": "Alameda, CA",
                "name": "Alameda Community Learning Center",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "54a953dd-3bdc-47b1-b465-0e4d3705637e",
                    "zipCode": "a2b1830b-98f1-4ebd-83e1-b3e0b4fdffcb"
                },
                "premium": true,
                "shortName": "Alameda Community Learning Center",
                "tagline": [
                    "Public School",
                    "Alameda, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "alameda-community-learning-center-alameda-ca",
                "variation": 1056
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 351
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "The class sizes at my school are small, so teachers can individually help every student. The school population is also small. More people leave than those who apply so all of us are pretty close. The low school population is mostly due to the size of our campus, and our general lack of regular high school things like sports games, band, and theatre. The main upside of our school from an academic standpoint is that students are required to take classes at the nearby community college, and the school pays for the classes. In my sophomore year, I took Psychology 101 and Beginners Ceramics. These college classes gave me the opportunity to explore my interests, meet people in different fields, and get college credits (which will make college cheaper for me). Another upside of my school is that the teachers that stay care about us. My digital music teacher is like a father to many, and my humanities teachers feel like mentors. I feel that I made a good choice, attending ACLC",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-06T02:08:56.112281Z",
                "guid": "603c70af-417a-4f91-b4bb-20aff085c433",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "default": {
                    "crops": {
                        "DesktopHeader": "https://s3.amazonaws.com/photos.niche.com/c30dcd6b87a3f97dff16f77d956ed5daea803106",
                        "MobileHeader": "https://s3.amazonaws.com/photos.niche.com/72293086ff014ecbc765a920d147d65b42a33d63",
                        "Thumbnail": "https://s3.amazonaws.com/photos.niche.com/c0c27db8a0b8376ba22fb6c6eb2db8238aad4aff"
                    },
                    "licenseName": "UNLICENSED"
                },
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.287,37.7792,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.287,37.7792,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.625,
                "count": 24
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94501"
            }
        ]
    },
    {
        "guid": "a9d8c610-2b02-4531-8ff0-024bfaf39031",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 59,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.2817,
                "lon": -121.93029
            },
            "entity": {
                "abbreviation": "Westmont High School",
                "alternates": {
                    "ceeb": "053103",
                    "nces": "060723000676"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "a9d8c610-2b02-4531-8ff0-024bfaf39031",
                "isClaimed": true,
                "isPremium": false,
                "location": "Campbell, CA",
                "name": "Westmont High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "b3b98262-15ef-44a8-815a-27134567fadc",
                    "parent": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                    "schoolDistrict": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "4df422c6-0638-49ba-8066-ba47e02b585b",
                    "zipCode": "ca297213-7ddc-46ed-b83c-f4704a492b61"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Campbell Union High School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                        "location": "San Jose, CA",
                        "name": "Campbell Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "5750507d-5a3f-47db-a00c-b8ac64163449",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "c051b239-374c-4f96-b426-d3be11c6ef67"
                        },
                        "premium": false,
                        "shortName": "Campbell Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "campbell-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Westmont High School",
                "tagline": [
                    "Campbell Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "westmont-high-school-campbell-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1601
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Westmont High School gives each student an adequate education. However, the administration tends to shy away from many pressing issues within the school. Recently, the staff has developed new programs to deal with discrimination within the school. Unfortunately, the issues continue to occur. The teachers are truly determined to help their students, but the course offerings could definitely be more rigorous. Overall, the education at this school is beneficial, but the school culture is very negative.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-12T19:18:54.562081Z",
                "guid": "e808046c-8b03-4df6-a3e0-cd9e925d354c",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.986,37.2714,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.986,37.2714,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5324074074074074,
                "count": 216
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95008"
            }
        ]
    },
    {
        "guid": "00878a37-c0e8-4353-a81e-8ef4bf066784",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 60,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.938103,
                "lon": -122.534623
            },
            "entity": {
                "abbreviation": "Tamiscal High (Alternative)",
                "alternates": {
                    "ceeb": "051396",
                    "nces": "063879010109"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "00878a37-c0e8-4353-a81e-8ef4bf066784",
                "isClaimed": false,
                "isPremium": false,
                "location": "Larkspur, CA",
                "name": "Tamiscal High (Alternative)",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "7fb983ef-9045-46a8-beff-5675b1357340",
                    "schoolDistrict": "7fb983ef-9045-46a8-beff-5675b1357340",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "db131da3-37dc-42cf-aad2-15024d364e4d",
                    "zipCode": "f981dbb9-3c01-40c1-97a3-f476d8291c9a"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "TUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "7fb983ef-9045-46a8-beff-5675b1357340",
                        "location": "Larkspur, CA",
                        "name": "Tamalpais Union High School District",
                        "parentGUIDs": {
                            "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "db131da3-37dc-42cf-aad2-15024d364e4d",
                            "zipCode": "f981dbb9-3c01-40c1-97a3-f476d8291c9a"
                        },
                        "premium": false,
                        "shortName": "Tamalpais Union High School District",
                        "tagline": [
                            "School District",
                            "Larkspur, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "tamalpais-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Tamiscal High (Alternative)",
                "tagline": [
                    "Tamalpais Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "tamiscal-high-alternative-larkspur-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 124
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 11
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "I love Tamiscal. The staff is amazing— teachers are knowledgeable, kind, and accommodating to each student's individual needs. Academics here are equal in rigor to the bigger schools in the Tam District. One could argue that the program is even more difficult due to the responsibilities that come with independent learning. Being a student here takes a lot of self-discipline. Tamiscal has a close-knit community of unique and talented students. Many students are enrolled in pre-professional programs, which preclude full-time attendance at a traditional high school. There are athletes, dancers, musicians, artists, and many other students who participate in intensive extracurricular activities. The social scene is different from that of a traditional high school, but it isn't exclusive. Everyone is friendly and you're able to learn a lot from those around you.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-22T20:23:09.528399Z",
                "guid": "efd92285-2899-4d75-ae83-3687eb37dafe",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.53,37.9378,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.53,37.9378,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.476190476190476,
                "count": 21
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94939"
            }
        ]
    },
    {
        "guid": "fe3b8f0d-372a-4da7-9e88-3175c7f5db21",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 61,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.623857,
                "lon": -122.087727
            },
            "entity": {
                "abbreviation": "Leadership Public Schools - Hayward",
                "alternates": {
                    "ceeb": "051231",
                    "nces": "060181510737"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "fe3b8f0d-372a-4da7-9e88-3175c7f5db21",
                "isClaimed": false,
                "isPremium": false,
                "location": "Hayward, CA",
                "name": "Leadership Public Schools - Hayward",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "723769d9-71d5-4272-8024-340ffcff7fcc",
                    "schoolNetwork": "b417dc33-d284-4a75-aa5f-71849ab590fa",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                    "zipCode": "e8c32215-6d14-4b33-82bd-2d41b6b32206"
                },
                "premium": false,
                "shortName": "LPS Hayward",
                "tagline": [
                    "Public School",
                    "Hayward, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "leadership-public-schools---hayward-hayward-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 595
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Leadership Public School is a charter school that focuses on building leadership based on respect, responsibility, and respect. The school has a wide variety of extracurriculars that help develop the student's career and interests like Makers and Drama. I had a lot of fun in these classes and fell in love with theater after having drama during my freshman year. Maker class thought me to work collaboratively to build physical projects and often had to problem-solve to develop our projects such as making shoes or building an arcade game. This high school takes the community to a different level, town hall every Friday often allows for competition between every class, in the middle of the ceremony we shout out the royal of the week, which is a royal that has shined during the week. We also end up with a chant before we leave that everyone has to do correctly so that we can leave, It's kinda culty but we all love it. Overall a school filled with very respectful and open-minded students.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-04-10T10:21:20.609056Z",
                "guid": "2d3f6c9a-3656-4fb6-8309-a464019b1ae1",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.088,37.6239,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.088,37.6239,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.893939393939394,
                "count": 264
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94545"
            }
        ]
    },
    {
        "guid": "e6f05707-4005-4300-92f5-e0c018192da3",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 62,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.807816,
                "lon": -122.271085
            },
            "entity": {
                "abbreviation": "Oakland School for the Arts",
                "alternates": {
                    "ceeb": "052410",
                    "nces": "060245810461"
                },
                "character": "Public, Magnet, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "e6f05707-4005-4300-92f5-e0c018192da3",
                "isClaimed": true,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Oakland School for the Arts",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "b42a540d-fcaa-4215-99d6-2fe916c20c44"
                },
                "premium": false,
                "shortName": "Oakland School for the Arts",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "oakland-school-for-the-arts-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 749
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "Oakland School for the Arts is an amazing community for young artists, and one I'm super grateful to have been a part of. It's definitely made for artsy kids though, rather than those looking for a lot of academic rigor. There is a lot of academic teacher turnover, but the arts teachers for the most part stay consistent and are truly the glue holding the whole operation together! Despite sort of average stats, I give OSA a high rating because of everything I gained from such an arts-friendly and supportive learning environment. The shift to online arts classes seems to be doing alright.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-12-05T20:30:35.123431Z",
                "guid": "dd81f011-bccd-4c3a-92c5-a046d9cb75cf",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.271,37.8078,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.271,37.8078,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7777777777777777,
                "count": 144
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94612"
            }
        ]
    },
    {
        "guid": "39ad4ecf-b8b2-45ea-a810-fc86ed3b0aeb",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 63,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.452449,
                "lon": -121.901071
            },
            "entity": {
                "abbreviation": "Milpitas High School",
                "alternates": {
                    "ceeb": "051978",
                    "nces": "062450003666"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "39ad4ecf-b8b2-45ea-a810-fc86ed3b0aeb",
                "isClaimed": false,
                "isPremium": false,
                "location": "Milpitas, CA",
                "name": "Milpitas High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "b8ccd5a3-a309-4782-a213-14c30671603f",
                    "schoolDistrict": "b8ccd5a3-a309-4782-a213-14c30671603f",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "aa75a24b-3877-4c8e-9029-e2332e3f1c46",
                    "zipCode": "d68bb1dd-2a50-4ac9-af5d-a8b78944d236"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Milpitas Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "b8ccd5a3-a309-4782-a213-14c30671603f",
                        "location": "Milpitas, CA",
                        "name": "Milpitas Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "aa75a24b-3877-4c8e-9029-e2332e3f1c46",
                            "zipCode": "d68bb1dd-2a50-4ac9-af5d-a8b78944d236"
                        },
                        "premium": false,
                        "shortName": "Milpitas Unified School District",
                        "tagline": [
                            "School District",
                            "Milpitas, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "milpitas-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Milpitas High School",
                "tagline": [
                    "Milpitas Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "milpitas-high-school-milpitas-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 3177
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "My overall experience with Milpitas High School has been amazing so far! I've made lots of new friends and the teachers/staff are always very kind and helpful towards others. If I ever have any problems, the teachers respond to emails quite quickly and same for my peers. Last year I joined the cross country and track team and based on all the good experiences I gained, I know I will join for the following years. The team members always support each other and the coaches always motivate and push you to be the best version of yourself. The rallies, parades, and games are also fun! It's a great way for students to bond and get to know each other better. I think even with COVID-19, the rest of my high-school years will be absolutely fantastic at Milpitas High thanks to all my friends, teammates, and teachers/staff.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-09-22T04:49:43.49904Z",
                "guid": "eea65f32-1885-47ae-ab3a-b23201a3ddde",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.902,37.4505,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.902,37.4505,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5136612021857925,
                "count": 732
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95035"
            }
        ]
    },
    {
        "guid": "bb6c7fbc-4b41-4752-8a09-c04fc20a5701",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 64,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.530313,
                "lon": -122.26674
            },
            "entity": {
                "abbreviation": "Design Tech High School",
                "alternates": {
                    "nces": "060232413774"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "bb6c7fbc-4b41-4752-8a09-c04fc20a5701",
                "isClaimed": true,
                "isPremium": false,
                "location": "Redwood City, CA",
                "name": "Design Tech High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "f063d7b2-cbfb-4b65-b8b7-03f2d9f5a9dc",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "5ca486a6-52a6-4b83-aeda-db4b437b4d7f",
                    "zipCode": "80b04c41-59c1-4587-8f7c-24efc88eaf9a"
                },
                "premium": false,
                "shortName": "Design Tech High School",
                "tagline": [
                    "Public School",
                    "Redwood City, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "design-tech-high-school-redwood-city-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 555
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 30
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Design Tech High school is a decent school. The biggest draws are the intersession system, the concurrent enrollment system, and the excellent campus. The intersession system is a two week period that happens 4 times per school year. During this time, the student takes half their day for a design thinking course and the other half for their elective course. The concurrent enrollment system allows students to freely take courses at the three local community colleges, Skyline, CSM and Cañada.  The school has some flaws mainly pertaining to student voice in the school's administration, and the lack of organized sports. Overall the teachers are passionate and provide a good explanation of their respective topics. In order to thrive at this school, it requires a good deal of self direction and motivation. If you are active and passionate, then this is a place where you can go as far as you want, just be invested in your own education and you will thrive here.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-03T02:49:00.187247Z",
                "guid": "c80ab558-638d-4ec9-a1cf-527e8c3bd6ef",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.266,37.5327,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.266,37.5327,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.611940298507463,
                "count": 67
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94065"
            }
        ]
    },
    {
        "guid": "a31c217d-9ee5-4c90-9522-1f1234ea545e",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 65,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.801892,
                "lon": -122.2696
            },
            "entity": {
                "abbreviation": "Oakland Charter High School",
                "alternates": {
                    "ceeb": "054303",
                    "nces": "060146512041"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "a31c217d-9ee5-4c90-9522-1f1234ea545e",
                "isClaimed": true,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Oakland Charter High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                },
                "premium": false,
                "shortName": "Oakland Charter High School",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "oakland-charter-high-school-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 459
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I have attended this school for almost four years. If I were to go back in time to chose I would choose it again. This school is very resourceful and prepares their students for college. The teachers and staff are very supportive and care about the students. My GPA is very high because of the college classes the school provides. Also, the school makes us feel closer by hosting something called family meeting every Friday.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-24T00:54:11.458495Z",
                "guid": "9981b090-d508-4037-be1a-beb6dc598c6f",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.266,37.8002,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.266,37.8002,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.2658227848101267,
                "count": 158
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94601"
            }
        ]
    },
    {
        "guid": "00e3330a-129d-4186-ab93-1d22c69ba222",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 66,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.473468,
                "lon": -122.203791
            },
            "entity": {
                "abbreviation": "Everest Public High School",
                "alternates": {
                    "ceeb": "054429",
                    "nces": "060133412395"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "00e3330a-129d-4186-ab93-1d22c69ba222",
                "isClaimed": true,
                "isPremium": false,
                "location": "Redwood City, CA",
                "name": "Everest Public High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "8ea61add-d9d6-43b2-8dbe-55ef0ae2ad16",
                    "schoolNetwork": "2ed1eb64-2cd2-4b6a-8f49-20b86f2fe1ca",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "eb3f69c3-e6db-4239-8979-66e40ebafe12",
                    "zipCode": "ddb2570c-2e28-493c-939e-61390b422836"
                },
                "premium": false,
                "shortName": "Everest Public High School",
                "tagline": [
                    "Public School",
                    "Redwood City, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "everest-public-high-school-redwood-city-ca-060133412395",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 409
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "I love Everest because it is highly a small school! It gives me the opportunity to reach out to my teachers, getting one on one help, and overall create relationships with them. It is definitely a college prep school where we are surrounded by my technology and playlists that help us independently study on our own. We have a tradition every year where all freshman, sophomore, junior, and seniors go on a camping trip and create community bondings! It is diverse which makes me feel more like at home since I am from East Palo Alto and not Redwood City. They give the best elective classes that are UC Approved, for example, Ethnic Studies, in which a few schools don't really include. I am in my Junior year and had spent the last 2 in a half years has an unweighted GPA of a  4.0. Everest gives all students the opportunity to be in AP classes to give them the challenge of their education. Overall, it is a great school and can't believe I am leaving in less than 2 years!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-10-25T16:24:08.890507Z",
                "guid": "bd08ae95-3afd-4497-9a3d-0b8d7f8c8255",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.203861,37.47377,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.203861,37.47377,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.497041420118343,
                "count": 169
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94063"
            }
        ]
    },
    {
        "guid": "49aa34d9-ce7d-4dd7-b8b5-f49072199903",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 67,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.963863,
                "lon": -122.344634
            },
            "entity": {
                "abbreviation": "Middle College High School",
                "alternates": {
                    "ceeb": "053204",
                    "nces": "063255009622"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "49aa34d9-ce7d-4dd7-b8b5-f49072199903",
                "isClaimed": true,
                "isPremium": false,
                "location": "San Pablo, CA",
                "name": "Middle College High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "schoolDistrict": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "09d2e73c-0f8b-4efa-9c26-447cdb858242",
                    "zipCode": "a08c6674-b67b-4d2b-976e-ac88b0619d80"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "WCCUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "a053a637-da7b-48d7-a67d-fba014c2d452",
                        "location": "Richmond, CA",
                        "name": "West Contra Costa Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                            "zipCode": "9e563e34-37ab-4fc4-b373-ed793d877060"
                        },
                        "premium": false,
                        "shortName": "West Contra Costa Unified School District",
                        "tagline": [
                            "School District",
                            "Richmond, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "west-contra-costa-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Middle College High School",
                "tagline": [
                    "West Contra Costa Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "middle-college-high-school-san-pablo-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 288
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 29
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My experience at Middle College High School is overall good. Since the students at this high school take both high school and college courses our school's location is at Contra Costa College. This makes us have a lot of places to hang out with friends and study. What I like about this school is that you can always find help if you need it and also the food the college serves, even though you have to buy it. I do wish we made more events for students like the other regular high schools. We only get one rally per semester and we also do spirit week from time to time. Ultimately, Middle College High is an excellent opportunity for students who want to get ahead of their careers and follow their dreams.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-17T01:34:13.959864Z",
                "guid": "e675fbe5-4ab3-49a2-8e46-6e51071005a8",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.339,37.9721,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.339,37.9721,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5397727272727275,
                "count": 176
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94806"
            }
        ]
    },
    {
        "guid": "2503d7af-91d7-4a04-94c2-5d389c3989f1",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 68,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.442911,
                "lon": -122.231219
            },
            "entity": {
                "abbreviation": "Woodside High School",
                "alternates": {
                    "ceeb": "053808",
                    "nces": "063639006199"
                },
                "character": "Public, Magnet",
                "claimed": false,
                "displayable": true,
                "genus": "Magnet School",
                "guid": "2503d7af-91d7-4a04-94c2-5d389c3989f1",
                "isClaimed": false,
                "isPremium": false,
                "location": "Woodside, CA",
                "name": "Woodside High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                    "schoolDistrict": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "3fd9c449-6e9c-4b39-af8c-45c1109e0846",
                    "zipCode": "7d773137-7242-4cc9-91c9-d3770c1b9f33"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                        "location": "Redwood City, CA",
                        "name": "Sequoia Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a5dafe95-b00a-4d53-8912-9559cbb65dd9",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "5ca486a6-52a6-4b83-aeda-db4b437b4d7f",
                            "zipCode": "7d773137-7242-4cc9-91c9-d3770c1b9f33"
                        },
                        "premium": false,
                        "shortName": "Sequoia Union High School District",
                        "tagline": [
                            "School District",
                            "Redwood City, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "sequoia-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Woodside High School",
                "tagline": [
                    "Sequoia Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "woodside-high-school-woodside-ca",
                "variation": 52
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1964
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "Overall I have loved my experience at Woodside High school! Transitioning from middle school to high school brought me great fear and worries but with the help of the kind and caring staff, I was able to make the best of the many resources offered on campus! I wake up every morning and look forward to school, and am proud to say woodside high school will be the high school i will be graduating from in 2023. They offer a variety of clubs and sports, fit for people of all cultures and beliefs. Teachers do an amazing job of making all classes enjoyable and as a whole an amazing learning experience. The environment is comfortable, accepting, kind and I feel as though everyone is supportive of one another.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-06-12T08:07:26.09336Z",
                "guid": "c7ae691b-5316-4bf6-b544-2004c1a34092",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.231,37.4447,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.231,37.4447,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7674418604651163,
                "count": 215
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94062"
            }
        ]
    },
    {
        "guid": "ad531361-3695-44ac-ade4-71ea8839fe66",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 69,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 38.064063,
                "lon": -122.175472
            },
            "entity": {
                "abbreviation": "Benicia High School",
                "alternates": {
                    "ceeb": "050280",
                    "nces": "060462000422"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "ad531361-3695-44ac-ade4-71ea8839fe66",
                "isClaimed": true,
                "isPremium": false,
                "location": "Benicia, CA",
                "name": "Benicia High School",
                "parentGUIDs": {
                    "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "7c21191c-eac4-441c-86d9-aee0b22405db",
                    "schoolDistrict": "7c21191c-eac4-441c-86d9-aee0b22405db",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "1f8c93ce-b789-4186-992a-b1f87cc64d9f",
                    "zipCode": "6e4e6d26-8c6c-4784-a6d0-339cc1370fcb"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Benicia Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "7c21191c-eac4-441c-86d9-aee0b22405db",
                        "location": "Benicia, CA",
                        "name": "Benicia Unified School District",
                        "parentGUIDs": {
                            "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "1f8c93ce-b789-4186-992a-b1f87cc64d9f",
                            "zipCode": "6e4e6d26-8c6c-4784-a6d0-339cc1370fcb"
                        },
                        "premium": false,
                        "shortName": "Benicia Unified School District",
                        "tagline": [
                            "School District",
                            "Benicia, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "benicia-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Benicia High School",
                "tagline": [
                    "Benicia Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "benicia-high-school-benicia-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1555
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I’m currently still going to Benicia High and the teachers are great to work with and are very supportive with trying to push us to do our best. Many opportunities to take AP’s and Honors courses as well as they provided a personal SAT Prep class during our free time. The school functions are much fun as well, there are a ton of clubs to choose from and to be apart of! One thing that I wish would be is more diversity, most of all the other schools around Benicia High are very diverse. Benicia’s highest race  has to be mostly White. To my experience, Benicia High is overall a great school with a very strong support system, friendly faces, opportunities, and fun!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-01T12:21:21.697797Z",
                "guid": "bea64c8f-d644-4b3a-bda7-4c674319719e",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.174,38.0648,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.174,38.0648,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.539325842696629,
                "count": 356
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94510"
            }
        ]
    },
    {
        "guid": "f3bb768d-086a-46d3-940f-4dc72cbfc673",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 70,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.591975,
                "lon": -122.026414
            },
            "entity": {
                "abbreviation": "James Logan High School",
                "alternates": {
                    "ceeb": "050969",
                    "nces": "062691004072"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "f3bb768d-086a-46d3-940f-4dc72cbfc673",
                "isClaimed": true,
                "isPremium": false,
                "location": "Union City, CA",
                "name": "James Logan High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "305b3896-e539-4976-95d2-a90396c3f1cf",
                    "schoolDistrict": "305b3896-e539-4976-95d2-a90396c3f1cf",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "a1a37120-c207-41c6-9193-6d1b754eb2ec",
                    "zipCode": "f865aa9f-3f3c-41d7-80c3-1df06f3db370"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "New Haven Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "305b3896-e539-4976-95d2-a90396c3f1cf",
                        "location": "Union City, CA",
                        "name": "New Haven Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "a1a37120-c207-41c6-9193-6d1b754eb2ec",
                            "zipCode": "f865aa9f-3f3c-41d7-80c3-1df06f3db370"
                        },
                        "premium": false,
                        "shortName": "New Haven Unified School District",
                        "tagline": [
                            "School District",
                            "Union City, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "new-haven-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "James Logan High School",
                "tagline": [
                    "New Haven Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "james-logan-high-school-union-city-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 3635
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "James Logan High School is one big school, almost the size of a community college. I feel like because this school is big and lots of students attend there is way much diversity. These 2 years I've been at this school have really been crazy there has been lots of challenging things but also some great things. As a community we help bring each other up and on our feet. The best thing about this school I would say are all those teachers and counselors who are always there for students. We have everything! We have great clubs and we are better know for our sports. I honestly can't imagine myself in any other high school better than James Logan. Yes, we've had our bad times at this school , good thing about all the bad stuff is that we all learn as a community what we have to do to make sure we are all safe. This school really cares about students, teachers, and staff members. We all care about each others well being. I would say this the most important part about a school.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-22T06:09:28.693785Z",
                "guid": "dc1925f3-d2f4-43e4-988a-cd30bde5aba3",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.025,37.5916,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.025,37.5916,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.810062893081761,
                "count": 795
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94587"
            }
        ]
    },
    {
        "guid": "4ffe8114-13f1-4e5d-8dd5-7ea011668a94",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 71,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.346599,
                "lon": -121.98199
            },
            "entity": {
                "abbreviation": "Santa Clara High School",
                "alternates": {
                    "ceeb": "053280",
                    "nces": "063543007868"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "4ffe8114-13f1-4e5d-8dd5-7ea011668a94",
                "isClaimed": true,
                "isPremium": false,
                "location": "Santa Clara, CA",
                "name": "Santa Clara High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                    "schoolDistrict": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "44b1c9d0-0773-4aa7-aaeb-c04dda704fc1",
                    "zipCode": "d1fd4c8f-758c-4371-b58b-7ac5e13d8df8"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Santa Clara Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                        "location": "Santa Clara, CA",
                        "name": "Santa Clara Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "44b1c9d0-0773-4aa7-aaeb-c04dda704fc1",
                            "zipCode": "d1fd4c8f-758c-4371-b58b-7ac5e13d8df8"
                        },
                        "premium": false,
                        "shortName": "Santa Clara Unified School District",
                        "tagline": [
                            "School District",
                            "Santa Clara, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "santa-clara-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Santa Clara High School",
                "tagline": [
                    "Santa Clara Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "santa-clara-high-school-santa-clara-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1967
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "As a senior, I have experienced most of what this school has to offer. I was  vice president of my class, in leadership, president of a multicultural club, a cheerleader, on the badminton team, and participated in many events. I am positive that my school is very welcoming and diverse. As a minority, I have never felt left out or not included. I was never bullied due to my disability, and on the contrary, I was everyones friend!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-18T01:42:19.075872Z",
                "guid": "aa87bee7-dcd4-4aaa-8af8-ed8b98afac0c",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.982,37.3462,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.982,37.3462,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6370235934664246,
                "count": 551
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95051"
            }
        ]
    },
    {
        "guid": "aca23908-96f7-4e0d-97ad-166afa3b31e5",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 72,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.747232,
                "lon": -122.4813
            },
            "entity": {
                "abbreviation": "Abraham Lincoln High",
                "alternates": {
                    "ceeb": "052910",
                    "nces": "063441005581"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "aca23908-96f7-4e0d-97ad-166afa3b31e5",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Abraham Lincoln High",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "45ae15e7-7755-498f-b7ee-f6f7ee80674c",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "dfff3cae-3a03-46a7-b060-62db0e2af199"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Lincoln",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "abraham-lincoln-high-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2070
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "A great high school overall with a diverse student body! Many teachers and staff members are incredibly supportive and always teach with enthusiasm. No students are left behind because there’s always helpful resources like the after school peer tutoring or the health & wellness center to help them get back to their feet. The only thing I would critique about this school is that there’s a lack of AP and honors classes, so it’s difficult to get the AP credit that you want as an ambitious student.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-06T05:50:20.82165Z",
                "guid": "2ec6e9dc-67bb-4a50-8aa3-9f70f08c5f9f",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.481,37.7464,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.481,37.7464,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.9329608938547485,
                "count": 358
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94116"
            }
        ]
    },
    {
        "guid": "54466cec-7a3e-49bf-a87c-83972e6f6b32",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 73,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.247267,
                "lon": -121.884577
            },
            "entity": {
                "abbreviation": "Pioneer High School",
                "alternates": {
                    "ceeb": "053096",
                    "nces": "063459005732"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "54466cec-7a3e-49bf-a87c-83972e6f6b32",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Pioneer High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "5750507d-5a3f-47db-a00c-b8ac64163449",
                    "parent": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "schoolDistrict": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "cfe32ecb-646c-4ac4-8146-97a3f348c00e"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SJUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                        "location": "San Jose, CA",
                        "name": "San Jose Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "0a781906-f3cb-42ec-b08b-9acfcaf63aaa",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "763f10c1-8ad0-4832-90b4-5bad39b6e93f"
                        },
                        "premium": false,
                        "shortName": "San Jose Unified School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-jose-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Pioneer High School",
                "tagline": [
                    "San Jose Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "pioneer-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1600
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I have attended High School at Pioneer for 4 years and I have had very good experience with many of the teachers so much so that I consider them as second parents. They have very good quality of education and teaching skills. I definitely recommend Pioneer High to anyone looking to graduate from middle school to high school. Personally, I was provided with various opportunities, resources, and facilities throughout the 4 year I have attended this school and I am definitely going to miss it when I graduate this summer.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-23T02:02:59.104288Z",
                "guid": "42841f4d-8ac1-40a7-97a1-bc89531c4d86",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 4
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.883,37.2472,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.883,37.2472,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6191709844559585,
                "count": 386
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95118"
            }
        ]
    },
    {
        "guid": "31a67874-0d32-40e9-af00-d9c5dd798597",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 74,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.304184,
                "lon": -121.808318
            },
            "entity": {
                "abbreviation": "Silver Creek High School",
                "alternates": {
                    "ceeb": "053100",
                    "nces": "061182001309"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "31a67874-0d32-40e9-af00-d9c5dd798597",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Silver Creek High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "8809e41c-e338-454f-bcbb-c2a7fc64460b",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "d45dfd8d-1c4a-4d14-adf5-73af66adef2a"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Silver Creek High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "silver-creek-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2435
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "There are a lot of electives here, so there's a lot of choices for students! High school is what you want it to be like. This school is nice. Campus is easy to get used to, and most teachers are there to help. My experience here was pretty good, it's just that some science classes are unbearable. However, there's plenty of opportunity to get help. There's also a bunch of clubs! There's something for everyone.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-03-13T23:14:32.947859Z",
                "guid": "8ff58d69-fdd2-444b-905f-886af46665e5",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.806,37.3044,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.806,37.3044,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6327985739750446,
                "count": 561
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95121"
            }
        ]
    },
    {
        "guid": "4affd58f-a122-4788-9c48-613cf5a6c5ed",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 75,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.773183,
                "lon": -122.289619
            },
            "entity": {
                "abbreviation": "Encinal High School",
                "alternates": {
                    "ceeb": "050015",
                    "nces": "060177000045"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "4affd58f-a122-4788-9c48-613cf5a6c5ed",
                "isClaimed": false,
                "isPremium": false,
                "location": "Alameda, CA",
                "name": "Encinal Junior/Senior High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "3bfe75ba-c072-458a-a742-96bca1544408",
                    "schoolDistrict": "3bfe75ba-c072-458a-a742-96bca1544408",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "54a953dd-3bdc-47b1-b465-0e4d3705637e",
                    "zipCode": "a2b1830b-98f1-4ebd-83e1-b3e0b4fdffcb"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "AUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "3bfe75ba-c072-458a-a742-96bca1544408",
                        "location": "Alameda, CA",
                        "name": "Alameda Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "54a953dd-3bdc-47b1-b465-0e4d3705637e",
                            "zipCode": "a2b1830b-98f1-4ebd-83e1-b3e0b4fdffcb"
                        },
                        "premium": false,
                        "shortName": "Alameda City Unified School District",
                        "tagline": [
                            "School District",
                            "Alameda, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "alameda-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Encinal High School",
                "tagline": [
                    "Alameda Unified School District, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "encinal-junior-senior-high-school-alameda-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1261
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Even though Encinal High School is located in a predominantly white city, the learning community is extremely diverse. Due to this I was not only able to obtain my education, but as well as learn the social struggles minorities and other communities go through. My classmates and friends have taught me many life lessons such as being more aware about ones privilege, the injustices that occur towards minorities, and how to better educate myself on topics that include ones race. My teachers have helped me overcome a number of social challenges that many high school students aren't able to obtain. Because of the clubs I attend I have discovered my passion of political science, in order to help communities who struggle with economic and social challenges due to the color of their skin, religion, or what they have chosen to identify as. I want to make a change and thanks to Encinal High School I have the dedication and determination to do so.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-07-12T17:43:40.168864Z",
                "guid": "8c7be176-fa58-48a4-9511-8d5683389dc1",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.289,37.7716,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.289,37.7716,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.708791208791209,
                "count": 182
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94501"
            }
        ]
    },
    {
        "guid": "aba4d7c4-7994-4e1d-a74c-23777bdecf9c",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 76,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.83161,
                "lon": -122.254359
            },
            "entity": {
                "abbreviation": "Oakland Technical High School",
                "alternates": {
                    "ceeb": "052240",
                    "nces": "062805004305"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "aba4d7c4-7994-4e1d-a74c-23777bdecf9c",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Oakland Technical High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "60b359f6-6160-41a8-9d11-3415c3143417"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Oakland Tech",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "oakland-technical-high-school-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2016
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Oakland Technical High School is a great and diverse school with 2 campuses. It can be improved in staffing and resources with materials. Overall, it has been wonderful thriving in Tech and learning all sorts of skills. The teachers help you a lot when you ask them and they are super friendly!!! If only if we have more staffs, there can be more events going on like field trips and activities in inviting professionals to class. These take a lot of time from teachers other than teaching, grading, and doing whatever they do. Furthermore, Oakland Tech gives you a feeling of home when students learn to thrive in the environment where teacher encourages students to do well. Nonetheless, Oakland Tech have many supporting resources to support students so students do not fail in school. Oakland Technical High School has been a wonderful experience with the large campus, large number of students, and wonderful staff on board in the school. It would be good if they fix the schedule of restroom.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-04-30T23:16:21.546779Z",
                "guid": "24541c34-757c-42f9-8af9-a4a5fc25371c",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.255,37.8322,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.255,37.8322,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5478260869565217,
                "count": 460
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94611"
            }
        ]
    },
    {
        "guid": "45c27add-cc9c-43c8-8849-5b83b3352ed6",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 77,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.947218,
                "lon": -121.968685
            },
            "entity": {
                "abbreviation": "CVCHS",
                "alternates": {
                    "ceeb": "050658",
                    "nces": "060234203940"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "45c27add-cc9c-43c8-8849-5b83b3352ed6",
                "isClaimed": false,
                "isPremium": false,
                "location": "Concord, CA",
                "name": "Clayton Valley Charter High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "187f89d7-6963-49c2-b924-426631dae88f",
                    "zipCode": "64ec8361-307f-4c60-8518-5e08e7cc3cb0"
                },
                "premium": false,
                "shortName": "Clayton Valley",
                "tagline": [
                    "Public School",
                    "Concord, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "clayton-valley-charter-high-school-concord-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2196
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 28
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "I love Clayton Valley so much. Due to it being a charter school, there are so many opportunities for students to pursue including specialized classes based on future career interests. The clubs are amazing and there are over 50 of them! Sports teams at Clayton Valley are impeccable and give students a shot at physically exceeding their limits. The social environment is fantastic and everyone can find their niche they feel comfortable in!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-03-22T06:30:15.376238Z",
                "guid": "9ec83a00-602a-4b93-a860-fb2dc695665d",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.969531,37.95035,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.969531,37.95035,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8536585365853657,
                "count": 164
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94521"
            }
        ]
    },
    {
        "guid": "42d7e0f2-214b-4ea9-905f-7ed4c069c361",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 78,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.607622,
                "lon": -122.095416
            },
            "entity": {
                "abbreviation": "Venture (Alternative)",
                "alternates": {
                    "ceeb": "053224",
                    "nces": "063513008976"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "42d7e0f2-214b-4ea9-905f-7ed4c069c361",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Ramon, CA",
                "name": "Venture (Alternative)",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                    "schoolDistrict": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                    "zipCode": "e8c32215-6d14-4b33-82bd-2d41b6b32206"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SRVUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                        "location": "Danville, CA",
                        "name": "San Ramon Valley Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "fcc57eee-ebde-443a-b77d-e10bbde2f779",
                            "zipCode": "bd3e7c23-836c-470d-ab71-7f4963ad582c"
                        },
                        "premium": false,
                        "shortName": "San Ramon Valley Unified School District",
                        "tagline": [
                            "School District",
                            "Danville, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-ramon-valley-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Venture (Alternative)",
                "tagline": [
                    "San Ramon Valley Unified School District, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "venture-alternative-san-ramon-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 154
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 17
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I have had a very good experience with Venture. The independent study works very well for me. At the same time, teachers are always there with support and helpful answers whenever I need it.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-02-21T20:14:55.996067Z",
                "guid": "db820dc2-3471-4b80-be61-c191153dca8d",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.905,37.7674,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.905,37.7674,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.1875,
                "count": 16
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94582"
            }
        ]
    },
    {
        "guid": "72a1d925-0ade-469c-86dd-f5cd2e95cab3",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 79,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.29296,
                "lon": -122.002377
            },
            "entity": {
                "abbreviation": "Prospect High School",
                "alternates": {
                    "ceeb": "053344",
                    "nces": "060723000673"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "72a1d925-0ade-469c-86dd-f5cd2e95cab3",
                "isClaimed": true,
                "isPremium": false,
                "location": "Saratoga, CA",
                "name": "Prospect High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "2af26fb6-2239-44b4-be58-b0e8e46b2a61",
                    "parent": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                    "schoolDistrict": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "e0be8fef-526c-4910-9500-3b4b953963dd",
                    "zipCode": "d862ebf1-2d26-4072-bc4b-528805062a62"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Campbell Union High School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                        "location": "San Jose, CA",
                        "name": "Campbell Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "5750507d-5a3f-47db-a00c-b8ac64163449",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "c051b239-374c-4f96-b426-d3be11c6ef67"
                        },
                        "premium": false,
                        "shortName": "Campbell Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "campbell-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Prospect High School",
                "tagline": [
                    "Campbell Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "prospect-high-school-saratoga-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1555
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "Overall I had a really great experience at Prospect! I was given the opportunities and resources to challenge myself academically and connect with engaging and unique teachers each year. I felt as though atmosphere of the campus improved each and every year with different opportunities to get involved in clubs, sports, and different events. With a really diverse student body, it was awesome to see how leadership and administration catered events and opportunities to appeal to different groups. I think Prospect is a great school and an environment that any student can thrive in if they put in the effort.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-29T19:14:24.412819Z",
                "guid": "6fb581ad-d86a-45df-bf52-c88b2f9c2106",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122,37.2911,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122,37.2911,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.397810218978102,
                "count": 274
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95070"
            }
        ]
    },
    {
        "guid": "7491f1de-9c1a-4ff9-8f02-278b05781b09",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 80,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 38.098507,
                "lon": -122.576736
            },
            "entity": {
                "abbreviation": "Nova Education Center",
                "alternates": {
                    "ceeb": "052171",
                    "nces": "062772004199"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "7491f1de-9c1a-4ff9-8f02-278b05781b09",
                "isClaimed": false,
                "isPremium": false,
                "location": "Novato, CA",
                "name": "Nova Education Center",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "b9ce499b-3724-477a-89d8-5d6372cb9484",
                    "schoolDistrict": "b9ce499b-3724-477a-89d8-5d6372cb9484",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "2122e23f-f26c-4604-9180-d896f31c483d",
                    "zipCode": "7cf6b53c-a89f-46d8-a63f-d6f897c0dd65"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Novato Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "b9ce499b-3724-477a-89d8-5d6372cb9484",
                        "location": "Novato, CA",
                        "name": "Novato Unified School District",
                        "parentGUIDs": {
                            "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "2122e23f-f26c-4604-9180-d896f31c483d",
                            "zipCode": "bff8a774-e3f4-4cfd-8ffa-8c5dfbf869ab"
                        },
                        "premium": false,
                        "shortName": "Novato Unified School District",
                        "tagline": [
                            "School District",
                            "Novato, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "novato-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Nova Education Center",
                "tagline": [
                    "Novato Unified School District, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "nova-education-center-novato-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 39
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 13
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "Attending this school made my final two years of high school considerably more worthwhile.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2016-07-12T23:15:17Z",
                "guid": "33730697-0de2-49b1-ae8e-a5c497b6d815",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.576,38.0983,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.576,38.0983,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.714285714285714,
                "count": 7
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94947"
            }
        ]
    },
    {
        "guid": "06400c85-92d3-4967-8461-1d604c61efaa",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 81,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.469622,
                "lon": -122.432245
            },
            "entity": {
                "abbreviation": "Half Moon Bay High School",
                "alternates": {
                    "ceeb": "051120",
                    "nces": "060678000599"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "06400c85-92d3-4967-8461-1d604c61efaa",
                "isClaimed": false,
                "isPremium": false,
                "location": "Half Moon Bay, CA",
                "name": "Half Moon Bay High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "d9dbf94b-adf8-4619-931e-ebcff1d6649f",
                    "schoolDistrict": "d9dbf94b-adf8-4619-931e-ebcff1d6649f",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "6f401739-fe70-4434-8602-b2cdb57c2074",
                    "zipCode": "cfe7994d-8a48-4529-b312-78d0deacfe27"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Cabrillo Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "d9dbf94b-adf8-4619-931e-ebcff1d6649f",
                        "location": "Half Moon Bay, CA",
                        "name": "Cabrillo Unified School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "6f401739-fe70-4434-8602-b2cdb57c2074",
                            "zipCode": "cfe7994d-8a48-4529-b312-78d0deacfe27"
                        },
                        "premium": false,
                        "shortName": "Cabrillo Unified School District",
                        "tagline": [
                            "School District",
                            "Half Moon Bay, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "cabrillo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Half Moon Bay High School",
                "tagline": [
                    "Cabrillo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "half-moon-bay-high-school-half-moon-bay-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1001
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Love the teachers here, they’re all enthusiastic about being great mentors to the students and aren’t afraid to have some fun while they’re at it! Nestled atop a small hill overlooking the ocean, I couldn’t ask for a better location.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-01-03T02:48:09.316459Z",
                "guid": "89d394a4-b831-4ac2-8e6a-4eac9ede85ab",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.428,37.4736,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.428,37.4736,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.2955974842767297,
                "count": 159
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94019"
            }
        ]
    },
    {
        "guid": "aa2d2b92-38f5-41f3-a69c-e706f0de905a",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 82,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.39836,
                "lon": -122.014546
            },
            "entity": {
                "abbreviation": "Summit Denali",
                "alternates": {
                    "nces": "060216913485"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "aa2d2b92-38f5-41f3-a69c-e706f0de905a",
                "isClaimed": true,
                "isPremium": false,
                "location": "Sunnyvale, CA",
                "name": "Summit Public School - Denali Campus",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "schoolNetwork": "2ed1eb64-2cd2-4b6a-8f49-20b86f2fe1ca",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "cd0684fb-f68d-419b-8bf5-6500062b6af5",
                    "zipCode": "dfa40734-09f2-436c-874c-ac28a0c26bdd"
                },
                "premium": false,
                "shortName": "Summit Denali",
                "tagline": [
                    "Public School",
                    "Sunnyvale, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "summit-public-school---denali-campus-sunnyvale-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 575
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Denali is a good school to choose if you’re looking for a support structure from teachers. However the students are relatively cliquey and it could be hard to make friends. In my experience Denali caters mostly to future STEM majors who plan on enrolling in a 4 year university and has little to no liberal, visual, or music arts focus. Denali also doesn’t provide sufficient resources for students who choose to take a less traditional career/after high school path, though this may change, as they’ve only had two senior classes so far. The teachers are passionate about their students and actually do care, but teacher retention is not Denali’s strong suit. Despite all this, it’s still a million times more preferable than traditional public school as there is far more support available from teachers, the school is flexible, classes are smaller, resources are easier to come by, and they teach you much more about adult life than a public school would.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-04-28T05:21:28.597487Z",
                "guid": "40e42dcf-7a0d-42fb-a3b1-f64168571ced",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.992,37.3829,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.992,37.3829,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8666666666666667,
                "count": 15
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94089"
            }
        ]
    },
    {
        "guid": "91c017ba-cf11-47ae-836e-50424f0f21c7",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 83,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.6745,
                "lon": -122.15
            },
            "entity": {
                "abbreviation": "KIPP King Collegiate High School",
                "alternates": {
                    "ceeb": "054231",
                    "nces": "060215211893"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "91c017ba-cf11-47ae-836e-50424f0f21c7",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Lorenzo, CA",
                "name": "KIPP King Collegiate High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "schoolNetwork": "a310ca2b-9585-4429-96b5-bd4924a4c483",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "e97f4f73-e7d3-41d6-a288-8114432efadc",
                    "zipCode": "5820f130-05d4-461d-b769-af76b2295d66"
                },
                "premium": false,
                "shortName": "KIPP King Collegiate High School",
                "tagline": [
                    "Public School",
                    "San Lorenzo, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "kipp-king-collegiate-high-school-san-lorenzo-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 642
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I enjoyed being in a diverse environment where it felt that my teachers were rooting for me. At KIP teachers are always willing to stay some minutes after school in order to help the students fully comprehend the lesson of the day. Similarly, I was involved in the leadership class where I was able to interact with students from all 4-grade levels as we worked to build school spirit. The school tries its best to keep students in a happy and safe environment, even through the pandemic. The teachers are constantly checking in on students' mental health to assure we are staying strong through these hard times. I would like to see improvement in the clubs and activities at school since it seems they don't get much support from the administration in order to help them grow outside of the school community. But, overall a great school!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-12-08T18:31:03.774532Z",
                "guid": "c79dc545-9bea-453c-8533-4892d2066164",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.15,37.6745,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.15,37.6745,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.644518272425249,
                "count": 301
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94580"
            }
        ]
    },
    {
        "guid": "7de9a737-3223-458b-b08c-89039a41c4b2",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 84,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.251509,
                "lon": -121.820848
            },
            "entity": {
                "abbreviation": "Summit Public School: Tahoma",
                "alternates": {
                    "ceeb": "054620",
                    "nces": "060222212625"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "7de9a737-3223-458b-b08c-89039a41c4b2",
                "isClaimed": true,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Summit Public School: Tahoma",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "078c8917-e52e-4332-af2e-2091c6f2b825",
                    "schoolNetwork": "2ed1eb64-2cd2-4b6a-8f49-20b86f2fe1ca",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "656c3aa8-650d-4f5e-97c4-2c4879faa9d3"
                },
                "premium": false,
                "shortName": "Summit Public School: Tahoma",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "summit-public-school--tahoma-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 379
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 16
                }
            ],
            "featuredReview": {
                "author": "Parent",
                "body": "During this time, trying to juggle work and being a \"parent teacher\" with virtual learning, I am grateful for the teachers, mentors, and admin staff at Summit who have developed an excellent online learning experience. While we are still trying to learn and understand the new normal of virtual learning, the platform that Summit has given parents has been amazing! I chose this school for my son because of the small environment, mentorship and academic programs, and I believe that my son will be well prepared when he graduates in 4 years. We are happy with our experiences thus far and I am sure there are other parents that feel the same way!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-12-20T07:29:15.076296Z",
                "guid": "af48c9a4-c244-4251-9dea-e8336aa9556a",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.82,37.2539,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.82,37.2539,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.175438596491228,
                "count": 57
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95123"
            }
        ]
    },
    {
        "guid": "f1f0da22-aae0-4028-9679-e5f50bd2c03a",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 85,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.680399,
                "lon": -121.761459
            },
            "entity": {
                "abbreviation": "Livermore High School",
                "alternates": {
                    "ceeb": "051425",
                    "nces": "062211002630"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "f1f0da22-aae0-4028-9679-e5f50bd2c03a",
                "isClaimed": true,
                "isPremium": false,
                "location": "Livermore, CA",
                "name": "Livermore High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "19cd8fd6-2e3f-4241-bb82-be4e992de8bf",
                    "schoolDistrict": "19cd8fd6-2e3f-4241-bb82-be4e992de8bf",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "fc27d7f3-833b-4d0b-bced-8aa3c3c99758",
                    "zipCode": "0a020eaf-ab20-4a50-8308-d60ca74bd07f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Livermore Valley Joint Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "19cd8fd6-2e3f-4241-bb82-be4e992de8bf",
                        "location": "Livermore, CA",
                        "name": "Livermore Valley Joint Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "fc27d7f3-833b-4d0b-bced-8aa3c3c99758",
                            "zipCode": "c06482ed-5084-4a24-95f9-0ab50e7042b2"
                        },
                        "premium": false,
                        "shortName": "Livermore Valley Joint Unified School District",
                        "tagline": [
                            "School District",
                            "Livermore, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "livermore-valley-joint-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Livermore High School",
                "tagline": [
                    "Livermore Valley Joint Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "livermore-high-school-livermore-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1878
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Livermore High is an amazing school. The teachers are supportive and, for the most part, enjoyable and kind. The sports are fun and they bring the student body together. Life at school wouldn’t be the same without them. The coaches are amazing and some of the nicest people I have met. Everyone wants you to succeed at Livermore High, and you can find help no matter who you are. There is almost no bullying at Livermore High either. The students are friendly and kind to one another. Every student can’t find a place at Livermore High. My high school experience has been great so far. However, I do not agree with our school district’s handling of online school. The amount of time we spend in class doesn’t feel sufficient and I worry for my quality of education at times. Overall, the school is amazing.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-01T06:18:39.347595Z",
                "guid": "a862eca2-b1eb-4ad7-b506-641adf56a972",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.76,37.6811,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.76,37.6811,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.643410852713178,
                "count": 387
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94550"
            }
        ]
    },
    {
        "guid": "a15a9e44-9760-42e4-911f-3b8856d6b4d1",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 86,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.966602,
                "lon": -122.066572
            },
            "entity": {
                "abbreviation": "College Park High School",
                "alternates": {
                    "ceeb": "050659",
                    "nces": "062637003941"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "a15a9e44-9760-42e4-911f-3b8856d6b4d1",
                "isClaimed": false,
                "isPremium": false,
                "location": "Pleasant Hill, CA",
                "name": "College Park High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "schoolDistrict": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "454e8dd6-f26e-4493-a281-1f2250e8bae9",
                    "zipCode": "c02f3379-b7e4-421d-8daf-40132890b3fd"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "MDUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                        "location": "Concord, CA",
                        "name": "Mt. Diablo Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "187f89d7-6963-49c2-b924-426631dae88f",
                            "zipCode": "fca2caaa-dbcc-472c-be69-c07f58b2a359"
                        },
                        "premium": false,
                        "shortName": "Mt. Diablo Unified School District",
                        "tagline": [
                            "School District",
                            "Concord, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mt-diablo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "College Park High",
                "tagline": [
                    "Mt. Diablo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "college-park-high-school-pleasant-hill-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2036
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "College park is an excellent school, yet sometimes lacking in Administrative competence. The teachers are mostly excellent, with some outliers pulling the mean down. Overall, in my four years I have enjoyed attending College Park High School!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-09-15T16:44:37.44767Z",
                "guid": "78151782-cc5d-435f-ac64-c188f82bd3de",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.072,37.9645,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.072,37.9645,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5165165165165164,
                "count": 333
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94523"
            }
        ]
    },
    {
        "guid": "5ce2c4d8-a058-4e37-85ac-c5ec1ad2aabd",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 87,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.777823,
                "lon": -122.492095
            },
            "entity": {
                "abbreviation": "George Washington High",
                "alternates": {
                    "ceeb": "052950",
                    "nces": "063441005617"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "5ce2c4d8-a058-4e37-85ac-c5ec1ad2aabd",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "George Washington High",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "17498cb5-11d4-482c-8bb3-a9dad794c27e",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "095d8179-e190-4e1d-a747-e79c35d38d3c"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "George Washington High",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "george-washington-high-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1995
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Many uprising high school students living in San Francisco would try their best to get into Lowell High School but I wished to get into George Washington High School. This school might not be the best high school in the city but the school itself is wonderful. First off, all the teachers desperately want the best for their students. Teachers wanted students to have the best resources and provide it to students if they don't have the right resources. Teachers checkup on students to see if they're doing well mentally or physically. There's also a great college and career center at this school. The staffs want students to be admitted to their dream schools. They hold workshops which teach students about college admission essays, SAT and ACT, scholarships, future careers, and etc. Overall, this school provides a great environment for me to study and pursue my future dreams.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-22T07:18:55.451399Z",
                "guid": "5e746304-d3f1-4e6c-abdb-07ab6fb9c860",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.491,37.7777,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.491,37.7777,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6393034825870645,
                "count": 402
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94121"
            }
        ]
    },
    {
        "guid": "9a1cd067-22a0-4cd7-8b79-6d2186f0f9a0",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 88,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.664089,
                "lon": -122.442383
            },
            "entity": {
                "abbreviation": "El Camino High School",
                "alternates": {
                    "ceeb": "053413",
                    "nces": "063753006342"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "9a1cd067-22a0-4cd7-8b79-6d2186f0f9a0",
                "isClaimed": false,
                "isPremium": false,
                "location": "South San Francisco, CA",
                "name": "El Camino High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "41a0969a-227f-49e4-989c-cce558a6963c",
                    "schoolDistrict": "41a0969a-227f-49e4-989c-cce558a6963c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "64832fba-4ed7-403d-a9bb-3c8c5210d64c",
                    "zipCode": "8c664451-0242-437f-a6d9-d577f9b17d9e"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "South San Francisco Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "41a0969a-227f-49e4-989c-cce558a6963c",
                        "location": "South San Francisco, CA",
                        "name": "South San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "64832fba-4ed7-403d-a9bb-3c8c5210d64c",
                            "zipCode": "8c664451-0242-437f-a6d9-d577f9b17d9e"
                        },
                        "premium": false,
                        "shortName": "South San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "South San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "south-san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "El Camino High School",
                "tagline": [
                    "South San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "el-camino-high-school-south-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1267
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "My experience at El Camino High School overall was a positive experience. I expected going from a small middle school to a high school with tons of kids was going to be difficult, however, high school was enjoyable for the most part. There were many opportunities available for students to succeed such as extra tutoring hours, clubs, and sports. I chose to participate in Badminton and Tennis which I learned teamwork. In addition, becoming Animal Club president showed me what leadership is like. I had some helpful teachers throughout my years, however, there were certain ones that negatively impacted my personal experience. Every school has their flaws, however, El Camino High School could have handled certain situations better. Safety did not seem like their top concern by any means.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-06-15T07:12:47.202783Z",
                "guid": "e30f306e-51a5-45b2-9ce5-6cddf2e04173",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.442,37.6666,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.442,37.6666,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5974025974025974,
                "count": 308
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94080"
            }
        ]
    },
    {
        "guid": "fa0c47ef-b845-4f0d-9cfc-165b25f41ca9",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 89,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.316555,
                "lon": -121.992486
            },
            "entity": {
                "abbreviation": "KIPP San Jose Collegiate",
                "alternates": {
                    "ceeb": "054377",
                    "nces": "060204712236"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "fa0c47ef-b845-4f0d-9cfc-165b25f41ca9",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "KIPP San Jose Collegiate",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "2af26fb6-2239-44b4-be58-b0e8e46b2a61",
                    "schoolNetwork": "a310ca2b-9585-4429-96b5-bd4924a4c483",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "ca7b746e-cd3c-474a-a264-ac5c6e4ff339"
                },
                "premium": false,
                "shortName": "KIPP San Jose Collegiate",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "kipp-san-jose-collegiate-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 530
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My experience at KIPP was pleasant for the most part. Coming in and being one of the few new students added to a class that was basically with each other for their whole elementary and middle school years, I was scared of being an outcast. Though entering in, it was the exact opposite! I learned from many people from that school, not just being teachers, but students as well. The only thing I wish could've been better was how strict they were for some things, but besides that, I'm glad I had an opportunity to be in a school like this one. If I had the chance to choose from the beginning, I'd gladly do it all over again.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-28T21:42:16.754701Z",
                "guid": "5f051dae-d1cc-4a72-bd42-842ee25d5933",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.86,37.3693,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.86,37.3693,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6413793103448278,
                "count": 145
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95133"
            }
        ]
    },
    {
        "guid": "0df1ba4f-0d20-4b44-8cbb-41820ecb6920",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 90,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.954554,
                "lon": -121.80205
            },
            "entity": {
                "abbreviation": "Dozier-Libbey Medical High School",
                "alternates": {
                    "ceeb": "054355",
                    "nces": "060285012278"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "0df1ba4f-0d20-4b44-8cbb-41820ecb6920",
                "isClaimed": false,
                "isPremium": false,
                "location": "Antioch, CA",
                "name": "Dozier-Libbey Medical High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                    "schoolDistrict": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                    "zipCode": "a67a738f-0765-4797-b0e3-4c395ccd760b"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Antioch Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                        "location": "Antioch, CA",
                        "name": "Antioch Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                            "zipCode": "2026ed1b-602c-43a5-859e-4d5b3ed7410b"
                        },
                        "premium": false,
                        "shortName": "Antioch Unified School District",
                        "tagline": [
                            "School District",
                            "Antioch, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "antioch-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Dozier-Libbey Medical High School",
                "tagline": [
                    "Antioch Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "dozier-libbey-medical-high-school-antioch-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 713
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 27
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "This school gives you a fundamental background to what medical school will be like, making it an ideal place for future health professionals. The teachers care for their students and with the small classrooms, it is easy to build a positive relationship with each of your teachers. Additionally, this school will prepare for college and possibly give students an advantage with the integrated projects the school does. Overall, this school does a fantastic job in preparing students for the work force and giving students the opportunity  to demonstrate their skills they have acquired at Dozier-Libbey Medical High School!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-21T04:58:11.224062Z",
                "guid": "301eff13-226c-40b2-bef7-f1bf98621344",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.768,37.9481,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.768,37.9481,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.859872611464968,
                "count": 314
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94531"
            }
        ]
    },
    {
        "guid": "12b43c01-b486-47a8-b270-627f2d8c103f",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 91,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 38.090666,
                "lon": -122.571868
            },
            "entity": {
                "abbreviation": "Novato High School",
                "alternates": {
                    "ceeb": "052170",
                    "nces": "062772004191"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "12b43c01-b486-47a8-b270-627f2d8c103f",
                "isClaimed": false,
                "isPremium": false,
                "location": "Novato, CA",
                "name": "Novato High School",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "b9ce499b-3724-477a-89d8-5d6372cb9484",
                    "schoolDistrict": "b9ce499b-3724-477a-89d8-5d6372cb9484",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "2122e23f-f26c-4604-9180-d896f31c483d",
                    "zipCode": "7cf6b53c-a89f-46d8-a63f-d6f897c0dd65"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Novato Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "b9ce499b-3724-477a-89d8-5d6372cb9484",
                        "location": "Novato, CA",
                        "name": "Novato Unified School District",
                        "parentGUIDs": {
                            "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "2122e23f-f26c-4604-9180-d896f31c483d",
                            "zipCode": "bff8a774-e3f4-4cfd-8ffa-8c5dfbf869ab"
                        },
                        "premium": false,
                        "shortName": "Novato Unified School District",
                        "tagline": [
                            "School District",
                            "Novato, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "novato-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Novato High School",
                "tagline": [
                    "Novato Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "novato-high-school-novato-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1410
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "I am a current junior at Novato High School and a student in the Marin School of the Arts Program.  In the past three years, I've experienced changes in administration that have both benefitted our campus and caused detrimental effects on student life and overall cooperation.  I believe that the arts is NHS's number 1 aspect while a close number 2 would be our strive for wellness on campus.  We have established many resources, specifically an East Annex that is dedicated to helping students overcome mental, physical, and other issues.  On the other hand, there is a large population of students who don't see school and academics as a priority.  I feel that our school is lacking in the particular resources needed to help these students.  Our school does not seem to have any students in the middle; we are either great academically or doing poorly, and I believe that our school should work harder on providing the necessary support for the latter group of students.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-11-14T22:33:41.791419Z",
                "guid": "ca2fca55-ecfa-4ce6-a0d5-0289a2cfe99b",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.572,38.0894,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.572,38.0894,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6444444444444444,
                "count": 450
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94947"
            }
        ]
    },
    {
        "guid": "4b3e8c21-c99b-492c-b382-834be47b376d",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 92,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.803381,
                "lon": -122.42395
            },
            "entity": {
                "abbreviation": "Galileo High School",
                "alternates": {
                    "ceeb": "052945",
                    "nces": "063441005612"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "4b3e8c21-c99b-492c-b382-834be47b376d",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Galileo High School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "963a82de-5229-4167-b80d-0b231bb94570",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "a2266d23-e1e6-4459-a631-2eeb3e801498"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Galileo High School",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "galileo-high-school-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1816
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "At 1150 Francisco St, San Francisco, CA 94109, there are two educational facilities. The first one consists mostly of the classrooms and the second one across the street contains the giant football field and gyms. These two combined make the Galileo High School.  It is a great school with a chill environment. Varsity and diversity are key through the school. It can be shown by the diverse students, teachers, classes, level of classes, clubs, sports, etc. The teachers prioritize efficient ways of teaching with the students to prepare them for college. Interactions and communication between teacher and students and student to the student are key in the classroom environment. The teachers and staffs help monitor the safety and well-being of the students and provide them with the assistance that they need. After all, it's like a community where people keep themselves and accountable for their actions. It is a place to learn something new and have fun at the same time. I enjoy the school.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-11-18T21:44:02.264964Z",
                "guid": "afd8dbd0-cdc6-4f08-938a-d7abaf00edc1",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.424,37.8039,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.424,37.8039,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.540755467196819,
                "count": 503
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94109"
            }
        ]
    },
    {
        "guid": "807db1e5-a628-48d2-b403-58fe8b5bcf35",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 93,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.25783,
                "lon": -121.830965
            },
            "entity": {
                "abbreviation": "Santa Teresa High School",
                "alternates": {
                    "ceeb": "053106",
                    "nces": "061182001308"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "807db1e5-a628-48d2-b403-58fe8b5bcf35",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Santa Teresa High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "078c8917-e52e-4332-af2e-2091c6f2b825",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "656c3aa8-650d-4f5e-97c4-2c4879faa9d3"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Santa Teresa High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "santa-teresa-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2145
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I loved my experience in high school because of the teachers I had! You could tell that they're incredibly passionate about teaching and that they genuinely care about their students. If you didn't understand something, teachers would patiently explain it to you, which made it easier to reach out for help. The only problem with the school is that there are vaping issues. I hope it gets resolved soon! It bothers me whenever I find out that a person vapes because we've been told our whole life that drugs are detrimental to a person's health, yet people still do it.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-10-19T19:27:30.306904Z",
                "guid": "5d62d753-1a6e-4d2d-a4bf-3abb00a80043",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.829,37.2356,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.829,37.2356,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.50561797752809,
                "count": 445
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95123"
            }
        ]
    },
    {
        "guid": "dbd24caf-3ac4-4271-9c2b-e5368adbe71a",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 95,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 38.00253,
                "lon": -122.134033
            },
            "entity": {
                "abbreviation": "Alhambra Senior High School",
                "alternates": {
                    "ceeb": "051915",
                    "nces": "062403003612"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "dbd24caf-3ac4-4271-9c2b-e5368adbe71a",
                "isClaimed": false,
                "isPremium": false,
                "location": "Martinez, CA",
                "name": "Alhambra Senior High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "bb309258-c416-4193-9d2e-072248ea2ba6",
                    "schoolDistrict": "bb309258-c416-4193-9d2e-072248ea2ba6",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "5aa2a0dd-3537-4cd9-817a-24409c06ce5d",
                    "zipCode": "2c9a56d6-f5d7-43ae-90db-4fab4497e4a2"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Martinez Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "bb309258-c416-4193-9d2e-072248ea2ba6",
                        "location": "Martinez, CA",
                        "name": "Martinez Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "5aa2a0dd-3537-4cd9-817a-24409c06ce5d",
                            "zipCode": "2c9a56d6-f5d7-43ae-90db-4fab4497e4a2"
                        },
                        "premium": false,
                        "shortName": "Martinez Unified School District",
                        "tagline": [
                            "School District",
                            "Martinez, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "martinez-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Alhambra Senior High School",
                "tagline": [
                    "Martinez Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "alhambra-senior-high-school-martinez-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1232
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Parent",
                "body": "Small town community where everyone knows everyone. Parents group together with the teachers to make sure the students are receiving all the resources possible. Great football team, lots of spirit and the marching band is cool too!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-09-17T17:20:00.218328Z",
                "guid": "2684f245-4b55-44d4-bec4-16eb1393c697",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.134,38.0018,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.134,38.0018,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6373626373626373,
                "count": 182
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94553"
            }
        ]
    },
    {
        "guid": "ca3b4420-08ee-4a07-8f99-b9148e9d5929",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 96,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.935376,
                "lon": -122.070431
            },
            "entity": {
                "abbreviation": "Horizons Alternative School",
                "alternates": {
                    "nces": "062637009946"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "ca3b4420-08ee-4a07-8f99-b9148e9d5929",
                "isClaimed": false,
                "isPremium": false,
                "location": "Pleasant Hill, CA",
                "name": "Horizons School: Independent Study",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "schoolDistrict": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "454e8dd6-f26e-4493-a281-1f2250e8bae9",
                    "zipCode": "c02f3379-b7e4-421d-8daf-40132890b3fd"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "MDUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                        "location": "Concord, CA",
                        "name": "Mt. Diablo Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "187f89d7-6963-49c2-b924-426631dae88f",
                            "zipCode": "fca2caaa-dbcc-472c-be69-c07f58b2a359"
                        },
                        "premium": false,
                        "shortName": "Mt. Diablo Unified School District",
                        "tagline": [
                            "School District",
                            "Concord, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mt-diablo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Horizons Alternative School",
                "tagline": [
                    "Mt. Diablo Unified School District, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "horizons-school--independent-study-pleasant-hill-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 155
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 11
                }
            ],
            "featuredReview": {
                "author": "Freshman",
                "body": "Horizons Independent Study School provides outstanding opportunities for students who (1) can't go to regular school because of other commitments (e.g., sports); (2) want to finish school faster; or (3) don't like going to regular school. Each student at Horizons gets an individual advisor who helps you through the year. Advisors are wonderful: very knowledgeable and caring! You get free help for math! Plus you can complete courses at the local community college earning college and high school credits at the same time.  Love it.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-01-25T16:41:20.608285Z",
                "guid": "5c7b17ee-c9df-42c6-8c91-d49882e6fa12",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.068,37.9336,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.068,37.9336,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.388888888888889,
                "count": 18
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94523"
            }
        ]
    },
    {
        "guid": "a7a8cdf5-2b83-4e57-90b9-174fc1df17fe",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 97,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.626972,
                "lon": -122.420346
            },
            "entity": {
                "abbreviation": "Capuchino High School",
                "alternates": {
                    "ceeb": "052810",
                    "nces": "063498005921"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "a7a8cdf5-2b83-4e57-90b9-174fc1df17fe",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Bruno, CA",
                "name": "Capuchino High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "schoolDistrict": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "501fa4d3-c95b-4be7-8f45-a278b79ec201",
                    "zipCode": "2747e85f-3e2c-4bb8-a767-725ae14708a4"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SMUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                        "location": "San Mateo, CA",
                        "name": "San Mateo Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "2e248a4c-74bf-4d82-8538-a83219eb322b",
                            "zipCode": "3435a379-835e-44ad-a67d-683bc7ef6fc8"
                        },
                        "premium": false,
                        "shortName": "San Mateo Union High School District",
                        "tagline": [
                            "School District",
                            "San Mateo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-mateo-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Capuchino High School",
                "tagline": [
                    "San Mateo Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "capuchino-high-school-san-bruno-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1187
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Campus is beautiful, great administration, mediocre food, and debatable language and math department. Students also frequently trash the place during lunch. Regarding teachers, the Spanish teachers really didn't know fluent language and one of them even though speaking only Spanish in a Spanish 1 class would be a good idea, obviously not. Math wise, some teach passionately, others only give a 5min lecture then move to worksheets and textbook work for the rest of class. Decent school, not much competition academically. Only caveat is no AP courses are really offered, only IB.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-30T05:58:39.160648Z",
                "guid": "246495b3-4825-40f0-9158-ccfb0bb181d0",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.406,37.6101,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.406,37.6101,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7670454545454546,
                "count": 352
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94066"
            }
        ]
    },
    {
        "guid": "70433fb5-73db-42fa-97b0-310abdc83968",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 98,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.345743,
                "lon": -121.809861
            },
            "entity": {
                "abbreviation": "Summit Public School: Rainier",
                "alternates": {
                    "ceeb": "054621",
                    "nces": "060174912769"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "70433fb5-73db-42fa-97b0-310abdc83968",
                "isClaimed": true,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Summit Public School: Rainier",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "259502ce-bdc7-4b71-89e6-a525fa78a771",
                    "schoolNetwork": "2ed1eb64-2cd2-4b6a-8f49-20b86f2fe1ca",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "5be5c65e-b5cd-43bf-91dc-4e9af8c6c1f0"
                },
                "premium": false,
                "shortName": "Summit Public School: Rainier",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "summit-public-school--rainier-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 362
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 14
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My parents enrolled me into this school during my Junior year as my GPA was far below UC/CSU expectations and I needed clear guidance for my future (I couldn't talk to my counselor as much as I would've liked at my previous school because of the school's population). I was reluctant at first, mainly because I wouldn't be able to see my friends as much. But after almost 2 years at this school, I appreciate my parents' decision immensely. \n\nThis school provided me the opportunity for a 2nd chance. With its small mentor group system and college-like schedule, I was able to dramatically increase my GPA and learn a lot more about college. Due to the school's small population (400), I felt a lot more comfortable with the school's culture compared to my previous school. \n\nMy only problem with this high-school is it's campus size. Although I do like the small population, the compact campus makes facilities (restrooms specifically, we only have 1 facility) a lot more busy.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-03-12T04:35:22.731545Z",
                "guid": "9b366ca2-e823-4c81-86b8-8b8db2cf5c30",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.808,37.3462,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.808,37.3462,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.857142857142857,
                "count": 63
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95127"
            }
        ]
    },
    {
        "guid": "af972b70-69de-4320-85a4-d5873a298abe",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 99,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.486615,
                "lon": -122.210549
            },
            "entity": {
                "abbreviation": "Summit Preparatory Charter High School",
                "alternates": {
                    "ceeb": "053878",
                    "nces": "060228711981"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "af972b70-69de-4320-85a4-d5873a298abe",
                "isClaimed": true,
                "isPremium": false,
                "location": "Redwood City, CA",
                "name": "Summit Preparatory Charter High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "6ea4b2c4-b8ad-4bfd-a750-a048a992eae3",
                    "schoolNetwork": "2ed1eb64-2cd2-4b6a-8f49-20b86f2fe1ca",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "5ca486a6-52a6-4b83-aeda-db4b437b4d7f",
                    "zipCode": "ddb2570c-2e28-493c-939e-61390b422836"
                },
                "premium": false,
                "shortName": "Summit Preparatory Charter High School",
                "tagline": [
                    "Public School",
                    "Redwood City, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "summit-preparatory-charter-high-school-redwood-city-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 454
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "My overall experience at this charter high school was like watching the continuation of a tv show that started off good but got more and more boring after the second season. Unlike a typical high school, we don't have pep rallies, football, a cafeteria, exams nor finals, or even a proper office. But we do have exactly 18 classrooms, about 400 students, and everyone has about 80 10-question quizzes to complete every year because we don't have exams or finals. This school is meant to prepare students for college, so we get a lot of help throughout the four years of high school. High school drama here isn't too crazy, but because it's such a small building, rumors get around quickly which eventually just gets annoying. Mostly all of the teachers of assistant teachers at this school are very intelligent, young, and passionate about their careers! This to me is great because I noticed it motivated us to achieve our goals and is easy to communicate with them!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-07T09:55:07.065432Z",
                "guid": "0f1cdb6a-2729-4ee9-94c1-fe8f4bb841a6",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.21,37.4865,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.21,37.4865,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.566666666666667,
                "count": 120
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94063"
            }
        ]
    },
    {
        "guid": "01f01b7c-7ad8-4235-b232-6f94c553fd3c",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 100,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.328465,
                "lon": -121.922915
            },
            "entity": {
                "abbreviation": "Abraham Lincoln High School",
                "alternates": {
                    "ceeb": "053075",
                    "nces": "063459005696"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "01f01b7c-7ad8-4235-b232-6f94c553fd3c",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Abraham Lincoln High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "4ad16957-e01a-4f4f-bd3b-64a65188eb18",
                    "parent": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "schoolDistrict": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "bf537caa-7876-4936-b0a8-98add2dd3610"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SJUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                        "location": "San Jose, CA",
                        "name": "San Jose Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "0a781906-f3cb-42ec-b08b-9acfcaf63aaa",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "763f10c1-8ad0-4832-90b4-5bad39b6e93f"
                        },
                        "premium": false,
                        "shortName": "San Jose Unified School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-jose-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Abraham Lincoln High School",
                "tagline": [
                    "San Jose Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "abraham-lincoln-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1805
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Parent",
                "body": "My three children have attended this school. We have been happy and would recommend it. There are excellent AP courses with good support, engaging clubs, and my kids were able to participate in the arts and athletics. This included juried contests, national performances, CCS finals as well as championships—so not just participation but opportunities to excel. My kids had opportunities at selective universities as did their classmates: UCLA, Naval Academy, Harvard, UC Berkeley, Brown, Georgetown, in addition to all the other UCs, many at Cal Poly and other CSUs. Santa Clara, Chapman and Lewis Clark are some of the other privates schools attended. Some students take the community college route for various reasons but there is support no matter your path. Now their friends are in graduate school including MIT, Brown and Stanford! Go Lions!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-03-16T19:29:00.593236Z",
                "guid": "66e4804e-daa1-44fc-832e-9d5aeda3a900",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.924,37.3277,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.924,37.3277,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8322784810126582,
                "count": 316
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95126"
            }
        ]
    },
    {
        "guid": "dd41a557-98bb-4bf1-9dc1-f1c738ad657c",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 101,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 38.119161,
                "lon": -122.609121
            },
            "entity": {
                "abbreviation": "San Marin High School",
                "alternates": {
                    "ceeb": "052172",
                    "nces": "062772004196"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "dd41a557-98bb-4bf1-9dc1-f1c738ad657c",
                "isClaimed": false,
                "isPremium": false,
                "location": "Novato, CA",
                "name": "San Marin High School",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "b9ce499b-3724-477a-89d8-5d6372cb9484",
                    "schoolDistrict": "b9ce499b-3724-477a-89d8-5d6372cb9484",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "2122e23f-f26c-4604-9180-d896f31c483d",
                    "zipCode": "bff8a774-e3f4-4cfd-8ffa-8c5dfbf869ab"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Novato Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "b9ce499b-3724-477a-89d8-5d6372cb9484",
                        "location": "Novato, CA",
                        "name": "Novato Unified School District",
                        "parentGUIDs": {
                            "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "2122e23f-f26c-4604-9180-d896f31c483d",
                            "zipCode": "bff8a774-e3f4-4cfd-8ffa-8c5dfbf869ab"
                        },
                        "premium": false,
                        "shortName": "Novato Unified School District",
                        "tagline": [
                            "School District",
                            "Novato, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "novato-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "San Marin High School",
                "tagline": [
                    "Novato Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "san-marin-high-school-novato-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1135
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "I have had a wonderful experience thus far at San Marin. Most of my teachers have been great, and my counselor is very helpful. The school makes an active effort to be inclusive and progressive. There are lots of clubs. My only negative experience is with the Physical Education requirements. I play three sports at San Marin, but because I am technically underweight and not flexible, I had to take a second year of PE. I play volleyball, soccer, and track and field. I love playing sports, but I should be exempt from PE for the sheer amount of sports seasons I have played in and because I am healthy and driven.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-19T19:23:55.958306Z",
                "guid": "5a69c6f3-851f-4ee5-9d7a-f7aeb70dd82d",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.611,38.1201,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.611,38.1201,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.673469387755102,
                "count": 147
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94945"
            }
        ]
    },
    {
        "guid": "d29787e1-52ab-4a40-be48-0485422c740e",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 102,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.905439,
                "lon": -122.294418
            },
            "entity": {
                "abbreviation": "El Cerrito Senior High School",
                "alternates": {
                    "ceeb": "050815",
                    "nces": "063255005022"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "d29787e1-52ab-4a40-be48-0485422c740e",
                "isClaimed": true,
                "isPremium": false,
                "location": "El Cerrito, CA",
                "name": "El Cerrito High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "schoolDistrict": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "f343dc53-cb24-4991-838e-fd06781600a8",
                    "zipCode": "5c0d439b-7e68-4d4e-ac7b-5c3008345353"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "WCCUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "a053a637-da7b-48d7-a67d-fba014c2d452",
                        "location": "Richmond, CA",
                        "name": "West Contra Costa Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                            "zipCode": "9e563e34-37ab-4fc4-b373-ed793d877060"
                        },
                        "premium": false,
                        "shortName": "West Contra Costa Unified School District",
                        "tagline": [
                            "School District",
                            "Richmond, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "west-contra-costa-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "El Cerrito Senior High School",
                "tagline": [
                    "West Contra Costa Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "el-cerrito-high-school-el-cerrito-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1506
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "The best part of El Cerrito High School is that making friends was easy. There are so many people here that share my interests and academic level. I have also found it easy to trust my teachers with my personal life and struggles that may be going on. If I were to change one thing, it'd would be class availability . Sometimes I find it hard to get into the classes I need to take to challenge myself. I would also change the school spirit. We tend not to be very excited about rallies, school fundraisers, and other events. I wish people wanted to participate in our school's community more.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-06-22T21:35:56.518463Z",
                "guid": "a068cad0-e3f0-4cd1-95b8-85aa0bd5cfc3",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.295,37.9075,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.295,37.9075,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.617021276595745,
                "count": 282
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94530"
            }
        ]
    },
    {
        "guid": "da04ed2b-2d15-4e10-a010-1f7c61a47e3a",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 103,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.722069,
                "lon": -122.439765
            },
            "entity": {
                "abbreviation": "Balboa High School",
                "alternates": {
                    "ceeb": "052916",
                    "nces": "063441005587"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "da04ed2b-2d15-4e10-a010-1f7c61a47e3a",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Balboa High School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "95c0370c-58af-428a-98dc-478e22f3237b",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "61413703-2cce-42b9-a718-b28b79a1680f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Balboa High School",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "balboa-high-school-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1217
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "As an upcoming graduate of Balboa, I can say that it has its ups and downs. Although I picked this school as my first choice, I can say that it's not really the best school ever. It's however a good school though! A pro of Balboa is the diversity there. With the diversity there, you can be able to make any friends that are from different cultures. Another pro is that we have a pathway system, which can help us enhance our career skills and explore our options in the future. The last pro is that there is a college room, so we're able to receive the support we need for colleges. However, I can say it has it's own cons too. There is a lack of AP classes. I got a chance to take 3 AP classes overall, I wish that there were more. I know it's a pathway school and because of that, it interferes with our schedule to pick any AP classes. Overall, I recommend this school despite it's cons!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-12-31T02:32:28.291384Z",
                "guid": "1f2b3208-23de-4357-a4da-345dd639ae77",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.441,37.721,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.441,37.721,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.63265306122449,
                "count": 245
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94112"
            }
        ]
    },
    {
        "guid": "35ffca2b-185c-4b47-84c9-555891f8ba1a",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 104,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.316555,
                "lon": -121.992486
            },
            "entity": {
                "abbreviation": "Independence High School",
                "alternates": {
                    "ceeb": "053087",
                    "nces": "061182001302"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "35ffca2b-185c-4b47-84c9-555891f8ba1a",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Independence High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "2af26fb6-2239-44b4-be58-b0e8e46b2a61",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "ca7b746e-cd3c-474a-a264-ac5c6e4ff339"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Independence High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "independence-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2872
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "Independence High has a huge campus, causing students to get lost all the time. However, it is exciting to explore different parts of the school! At this high school, I was was able to experience many things. I joined clubs and even performed in rallies. My first performance was for Korean Club at the Homecoming rally, which got famous among other K-pop fans around the world. I also performed for Ukulele Club at the Multi-cultural rally, where we sung Hawaiian songs, both in English and Hawaiian language. It was amazing to see other cultural performances and more! Independence High has a cultural diversity, which allows the staff and students to support and respect each other.  Most people at this school are genuinely kind and friendly!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-30T06:24:24.980539Z",
                "guid": "bf69a95d-a528-4eae-9938-7b784e92bf5a",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.858,37.3689,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.858,37.3689,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6399491094147582,
                "count": 786
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95133"
            }
        ]
    },
    {
        "guid": "8e797e44-c21f-4267-b2c3-e36cba8e034a",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 105,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.528436,
                "lon": -121.983044
            },
            "entity": {
                "abbreviation": "John F. Kennedy High School",
                "alternates": {
                    "ceeb": "050966",
                    "nces": "061440001672"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "8e797e44-c21f-4267-b2c3-e36cba8e034a",
                "isClaimed": false,
                "isPremium": false,
                "location": "Fremont, CA",
                "name": "John F. Kennedy High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "schoolDistrict": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "36041593-134d-436a-b83b-4c4244f6a447",
                    "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                        "location": "Fremont, CA",
                        "name": "Fremont Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "36041593-134d-436a-b83b-4c4244f6a447",
                            "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                        },
                        "premium": false,
                        "shortName": "Fremont Unified School District",
                        "tagline": [
                            "School District",
                            "Fremont, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "John F. Kennedy High School",
                "tagline": [
                    "Fremont Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "john-f-kennedy-high-school-fremont-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1292
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "I liked my experience at Kennedy. I just believe it needs to be updated facilities wise. The school was dirty and definitely needed more bathrooms throughout campus. The academics were just average, could be better and sometimes the teachers could have disciplined students more. But I will always be grateful to be a Titan!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-19T04:05:08.43994Z",
                "guid": "f0582e34-36f4-4afc-95dd-4ddb175acccc",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.986,37.5291,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.986,37.5291,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.590818363273453,
                "count": 501
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94538"
            }
        ]
    },
    {
        "guid": "f176ce15-6959-4a87-8cb4-7d7146f02b92",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 106,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.935726,
                "lon": -121.695827
            },
            "entity": {
                "abbreviation": "Liberty High School",
                "alternates": {
                    "ceeb": "050375",
                    "nces": "062160002573"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "f176ce15-6959-4a87-8cb4-7d7146f02b92",
                "isClaimed": false,
                "isPremium": false,
                "location": "Brentwood, CA",
                "name": "Liberty High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                    "schoolDistrict": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "8c697687-c0ec-469c-98e8-e0a06e72a35a",
                    "zipCode": "fea44aef-6d39-4c1c-9267-b5b70ebd1cf5"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Liberty Union High School District (Brentwood)",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                        "location": "Brentwood, CA",
                        "name": "Liberty Union High School District (Brentwood)",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "8c697687-c0ec-469c-98e8-e0a06e72a35a",
                            "zipCode": "fea44aef-6d39-4c1c-9267-b5b70ebd1cf5"
                        },
                        "premium": false,
                        "shortName": "Liberty Union High School District (Brentwood)",
                        "tagline": [
                            "School District",
                            "Brentwood, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "liberty-union-high-school-district-brentwood-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Liberty High School",
                "tagline": [
                    "Liberty Union High School District (Brentwood), CA",
                    "9-12"
                ],
                "type": "School",
                "url": "liberty-high-school-brentwood-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2708
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "As a mere freshman, Liberty High School was initially just considered another school that I had to attend.  Ugh!  However, after my 4 years I have to say it has not only been enjoyable, but has been a fruitful and arduous time that has taught me so much in the class and outside.  This year has been the exception with Covid, but with the year coming to an end soon I can not complain and am grateful for all the teachers and the school is doing to be eventful.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-03-31T05:39:09.753966Z",
                "guid": "dab5302a-f522-416c-a4a7-386489fda9ae",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.694,37.9359,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.694,37.9359,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7857142857142856,
                "count": 448
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94513"
            }
        ]
    },
    {
        "guid": "9d555df4-b81d-4d4e-bb16-faf9cc3736a3",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 107,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 38.001224,
                "lon": -122.553125
            },
            "entity": {
                "abbreviation": "Terra Linda High School",
                "alternates": {
                    "ceeb": "053231",
                    "nces": "063511005941"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "9d555df4-b81d-4d4e-bb16-faf9cc3736a3",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Rafael, CA",
                "name": "Terra Linda High School",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "dc30ba2a-37d6-4766-b90c-517b11b7cdde",
                    "parent": "d6dc2987-9315-432d-bc69-a6b31ad35c7a",
                    "schoolDistrict": "d6dc2987-9315-432d-bc69-a6b31ad35c7a",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "03b49160-d1e2-4a70-8c58-319b241306a8",
                    "zipCode": "a84b9cf7-0228-401b-85bd-1497a6685ebb"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "San Rafael City High School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "d6dc2987-9315-432d-bc69-a6b31ad35c7a",
                        "location": "San Rafael, CA",
                        "name": "San Rafael City High School District",
                        "parentGUIDs": {
                            "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "dc30ba2a-37d6-4766-b90c-517b11b7cdde",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "03b49160-d1e2-4a70-8c58-319b241306a8",
                            "zipCode": "a84b9cf7-0228-401b-85bd-1497a6685ebb"
                        },
                        "premium": false,
                        "shortName": "San Rafael City High School District",
                        "tagline": [
                            "School District",
                            "San Rafael, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-rafael-city-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Terra Linda High School",
                "tagline": [
                    "San Rafael City High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "terra-linda-high-school-san-rafael-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1230
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Terra Linda high school made me become the student I am today. Thanks to them I came out of my comfort zone. They made me feel comfortable no matter what. They helped me accomplish my goals that I never thought I would be able to accomplish. Every staff there is very supportive! They help you become that great/amazing student when no one was there for you. They are there for you in your ups and downs. Terra Linda has the supportive teachers that help you go to the extent. They help us out with our homework and etc. Their community involvement is amazing! They really help you with your college necessities very well. Terra Linda is a very safe school environment. Teachers are very organized and their lesson plans very clear. Terra Linda makes you fell like yourself and they help you out with whatever you need .",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-21T23:22:36.38702Z",
                "guid": "27473548-a975-498d-a98e-e717c7ba0567",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.554,37.9994,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.554,37.9994,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5392670157068062,
                "count": 191
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94903"
            }
        ]
    },
    {
        "guid": "8998c4c8-9563-46f8-b68b-f45c7652f6ff",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 108,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.780155,
                "lon": -122.445729
            },
            "entity": {
                "abbreviation": "Raoul Wallenberg Traditional High",
                "alternates": {
                    "ceeb": "052999",
                    "nces": "063441007845"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "8998c4c8-9563-46f8-b68b-f45c7652f6ff",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Raoul Wallenberg Traditional High",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "3edae0c7-a523-4f55-956b-e60c276bf5f5",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "1b2bdc40-30b1-4227-bccb-fd8c4930354e"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Raoul Wallenberg Traditional High",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "raoul-wallenberg-traditional-high-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 626
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Wallenberg High School is great in terms of the teachers and academics. As long as you do your best to finish your assignments, your grades will be just fine. They're all very nice and understanding, so if you miss class or need more time on an assignment, you just need to let them know beforehand/why. Not all the teachers' teaching style are \"fit\" for everyone. Keep in mind though that this school is pretty small, so there are limited resources. For example, there always seem to be a shortage of toilet paper in the restroom. There are also times when there are a small amount of students that are seen as  \"uncooperative.\"",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-07T02:09:31.21067Z",
                "guid": "409b3a50-1592-4596-9b06-7c4cb6651599",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.446,37.7805,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.446,37.7805,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.29004329004329,
                "count": 231
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94115"
            }
        ]
    },
    {
        "guid": "44af98ef-5c65-4662-be4f-6507cf5e8f01",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 109,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.782998,
                "lon": -122.437611
            },
            "entity": {
                "abbreviation": "Gateway High School",
                "alternates": {
                    "ceeb": "052947",
                    "nces": "060242607725"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "44af98ef-5c65-4662-be4f-6507cf5e8f01",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Gateway High School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "9ae6d1c0-ee34-4266-84ab-3a6632674608",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "9fbdd391-c59a-4ee3-a774-a928ff2f0905"
                },
                "premium": false,
                "shortName": "Gateway High School",
                "tagline": [
                    "Public School",
                    "San Francisco, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "gateway-high-school-san-francisco-ca-063441007725",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 479
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 17
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I liked that Gateway was small for the most part. It allowed you to really connect with all the staff and peers around you. The small community allowed for deeper connections with the people you had connections with. The wide diversity of staff also makes it a very inclusive space for students and I found that I had multiple staff members I could rely on when I was struggling. The sports community has vastly grown and with that, school spirit has been showing through. I would say that my experience at Gateway was one that I wasn't expecting, but nonetheless, I still enjoyed the moments I've had at Gateway that made me feel like I belonged there.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-16T18:34:04.51416Z",
                "guid": "0352ead5-c455-4b26-a766-c5937a224c3e",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.438,37.7833,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.438,37.7833,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.9696969696969697,
                "count": 99
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94115"
            }
        ]
    },
    {
        "guid": "db12d7d1-1d84-4351-9bc2-81b353875294",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 110,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.6840558,
                "lon": -122.4833425
            },
            "entity": {
                "abbreviation": "Westmoor High School",
                "alternates": {
                    "ceeb": "050723",
                    "nces": "061893002298"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "db12d7d1-1d84-4351-9bc2-81b353875294",
                "isClaimed": false,
                "isPremium": false,
                "location": "Daly City, CA",
                "name": "Westmoor High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "88d77336-3b63-4d91-9d64-307e50ca145b",
                    "schoolDistrict": "88d77336-3b63-4d91-9d64-307e50ca145b",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "41a99124-6b7c-496d-9635-39a33c683883",
                    "zipCode": "6e76147a-b88b-4659-93c4-fe720003e7e7"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Jefferson Union High School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "88d77336-3b63-4d91-9d64-307e50ca145b",
                        "location": "Daly City, CA",
                        "name": "Jefferson Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "41a99124-6b7c-496d-9635-39a33c683883",
                            "zipCode": "6e76147a-b88b-4659-93c4-fe720003e7e7"
                        },
                        "premium": false,
                        "shortName": "Jefferson Union High School District",
                        "tagline": [
                            "School District",
                            "Daly City, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "jefferson-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Westmoor High School",
                "tagline": [
                    "Jefferson Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "westmoor-high-school-daly-city-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1526
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "I am currently a student at Westmoor High School. I have attended this school for the last three years and have grown to love it. The faculty are dedicated to helping students grow and develop as not only students, but also people. However, as excellent as our teachers and staff members are, we don’t have enough resources or money for our students to have the best experiences they can in their departments. For example, our music and science departments get nearly no funding for the entire year and must rely on donations and fundraisers to maintain them. In my few years here, I’ve learned many things from these two departments and I can only imagine how many more students could develop and grow if all our departments had adequate funding as well as equal resources. Overall, Westmoor is an amazing school with incredible potential to become a place for students and others to become outstanding human beings!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-09-26T01:34:01.9898Z",
                "guid": "0e2d892a-0471-4864-9c7e-02f0e3a69411",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.4833425,37.6840558,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.4833425,37.6840558,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.643884892086331,
                "count": 278
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94015"
            }
        ]
    },
    {
        "guid": "0a0daf74-c6ce-437b-94b8-824417876844",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 111,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.303237,
                "lon": -121.930308
            },
            "entity": {
                "abbreviation": "Del Mar High School",
                "alternates": {
                    "ceeb": "053083",
                    "nces": "060723000665"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "0a0daf74-c6ce-437b-94b8-824417876844",
                "isClaimed": true,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Del Mar High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "9bed7cde-76c6-4ed3-9076-f48cade709d3",
                    "parent": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                    "schoolDistrict": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "bf537caa-7876-4936-b0a8-98add2dd3610"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Campbell Union High School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                        "location": "San Jose, CA",
                        "name": "Campbell Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "5750507d-5a3f-47db-a00c-b8ac64163449",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "c051b239-374c-4f96-b426-d3be11c6ef67"
                        },
                        "premium": false,
                        "shortName": "Campbell Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "campbell-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Del Mar High School",
                "tagline": [
                    "Campbell Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "del-mar-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1300
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I had a very positive experience at Del Mar High School. The teachers and staff are very supportive and do their best to give every student a positive learning experience. The school as a whole encourages all students to participate in higher-level courses and extracurriculars, which overall betters the school atmosphere. The school has handled the COVID-19 restrictions very well, and ensured that all students have the same opportunities for learning from home effectively. Students have a lot of options when it comes to classes, and there are a lot of very interesting options. Del Mar is an IB school, so although there are a lot of IB options, AP courses are limited.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-11-30T04:32:44.110321Z",
                "guid": "fbd8bd7e-bfc9-49b2-a79f-1ccb4fbc6d03",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.927,37.3037,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.927,37.3037,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6946902654867255,
                "count": 226
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95128"
            }
        ]
    },
    {
        "guid": "424bd5ec-173c-4ebc-8720-9e27e1f75e05",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 112,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.746794,
                "lon": -122.141509
            },
            "entity": {
                "abbreviation": "East Bay Innovation Academy",
                "alternates": {
                    "ceeb": "059801",
                    "nces": "060219213735"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "424bd5ec-173c-4ebc-8720-9e27e1f75e05",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "East Bay Innovation Academy",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "3816271d-bf9c-431c-9e92-8f63ddf53940"
                },
                "premium": false,
                "shortName": "East Bay Innovation Academy",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "east-bay-innovation-academy-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 562
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "The teachers are incredibly invested in student success. Very small school, so you get close to your classmates and teachers. EBIA is hands-on and STEAM-based and has a college preparatory curriculum. The only reason it's getting a four-star and not a five is because they don't have any sports teams and the school events are limited. However, I played varsity soccer at Skyline Highschool, which was fine!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-21T21:20:05.91294Z",
                "guid": "797ad381-dd55-4e0d-a0c8-77aa8f72feae",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.141,37.7456,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.141,37.7456,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.428571428571429,
                "count": 7
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94605"
            }
        ]
    },
    {
        "guid": "531add13-e0b7-4973-b16f-59f1064d7fcc",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 113,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.592309,
                "lon": -122.475517
            },
            "entity": {
                "abbreviation": "Terra Nova High School",
                "alternates": {
                    "ceeb": "050721",
                    "nces": "061893002296"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "531add13-e0b7-4973-b16f-59f1064d7fcc",
                "isClaimed": false,
                "isPremium": false,
                "location": "Pacifica, CA",
                "name": "Terra Nova High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "88d77336-3b63-4d91-9d64-307e50ca145b",
                    "schoolDistrict": "88d77336-3b63-4d91-9d64-307e50ca145b",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "31f36d31-d402-416c-a8c8-c1050bc23388",
                    "zipCode": "4296d11e-c508-4cdd-9609-6ede3d3e659e"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Jefferson Union High School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "88d77336-3b63-4d91-9d64-307e50ca145b",
                        "location": "Daly City, CA",
                        "name": "Jefferson Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "41a99124-6b7c-496d-9635-39a33c683883",
                            "zipCode": "6e76147a-b88b-4659-93c4-fe720003e7e7"
                        },
                        "premium": false,
                        "shortName": "Jefferson Union High School District",
                        "tagline": [
                            "School District",
                            "Daly City, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "jefferson-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Terra Nova High School",
                "tagline": [
                    "Jefferson Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "terra-nova-high-school-pacifica-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 812
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Terra Nova High is a pretty good school. I was able to meet amazing people, discover new interests, and grow as a student. Terra Nova offers many sports and clubs so it's easy to connect with new people. Compared to other schools in the district it is the more academically challenging(more ap courses to choose from) and it also has a good level of school pride. I loved going to food fairs, rallies, dances, games, and field trips. That being said my biggest complaint is just that the teachers are really inconsistent with quality. I've had amazing teachers in english, math, art, and chemistry however the language department isn't as reliable. This issue really isn't even the schools' fault because teachers can't live in this area due to the small salary and high rent prices. I overall enjoyed my time at Terra Nova and I think it's a pretty good school.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-12T04:25:17.593812Z",
                "guid": "91e7fcea-5a0c-4848-8263-63543427d1e8",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.476,37.5951,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.476,37.5951,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.31021897810219,
                "count": 274
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94044"
            }
        ]
    },
    {
        "guid": "aa4c0a15-93ab-494e-b048-c6dbd3823f67",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 114,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.877228,
                "lon": -122.073423
            },
            "entity": {
                "abbreviation": "Acalanes Center for Independent Study",
                "alternates": {
                    "ceeb": "053926",
                    "nces": "060165010751"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "aa4c0a15-93ab-494e-b048-c6dbd3823f67",
                "isClaimed": false,
                "isPremium": false,
                "location": "Walnut Creek, CA",
                "name": "Acalanes Center for Independent Study",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                    "schoolDistrict": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "e3c4436c-7dc9-4c55-8ef7-d47f7a932ba9",
                    "zipCode": "0f5bfe3e-c4e2-4b41-afd1-7f0c717be19f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "AUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ff37e6dc-3fa4-4b54-bd90-cbe52b4a1815",
                        "location": "Lafayette, CA",
                        "name": "Acalanes Union High School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "e4e259e3-74e6-485c-8a9b-9d48c8298442",
                            "zipCode": "3bbdf3eb-e3f7-45ec-a476-cd13a4bb1d7f"
                        },
                        "premium": false,
                        "shortName": "Acalanes Union High School District",
                        "tagline": [
                            "School District",
                            "Lafayette, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "acalanes-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Acalanes Center for Independent Study",
                "tagline": [
                    "Acalanes Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "acalanes-center-for-independent-study-walnut-creek-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 27
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 17
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.075,37.8763,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.075,37.8763,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4,
                "count": 5
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94595"
            }
        ]
    },
    {
        "guid": "49f238e9-2d72-473d-ade8-db1bdf3a53f7",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 115,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.291626,
                "lon": -121.89638
            },
            "entity": {
                "abbreviation": "Willow Glen High School",
                "alternates": {
                    "ceeb": "053105",
                    "nces": "063459005746"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "49f238e9-2d72-473d-ade8-db1bdf3a53f7",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Willow Glen High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "9bed7cde-76c6-4ed3-9076-f48cade709d3",
                    "parent": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "schoolDistrict": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "0f5f9ca7-0382-4b2d-8697-36994f2fddf7"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SJUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                        "location": "San Jose, CA",
                        "name": "San Jose Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "0a781906-f3cb-42ec-b08b-9acfcaf63aaa",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "763f10c1-8ad0-4832-90b4-5bad39b6e93f"
                        },
                        "premium": false,
                        "shortName": "San Jose Unified School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-jose-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Willow Glen High School",
                "tagline": [
                    "San Jose Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "willow-glen-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1737
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I really enjoyed my experience at Willow Glen! The people are great and the environment is really exciting!\nAlthough, the math department is not very good. Many complaints were made every week yet they did not work to solve the problem.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-03-21T23:52:45.844739Z",
                "guid": "fcb4d739-e321-4c11-8dc8-b42c5f540428",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.897,37.2919,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.897,37.2919,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.586805555555556,
                "count": 288
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95125"
            }
        ]
    },
    {
        "guid": "60d8e61a-2481-450c-a4a9-c94648a7a879",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 116,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.813468,
                "lon": -122.275858
            },
            "entity": {
                "abbreviation": "American Indian Public High School",
                "alternates": {
                    "ceeb": "054176",
                    "nces": "060222711563"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "60d8e61a-2481-450c-a4a9-c94648a7a879",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "American Indian Public High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64"
                },
                "premium": false,
                "shortName": "American Indian Public High School",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "american-indian-public-high-school-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 411
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "I love going to AIMS, they provide so many free opportunities for students. The school provides a variety of students free access to AP tests, PSAT, SAT, and ACT. The school has a very diverse environment that allows students to express themselves freely! The school focuses on college readiness and prepares students academically through school-wide required AP classes that fulfill our college general education and guarantee four year college acceptance.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-03-13T16:48:57.305749Z",
                "guid": "37ea9edd-aaef-474e-9bf4-71846d8d31ae",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.249,37.8114,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.249,37.8114,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.1420765027322406,
                "count": 183
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94607"
            }
        ]
    },
    {
        "guid": "f46335ab-f9e4-4dce-9217-511b2876104d",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 117,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.977281,
                "lon": -121.991278
            },
            "entity": {
                "abbreviation": "Concord High School",
                "alternates": {
                    "ceeb": "050657",
                    "nces": "062637003942"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "f46335ab-f9e4-4dce-9217-511b2876104d",
                "isClaimed": false,
                "isPremium": false,
                "location": "Concord, CA",
                "name": "Concord High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "schoolDistrict": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "187f89d7-6963-49c2-b924-426631dae88f",
                    "zipCode": "64ec8361-307f-4c60-8518-5e08e7cc3cb0"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "MDUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                        "location": "Concord, CA",
                        "name": "Mt. Diablo Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "187f89d7-6963-49c2-b924-426631dae88f",
                            "zipCode": "fca2caaa-dbcc-472c-be69-c07f58b2a359"
                        },
                        "premium": false,
                        "shortName": "Mt. Diablo Unified School District",
                        "tagline": [
                            "School District",
                            "Concord, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mt-diablo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Concord High School",
                "tagline": [
                    "Mt. Diablo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "concord-high-school-concord-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1385
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My experience at Concord High was great while it lasted, since I did not have an in person senior year at school due to the Covid-19 pandemic it was fun and memorable. I loved the diversity and culture at our school and how there was so many things I learned about others whether it was about ethnic cultures, about people I knew in general, and about the schools dynamic. The staff is really caring and always want the students to do their best. I think depending on the students and how they put themselves out there being more involved in the school or not, gives different perspectives of how people experienced high school. Of course, no school is perfect so there was some small things that weren't the best but most of them wasn't the schools fault. I believe that the more you become involved with the school and what they have to offer, the experience and memories will last forever.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-08T05:41:06.699481Z",
                "guid": "9a376b68-0b07-450a-b6ee-fa94a5eb862b",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.989,37.978,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.989,37.978,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.623134328358209,
                "count": 268
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94521"
            }
        ]
    },
    {
        "guid": "a56ae4b4-1902-4992-bcae-cab7b1cbe27e",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 118,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.823027,
                "lon": -122.234097
            },
            "entity": {
                "abbreviation": "Millennium High Alternative School",
                "alternates": {
                    "ceeb": "052468",
                    "nces": "063033007819"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "a56ae4b4-1902-4992-bcae-cab7b1cbe27e",
                "isClaimed": false,
                "isPremium": false,
                "location": "Piedmont, CA",
                "name": "Millennium High Alternative School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "ffc793dc-426b-4df9-8bd2-7250f0309363",
                    "schoolDistrict": "ffc793dc-426b-4df9-8bd2-7250f0309363",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "56749142-fea1-470f-b296-912a61cb1169",
                    "zipCode": "c2e42d78-53d8-4353-a489-378eab873ee1"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "PUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ffc793dc-426b-4df9-8bd2-7250f0309363",
                        "location": "Piedmont, CA",
                        "name": "Piedmont City Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "56749142-fea1-470f-b296-912a61cb1169",
                            "zipCode": "c2e42d78-53d8-4353-a489-378eab873ee1"
                        },
                        "premium": false,
                        "shortName": "Piedmont City Unified School District",
                        "tagline": [
                            "School District",
                            "Piedmont, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "piedmont-city-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Millennium High Alternative School",
                "tagline": [
                    "Piedmont City Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "millennium-high-alternative-school-piedmont-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 65
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 11
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Millennium High School is a closely knit community full of kids mostly from out of the Piedmont School District. It offers small class sizes and the teachers care about every student and are always there to help. It's also right next door to Piedmont High School where I am able to take more advanced classes.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-04-06T05:04:34.562441Z",
                "guid": "ac8fd04a-075e-49e2-9d8b-e7d8d08cb235",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.233,37.8225,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.233,37.8225,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.923076923076923,
                "count": 13
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94611"
            }
        ]
    },
    {
        "guid": "bf3ab8bb-1bfd-4c9b-b393-89c0012494b9",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 119,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.733622,
                "lon": -122.382125
            },
            "entity": {
                "abbreviation": "KIPP San Francisco College Preparatory",
                "alternates": {
                    "ceeb": "054816",
                    "nces": "060195713410"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "bf3ab8bb-1bfd-4c9b-b393-89c0012494b9",
                "isClaimed": true,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "KIPP San Francisco College Preparatory",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "ff75ef65-191a-403a-ad30-436dec05b378",
                    "schoolNetwork": "a310ca2b-9585-4429-96b5-bd4924a4c483",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "6d9673ef-a1db-480d-bcce-79e87b94f91c"
                },
                "premium": false,
                "shortName": "KIPP San Francisco College Preparatory",
                "tagline": [
                    "Public School",
                    "San Francisco, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "kipp-san-francisco-college-preparatory-san-francisco-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 403
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "This school is academically very well. It prepared me for the load work in college so it was easier for me to adjust to the college life. I’m super grateful for that?! Small school so teachers are always available to help. \nHowever it was long school hours which for someone who is a good independent student, it can be too much at times and may feel like there’s a lack of freedom.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-02-11T09:08:56.376054Z",
                "guid": "4d8d6724-3225-4ab6-8092-51cb292c38f4",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.382,37.7323,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.382,37.7323,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6842105263157894,
                "count": 38
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94124"
            }
        ]
    },
    {
        "guid": "41fdfe1c-9db9-4225-a0e2-ce93b5117daa",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 120,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.680798,
                "lon": -122.138485
            },
            "entity": {
                "abbreviation": "Arroyo High School",
                "alternates": {
                    "ceeb": "053125",
                    "nces": "063471005845"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "41fdfe1c-9db9-4225-a0e2-ce93b5117daa",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Lorenzo, CA",
                "name": "Arroyo High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "e54d426f-208e-46bc-9c03-0fc37e4b218c",
                    "schoolDistrict": "e54d426f-208e-46bc-9c03-0fc37e4b218c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "e97f4f73-e7d3-41d6-a288-8114432efadc",
                    "zipCode": "5820f130-05d4-461d-b769-af76b2295d66"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "San Lorenzo Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "e54d426f-208e-46bc-9c03-0fc37e4b218c",
                        "location": "San Lorenzo, CA",
                        "name": "San Lorenzo Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "b04852e8-80bc-429e-bdfb-748588649add",
                            "zipCode": "5820f130-05d4-461d-b769-af76b2295d66"
                        },
                        "premium": false,
                        "shortName": "San Lorenzo Unified School District",
                        "tagline": [
                            "School District",
                            "San Lorenzo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-lorenzo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Arroyo High School",
                "tagline": [
                    "San Lorenzo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "arroyo-high-school-san-lorenzo-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1819
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Arroyo is a very well structured and progressive school, with an academy system that allows for students to be around other students that share the same goals. While my experience can't speak for everyone, all the teachers that I've had have all been true in trying to educate their students, and are usually understanding of anything that hinders a student's ability to learn, and helps them adapt to it. \n\nAs for specifics, the science programs at Arroyo are quite exceptional. College and career resources are abundant at the school, with very thorough career counselors that are eager to help their students. \n\nAny issue I've ever had with Arroyo was because of the administration. Poor handling of student affairs is what causes many underlying issues that result in poor school pride and a school identity many students are ashamed of. This is especially disappointing considering the amount of potential the community of teachers and students have to reach something greater.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-09-22T05:30:11.95577Z",
                "guid": "d97d8cfb-080b-4c3c-bef8-d642eca7f71c",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.138,37.6805,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.138,37.6805,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.294498381877023,
                "count": 309
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94580"
            }
        ]
    },
    {
        "guid": "284977e6-a0d7-4090-a95d-1b4e5f17344b",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 121,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.779598,
                "lon": -122.28794
            },
            "entity": {
                "abbreviation": "Nea",
                "alternates": {
                    "ceeb": "054529",
                    "nces": "060188712399"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "284977e6-a0d7-4090-a95d-1b4e5f17344b",
                "isClaimed": true,
                "isPremium": false,
                "location": "Alameda, CA",
                "name": "Nea Community Learning Center",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "54a953dd-3bdc-47b1-b465-0e4d3705637e",
                    "zipCode": "a2b1830b-98f1-4ebd-83e1-b3e0b4fdffcb"
                },
                "premium": false,
                "shortName": "Nea",
                "tagline": [
                    "Public School",
                    "Alameda, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "nea-community-learning-center-alameda-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 579
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Nea Community Learning Center, is a good school. I love this school and it is diverse. It does not matter where you come from, the school's main goal is to ensure that you feel welcome. I have been in this school for five years and I have meet new friends and teachers. There are no hate crimes that happen in the school. Although it is not a big school as everyone's dream high school is, I can guarantee you that it is the best school you could dream off. There are no AP classes or sports but the school gives you an opportunity to branch out to colleges to complete the requirements.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-23T23:35:17.527134Z",
                "guid": "8a173f1d-ac7e-4f50-9194-7061df9b2c94",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.287,37.7792,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.287,37.7792,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.75,
                "count": 40
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94501"
            }
        ]
    },
    {
        "guid": "5250a961-5ace-493a-a4b1-85035e022924",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 122,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.720509,
                "lon": -122.405009
            },
            "entity": {
                "abbreviation": "Phillip And Sala Burton Academic High School",
                "alternates": {
                    "ceeb": "052994",
                    "nces": "063441008189"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "5250a961-5ace-493a-a4b1-85035e022924",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Phillip And Sala Burton Academic High School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "f03b3dc2-87ff-47a3-a436-170bc3a6609a",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "67339067-3b07-488a-a8f9-c097bd4fcad2"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Burton Academic High",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "phillip-and-sala-burton-academic-high-school-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1092
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "My teachers were supportive to us, especially in applying for college. There were a few honors and AP courses that could help students advance their learning and prepare for college. Upon entering school, I felt safe with the security guards and they were all cool. The bus stop was literally right outside the school and after school, there would be shuttles for students to get home faster. We weren't the worse at sports, but we weren't the best. My favorite memory of high school was rallies and food festivals that were led by a variety of clubs. The rallies truly brought the school together and showed our pride in the school. Every Friday, we had a DJ play music for us and it would be so fun watching people dancing. Wish students right now would experience this true high school experience.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-01T16:41:57.710282Z",
                "guid": "e584fa58-9727-43c4-a2a7-fbf523cd3bb3",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.407,37.7213,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.407,37.7213,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8875,
                "count": 160
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94134"
            }
        ]
    },
    {
        "guid": "3bb4731d-e006-43ad-b5d3-71c5bbeefd75",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 123,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.971633,
                "lon": -122.513318
            },
            "entity": {
                "abbreviation": "San Rafael High School",
                "alternates": {
                    "ceeb": "053222",
                    "nces": "063511005938"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "3bb4731d-e006-43ad-b5d3-71c5bbeefd75",
                "isClaimed": true,
                "isPremium": false,
                "location": "San Rafael, CA",
                "name": "San Rafael High School",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "40ad174f-166d-4d99-a58a-bb82f378e20f",
                    "parent": "d6dc2987-9315-432d-bc69-a6b31ad35c7a",
                    "schoolDistrict": "d6dc2987-9315-432d-bc69-a6b31ad35c7a",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "03b49160-d1e2-4a70-8c58-319b241306a8",
                    "zipCode": "218cd2f0-f326-4a8e-a957-02117d51d241"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "San Rafael City High School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "d6dc2987-9315-432d-bc69-a6b31ad35c7a",
                        "location": "San Rafael, CA",
                        "name": "San Rafael City High School District",
                        "parentGUIDs": {
                            "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "dc30ba2a-37d6-4766-b90c-517b11b7cdde",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "03b49160-d1e2-4a70-8c58-319b241306a8",
                            "zipCode": "a84b9cf7-0228-401b-85bd-1497a6685ebb"
                        },
                        "premium": false,
                        "shortName": "San Rafael City High School District",
                        "tagline": [
                            "School District",
                            "San Rafael, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-rafael-city-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "San Rafael High School",
                "tagline": [
                    "San Rafael City High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "san-rafael-high-school-san-rafael-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1333
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I just love my school! Diversity, attention from teachers to students, and many other opportunities to overcome yourself and have more chances to get into colleges. There is so much help and programs for students, they care about their students, teachers, and staff.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-24T01:21:32.857541Z",
                "guid": "8ae43e9b-9bdf-49ff-a019-7d8edf7bbd0b",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.514,37.971,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.514,37.971,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7068062827225132,
                "count": 191
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94901"
            }
        ]
    },
    {
        "guid": "feab8a03-2826-4381-8138-97a94fc9b837",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 124,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.676543,
                "lon": -121.739733
            },
            "entity": {
                "abbreviation": "Vineyard Alternative School",
                "alternates": {
                    "ceeb": "053886",
                    "nces": "062211008877"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "feab8a03-2826-4381-8138-97a94fc9b837",
                "isClaimed": true,
                "isPremium": false,
                "location": "Livermore, CA",
                "name": "Vineyard Alternative School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "19cd8fd6-2e3f-4241-bb82-be4e992de8bf",
                    "schoolDistrict": "19cd8fd6-2e3f-4241-bb82-be4e992de8bf",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "fc27d7f3-833b-4d0b-bced-8aa3c3c99758",
                    "zipCode": "0a020eaf-ab20-4a50-8308-d60ca74bd07f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Livermore Valley Joint Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "19cd8fd6-2e3f-4241-bb82-be4e992de8bf",
                        "location": "Livermore, CA",
                        "name": "Livermore Valley Joint Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "fc27d7f3-833b-4d0b-bced-8aa3c3c99758",
                            "zipCode": "c06482ed-5084-4a24-95f9-0ab50e7042b2"
                        },
                        "premium": false,
                        "shortName": "Livermore Valley Joint Unified School District",
                        "tagline": [
                            "School District",
                            "Livermore, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "livermore-valley-joint-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Vineyard Alternative School",
                "tagline": [
                    "Livermore Valley Joint Unified School District, CA",
                    "12"
                ],
                "type": "School",
                "url": "vineyard-alternative-school-livermore-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 136
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 9
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Not only is the staff incredibly welcoming and kind, they are also extremely accommodating. Teachers and staff are always there to help with anything whether it's rush sending transcripts, adding classes, or any other request. The teachers are understanding and are some of the kindest people I've ever met while also very encouraging and motivating.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2017-02-26T03:44:47.428821Z",
                "guid": "1474a58a-5e2b-4075-9533-2c68c018bc6c",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.741,37.6766,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.741,37.6766,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 2
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94550"
            }
        ]
    },
    {
        "guid": "698e0b8c-ea54-4647-ba5a-83f2b1cfbac7",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 125,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.636831,
                "lon": -122.485165
            },
            "entity": {
                "abbreviation": "Oceana High School",
                "alternates": {
                    "ceeb": "052308",
                    "nces": "061893002294"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "698e0b8c-ea54-4647-ba5a-83f2b1cfbac7",
                "isClaimed": false,
                "isPremium": false,
                "location": "Pacifica, CA",
                "name": "Oceana High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "88d77336-3b63-4d91-9d64-307e50ca145b",
                    "schoolDistrict": "88d77336-3b63-4d91-9d64-307e50ca145b",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "31f36d31-d402-416c-a8c8-c1050bc23388",
                    "zipCode": "4296d11e-c508-4cdd-9609-6ede3d3e659e"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Jefferson Union High School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "88d77336-3b63-4d91-9d64-307e50ca145b",
                        "location": "Daly City, CA",
                        "name": "Jefferson Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "41a99124-6b7c-496d-9635-39a33c683883",
                            "zipCode": "6e76147a-b88b-4659-93c4-fe720003e7e7"
                        },
                        "premium": false,
                        "shortName": "Jefferson Union High School District",
                        "tagline": [
                            "School District",
                            "Daly City, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "jefferson-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Oceana High School",
                "tagline": [
                    "Jefferson Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "oceana-high-school-pacifica-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 599
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I attended Oceana for 4 years, and I have to say it is a wonderful school to send your student to. We have a pretty small indoor-outdoor campus with one main hallway. The view of the ocean is beautiful as well. The teachers are wonderful, though the school is a little underfunded. Despite that, it is great. Teachers are deeply involved and invested in student success. You may even find yourself becoming friends with the teachers that teach you. Students are on the lower end of school spirit. The student government works very hard to get things done and throw fun dances and events for the students. Our campus is very diverse in terms of faculty and students. Oceana is a great college preparation school that even offers free PSAT and SAT testing. One downside is the school does not have many sports team, but it most likely has the one you are interested in. Parent involvement is low and I find that to be a good thing as parents should not be too involved at such an age.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-03-26T22:07:07.734382Z",
                "guid": "d6a6e873-6932-4606-af2e-3905fe0a3776",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.487,37.6388,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.487,37.6388,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.4,
                "count": 175
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94044"
            }
        ]
    },
    {
        "guid": "1202ba6e-264e-4772-8542-cd980ffda3d0",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 126,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.7617201,
                "lon": -122.4006227
            },
            "entity": {
                "abbreviation": "S.F. International High School",
                "alternates": {
                    "ceeb": "054515",
                    "nces": "063441012494"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "1202ba6e-264e-4772-8542-cd980ffda3d0",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "S.F. International High School",
                "parentGUIDs": {
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "0e7feade-1234-4a78-b9a6-f0a08b901e7c",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "781604ff-cae4-4ff7-8bc5-30889e25ac1f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "S.F. International High School",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "sf-international-high-school-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 297
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "The way that immigrant students connect with each other is just amazing. Teachers at San Francisco International High school do a great job teaching us how to learn a second language such as English. When you see students from all over the world learning together is amazing because not having a common language to speak is a hard challenge that students overcome. On the other hand, I would like from the district to support my school more because students over there are special and hard working. They can support our school more by providing more help to different students who also work outside of school to support their families. This would be helpful to them because they would have less issues to face with.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-02-19T07:22:02.479947Z",
                "guid": "a3972539-932f-4b40-b740-20c85254fccd",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.4006227,37.7617201,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.4006227,37.7617201,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8620689655172415,
                "count": 29
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94107"
            }
        ]
    },
    {
        "guid": "f049b33f-d256-44ae-a385-c16fff8260c6",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 127,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.258565,
                "lon": -121.853051
            },
            "entity": {
                "abbreviation": "Gunderson High School",
                "alternates": {
                    "ceeb": "053088",
                    "nces": "063459005716"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "f049b33f-d256-44ae-a385-c16fff8260c6",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Gunderson High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "078c8917-e52e-4332-af2e-2091c6f2b825",
                    "parent": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "schoolDistrict": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "bcda0e04-4247-440c-ae7f-42454876c867"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SJUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                        "location": "San Jose, CA",
                        "name": "San Jose Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "0a781906-f3cb-42ec-b08b-9acfcaf63aaa",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "763f10c1-8ad0-4832-90b4-5bad39b6e93f"
                        },
                        "premium": false,
                        "shortName": "San Jose Unified School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-jose-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Gunderson High School",
                "tagline": [
                    "San Jose Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "gunderson-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1093
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "The school is extremely diverse! The yearbook program was nationally award winning and absolutely phenomenal! Teachers truly care for the students and are willing to help students in whatever they need help with. many school activities going on throughout the year so students always have fun events they can attend. Track here was amazing and the coach truly cares for his athletes and wants to see them succeed. Having classes that are an hour and thirty minutes allows for students to feel and get used to what longer college classes feel like.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-08-18T07:53:56.999463Z",
                "guid": "c89af285-6d05-4266-971f-0abf00ea8886",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.854,37.2584,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.854,37.2584,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8300970873786406,
                "count": 206
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95136"
            }
        ]
    },
    {
        "guid": "2c353cdc-b23b-4a52-ab5d-d319f9c9463f",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 128,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 38.052385,
                "lon": -122.220917
            },
            "entity": {
                "abbreviation": "John Swett High School",
                "alternates": {
                    "ceeb": "050710",
                    "nces": "061899002302"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "2c353cdc-b23b-4a52-ab5d-d319f9c9463f",
                "isClaimed": false,
                "isPremium": false,
                "location": "Crockett, CA",
                "name": "John Swett High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "8dd379c5-017b-4b7f-8485-4543a3c9761d",
                    "schoolDistrict": "8dd379c5-017b-4b7f-8485-4543a3c9761d",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "f0624f6f-b23a-41f4-b431-0766074a6e92",
                    "zipCode": "e3c1c7a6-1f75-4afc-98bd-08e6b48fe731"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "John Swett Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "8dd379c5-017b-4b7f-8485-4543a3c9761d",
                        "location": "Rodeo, CA",
                        "name": "John Swett Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "362b3980-b744-46dc-a22d-af772d04f66f",
                            "zipCode": "b246fcf7-0c1e-4866-8773-4baa7b3add25"
                        },
                        "premium": false,
                        "shortName": "John Swett Unified School District",
                        "tagline": [
                            "School District",
                            "Rodeo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "john-swett-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "John Swett High School",
                "tagline": [
                    "John Swett Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "john-swett-high-school-crockett-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 453
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "A small community where the teachers and staff become family. A place where education is heavily implied and being the best is motivated. This school has extracurricular activities to help build a student's application. The teachers work side by side with students and aid them in any help or advice that they mad need. This school is also under construction and is remodeling the area to make it look more appealing. However throughout the construction, it does not impose a distraction to a student’s learning. The diverse community also helps create a loving environment where everyone is welcomed and loved despite where they come from! A true gem in the contra costa county!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2017-11-28T04:34:47.588495Z",
                "guid": "86d49b8e-35a7-4275-9ec9-c02b881bfb09",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.221,38.0538,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.221,38.0538,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.627906976744186,
                "count": 86
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94525"
            }
        ]
    },
    {
        "guid": "d2eab9d3-f670-40eb-ab77-2b81037c047d",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 129,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.649795,
                "lon": -122.428237
            },
            "entity": {
                "abbreviation": "South San Francisco High School",
                "alternates": {
                    "ceeb": "053415",
                    "nces": "063753006352"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "d2eab9d3-f670-40eb-ab77-2b81037c047d",
                "isClaimed": false,
                "isPremium": false,
                "location": "South San Francisco, CA",
                "name": "South San Francisco High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "41a0969a-227f-49e4-989c-cce558a6963c",
                    "schoolDistrict": "41a0969a-227f-49e4-989c-cce558a6963c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "64832fba-4ed7-403d-a9bb-3c8c5210d64c",
                    "zipCode": "8c664451-0242-437f-a6d9-d577f9b17d9e"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "South San Francisco Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "41a0969a-227f-49e4-989c-cce558a6963c",
                        "location": "South San Francisco, CA",
                        "name": "South San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "64832fba-4ed7-403d-a9bb-3c8c5210d64c",
                            "zipCode": "8c664451-0242-437f-a6d9-d577f9b17d9e"
                        },
                        "premium": false,
                        "shortName": "South San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "South San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "south-san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "South San Francisco High School",
                "tagline": [
                    "South San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "south-san-francisco-high-school-south-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1321
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Personally, I have had a great relationship at South San Francisco High School. I have had the opportunity to take various challenging classes that are preparing me for college. In every single class I have taken, I have never had any problem with the teachers. It is clear that every teacher wants the best for their students. In challenging classes, such as AP classes, my teachers have worked hard to provide students with the resources and information they need to excel in the AP exams and in college. However, I think that the food is below average, as most of the food served is prepackaged and unhealthy. I also know that the school does not invest in the arts, such as drama and theater, which also could be due to a lack of money in general. I would also say that the safety is average since there are a few security guards at the front of the school watching as students walk in and making sure they are safe.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-05-19T18:15:44.626714Z",
                "guid": "ff46cc6e-5455-4a22-93cb-2349b4362cfd",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.426,37.648,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.426,37.648,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.314420803782506,
                "count": 423
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94080"
            }
        ]
    },
    {
        "guid": "56514020-fb82-4103-b449-ff25c4e4ac6e",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 130,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.712818,
                "lon": -122.093035
            },
            "entity": {
                "abbreviation": "Redwood Continuation High School",
                "alternates": {
                    "nces": "060780000744"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "56514020-fb82-4103-b449-ff25c4e4ac6e",
                "isClaimed": false,
                "isPremium": false,
                "location": "Castro Valley, CA",
                "name": "Redwood Continuation High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "3707b90b-92ee-4fe1-b360-2afce14889fb",
                    "schoolDistrict": "3707b90b-92ee-4fe1-b360-2afce14889fb",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "3b63d4f5-8c5d-4908-9952-1529e9a9dcee",
                    "zipCode": "ca87fa67-ecae-4bbb-a27b-22324f3483bc"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Castro Valley Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "3707b90b-92ee-4fe1-b360-2afce14889fb",
                        "location": "Castro Valley, CA",
                        "name": "Castro Valley Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "3b63d4f5-8c5d-4908-9952-1529e9a9dcee",
                            "zipCode": "ca87fa67-ecae-4bbb-a27b-22324f3483bc"
                        },
                        "premium": false,
                        "shortName": "Castro Valley Unified School District",
                        "tagline": [
                            "School District",
                            "Castro Valley, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "castro-valley-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Redwood Continuation High School",
                "tagline": [
                    "Castro Valley Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "redwood-continuation-high-school-castro-valley-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 125
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 16
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "This school was the opening door to my success in life. People may say continuation schools are for bad kids and all, but i find that very hard to believe. Students at this school are just students that need a little extra help with their studies and a more 1 to 1 expirience. Nobody is perfect and we are not meant to be like everyone else. Hey if this is what works best for us then be it. I looked at it more as school for really special souls that needed a little push to fly away. I truly enjoyed this school. The staff in this school is one of the most inspirational staff. I loved how they cared for us . They would always check in on me, even if there was nothing wrong . I love how it's a safe place where you can go do your work and leave knowing that you can come back the next day and do better. All the teachers are very good teachers. They are very special teachers. These teachers help students like me (that learn differently) feel welcomed and feel like we belong .",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2017-06-16T05:20:23.978608Z",
                "guid": "4b3992a1-bcd2-46ce-86c4-7aac7efa9eeb",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.092,37.7136,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.092,37.7136,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 5
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94546"
            }
        ]
    },
    {
        "guid": "a9d3d425-1029-4a3e-b500-1e19d4a67269",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 131,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.655271,
                "lon": -121.875439
            },
            "entity": {
                "abbreviation": "Village High School",
                "alternates": {
                    "ceeb": "052499",
                    "nces": "060002009280"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "a9d3d425-1029-4a3e-b500-1e19d4a67269",
                "isClaimed": true,
                "isPremium": false,
                "location": "Pleasanton, CA",
                "name": "Village High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "29f69694-5146-4bfb-b2b3-aa52956e3114",
                    "parent": "c831a26c-bfd8-400a-9df2-b2bcdbc75eb3",
                    "schoolDistrict": "c831a26c-bfd8-400a-9df2-b2bcdbc75eb3",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "6a69cf51-74d9-4871-a020-7a26cc1e03a8",
                    "zipCode": "e7654ec4-7c93-4d2e-a586-048286d02972"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "PUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "c831a26c-bfd8-400a-9df2-b2bcdbc75eb3",
                        "location": "Pleasanton, CA",
                        "name": "Pleasanton Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "29f69694-5146-4bfb-b2b3-aa52956e3114",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "6a69cf51-74d9-4871-a020-7a26cc1e03a8",
                            "zipCode": "e7654ec4-7c93-4d2e-a586-048286d02972"
                        },
                        "premium": false,
                        "shortName": "Pleasanton Unified School District",
                        "tagline": [
                            "School District",
                            "Pleasanton, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "pleasanton-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Village High School",
                "tagline": [
                    "Pleasanton Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "village-high-school-pleasanton-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 113
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 10
                }
            ],
            "featuredReview": {
                "author": "Parent",
                "body": "My son went here for 2 and a half years.  He was just lost at FHS too many kids too much drama and was ridiculed for getting a B on tests from his teachers and other students - a whole new kind of bullying.  He was so much more relaxed and happy at Village.  I could tell the teachers were very easy going and the whole atmosphere was better.  They had adopted no homework and I was \na very big proponent of this way of teaching - just a great fit for my child.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-09-10T22:54:03.452966Z",
                "guid": "6d37d71a-b1ca-4f2b-ae53-f369b9536d94",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.875,37.6558,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.875,37.6558,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.75,
                "count": 4
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94566"
            }
        ]
    },
    {
        "guid": "c561ace2-7884-4b70-9919-d94024022aa0",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 132,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.963854,
                "lon": -121.772219
            },
            "entity": {
                "abbreviation": "Deer Valley High School",
                "alternates": {
                    "ceeb": "050109",
                    "nces": "060285005724"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "c561ace2-7884-4b70-9919-d94024022aa0",
                "isClaimed": false,
                "isPremium": false,
                "location": "Antioch, CA",
                "name": "Deer Valley High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                    "schoolDistrict": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                    "zipCode": "a67a738f-0765-4797-b0e3-4c395ccd760b"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Antioch Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                        "location": "Antioch, CA",
                        "name": "Antioch Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                            "zipCode": "2026ed1b-602c-43a5-859e-4d5b3ed7410b"
                        },
                        "premium": false,
                        "shortName": "Antioch Unified School District",
                        "tagline": [
                            "School District",
                            "Antioch, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "antioch-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Deer Valley High School",
                "tagline": [
                    "Antioch Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "deer-valley-high-school-antioch-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1986
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I really love the school spirit, events, and activities that our school provides. Our students are very diverse as well as talented. There is an amazing performing art program, where our choirs are taught by an amazingly supportive teacher and win competitions. We also have talented dancers and actors who can really give show-stopping performances. Other than performing arts, we also have an amazing television production class, full of talented students who make the school news, educational skits, event recaps, short films, and graphics. Besides our programs, our school also hosts fun events like rallies, festivals, and planetarium shows. The teachers are also very kind and do an amazing job of preparing students for their future and creating good relationships. If there was anything I'd change is our school's tarnished reputation and our fundings.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-03-14T23:43:36.237596Z",
                "guid": "1fce957b-e6e7-4d89-873c-cb9ba6b4a6c6",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.775,37.9636,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.775,37.9636,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.3464566929133857,
                "count": 508
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94531"
            }
        ]
    },
    {
        "guid": "31d1d05f-5f98-483e-8bdf-236c4de35b8e",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 133,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.761431,
                "lon": -122.427001
            },
            "entity": {
                "abbreviation": "Mission High School",
                "alternates": {
                    "ceeb": "052980",
                    "nces": "063441005650"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "31d1d05f-5f98-483e-8bdf-236c4de35b8e",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Mission High School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "534e0d5b-5645-4a30-91fb-0228f30fbf0a",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "a3ca5eac-7152-427f-be6e-9e3727c508ed"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Mission High School",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "mission-high-school-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1099
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 17
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "Originally transferred to MHS  was because it was close to home and no transportation was needed. I’ve spent 3 years attending the school and it was an amazing experience. Many educators really care about their students and offer resources to support them. Student led activities throughout the years and is inclusive to everyone. Many students want to help each other out as family. The environment of the school is warm although it may have some bad days. At the end of the school day, it becomes a home away from home for many students as it was for me. I’m glad I got the opportunity to be able to attend. Thank you!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-11-24T02:06:55.362754Z",
                "guid": "f90ce2fe-058b-4b7b-82b6-89eac54a4377",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.427,37.7614,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.427,37.7614,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8978494623655915,
                "count": 186
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94114"
            }
        ]
    },
    {
        "guid": "026edd54-46da-49fe-af3d-630d71710433",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 134,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 38.049955,
                "lon": -122.151866
            },
            "entity": {
                "abbreviation": "Liberty High School",
                "alternates": {
                    "nces": "060462000425"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "026edd54-46da-49fe-af3d-630d71710433",
                "isClaimed": true,
                "isPremium": false,
                "location": "Benicia, CA",
                "name": "Liberty High School",
                "parentGUIDs": {
                    "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "7c21191c-eac4-441c-86d9-aee0b22405db",
                    "schoolDistrict": "7c21191c-eac4-441c-86d9-aee0b22405db",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "1f8c93ce-b789-4186-992a-b1f87cc64d9f",
                    "zipCode": "6e4e6d26-8c6c-4784-a6d0-339cc1370fcb"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Benicia Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "7c21191c-eac4-441c-86d9-aee0b22405db",
                        "location": "Benicia, CA",
                        "name": "Benicia Unified School District",
                        "parentGUIDs": {
                            "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "1f8c93ce-b789-4186-992a-b1f87cc64d9f",
                            "zipCode": "6e4e6d26-8c6c-4784-a6d0-339cc1370fcb"
                        },
                        "premium": false,
                        "shortName": "Benicia Unified School District",
                        "tagline": [
                            "School District",
                            "Benicia, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "benicia-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Liberty High School",
                "tagline": [
                    "Benicia Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "liberty-high-school-benicia-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 72
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 14
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.151,38.0501,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.151,38.0501,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.625,
                "count": 8
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94510"
            }
        ]
    },
    {
        "guid": "0865351c-fc1d-413e-9081-ae1f6cdd39e6",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 135,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.251509,
                "lon": -121.820848
            },
            "entity": {
                "abbreviation": "Oak Grove High School",
                "alternates": {
                    "ceeb": "053099",
                    "nces": "061182001305"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "0865351c-fc1d-413e-9081-ae1f6cdd39e6",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Oak Grove High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "078c8917-e52e-4332-af2e-2091c6f2b825",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "656c3aa8-650d-4f5e-97c4-2c4879faa9d3"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Oak Grove High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "oak-grove-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1766
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Moving to San Jose several years ago, I was anxious to attend high school. Knowing it was not like how it was displayed in movies, I questioned how I would personally fit into such environment. The funny thing is, I remember my first day of high school, as a freshmen, like it was just yesterday. To my astonishment, I found myself adjusting quite comfortably into this new community. Three years later, I am writing this experience of mine as a junior! Through my years at Oak Grove, I realize that I needed that extra \"push\" and motivation for me to participate in all the school offers. My high school had various clubs and programs of student involvement, allowing them to engage with real-life situations they can further apply to their future life. I find that Oak Grove has amazing opportunities for  diverse students to strive in their academics and build their identity, through their passions and understandings. Once an eagle, always an eagle. Go eagles, Class of 2021!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-03-27T23:22:58.083071Z",
                "guid": "78664cdb-5634-4a60-a429-d60830045977",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.82,37.2539,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.82,37.2539,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5420054200542004,
                "count": 369
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95123"
            }
        ]
    },
    {
        "guid": "14a94672-2316-41ed-a6dd-ba22a246f131",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 136,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 38.1506,
                "lon": -122.245
            },
            "entity": {
                "abbreviation": "MIT Academy",
                "alternates": {
                    "ceeb": "053833",
                    "nces": "060248310681"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "14a94672-2316-41ed-a6dd-ba22a246f131",
                "isClaimed": true,
                "isPremium": false,
                "location": "Vallejo, CA",
                "name": "Mare Island Technology Academy",
                "parentGUIDs": {
                    "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "cd45ba4f-972c-4537-bd0a-adc5060daf7c",
                    "zipCode": "2a6799d3-4951-4fc5-9600-781d2e0f8833"
                },
                "premium": false,
                "shortName": "MIT Academy",
                "tagline": [
                    "Public School",
                    "Vallejo, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "mare-island-technology-academy-vallejo-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 525
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "MITA has very caring teachers. The very good teachers genuinely care about and connect with their students. They provide good resources for college-readiness, too! One con, however, is that their system to make change within the school's system may be too bureaucratic or unorganized.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-16T21:18:01.313606Z",
                "guid": "cf60a636-deac-4461-8bb0-dfc4fdb94f28",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.245,38.1506,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.245,38.1506,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.3873873873873874,
                "count": 222
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94589"
            }
        ]
    },
    {
        "guid": "6e60eca2-2a0e-4f9c-bbd0-a29d44f8059a",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 137,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.695818,
                "lon": -122.46477
            },
            "entity": {
                "abbreviation": "Jefferson High School",
                "alternates": {
                    "ceeb": "050720",
                    "nces": "061893002293"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "6e60eca2-2a0e-4f9c-bbd0-a29d44f8059a",
                "isClaimed": false,
                "isPremium": false,
                "location": "Daly City, CA",
                "name": "Jefferson High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "88d77336-3b63-4d91-9d64-307e50ca145b",
                    "schoolDistrict": "88d77336-3b63-4d91-9d64-307e50ca145b",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "41a99124-6b7c-496d-9635-39a33c683883",
                    "zipCode": "73a39e4a-bcc0-4688-99ae-a5dc425c236e"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Jefferson Union High School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "88d77336-3b63-4d91-9d64-307e50ca145b",
                        "location": "Daly City, CA",
                        "name": "Jefferson Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "41a99124-6b7c-496d-9635-39a33c683883",
                            "zipCode": "6e76147a-b88b-4659-93c4-fe720003e7e7"
                        },
                        "premium": false,
                        "shortName": "Jefferson Union High School District",
                        "tagline": [
                            "School District",
                            "Daly City, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "jefferson-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Jefferson High School",
                "tagline": [
                    "Jefferson Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "jefferson-high-school-daly-city-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1217
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "Being at Jefferson High School for a total of 4 years, I’ve been able to experience both the good and the ugly. For starters, the environment is decent — there were constant brawls, multiple faulty fire alarms going off, and there were lots of visible cliques, yet that is quite unavoidable. On the other hand, the teachers at this school are very supportive and are always there to give you the help that you need! The teachers do not want to see anyone fail, and it’s clear! One thing I would like to see change is the amount of AP classes that they offer. Sadly, they do not offered that many compared to others schools; however, they are beginning to grow! The sports teams are very lively, and they’ve had quite luck and success for the years that I’ve been there!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-06-25T18:24:27.132401Z",
                "guid": "2e4d9869-449d-45cc-bd52-c4e0fd9be8b6",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.467,37.696,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.467,37.696,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5826771653543306,
                "count": 127
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94014"
            }
        ]
    },
    {
        "guid": "fe735f7f-0ff5-47e1-9c28-de7774156962",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 138,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.473468,
                "lon": -122.203791
            },
            "entity": {
                "abbreviation": "Everest Public High School",
                "alternates": {
                    "ceeb": "054429",
                    "nces": "060222912395"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "fe735f7f-0ff5-47e1-9c28-de7774156962",
                "isClaimed": false,
                "isPremium": false,
                "location": "Redwood City, CA",
                "name": "Everest Public High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "8ea61add-d9d6-43b2-8dbe-55ef0ae2ad16",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "eb3f69c3-e6db-4239-8979-66e40ebafe12",
                    "zipCode": "ddb2570c-2e28-493c-939e-61390b422836"
                },
                "premium": false,
                "shortName": "Everest Public High School",
                "tagline": [
                    "Public School",
                    "Redwood City, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "everest-public-high-school-redwood-city-ca-060222912395",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 407
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My experience here at Everest has been the best 4 years of my entire High School career. I've created so many connections with plenty of the staff and was provided so much guidance and help when needed. The school culture is excellent as well as the involvement of not only the students and staff but from the families as well.  This school has helped me with college applications, seeking help with school work and helping with things outside of school.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-03-24T20:35:57.240559Z",
                "guid": "6e2a1694-551e-4e4b-b94f-bbed1b82c33a",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.204,37.4738,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.204,37.4738,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7333333333333334,
                "count": 15
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94063"
            }
        ]
    },
    {
        "guid": "335a3d77-9230-4f67-9eab-bf91bfbdaabd",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 139,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.926507,
                "lon": -122.024646
            },
            "entity": {
                "abbreviation": "Contra Costa School of Performing Arts",
                "alternates": {
                    "nces": "060233614059"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "335a3d77-9230-4f67-9eab-bf91bfbdaabd",
                "isClaimed": true,
                "isPremium": false,
                "location": "Walnut Creek, CA",
                "name": "Contra Costa School of Performing Arts",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "e3c4436c-7dc9-4c55-8ef7-d47f7a932ba9",
                    "zipCode": "047384f0-7981-4f9a-bed7-6c8444ca2013"
                },
                "premium": false,
                "shortName": "Contra Costa School of Performing Arts",
                "tagline": [
                    "Public School",
                    "Walnut Creek, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "contra-costa-school-of-performing-arts-walnut-creek-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 471
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 27
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I have been at this school since the beginning, and the growth of it has been immense. I am endlessly thankful for the independence I learned at this school to complete my own work, and the in depth art conservatory training I have gained, and would not have been able to gain anywhere else.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-11-26T21:39:00.060377Z",
                "guid": "cb403b24-e944-4894-b5bb-54122e8fe31c",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {},
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.4,
                "count": 5
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94598"
            }
        ]
    },
    {
        "guid": "ad0beb01-42e8-4c4d-8096-12c028d896b2",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 140,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 38.000018,
                "lon": -122.25256
            },
            "entity": {
                "abbreviation": "Hercules High School",
                "alternates": {
                    "ceeb": "051206",
                    "nces": "063255008691"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "ad0beb01-42e8-4c4d-8096-12c028d896b2",
                "isClaimed": true,
                "isPremium": false,
                "location": "Hercules, CA",
                "name": "Hercules High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "schoolDistrict": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "3a20a2dd-d499-4eba-bdbc-675718ad1219",
                    "zipCode": "2a72918e-7bd7-4ca7-8e12-b2ea6b32d398"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "WCCUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "a053a637-da7b-48d7-a67d-fba014c2d452",
                        "location": "Richmond, CA",
                        "name": "West Contra Costa Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                            "zipCode": "9e563e34-37ab-4fc4-b373-ed793d877060"
                        },
                        "premium": false,
                        "shortName": "West Contra Costa Unified School District",
                        "tagline": [
                            "School District",
                            "Richmond, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "west-contra-costa-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Hercules High School",
                "tagline": [
                    "West Contra Costa Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "hercules-high-school-hercules-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 867
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Hercules High School has been a kind school to me over the past four years. The students are very involved in activities and sports which makes up for the lack of parent and staff involvement in organizing events. The staff and teachers are funny and many are passionate on the subject they teach. The school is very diverse as well and the students have passions for their futures. I have made a great connection in being in their yearbook class, which has allowed me to become familiar with our students and staff. The intentions in the people here are good and each grade level has each others back.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-11-15T04:58:47.253336Z",
                "guid": "93b93d02-78a0-4625-88c2-c84f36dcf55c",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.253,37.9994,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.253,37.9994,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.1386861313868613,
                "count": 274
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94547"
            }
        ]
    },
    {
        "guid": "423aa95c-5d06-4901-91df-17c36e3a0f8a",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 141,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.345743,
                "lon": -121.809861
            },
            "entity": {
                "abbreviation": "Mt. Pleasant High School",
                "alternates": {
                    "ceeb": "053094",
                    "nces": "061182001304"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "423aa95c-5d06-4901-91df-17c36e3a0f8a",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Mt. Pleasant High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "259502ce-bdc7-4b71-89e6-a525fa78a771",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "5be5c65e-b5cd-43bf-91dc-4e9af8c6c1f0"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Mt. Pleasant High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "mt-pleasant-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1271
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "The teachers at Mt. Pleasant High School genuinely care about your mental health and overall well-being which is very relieving and comforting (especially during the changes that the pandemic has brought to learning). In addition, they know that some students have difficult home situations (for example, low-income) and they always speak to the students to see how they can help them. The culture at MP has shown me that money and prestige do not mean a thing when there is a vibrant and connected community to make your high school experience worthwhile. As a senior, I am extremely proud to carry the MP name with me.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-03-04T03:51:19.358485Z",
                "guid": "1ebe356e-924f-40e4-8a94-47987ad2a735",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.808,37.3462,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.808,37.3462,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.498567335243553,
                "count": 349
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95127"
            }
        ]
    },
    {
        "guid": "49949a9e-a44e-4e70-af78-1866cf058145",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 142,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.495131,
                "lon": -122.237646
            },
            "entity": {
                "abbreviation": "Redwood High School",
                "alternates": {
                    "ceeb": "052603",
                    "nces": "063639006196"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "49949a9e-a44e-4e70-af78-1866cf058145",
                "isClaimed": false,
                "isPremium": false,
                "location": "Redwood City, CA",
                "name": "Redwood High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "e9b53ea4-d69f-427a-bfce-9b5afaca3303",
                    "parent": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                    "schoolDistrict": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "5ca486a6-52a6-4b83-aeda-db4b437b4d7f",
                    "zipCode": "ddb2570c-2e28-493c-939e-61390b422836"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "98b766b3-1e08-4fd9-b0cf-7495cf989c2c",
                        "location": "Redwood City, CA",
                        "name": "Sequoia Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a5dafe95-b00a-4d53-8912-9559cbb65dd9",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "5ca486a6-52a6-4b83-aeda-db4b437b4d7f",
                            "zipCode": "7d773137-7242-4cc9-91c9-d3770c1b9f33"
                        },
                        "premium": false,
                        "shortName": "Sequoia Union High School District",
                        "tagline": [
                            "School District",
                            "Redwood City, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "sequoia-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Redwood High School",
                "tagline": [
                    "Sequoia Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "redwood-high-school-redwood-city-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 227
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.244,37.4952,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.244,37.4952,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 2.857142857142857,
                "count": 7
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94063"
            }
        ]
    },
    {
        "guid": "3df0c4a7-814e-4df0-b99a-f4ffa6b595c4",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 143,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.329548,
                "lon": -121.830065
            },
            "entity": {
                "abbreviation": "William C. Overfelt High School",
                "alternates": {
                    "ceeb": "053107",
                    "nces": "061182001306"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "3df0c4a7-814e-4df0-b99a-f4ffa6b595c4",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "William C. Overfelt High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "259502ce-bdc7-4b71-89e6-a525fa78a771",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "ac9aac5c-c77f-4b0d-8bc0-ae6dfa42a701"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "William C. Overfelt High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "william-c-overfelt-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1438
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "High school was a huge game-changer for me. I came out of middle school as a despondent and pessimistic kid who was constantly bored with how little there was to do in school. I didn't have any school resources or exciting programs that brought me closer to my friends and teachers. That all turned around when I came to Overfelt, where I met people who were truly happy to be a part of the school. The teachers are constantly interacting with students and supporting their learning. I made my 2 best friends and started the Super Gaming Club with them. We've gone on so many adventures together and worked to create something that has brought joy to other students and school members as well. There have been so many kind people that have helped me along the way, and I couldn't be more grateful to the school and the people that I've met in my 4 years here. Even while being stuck at home, Overfelt has been a place that I will never forget and I'd love to return there to make more memories soon.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-09-09T21:36:44.65024Z",
                "guid": "58d12e95-e99e-464a-8bea-5e96485ea8a3",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.83,37.3305,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.83,37.3305,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7471264367816093,
                "count": 261
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95122"
            }
        ]
    },
    {
        "guid": "18bc98cb-3e69-4926-ab38-2669a8766b26",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 144,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.74575,
                "lon": -122.450792
            },
            "entity": {
                "abbreviation": "Academy of Arts & Sciences",
                "alternates": {
                    "ceeb": "054439",
                    "nces": "063441012526"
                },
                "character": "Public, Magnet, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Magnet School",
                "guid": "18bc98cb-3e69-4926-ab38-2669a8766b26",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "The Academy - San Francisco at McAteer",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "554d2930-0795-4eee-a305-65351bba79b6",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "ee205ed4-1f3f-448a-8f17-065ffce55d35"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Academy of Arts & Sciences",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "the-academy---san-francisco-at-mcateer-san-francisco-ca",
                "variation": 52
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 358
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Parent",
                "body": "So far excellent. My son loves the teachers and students here. My husband and I love the teacher, staff and college prep they offer here too. My son can earn college credits in his senior year at this school too! We came from parochial school which not a great experience for my son.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-09-05T15:24:32.029448Z",
                "guid": "df0d9397-5909-4421-ad89-5d2a8ebbba88",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.449,37.7451,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.449,37.7451,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5825242718446604,
                "count": 103
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94131"
            }
        ]
    },
    {
        "guid": "03ad624d-e368-45cd-a934-1475a0341b71",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 145,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.631327,
                "lon": -122.102475
            },
            "entity": {
                "abbreviation": "Impact Academy of Arts & Technology",
                "alternates": {
                    "ceeb": "054255",
                    "nces": "060164711849"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "03ad624d-e368-45cd-a934-1475a0341b71",
                "isClaimed": false,
                "isPremium": false,
                "location": "Hayward, CA",
                "name": "Impact Academy of Arts & Technology",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "723769d9-71d5-4272-8024-340ffcff7fcc",
                    "schoolNetwork": "f55e8d73-7e39-4bee-8c3f-7e814462499a",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                    "zipCode": "e8c32215-6d14-4b33-82bd-2d41b6b32206"
                },
                "premium": false,
                "shortName": "Impact Academy of Arts & Technology",
                "tagline": [
                    "Public School",
                    "Hayward, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "impact-academy-of-arts--and--technology-hayward-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 842
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 26
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Impact Academy is very community-centric! They really prepare their students for college-level critical thinking and problem-solving. However, their science and math classes often suffer because of their issues with teacher retention. Their teachers and faculty support the students and ensure every student feels recognized and uplifted.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-19T09:32:52.880309Z",
                "guid": "beb830c9-cb86-4aee-8f39-4058a4b8765a",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.102,37.6313,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.102,37.6313,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5317073170731708,
                "count": 205
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94545"
            }
        ]
    },
    {
        "guid": "35931e90-942d-4149-a97c-bea948eede23",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 146,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.773714,
                "lon": -122.185508
            },
            "entity": {
                "abbreviation": "Oakland Unity High School",
                "alternates": {
                    "ceeb": "052484",
                    "nces": "060229211351"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "35931e90-942d-4149-a97c-bea948eede23",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Oakland Unity High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "3816271d-bf9c-431c-9e92-8f63ddf53940"
                },
                "premium": false,
                "shortName": "Oakland Unity High School",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "oakland-unity-high-school-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 359
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Oakland Unity High School is an amazing charter school! I have spent my whole high school experience in this school and I’m so happy I did. I love my classmates and my teachers, I live how our school have born we actually follow in order to respect ourself and others. We are a very small school but we have a big heart and mind to help our community and others as well. My school so far is the best my principle is amazing at his job and I love how he’s always there to support us and watching us through our journey. All my teacher are amazing as well I get the help needed when I need it and I always love that. I could not have chose other school that is not Oakland Unity High School. They help us get our credits that are necessary for college and prepare us in order to be ready to go to college.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-10-12T06:33:07.119564Z",
                "guid": "8b3d9078-278a-4000-8c96-360bdce0a656",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.185,37.7736,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.185,37.7736,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8793103448275863,
                "count": 58
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94605"
            }
        ]
    },
    {
        "guid": "559e1097-e6b6-4157-9e25-f4bdc8536423",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 147,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.968592,
                "lon": -122.325832
            },
            "entity": {
                "abbreviation": "Vista High (Alternative)",
                "alternates": {
                    "ceeb": "052632",
                    "nces": "063255010198"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "559e1097-e6b6-4157-9e25-f4bdc8536423",
                "isClaimed": true,
                "isPremium": false,
                "location": "San Pablo, CA",
                "name": "Vista High (Alternative)",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "schoolDistrict": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                    "zipCode": "a08c6674-b67b-4d2b-976e-ac88b0619d80"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "WCCUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "a053a637-da7b-48d7-a67d-fba014c2d452",
                        "location": "Richmond, CA",
                        "name": "West Contra Costa Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                            "zipCode": "9e563e34-37ab-4fc4-b373-ed793d877060"
                        },
                        "premium": false,
                        "shortName": "West Contra Costa Unified School District",
                        "tagline": [
                            "School District",
                            "Richmond, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "west-contra-costa-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Vista High (Alternative)",
                "tagline": [
                    "West Contra Costa Unified School District, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "vista-high-alternative-san-pablo-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 253
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 14
                }
            ],
            "featuredReview": {
                "author": "Parent",
                "body": "My son starting attending in his sophomore year because he was having health issues and was missing too much school and falling behind at his regular high school.  Vista's one on one program was great for him.  He thrived at Vista and was even able to do concurrent classes at the local community college.  He enjoyed his supervising teacher who was the same for all three years.  He graduated ahead of schedule and was just accepted to UC Berkeley!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-22T03:21:15.105996Z",
                "guid": "036baa71-5b61-41fb-9ec6-822742576312",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.325,37.9686,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.325,37.9686,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.285714285714286,
                "count": 7
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94806"
            }
        ]
    },
    {
        "guid": "d7822d39-5bba-475e-9b88-c37616488287",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 148,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.320733,
                "lon": -121.848264
            },
            "entity": {
                "abbreviation": "Yerba Buena High School",
                "alternates": {
                    "ceeb": "053113",
                    "nces": "061182001310"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "d7822d39-5bba-475e-9b88-c37616488287",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Yerba Buena High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "259502ce-bdc7-4b71-89e6-a525fa78a771",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "ac9aac5c-c77f-4b0d-8bc0-ae6dfa42a701"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Yerba Buena High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "yerba-buena-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1706
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My experience here at Yerba Buena High has been the best! The teachers, staff, and counselors are very nice and welcoming. The campus is superb with its new addition; The Student Union. I highly recommend attending Yerba Buena High if you are interested in a nice campus, excellent teachers, and great staff members to help you achieve your goals in the near future.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-05-21T16:55:01.043412Z",
                "guid": "573292ea-ae69-4d24-81ef-d37dbe27d640",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.849,37.3184,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.849,37.3184,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.552825552825553,
                "count": 407
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95122"
            }
        ]
    },
    {
        "guid": "65849b01-1855-498c-a533-ea8da97f7038",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 149,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.763185,
                "lon": -122.464044
            },
            "entity": {
                "abbreviation": "Independence High School",
                "alternates": {
                    "ceeb": "052998",
                    "nces": "063441007840"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "65849b01-1855-498c-a533-ea8da97f7038",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Independence High School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "a050bfe7-0851-4a3d-8418-018310efa8a2",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "b4e89c98-14e0-415a-81a3-67446f01feef"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Independence High School",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "independence-high-school-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 186
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 14
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "I've just graduated from this school, and honestly, I really enjoyed my experience, but many might beg to differ. Independence High School is a SFUSD alternative school that uses the independent study curriculum, and is intended for those who need remedial courses, and/or just find the traditional school not suitable for their needs. Having transferred here after dwindling for a few years at my old, artistically + academically challenging school, and battling through mental health issues, I was able to heal. In addition, I was able to flourish intellectually, socially, and as a persn due to the extra time that Independence gave me throughout the week, as we were only required to go once a week. The extra time allowed me to work directly in my communities, take classes at CCSF, pursue internships, create art, music, dance and so much more, all while learning time management & self reliance. I just wish that the school provided more rigorous/challenging coursework options, so that I could have been challenged more academically as well, but that can be achieved through dual enrollment at CCSF/Skyline. Speaking on other things----the building itself is near spotless & really nice; there's a lot of resources, like new books, macbook airs/pros, 3d printer, etc.;the wellness center is so comfortable and fantastic; teachers/staff are so sociable, helpful, approachable, and amazing. At Independence, I got extremely involved with the prom committee, which turned out to be a success, and that's def one of the highlights of my time there, amongst many. I've met some of the most amazing, resilient people, grown, and had an amazing time all in all----this school is truly a hidden gem in the school system. It's also what you make of the experience, and for me, I guess I tried my best to make the most out of it, and it turned out. There's so many more things I can say about this fantastic school, but there's not enough words to do so, so I'll just give it all my love & gratitude.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2016-07-21T04:30:36Z",
                "guid": "2c6870aa-3a99-47be-a92a-39ea1c3bd9d8",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.464,37.7633,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.464,37.7633,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6,
                "count": 5
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94122"
            }
        ]
    },
    {
        "guid": "69c227be-e7ae-40e2-bcb8-008ae42cc4ec",
        "badge": {
            "display": "Best Public High Schools in San Francisco Bay Area",
            "ordinal": 150,
            "total": 255,
            "vanityURL": "best-public-high-schools/m/san-francisco-metro-area",
            "photoURLs": {
                "desktop": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_2048.png",
                "mobile": "https://d33a4decm84gsn.cloudfront.net/search/2021/k12/k12-public-schools_640.png"
            }
        },
        "content": {
            "centroid": {
                "lat": 37.71865,
                "lon": -122.144286
            },
            "entity": {
                "abbreviation": "San Leandro High School",
                "alternates": {
                    "ceeb": "053120",
                    "nces": "063468005842"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "69c227be-e7ae-40e2-bcb8-008ae42cc4ec",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Leandro, CA",
                "name": "San Leandro High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "b6ea04ec-14e7-4ba5-9f67-a30aeade2aae",
                    "parent": "703b106b-ed91-4085-98d4-5867e5f04ecb",
                    "schoolDistrict": "703b106b-ed91-4085-98d4-5867e5f04ecb",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "97147736-91ca-4fcf-8a1e-c9419d2d2593",
                    "zipCode": "0418db05-538d-429e-a8b8-8b6441797a1d"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "San Leandro Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "703b106b-ed91-4085-98d4-5867e5f04ecb",
                        "location": "San Leandro, CA",
                        "name": "San Leandro Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a2d1b6e7-6b04-4cd6-a4bf-7eadb1067cb7",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "97147736-91ca-4fcf-8a1e-c9419d2d2593",
                            "zipCode": "0418db05-538d-429e-a8b8-8b6441797a1d"
                        },
                        "premium": false,
                        "shortName": "San Leandro Unified School District",
                        "tagline": [
                            "School District",
                            "San Leandro, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-leandro-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "San Leandro High School",
                "tagline": [
                    "San Leandro Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "san-leandro-high-school-san-leandro-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2652
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I just transferred to this school my senior year, and it has been the best year for me in my high school career. The community here is amazing, the teachers are understanding and respectful. Overall, I've never received as good of grades as I did this semester, because I actually learned! The honors and AP program they offer here are perfect for those who want to go above and beyond with their academics.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-03-03T16:55:07.673391Z",
                "guid": "93e52e93-4b40-4979-9272-88143ac86d1e",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 3
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.141,37.7185,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.141,37.7185,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.4197292069632494,
                "count": 517
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94577"
            }
        ]
    },
    {
        "guid": "916d51ec-7563-495b-a339-f1df45b859fc",
        "content": {
            "centroid": {
                "lat": 37.934277,
                "lon": -122.528511
            },
            "entity": {
                "abbreviation": "San Andreas High School",
                "alternates": {
                    "ceeb": "051366",
                    "nces": "063879006524"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "916d51ec-7563-495b-a339-f1df45b859fc",
                "isClaimed": false,
                "isPremium": false,
                "location": "Larkspur, CA",
                "name": "San Andreas High School",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "7fb983ef-9045-46a8-beff-5675b1357340",
                    "schoolDistrict": "7fb983ef-9045-46a8-beff-5675b1357340",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "db131da3-37dc-42cf-aad2-15024d364e4d",
                    "zipCode": "f981dbb9-3c01-40c1-97a3-f476d8291c9a"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "TUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "7fb983ef-9045-46a8-beff-5675b1357340",
                        "location": "Larkspur, CA",
                        "name": "Tamalpais Union High School District",
                        "parentGUIDs": {
                            "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "db131da3-37dc-42cf-aad2-15024d364e4d",
                            "zipCode": "f981dbb9-3c01-40c1-97a3-f476d8291c9a"
                        },
                        "premium": false,
                        "shortName": "Tamalpais Union High School District",
                        "tagline": [
                            "School District",
                            "Larkspur, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "tamalpais-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "San Andreas High School",
                "tagline": [
                    "Tamalpais Union High School District, CA",
                    "10-12"
                ],
                "type": "School",
                "url": "san-andreas-high-school-larkspur-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 69
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 12
                }
            ],
            "featuredReview": {
                "author": "Parent",
                "body": "My daughter transferred to San Andreas, because she was not doing well\nin high school. She never enjoyed school. At that point, her goal was to get her high school diploma as soon as possible and then get a job. The supportive atmosphere and engaging teachers, sparked her interest in learning for the first time. She realized that she was capable of getting good grades, her opinions counted and now she is starting her second year of college. I know that it was her time at San Andreas that was the game-changer for her.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-08-16T19:32:59.91664Z",
                "guid": "b75ad533-9a5e-45eb-857c-282b6a283ac2",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.529,37.934,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.529,37.934,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.4,
                "count": 5
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94939"
            }
        ]
    },
    {
        "guid": "85661b38-d7b6-487b-8783-619d6195b2d3",
        "content": {
            "centroid": {
                "lat": 37.523453,
                "lon": -122.004845
            },
            "entity": {
                "abbreviation": "Newark Memorial High School",
                "alternates": {
                    "ceeb": "052114",
                    "nces": "062706004085"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "85661b38-d7b6-487b-8783-619d6195b2d3",
                "isClaimed": false,
                "isPremium": false,
                "location": "Newark, CA",
                "name": "Newark Memorial High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "76fb7aec-f438-42a3-82f2-6ad1f6bf15f5",
                    "schoolDistrict": "76fb7aec-f438-42a3-82f2-6ad1f6bf15f5",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "ed699caa-41e0-4b17-9bf6-cddf0a782bac",
                    "zipCode": "27c6b5a2-f312-47d3-873e-e798e3f00196"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Newark Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "76fb7aec-f438-42a3-82f2-6ad1f6bf15f5",
                        "location": "Newark, CA",
                        "name": "Newark Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "ed699caa-41e0-4b17-9bf6-cddf0a782bac",
                            "zipCode": "27c6b5a2-f312-47d3-873e-e798e3f00196"
                        },
                        "premium": false,
                        "shortName": "Newark Unified School District",
                        "tagline": [
                            "School District",
                            "Newark, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "newark-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Newark Memorial High School",
                "tagline": [
                    "Newark Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "newark-memorial-high-school-newark-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1711
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 29
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "My experience at Newark memorial high school was good. The staff there was very helpful in ways and the teachers there were very helpful when it came down to helping those who didn’t understand the material. I liked how Newark memorial involved the students by having their club day and also having events to support clubs there. For instance, there was an event for day of the dead that was by MEChA and Folklorico. Something I would like to see change is preparing the seniors for college. As for me, It was a bit hectic going from high school to college because everything is very different compared to being with the same people for four years and having less things related to work to do in high school compared to college.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-08-31T06:37:55.063295Z",
                "guid": "070c11eb-55a6-4b76-b4a7-bb645b0bdd72",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.002,37.5202,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.002,37.5202,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.300395256916996,
                "count": 253
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94560"
            }
        ]
    },
    {
        "guid": "7d0510ae-ab9c-4ddb-ba00-e20e180d6d46",
        "content": {
            "centroid": {
                "lat": 37.672093,
                "lon": -122.0980352
            },
            "entity": {
                "abbreviation": "Silver Oak High Public Montessori Charter School",
                "alternates": {
                    "nces": "060223813531"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "7d0510ae-ab9c-4ddb-ba00-e20e180d6d46",
                "isClaimed": false,
                "isPremium": false,
                "location": "Hayward, CA",
                "name": "Silver Oak High Public Montessori Charter School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "79a41c1b-d6de-4e7f-888d-c9468fac9c1c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                    "zipCode": "6933fc80-ff2d-4020-ab31-239bec481049"
                },
                "premium": false,
                "shortName": "Silver Oak High Public Montessori Charter School",
                "tagline": [
                    "Public School",
                    "Hayward, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "silver-oak-high-public-montessori-charter-school-hayward-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 218
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "The school is really small in a good way. There are about 20-27 students per class making it easy to receive help from a teacher in a fast manner. The school does lack programs and a variety of sports but that's okay because it's really small so it makes sense as to why there aren't a lot of sports/programs available. The school highly emphasizes we are a community made up of the staff, students, and teachers and I agree that we are. Everything is communicated to everyone really easily and we just work together to have the best learning environment possible.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-01T20:41:48.940128Z",
                "guid": "9947c55e-f363-492c-9535-33a0cb7fffcd",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.0980352,37.672093,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.0980352,37.672093,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.823529411764706,
                "count": 17
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94541"
            }
        ]
    },
    {
        "guid": "c3ae4307-7d52-40f9-a047-0b66f521fe64",
        "content": {
            "centroid": {
                "lat": 37.625365,
                "lon": -122.090578
            },
            "entity": {
                "abbreviation": "Mt. Eden High School",
                "alternates": {
                    "ceeb": "051153",
                    "nces": "061674002124"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "c3ae4307-7d52-40f9-a047-0b66f521fe64",
                "isClaimed": false,
                "isPremium": false,
                "location": "Hayward, CA",
                "name": "Mt. Eden High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "723769d9-71d5-4272-8024-340ffcff7fcc",
                    "parent": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                    "schoolDistrict": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                    "zipCode": "e8c32215-6d14-4b33-82bd-2d41b6b32206"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "HUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                        "location": "Hayward, CA",
                        "name": "Hayward Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "3ee6b10e-9c9c-43c9-bee6-1755097895e1",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                            "zipCode": "72f14b46-7398-463c-a7b1-84d94dfe3a97"
                        },
                        "premium": false,
                        "shortName": "Hayward Unified School District",
                        "tagline": [
                            "School District",
                            "Hayward, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "hayward-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Mt. Eden High School",
                "tagline": [
                    "Hayward Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "mt-eden-high-school-hayward-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1979
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My overall experience going to this High School has been a memorable one. Students and Staff are welcoming. The staff truly care about seeing the students succeed and put their best foot forward in making sure we understand the concepts they teach us. There are a variety of clubs that students can choose from that would best suit their interests. As there are also numerous sports students can be apart of aside from their school work. There's also an annual event at Mt. Eden that happens every year, It's Monarch day. This day brings students, staffs, parents and alumni all together. The school spirit is high, an experience that I won't ever forget. As well as that, there are extracurricular programs students can involve themselves in like Dance, Choir, Art, Band, and more! This school offers more than meets the eye. Definitely recommend.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-10-13T00:35:42.514048Z",
                "guid": "ce27e076-7bcf-4ae4-ba57-72988ab4c07f",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.09,37.6248,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.09,37.6248,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5219399538106235,
                "count": 433
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94545"
            }
        ]
    },
    {
        "guid": "7aa08a1b-421b-46ad-9018-5ef779c222aa",
        "content": {
            "centroid": {
                "lat": 37.933991,
                "lon": -122.361084
            },
            "entity": {
                "abbreviation": "Leadership Public Schools: Richmond",
                "alternates": {
                    "ceeb": "053970",
                    "nces": "060189211225"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "7aa08a1b-421b-46ad-9018-5ef779c222aa",
                "isClaimed": false,
                "isPremium": false,
                "location": "Richmond, CA",
                "name": "Leadership Public Schools: Richmond",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "schoolNetwork": "b417dc33-d284-4a75-aa5f-71849ab590fa",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                    "zipCode": "9e563e34-37ab-4fc4-b373-ed793d877060"
                },
                "premium": false,
                "shortName": "Leadership Public Schools: Richmond",
                "tagline": [
                    "Public School",
                    "Richmond, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "leadership-public-schools--richmond-richmond-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 597
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "Leadership Public Schools Richmond was a good school that offered us many resources and opportunities to prepare us for the college experience. They had a mission to get us all into college and the teacher student relationships were very enriching! However, they did hold our hands too often which held back the potential academic rigor that could have helps us with the high school college transition.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-03-14T06:37:27.233914Z",
                "guid": "2e328c29-d48b-418c-a5b7-132d1ee427e1",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.361,37.9341,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.361,37.9341,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8686131386861313,
                "count": 137
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94801"
            }
        ]
    },
    {
        "guid": "1309e652-5c44-4d8c-92c9-07476c1c1d78",
        "content": {
            "centroid": {
                "lat": 37.798182,
                "lon": -122.164644
            },
            "entity": {
                "abbreviation": "Skyline High School",
                "alternates": {
                    "ceeb": "052238",
                    "nces": "062805004315"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "1309e652-5c44-4d8c-92c9-07476c1c1d78",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Skyline High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "b96fa3ea-8713-4581-93cb-036864769ed5"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Skyline High School",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "skyline-high-school-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1592
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 15
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Honestly Skyline is a great school, like every other public school, we have our ups and downs when it comes to cleanliness and the quality of certain teachers, but Skyline always makes sure to prioritize its students in the best way possible! Skyline will always try to do their best that they can to provide for their students and the students will always make sure that their voices are heard no matter what.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-21T23:40:07.584265Z",
                "guid": "56c737ba-779e-4f0d-bb6f-8062691b35ed",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.161,37.7985,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.161,37.7985,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.3555555555555556,
                "count": 405
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94619"
            }
        ]
    },
    {
        "guid": "9fd7ee45-6bb3-41aa-bfab-74d64af7713f",
        "content": {
            "centroid": {
                "lat": 37.326436,
                "lon": -121.834562
            },
            "entity": {
                "abbreviation": "Alpha Cindy Avitia High School",
                "alternates": {
                    "nces": "060163613926"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "9fd7ee45-6bb3-41aa-bfab-74d64af7713f",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Alpha Cindy Avitia High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "259502ce-bdc7-4b71-89e6-a525fa78a771",
                    "schoolNetwork": "32061b3b-37e5-4624-a58b-532086d3e22f",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "ac9aac5c-c77f-4b0d-8bc0-ae6dfa42a701"
                },
                "premium": false,
                "shortName": "Alpha Cindy Avitia High School",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "alpha-cindy-avitia-high-school-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 438
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 17
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "Alpha Cindy Avitia is on the smaller side of your average high school, it is basically a one hallway charter school. They do offer a good amount of sports like soccer, basketball, and track but compared to other schools they don't have as many options. They have many rallies and many spirt weeks to compensate for there size and lack of funding but where they lack in funding they make up for in enthusiasm. All the staff here strives for you to get to college and pushes you towards more ap classes and in taking more extracurricular activities. All the teachers make you want to go to class, they find ways to relate to you and guide you in the right direction. They make students feel like they are in a safe space to learn and grow, as it should be, and the staff is always looking out for you.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-08T19:08:16.164323Z",
                "guid": "f324a809-74bc-4868-a230-278ae11ca38d",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.834,37.3265,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.834,37.3265,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8333333333333335,
                "count": 12
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95122"
            }
        ]
    },
    {
        "guid": "f3a54ca2-4335-480c-aa61-12af24b0ca52",
        "content": {
            "centroid": {
                "lat": 37.971794,
                "lon": -121.732228
            },
            "entity": {
                "abbreviation": "Freedom High School",
                "alternates": {
                    "ceeb": "050372",
                    "nces": "062160005726"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "f3a54ca2-4335-480c-aa61-12af24b0ca52",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakley, CA",
                "name": "Freedom High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                    "schoolDistrict": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "6ee6365f-3e69-4aad-a8df-5cd72ae38991",
                    "zipCode": "4e62bbb5-5683-41cb-a3ca-4f5f14325035"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Liberty Union High School District (Brentwood)",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                        "location": "Brentwood, CA",
                        "name": "Liberty Union High School District (Brentwood)",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "8c697687-c0ec-469c-98e8-e0a06e72a35a",
                            "zipCode": "fea44aef-6d39-4c1c-9267-b5b70ebd1cf5"
                        },
                        "premium": false,
                        "shortName": "Liberty Union High School District (Brentwood)",
                        "tagline": [
                            "School District",
                            "Brentwood, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "liberty-union-high-school-district-brentwood-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Freedom High School",
                "tagline": [
                    "Liberty Union High School District (Brentwood), CA",
                    "9-12"
                ],
                "type": "School",
                "url": "freedom-high-school-oakley-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2589
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Before Freshman year started, I had just moved away from my home city and moved into the smaller/developing city, Oakley, California. I was saddened by the fact that I had no close friends to talk to face-to-face nor did I know anyone. This didn't last quite long of course. Freedom High did an amazing job keeping me intact with my education and many students were open to conversing with me everyday. There were many events to look forward to throughout the school year such as Spirit Weeks and Friday rallies which had me screaming and chanting with my and for my Class of 2020 team. As a student diving into my senior year, I'll admit there were many hardships to pull through during my previous years as a Freshman, Sophomore, and Junior. This was mainly because I had challenged myself rigorously by taking numerous AP classes. Freedom High offers many AP courses to take for those willing to push themselves and a wide variety in elective classes as well. Overall, I enjoy Freedom!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-08-27T05:13:05.297505Z",
                "guid": "cf8a9e40-30a6-47ee-b160-58c80408329e",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.718,37.9706,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.718,37.9706,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.607717041800643,
                "count": 622
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94561"
            }
        ]
    },
    {
        "guid": "ee065529-6474-4f8d-bfbf-986ff75a5f51",
        "content": {
            "centroid": {
                "lat": 37.29342,
                "lon": -121.833214
            },
            "entity": {
                "abbreviation": "Andrew P. Hill High School",
                "alternates": {
                    "ceeb": "053077",
                    "nces": "061182001301"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "ee065529-6474-4f8d-bfbf-986ff75a5f51",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Andrew P. Hill High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "b3810c50-1d1b-4a15-8c27-36f244515bfd",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "22009871-64c9-41cb-9a56-3fd200b76810"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Andrew P. Hill High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "andrew-p-hill-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1867
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "As a recent alum, your experience at Andrew Hill is truly what you make of it. I was in the IB Diploma Program and the Medical Magnet Program at Andrew Hill and those two pathways were what made attending Andrew Hill worthwhile and the right decision for me. I think if I weren't in these two programs, my experience here would not be the same. My experience in IB Diploma gave me a community, encouraging teachers, and helped me find my place at this school. IB Diploma was definitely tough, but prepared me for college, helped me grow as a learner, and made me into a more resilient individual. The people in IB also made my experience at this school great. If you know that you want to be challenged and have the capacity to do well in an environment where resources aren't always handed to you, you should attend Andrew Hill, as it will push you to grow. I highly recommend the IB Diploma Program and the Medical Magnet Program at this school!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-12-24T22:42:21.052868Z",
                "guid": "652e001e-8f00-4b43-a2bd-3d83b65a70ba",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.83,37.2932,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.83,37.2932,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.3598326359832638,
                "count": 478
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95111"
            }
        ]
    },
    {
        "guid": "bbd77c11-c973-421f-9324-fea98282f2d1",
        "content": {
            "centroid": {
                "lat": 37.76856,
                "lon": -122.154338
            },
            "entity": {
                "abbreviation": "BayTech",
                "alternates": {
                    "ceeb": "054301",
                    "nces": "060182710720"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "bbd77c11-c973-421f-9324-fea98282f2d1",
                "isClaimed": true,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Bay Area Technology School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "3816271d-bf9c-431c-9e92-8f63ddf53940"
                },
                "premium": false,
                "shortName": "BayTech School",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "bay-area-technology-school-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 299
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "I attended Baytech from year 2014-2017. In those few years I had soo many opportunities presented to me! I felt safe and that my knowledge was actually being used around the school! I was a student athlete and created relationships with the entire school! Then comes a day where I felt I wa seeing surrounded by family not just students and teachers.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-06-17T18:49:04.103933Z",
                "guid": "176b7c2b-d620-432f-8be4-5b802e29c102",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.154,37.7662,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.154,37.7662,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6875,
                "count": 16
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour",
                    "value": "https://youtu.be/BogOrJye7Hw"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94605"
            },
            {
                "label": "Virtual Tour",
                "type": "virtualTour",
                "url": "https://youtu.be/BogOrJye7Hw"
            }
        ]
    },
    {
        "guid": "d7655a8c-78f7-4efc-a1ed-5112de380bc4",
        "content": {
            "centroid": {
                "lat": 37.4682466,
                "lon": -122.1278977
            },
            "entity": {
                "abbreviation": "Aspire East Palo Alto Charter School",
                "alternates": {
                    "ceeb": "054257",
                    "nces": "060160414051"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "d7655a8c-78f7-4efc-a1ed-5112de380bc4",
                "isClaimed": false,
                "isPremium": false,
                "location": "East Palo Alto, CA",
                "name": "Aspire East Palo Alto Charter School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "schoolNetwork": "6d55fb3e-0771-4fa6-bff7-2753f0a42065",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "bc4a42c3-a2f5-452a-9b9e-175d4f05cb82",
                    "zipCode": "e91bfc0c-bca1-45d4-909a-25b104b8c881"
                },
                "premium": false,
                "shortName": "Aspire East Palo Alto Charter School",
                "tagline": [
                    "Public School",
                    "East Palo Alto, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "aspire-east-palo-alto-charter-school-east-palo-alto-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 648
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 27
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.1278977,37.4682466,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.1278977,37.4682466,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 2.8,
                "count": 5
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94303"
            }
        ]
    },
    {
        "guid": "bded513b-28de-4805-a996-5924e242c47c",
        "content": {
            "centroid": {
                "lat": 37.93765,
                "lon": -122.024072
            },
            "entity": {
                "abbreviation": "Ygnacio Valley High School",
                "alternates": {
                    "ceeb": "050663",
                    "nces": "062637003986"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "bded513b-28de-4805-a996-5924e242c47c",
                "isClaimed": false,
                "isPremium": false,
                "location": "Concord, CA",
                "name": "Ygnacio Valley High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "schoolDistrict": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "187f89d7-6963-49c2-b924-426631dae88f",
                    "zipCode": "6b58b2cc-6f28-4ab5-9cae-5d07eb3c2450"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "MDUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                        "location": "Concord, CA",
                        "name": "Mt. Diablo Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "187f89d7-6963-49c2-b924-426631dae88f",
                            "zipCode": "fca2caaa-dbcc-472c-be69-c07f58b2a359"
                        },
                        "premium": false,
                        "shortName": "Mt. Diablo Unified School District",
                        "tagline": [
                            "School District",
                            "Concord, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mt-diablo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Ygnacio Valley High School",
                "tagline": [
                    "Mt. Diablo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "ygnacio-valley-high-school-concord-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1220
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My experience at Ygnacio Valley is really good, I enjoy being  in a diverse environment. What I like about Ygnacio Valley is the IB Program that they have, the IB program consist of classes such as the AP but more complex, our school is the only one that has it in the district.  Being a full diploma of IB has gave me the opportunity to prepare myself for collage and develop my educational skills, the IB program is one of the amazing programs that Ygnacio Valley has. I also enjoy getting the chance to meet people around the world, the good thing at Ygnacio Valley is the diversity, there are people from Mexico, El Salvador, South Korea, Spain, Brazil, etc.  Every 5 years they have a multicultural rally and I had the opportunity to be part of it, it was really wonderful seeing people representing their culture.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-03-11T18:47:33.778511Z",
                "guid": "2209fddb-d68d-425e-9ffc-4d286ae9af36",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.025,37.9348,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.025,37.9348,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.488,
                "count": 125
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94518"
            }
        ]
    },
    {
        "guid": "e13720a8-49a8-4e1a-adad-1f5bf487a4d4",
        "content": {
            "centroid": {
                "lat": 37.776361,
                "lon": -122.282279
            },
            "entity": {
                "abbreviation": "Island High School",
                "alternates": {
                    "ceeb": "050017",
                    "nces": "060177000048"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "e13720a8-49a8-4e1a-adad-1f5bf487a4d4",
                "isClaimed": false,
                "isPremium": false,
                "location": "Alameda, CA",
                "name": "Island High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "3bfe75ba-c072-458a-a742-96bca1544408",
                    "schoolDistrict": "3bfe75ba-c072-458a-a742-96bca1544408",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "54a953dd-3bdc-47b1-b465-0e4d3705637e",
                    "zipCode": "a2b1830b-98f1-4ebd-83e1-b3e0b4fdffcb"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "AUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "3bfe75ba-c072-458a-a742-96bca1544408",
                        "location": "Alameda, CA",
                        "name": "Alameda Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "54a953dd-3bdc-47b1-b465-0e4d3705637e",
                            "zipCode": "a2b1830b-98f1-4ebd-83e1-b3e0b4fdffcb"
                        },
                        "premium": false,
                        "shortName": "Alameda City Unified School District",
                        "tagline": [
                            "School District",
                            "Alameda, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "alameda-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Island High School",
                "tagline": [
                    "Alameda Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "island-high-school-alameda-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 96
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 11
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.281,37.7759,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.281,37.7759,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3,
                "count": 3
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94501"
            }
        ]
    },
    {
        "guid": "a1d29773-cc8b-4cb8-ab75-9060d8790d25",
        "content": {
            "centroid": {
                "lat": 37.361299,
                "lon": -122.066847
            },
            "entity": {
                "abbreviation": "Alta Vista High School",
                "alternates": {
                    "ceeb": "052229",
                    "nces": "062631003931"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "a1d29773-cc8b-4cb8-ab75-9060d8790d25",
                "isClaimed": true,
                "isPremium": false,
                "location": "Mountain View, CA",
                "name": "Alta Vista High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "61f38639-718b-403d-8aa9-dfcc7e1ed5f6",
                    "schoolDistrict": "61f38639-718b-403d-8aa9-dfcc7e1ed5f6",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "829d17a3-f1df-4505-8ff2-57bda4794f1c",
                    "zipCode": "e8a55ab4-9bff-4942-821c-369c0c98966c"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Mountain View-Los Altos Union High School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "61f38639-718b-403d-8aa9-dfcc7e1ed5f6",
                        "location": "Mountain View, CA",
                        "name": "Mountain View-Los Altos Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "829d17a3-f1df-4505-8ff2-57bda4794f1c",
                            "zipCode": "e8a55ab4-9bff-4942-821c-369c0c98966c"
                        },
                        "premium": false,
                        "shortName": "Mountain View-Los Altos Union High School District",
                        "tagline": [
                            "School District",
                            "Mountain View, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mountain-view-los-altos-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Alta Vista High School",
                "tagline": [
                    "Mountain View-Los Altos Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "alta-vista-high-school-mountain-view-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 79
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 11
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.064,37.3601,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.064,37.3601,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94040"
            }
        ]
    },
    {
        "guid": "dfb20a7c-a3b6-498a-8bb9-09bf8bc02478",
        "content": {
            "centroid": {
                "lat": 37.759621,
                "lon": -122.414701
            },
            "entity": {
                "abbreviation": "John O'Connell Alternative High",
                "alternates": {
                    "ceeb": "052960",
                    "nces": "063441007350"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "dfb20a7c-a3b6-498a-8bb9-09bf8bc02478",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "John O'Connell Alternative High",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "0cac67cc-9c02-4a4c-8cd6-5714b7fda8b7",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "c568e3a2-4c27-4503-a9f7-85276a6ec461"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "John O'Connell Alternative High",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "john-oconnell-alternative-high-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 480
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My overall experience at John O'Connell High School was okay. I loved the fact that they prepare you well for college as they make every student take college and career as a high school graduation requirement. In addition, there is a college and career center where plenty of students go to for college readiness help. Lastly, my favorite thing about John O'Connell are the integrated project based learning and internship opportunities they provide in three of the labs offered which are Culinary Arts & Entrepreneurship lab, the Health & Behavioral Sciences lab, and the Construction & Environmental Technology lab. My only big complaint would be the limited amount of honors and AP classes the school offers.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-02-26T02:02:08.738883Z",
                "guid": "898390b0-37a3-4df9-bcf8-9e0cfc0de869",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.415,37.7595,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.415,37.7595,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.389830508474576,
                "count": 118
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94110"
            }
        ]
    },
    {
        "guid": "ef8decf6-db8a-4a3c-b995-145d219e8514",
        "content": {
            "centroid": {
                "lat": 37.674551,
                "lon": -122.068357
            },
            "entity": {
                "abbreviation": "Hayward High School",
                "alternates": {
                    "ceeb": "051150",
                    "nces": "061674002116"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "ef8decf6-db8a-4a3c-b995-145d219e8514",
                "isClaimed": false,
                "isPremium": false,
                "location": "Hayward, CA",
                "name": "Hayward High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "47a764d7-c780-427c-9010-b9c8aa9c3454",
                    "parent": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                    "schoolDistrict": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                    "zipCode": "6933fc80-ff2d-4020-ab31-239bec481049"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "HUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                        "location": "Hayward, CA",
                        "name": "Hayward Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "3ee6b10e-9c9c-43c9-bee6-1755097895e1",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                            "zipCode": "72f14b46-7398-463c-a7b1-84d94dfe3a97"
                        },
                        "premium": false,
                        "shortName": "Hayward Unified School District",
                        "tagline": [
                            "School District",
                            "Hayward, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "hayward-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Hayward High School",
                "tagline": [
                    "Hayward Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "hayward-high-school-hayward-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1637
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "What I liked about Hayward High was that it was full of motivated and inspired individuals that had a strong sense of community to achieve their goals. People from all wakes of life with different family dynamics, household incomes, cultures, and experiences yet they were accepting of everyone. No school is perfect but the community was able to create perfect opportunities for people to grow and seek out prosperous futures. A wide variety of programs such as the athletics department with football, basketball, baseball, tennis, badminton, track & field, cross country, and wrestling, to the music program that offered orchestra, marching band and a concert ensemble. Plenty of clubs as well such as a Polynesian club where you'd learn about Polynesian culture and how it builds a stronger community with students when they can relate it to their own cultures. As well as events to share the beauty of the culture. There are plenty of things to be offered at Hayward High.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-29T04:06:56.361684Z",
                "guid": "443db402-4e26-4304-8696-ab44f68a67df",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.068,37.6718,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.068,37.6718,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.3557046979865772,
                "count": 298
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94541"
            }
        ]
    },
    {
        "guid": "85e72c23-eb05-4e4d-8cad-bab3309efa19",
        "content": {
            "centroid": {
                "lat": 37.879676,
                "lon": -121.641491
            },
            "entity": {
                "abbreviation": "Vista Oaks Charter School",
                "alternates": {
                    "ceeb": "054791",
                    "nces": "060177913821"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "85e72c23-eb05-4e4d-8cad-bab3309efa19",
                "isClaimed": false,
                "isPremium": false,
                "location": "Lodi, CA",
                "name": "Vista Oaks Charter School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "3f2c06a3-6dc5-4b8b-ae42-25d409d4ae34",
                    "zipCode": "4c4ae928-08ae-4b39-a92f-d9350bc71e2f"
                },
                "premium": false,
                "shortName": "Vista Oaks Charter School",
                "tagline": [
                    "Public School",
                    "Lodi, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "vista-oaks-charter-school-lodi-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 802
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 26
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Vista Oaks Charter School is a really good school. The classes are well taught. The teachers are very great! If you're looking to start homeschooling your children, Vista Oaks is the place to go.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2017-05-11T14:42:54.057174Z",
                "guid": "496d693c-5bdd-4882-8eb9-98920e743612",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.639,37.8779,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.639,37.8779,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6666666666666665,
                "count": 3
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95242"
            }
        ]
    },
    {
        "guid": "61852b0b-0505-4c1e-9509-9f91966eab03",
        "content": {
            "centroid": {
                "lat": 37.804442,
                "lon": -122.268255
            },
            "entity": {
                "abbreviation": "Envision Academy of Arts & Technology",
                "alternates": {
                    "ceeb": "054285",
                    "nces": "060161410947"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "61852b0b-0505-4c1e-9509-9f91966eab03",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Envision Academy For Arts & Technology",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "schoolNetwork": "f55e8d73-7e39-4bee-8c3f-7e814462499a",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "b42a540d-fcaa-4215-99d6-2fe916c20c44"
                },
                "premium": false,
                "shortName": "Envision Academy of Arts & Technology",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "envision-academy-for-arts--and--technology-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 385
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "I was a student in Envision Academy For Arts and Technology. When starting my first year I was very shy and not confident in who I was, but that changed when I continued being in this school. Each year I had to give a presentation that showed who I was as a person, how ready I was for each grade, and most importantly what where my plans after high school. With these presentation I became more confident with myself and others. It wasn't only the presentation that gave me that confidence but also the teachers that I had. Many of my teachers were giving me opportunities to grow as a person and show the skills that I had. They themselves saw someone who was smart, confident, and hard-worker. With that confidence that they had in me they helped me grow as a student and as a person.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-08T00:09:51.884701Z",
                "guid": "153cb234-24fe-4c9e-b5d2-b87398e186c4",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.268,37.8047,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.268,37.8047,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6233766233766236,
                "count": 77
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94612"
            }
        ]
    },
    {
        "guid": "1ad89e72-c18c-4357-9bc1-34c33445d88a",
        "content": {
            "centroid": {
                "lat": 37.316555,
                "lon": -121.992486
            },
            "entity": {
                "abbreviation": "Pegasus High School",
                "alternates": {
                    "ceeb": "054733",
                    "nces": "061182010320"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "1ad89e72-c18c-4357-9bc1-34c33445d88a",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Pegasus High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "2af26fb6-2239-44b4-be58-b0e8e46b2a61",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "ca7b746e-cd3c-474a-a264-ac5c6e4ff339"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Pegasus High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "11-12"
                ],
                "type": "School",
                "url": "pegasus-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 114
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "Great school! Helped me catch up on my credits. Can’t imagine being able to graduate without attending Pegasus!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-09-18T06:47:36.822059Z",
                "guid": "4c830985-9365-4026-a869-28eb85c69032",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.858,37.3689,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.858,37.3689,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.375,
                "count": 8
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95133"
            }
        ]
    },
    {
        "guid": "4dfb3970-9021-43a1-bfa7-62d8e0e09c44",
        "content": {
            "centroid": {
                "lat": 37.350478,
                "lon": -121.871101
            },
            "entity": {
                "abbreviation": "San Jose High School",
                "alternates": {
                    "ceeb": "053098",
                    "nces": "063459005736"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "4dfb3970-9021-43a1-bfa7-62d8e0e09c44",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "San Jose High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "0a781906-f3cb-42ec-b08b-9acfcaf63aaa",
                    "parent": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "schoolDistrict": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "953f02c6-35fb-44cc-a96d-584c48aceaab"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SJUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                        "location": "San Jose, CA",
                        "name": "San Jose Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "0a781906-f3cb-42ec-b08b-9acfcaf63aaa",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "763f10c1-8ad0-4832-90b4-5bad39b6e93f"
                        },
                        "premium": false,
                        "shortName": "San Jose Unified School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-jose-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "San Jose High School",
                "tagline": [
                    "San Jose Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "san-jose-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1054
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "What I liked about San Jose High School was the IB program. I really enjoyed challenging myself with IB classes that prepare you for college. San Jose High School was a great experience for me because it is filled with teachers who encourage you to go to college and achieve good grades. Through all my years in San Jose High School I passed all of my classes thanks to the help of teachers and their resources for example after school tutoring. I am glad to have joined the IB program in San Jose High School because IB classes give me college credit which will make my college years less stressful. To anyone who is considering attending San Jose high School I recommend doing sports! While attending San Jose High School I joined the basketball team it was a great experience because there I became more social and learned how to work in a team. I recommend San Jose High School to any student that wants to be more prepared for college.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-01-03T00:52:13.158086Z",
                "guid": "4fa28096-2e5e-491b-9d6c-5dd7a2063de9",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.872,37.3501,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.872,37.3501,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6374269005847952,
                "count": 171
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95116"
            }
        ]
    },
    {
        "guid": "25947a0c-6d9e-4943-8c8d-cf84d804e61d",
        "content": {
            "centroid": {
                "lat": 37.925167,
                "lon": -122.313662
            },
            "entity": {
                "abbreviation": "Summit K2",
                "alternates": {
                    "nces": "060191213776"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "25947a0c-6d9e-4943-8c8d-cf84d804e61d",
                "isClaimed": true,
                "isPremium": false,
                "location": "El Cerrito, CA",
                "name": "Summit Public School K2",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "schoolNetwork": "2ed1eb64-2cd2-4b6a-8f49-20b86f2fe1ca",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "f343dc53-cb24-4991-838e-fd06781600a8",
                    "zipCode": "5c0d439b-7e68-4d4e-ac7b-5c3008345353"
                },
                "premium": false,
                "shortName": "Summit K2",
                "tagline": [
                    "Public School",
                    "El Cerrito, CA",
                    "7-12"
                ],
                "type": "School",
                "url": "summit-public-school-k2-el-cerrito-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 533
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Parent",
                "body": "Small  - 100 students per grade. Able to go 7-12 grades on same campus. Teachers are young, motivated and engage with students individually. Students get assigned a mentor. Charter school with better system than regular public school - students can work at their own pace in each subject. Focus on being prepared for college. Nice buildings. Focus on academics, very few sports or clubs or activities outside of classes.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-03-01T02:44:33.006826Z",
                "guid": "5cbb97e2-39d5-4e6a-8465-3e73d8b0412b",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.314,37.9252,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.314,37.9252,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.1666666666666665,
                "count": 12
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour",
                    "value": "https://summitps.org/our-schools/summit-k2-el-cerrito-richmond/"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94530"
            },
            {
                "label": "Virtual Tour",
                "type": "virtualTour",
                "url": "https://summitps.org/our-schools/summit-k2-el-cerrito-richmond/"
            }
        ]
    },
    {
        "guid": "3af91584-3fb8-44f1-8d9c-3385e6316dde",
        "content": {
            "centroid": {
                "lat": 37.835599,
                "lon": -122.281458
            },
            "entity": {
                "abbreviation": "Emery Secondary School",
                "alternates": {
                    "ceeb": "050860",
                    "nces": "061263001426"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "3af91584-3fb8-44f1-8d9c-3385e6316dde",
                "isClaimed": false,
                "isPremium": false,
                "location": "Emeryville, CA",
                "name": "Emery Secondary School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "9506cf6d-6113-4ebb-a56a-d0c81e26d290",
                    "schoolDistrict": "9506cf6d-6113-4ebb-a56a-d0c81e26d290",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "b0225015-0071-4fd5-8ced-cc38a77740ed",
                    "zipCode": "9b0e24bf-e5f4-4fab-becb-f9156b7b0d68"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Emery Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "9506cf6d-6113-4ebb-a56a-d0c81e26d290",
                        "location": "Emeryville, CA",
                        "name": "Emery Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "b0225015-0071-4fd5-8ced-cc38a77740ed",
                            "zipCode": "9b0e24bf-e5f4-4fab-becb-f9156b7b0d68"
                        },
                        "premium": false,
                        "shortName": "Emery Unified School District",
                        "tagline": [
                            "School District",
                            "Emeryville, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "emery-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Emery Secondary School",
                "tagline": [
                    "Emery Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "emery-secondary-school-emeryville-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 209
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 13
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Emery high is a pretty small school. You might think that's a bad thing but no, small school comes with its perks. You may ask what type of perks? Well you know everyone in high school, you need help on something you got someone right next to you. The teachers at emery are awesome also, they will help you out when you are stuck, and they always give the best advice for the future. What more do you want!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-24T06:48:56.697344Z",
                "guid": "d8df5813-547e-4b26-847e-6a53b9664b3a",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.275,37.8378,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.275,37.8378,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 2.923076923076923,
                "count": 26
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94608"
            }
        ]
    },
    {
        "guid": "8c17c244-0dc6-483e-8229-9fed692c37e0",
        "content": {
            "centroid": {
                "lat": 38.019554,
                "lon": -121.88135
            },
            "entity": {
                "abbreviation": "Pittsburg Senior High School",
                "alternates": {
                    "ceeb": "052475",
                    "nces": "063060004752"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "8c17c244-0dc6-483e-8229-9fed692c37e0",
                "isClaimed": false,
                "isPremium": false,
                "location": "Pittsburg, CA",
                "name": "Pittsburg Senior High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "4343e9a4-a44a-4c29-b6ab-5713eb554bf1",
                    "schoolDistrict": "4343e9a4-a44a-4c29-b6ab-5713eb554bf1",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "0f3ccf9b-3550-4b3b-bc4e-0553b58c6d69",
                    "zipCode": "3da768f4-2aba-4f43-8fa3-a9f7e92a82d1"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Pittsburg Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "4343e9a4-a44a-4c29-b6ab-5713eb554bf1",
                        "location": "Pittsburg, CA",
                        "name": "Pittsburg Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "0f3ccf9b-3550-4b3b-bc4e-0553b58c6d69",
                            "zipCode": "3da768f4-2aba-4f43-8fa3-a9f7e92a82d1"
                        },
                        "premium": false,
                        "shortName": "Pittsburg Unified School District",
                        "tagline": [
                            "School District",
                            "Pittsburg, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "pittsburg-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Pittsburg Senior High School",
                "tagline": [
                    "Pittsburg Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "pittsburg-senior-high-school-pittsburg-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 3573
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Freshman",
                "body": "My first-year experience at Pittsburg High was one of the most glorious high lights of my life. I met so many people that showed me I can be loved, and have self- confidence. Every day was a unique adventure from going to different sporting games, to volunteering at numerous events. The school has also introduced to tennis, which was one of the best decisions I made out of several. Playing at other high schools that I have never even heard of opened me up to be a more social person. Being active was another perk with practice 3 hours every single day. Pittsburg High School brought me countless opportunities that I take advantage of daily. This school year is my most treasured which I will never forget.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-18T10:55:04.697707Z",
                "guid": "da02c180-e63c-4ef3-b72c-55c9aede1674",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.885,38.0195,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.885,38.0195,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.59811320754717,
                "count": 530
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94565"
            }
        ]
    },
    {
        "guid": "7315f624-3405-4f2b-a93e-e2fe9b8657a8",
        "content": {
            "centroid": {
                "lat": 37.686798,
                "lon": -122.122211
            },
            "entity": {
                "abbreviation": "San Lorenzo High School",
                "alternates": {
                    "ceeb": "053130",
                    "nces": "063471005859"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "7315f624-3405-4f2b-a93e-e2fe9b8657a8",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Lorenzo, CA",
                "name": "San Lorenzo High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "e54d426f-208e-46bc-9c03-0fc37e4b218c",
                    "schoolDistrict": "e54d426f-208e-46bc-9c03-0fc37e4b218c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "b04852e8-80bc-429e-bdfb-748588649add",
                    "zipCode": "5820f130-05d4-461d-b769-af76b2295d66"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "San Lorenzo Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "e54d426f-208e-46bc-9c03-0fc37e4b218c",
                        "location": "San Lorenzo, CA",
                        "name": "San Lorenzo Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "b04852e8-80bc-429e-bdfb-748588649add",
                            "zipCode": "5820f130-05d4-461d-b769-af76b2295d66"
                        },
                        "premium": false,
                        "shortName": "San Lorenzo Unified School District",
                        "tagline": [
                            "School District",
                            "San Lorenzo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-lorenzo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "San Lorenzo High School",
                "tagline": [
                    "San Lorenzo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "san-lorenzo-high-school-san-lorenzo-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1349
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "I have been a student at San Lorenzo High school for the past 3 years. SLZ has a lot of ups and downs. Lets start with the ups, slz has a good percentage of diversity, a good mixture in races. The teachers are very very supportive and will do anything for you to succeed. They check in with you through out the course of the year, and are very involved with the student activities. The sports in my school includes Basketball, Football, Soccer and many more, we are a very competitive school and we are best known for our victory in Basketball. Lastly, the students at San Lorenzo High are very friendly, and will make you feel involved and outspoken. Now the downside, as any other school there are fights, and disrespect . I would like for the district and School  Board is include more interactive classes so that the students can be involved throughout the school year.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-04T20:47:27.447915Z",
                "guid": "092725b3-5f74-4933-845c-ba8d9cdd4f77",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.124,37.6889,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.124,37.6889,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6444444444444444,
                "count": 180
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94580"
            }
        ]
    },
    {
        "guid": "07726dd0-46e1-4fb0-a07e-293584ba1707",
        "content": {
            "centroid": {
                "lat": 37.9127652,
                "lon": -122.3548865
            },
            "entity": {
                "abbreviation": "John Henry High School",
                "alternates": {
                    "nces": "060187213892"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "07726dd0-46e1-4fb0-a07e-293584ba1707",
                "isClaimed": false,
                "isPremium": false,
                "location": "Richmond, CA",
                "name": "John Henry High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                    "zipCode": "ce8bebad-32ac-45ac-bd87-076119b2c0fa"
                },
                "premium": false,
                "shortName": "John Henry High School",
                "tagline": [
                    "Public School",
                    "Richmond, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "john-henry-high-school-richmond-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 202
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I’m a senior at John Henry High School. These past three years have been really good. This school has helped me a lot and has inspired me to continue to do better. I see the difference this school has made in my community and I hope that when I leave this school continues to serve my community. Throughout the years I’ve seen a change in myself, I want more than just a high school diploma, I want a doctorate degree. All in all, John Henry high school is my savior.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-07-10T04:37:57.559593Z",
                "guid": "89da405f-08ee-4cd4-ba34-6418100cca47",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.3548865,37.9127652,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.3548865,37.9127652,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6666666666666665,
                "count": 12
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94804"
            }
        ]
    },
    {
        "guid": "b27ece3c-7efe-493f-8c7f-13fdfc12c641",
        "content": {
            "centroid": {
                "lat": 38.014576,
                "lon": -122.132632
            },
            "entity": {
                "abbreviation": "Vicente Martinez High School",
                "alternates": {
                    "ceeb": "051939",
                    "nces": "062403001966"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "b27ece3c-7efe-493f-8c7f-13fdfc12c641",
                "isClaimed": false,
                "isPremium": false,
                "location": "Martinez, CA",
                "name": "Vicente Martinez High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "bb309258-c416-4193-9d2e-072248ea2ba6",
                    "schoolDistrict": "bb309258-c416-4193-9d2e-072248ea2ba6",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "5aa2a0dd-3537-4cd9-817a-24409c06ce5d",
                    "zipCode": "2c9a56d6-f5d7-43ae-90db-4fab4497e4a2"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Martinez Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "bb309258-c416-4193-9d2e-072248ea2ba6",
                        "location": "Martinez, CA",
                        "name": "Martinez Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "5aa2a0dd-3537-4cd9-817a-24409c06ce5d",
                            "zipCode": "2c9a56d6-f5d7-43ae-90db-4fab4497e4a2"
                        },
                        "premium": false,
                        "shortName": "Martinez Unified School District",
                        "tagline": [
                            "School District",
                            "Martinez, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "martinez-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Vicente Martinez High School",
                "tagline": [
                    "Martinez Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "vicente-martinez-high-school-martinez-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 75
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 16
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "The teachers are incredibly helpful and give an arm and a leg just to help you achieve your goals. Without Vicente I probably would not have graduated.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-09-23T18:37:44.170198Z",
                "guid": "fd367e70-8f75-40e4-a5a8-4e559e664f8b",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.131,38.0005,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.131,38.0005,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94553"
            }
        ]
    },
    {
        "guid": "1eb7b8f5-38c2-4f2c-a4ae-b99c77bfcc8b",
        "content": {
            "centroid": {
                "lat": 37.979661,
                "lon": -122.310456
            },
            "entity": {
                "abbreviation": "De Anza Senior High School",
                "alternates": {
                    "ceeb": "052625",
                    "nces": "063255005018"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "1eb7b8f5-38c2-4f2c-a4ae-b99c77bfcc8b",
                "isClaimed": true,
                "isPremium": false,
                "location": "Richmond, CA",
                "name": "De Anza High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "schoolDistrict": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                    "zipCode": "f094286d-e04c-4e46-ab0c-2fc0dfc376dd"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "WCCUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "a053a637-da7b-48d7-a67d-fba014c2d452",
                        "location": "Richmond, CA",
                        "name": "West Contra Costa Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                            "zipCode": "9e563e34-37ab-4fc4-b373-ed793d877060"
                        },
                        "premium": false,
                        "shortName": "West Contra Costa Unified School District",
                        "tagline": [
                            "School District",
                            "Richmond, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "west-contra-costa-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "De Anza Senior High School",
                "tagline": [
                    "West Contra Costa Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "de-anza-high-school-richmond-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1368
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My overall experience at De Anza high school has been good because the school provides a safe and comfortable place where students can learn, grow, and discover new ideas. The school has experienced and professional teachers and counselors who assist and support students with all the help they need. One thing I wish that the school can improve on is their school lunch, In my opinion, they serve little food to the students during lunch most of the time it's not enough to sustain the students throughout the day.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-14T23:23:43.643462Z",
                "guid": "d1855aa0-aa02-4b2c-be3e-6e5b994add87",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.287,37.9679,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.287,37.9679,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6307692307692307,
                "count": 195
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94803"
            }
        ]
    },
    {
        "guid": "331339a1-5aae-481d-b8bf-4d4ea2b953de",
        "content": {
            "centroid": {
                "lat": 37.990819,
                "lon": -122.332794
            },
            "entity": {
                "abbreviation": "Making Waves Academy",
                "alternates": {
                    "ceeb": "054553",
                    "nces": "060150212043"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "331339a1-5aae-481d-b8bf-4d4ea2b953de",
                "isClaimed": false,
                "isPremium": false,
                "location": "Richmond, CA",
                "name": "Making Waves Academy",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                    "zipCode": "a08c6674-b67b-4d2b-976e-ac88b0619d80"
                },
                "premium": false,
                "shortName": "Making Waves Academy",
                "tagline": [
                    "Public School",
                    "Richmond, CA",
                    "5-12"
                ],
                "type": "School",
                "url": "making-waves-academy-richmond-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 940
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "My experience as a student at making waves academy was pretty good. There were several aspects of the school that contributed to those positive feelings. Firstly,  I like that Making Waves was a small school that allowed teachers to help students effectively. The teachers and administration were very involved with there students which made it comfortable for people to approach teachers when we needed help and assistance. Secondly, the fact that parent meetings happen pretty often was good because parents are able to be up to date with school events and activities. Overall I enjoyed my years at Making Waves Academy.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-02-15T02:37:26.513893Z",
                "guid": "22266c23-80d1-4191-9c91-d9b9b683fde3",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.333,37.9888,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.333,37.9888,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.9130434782608696,
                "count": 92
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94806"
            }
        ]
    },
    {
        "guid": "0bd7f3e2-71ed-491c-840a-56f254251f26",
        "content": {
            "centroid": {
                "lat": 37.615055,
                "lon": -122.029067
            },
            "entity": {
                "abbreviation": "Core Learning Academy at Conley-Caraballo High",
                "alternates": {
                    "nces": "062691011551"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "0bd7f3e2-71ed-491c-840a-56f254251f26",
                "isClaimed": true,
                "isPremium": false,
                "location": "Hayward, CA",
                "name": "Core Learning Academy at Conley-Caraballo High",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "e02c34d8-07d7-4299-83a5-d72170a68ab7",
                    "parent": "305b3896-e539-4976-95d2-a90396c3f1cf",
                    "schoolDistrict": "305b3896-e539-4976-95d2-a90396c3f1cf",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                    "zipCode": "72f14b46-7398-463c-a7b1-84d94dfe3a97"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "New Haven Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "305b3896-e539-4976-95d2-a90396c3f1cf",
                        "location": "Union City, CA",
                        "name": "New Haven Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "a1a37120-c207-41c6-9193-6d1b754eb2ec",
                            "zipCode": "f865aa9f-3f3c-41d7-80c3-1df06f3db370"
                        },
                        "premium": false,
                        "shortName": "New Haven Unified School District",
                        "tagline": [
                            "School District",
                            "Union City, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "new-haven-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Core Learning Academy at Conley-Caraballo High",
                "tagline": [
                    "New Haven Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "core-learning-academy-at-conley-caraballo-high-hayward-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 127
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 15
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "Conley was the greatest thing that has ever happened to me. The teachers there are unbelievably cool. I was a student back in 2015/16, people think this school is \"bad\" but that's so not the case. This school helped me when I was in a rough time in my life. And I'll forever always thank them. I've seen so many people I would see at Logan doing so bad, do better here and I see them turn their life's around as well. This school doesn't get enough recognition for all the good they do. So put some respect on conleys name! Geez .",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-02-03T01:31:30.781749Z",
                "guid": "5614fd87-4fa4-4894-81e5-feb7377d1ece",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.028,37.6151,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.028,37.6151,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94544"
            }
        ]
    },
    {
        "guid": "d6fcf776-4346-4d97-a5f7-fdd272ea62fd",
        "content": {
            "centroid": {
                "lat": 38.003402,
                "lon": -121.875913
            },
            "entity": {
                "abbreviation": "Black Diamond High School",
                "alternates": {
                    "ceeb": "052473",
                    "nces": "063060007821"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "d6fcf776-4346-4d97-a5f7-fdd272ea62fd",
                "isClaimed": false,
                "isPremium": false,
                "location": "Pittsburg, CA",
                "name": "Black Diamond High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "4343e9a4-a44a-4c29-b6ab-5713eb554bf1",
                    "schoolDistrict": "4343e9a4-a44a-4c29-b6ab-5713eb554bf1",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "0f3ccf9b-3550-4b3b-bc4e-0553b58c6d69",
                    "zipCode": "3da768f4-2aba-4f43-8fa3-a9f7e92a82d1"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Pittsburg Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "4343e9a4-a44a-4c29-b6ab-5713eb554bf1",
                        "location": "Pittsburg, CA",
                        "name": "Pittsburg Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "0f3ccf9b-3550-4b3b-bc4e-0553b58c6d69",
                            "zipCode": "3da768f4-2aba-4f43-8fa3-a9f7e92a82d1"
                        },
                        "premium": false,
                        "shortName": "Pittsburg Unified School District",
                        "tagline": [
                            "School District",
                            "Pittsburg, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "pittsburg-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Black Diamond High School",
                "tagline": [
                    "Pittsburg Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "black-diamond-high-school-pittsburg-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 218
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 13
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I loved everything about black diamond,  specially the staff and teacher and my basketball coach.  Learned alot mentally and most of all academically",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-22T00:47:03.655293Z",
                "guid": "796f9c02-34b5-4e6b-96e8-f48a98c655c6",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.875,38.0034,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.875,38.0034,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 2
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94565"
            }
        ]
    },
    {
        "guid": "328b5698-dd4d-4786-bf92-06028efe8152",
        "content": {
            "centroid": {
                "lat": 37.76856,
                "lon": -122.154338
            },
            "entity": {
                "abbreviation": "Sojourner Truth Independent Study",
                "alternates": {
                    "nces": "062805005701"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "328b5698-dd4d-4786-bf92-06028efe8152",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Sojourner Truth Independent Study",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "3816271d-bf9c-431c-9e92-8f63ddf53940"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Sojourner Truth Independent Study",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "sojourner-truth-independent-study-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 166
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 13
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Sojourner truth independent study is a public school that offers a second chance for individuals that want to pursue a higher education but with a different learning environment. Honestly, I never knew about this public school until I was trying to find another school to fit in with. It wasn’t a new feeling, but it felt weird. It’s a new school, new people. However, the staff was welcoming and accepting of students that messed up or wanted to study/learn by themselves. The school is limited in resources, which is understandable. I feel the school needs more recognition and respect because the school excels with what it has and it can propel to further success if the school got a positive reputation rather than a negative one. Thank you for giving me this opportunity for applying to this scholarship.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2017-10-30T18:41:52.449763Z",
                "guid": "25e26e4d-ef99-484a-bc22-ae9724bacdda",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.154,37.7662,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.154,37.7662,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.4,
                "count": 5
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94605"
            }
        ]
    },
    {
        "guid": "c94b6f43-e960-4800-9e03-af05097d308f",
        "content": {
            "centroid": {
                "lat": 37.6914,
                "lon": -122.46424
            },
            "entity": {
                "abbreviation": "Thornton High School",
                "alternates": {
                    "ceeb": "050826",
                    "nces": "061893001427"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "c94b6f43-e960-4800-9e03-af05097d308f",
                "isClaimed": false,
                "isPremium": false,
                "location": "Daly City, CA",
                "name": "Thornton High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "88d77336-3b63-4d91-9d64-307e50ca145b",
                    "schoolDistrict": "88d77336-3b63-4d91-9d64-307e50ca145b",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "41a99124-6b7c-496d-9635-39a33c683883",
                    "zipCode": "73a39e4a-bcc0-4688-99ae-a5dc425c236e"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Jefferson Union High School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "88d77336-3b63-4d91-9d64-307e50ca145b",
                        "location": "Daly City, CA",
                        "name": "Jefferson Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "41a99124-6b7c-496d-9635-39a33c683883",
                            "zipCode": "6e76147a-b88b-4659-93c4-fe720003e7e7"
                        },
                        "premium": false,
                        "shortName": "Jefferson Union High School District",
                        "tagline": [
                            "School District",
                            "Daly City, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "jefferson-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Thornton High School",
                "tagline": [
                    "Jefferson Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "thornton-high-school-daly-city-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 124
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 13
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "Thornton has some of the most caring and diligent staff and teachers that I have ever seen. I attended the school from 2008-2010 and the teachers all did their absolute best to help the students get back on the right path. I was only able to graduate due to their support and encouragement.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-01-27T04:28:07.68952Z",
                "guid": "3bc832ac-d5b2-403f-b430-31adffeb56c5",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.464,37.6912,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.464,37.6912,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 2
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94014"
            }
        ]
    },
    {
        "guid": "900bef9c-82d8-4828-a245-60c9c9f3233b",
        "content": {
            "centroid": {
                "lat": 37.368691,
                "lon": -121.83058
            },
            "entity": {
                "abbreviation": "James Lick High School",
                "alternates": {
                    "ceeb": "053090",
                    "nces": "061182001303"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "900bef9c-82d8-4828-a245-60c9c9f3233b",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "James Lick High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "5be5c65e-b5cd-43bf-91dc-4e9af8c6c1f0"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "James Lick High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "james-lick-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1053
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "It has a variety of sports and clubs. Though there are not many classes outside of the ones that are required for a diploma or the A-G requirements, there were options. \nThe first two years attending, there was construction at certain areas of the school which was unlikable. When a fire occurred in a city nearby, the district did not allow students to stay home even though the air was very unsafe. When the pandemic began, it took the school awhile to close and switch to online learning. Thankfully most of my teachers were understanding and did not require too much work. \nIn all of my years attending, students were given the chance to express their creativity and spirit in rallies and events which was great to see. It’s a typical(?) school where students would fight for the sake of their egos and punch windows for fun. But overall my experience was good.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-03-19T09:04:24.249745Z",
                "guid": "93a31bfd-3712-4778-8063-5f9043987864",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.831,37.3666,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.831,37.3666,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5491329479768785,
                "count": 173
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95127"
            }
        ]
    },
    {
        "guid": "e49230cb-ce44-45c4-a40a-aed8ee26d1f2",
        "content": {
            "centroid": {
                "lat": 37.668898,
                "lon": -122.115054
            },
            "entity": {
                "abbreviation": "East Bay Arts High School",
                "alternates": {
                    "ceeb": "054105",
                    "nces": "063471011567"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "e49230cb-ce44-45c4-a40a-aed8ee26d1f2",
                "isClaimed": false,
                "isPremium": false,
                "location": "Hayward, CA",
                "name": "East Bay Arts High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "e54d426f-208e-46bc-9c03-0fc37e4b218c",
                    "schoolDistrict": "e54d426f-208e-46bc-9c03-0fc37e4b218c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "zipCode": "6933fc80-ff2d-4020-ab31-239bec481049"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "San Lorenzo Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "e54d426f-208e-46bc-9c03-0fc37e4b218c",
                        "location": "San Lorenzo, CA",
                        "name": "San Lorenzo Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "b04852e8-80bc-429e-bdfb-748588649add",
                            "zipCode": "5820f130-05d4-461d-b769-af76b2295d66"
                        },
                        "premium": false,
                        "shortName": "San Lorenzo Unified School District",
                        "tagline": [
                            "School District",
                            "San Lorenzo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-lorenzo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "East Bay Arts High School",
                "tagline": [
                    "San Lorenzo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "east-bay-arts-high-school-hayward-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 214
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "Allowed me to explore my interests and creativity around the arts in a safe and socially stimulating environment. Very small class sizes. My graduating class was no more than 35 students. Very, very passionate teachers. They did everything they could to support their students. Sports are rated as terrible because our school technically didn't have sports teams, students would play for the main high schools' teams.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-02-07T06:34:31.063303Z",
                "guid": "a8cca9c8-2960-4346-88a2-4ece7a633163",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.115,37.6695,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.115,37.6695,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5208333333333335,
                "count": 48
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94541"
            }
        ]
    },
    {
        "guid": "1fe05094-a745-480d-bdb6-b587ed93cf5b",
        "content": {
            "centroid": {
                "lat": 37.762132,
                "lon": -122.193598
            },
            "entity": {
                "abbreviation": "Coliseum College Prep Academy",
                "alternates": {
                    "ceeb": "054412",
                    "nces": "062805011920"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "1fe05094-a745-480d-bdb6-b587ed93cf5b",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Coliseum College Prep Academy",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "e5836a73-f350-41af-a5c5-da313cd26efb"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Coliseum College Prep Academy",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "coliseum-college-prep-academy-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 486
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 15
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "The teachers are very engaging, committed, and accommodating to the students and in the classroom. The office hours and checking in with students about their education and health were the best because they also answered any questions I had about the work or class lessons. The school also always tried to celebrate holidays or celebrations together. I also like how it's mostly people of minorities since we can connect to each other in some way. Some things I would like changed or more clubs to keep people more engaged and connected. Another thing I would like to see changed is more variety of sports or a self-defense class to help students and keep them in shape and healthy.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-26T06:16:52.806033Z",
                "guid": "04b78e53-4cef-44d7-8378-acc9c3c761ed",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.193,37.7617,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.193,37.7617,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.588235294117647,
                "count": 51
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94621"
            }
        ]
    },
    {
        "guid": "19741fd5-2f73-46fc-aa70-ce68409343f9",
        "content": {
            "centroid": {
                "lat": 37.518879,
                "lon": -121.964486
            },
            "entity": {
                "abbreviation": "Robertson High School",
                "alternates": {
                    "ceeb": "050961",
                    "nces": "061440001686"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "19741fd5-2f73-46fc-aa70-ce68409343f9",
                "isClaimed": false,
                "isPremium": false,
                "location": "Fremont, CA",
                "name": "Robertson High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "schoolDistrict": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "36041593-134d-436a-b83b-4c4244f6a447",
                    "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                        "location": "Fremont, CA",
                        "name": "Fremont Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "36041593-134d-436a-b83b-4c4244f6a447",
                            "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                        },
                        "premium": false,
                        "shortName": "Fremont Unified School District",
                        "tagline": [
                            "School District",
                            "Fremont, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Robertson High School",
                "tagline": [
                    "Fremont Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "robertson-high-school-fremont-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 176
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 11
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "More sports and more outreaches to high risk youth and field trips . They need to really dig in to gearing students coming from broken homes the best opportunities for example taking a field trip to a college!!! They need to get them pumped up and motivated for beating the odds.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2017-06-12T18:37:13.488538Z",
                "guid": "f157340d-6a7a-4470-ad87-0620a7e4db95",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.964,37.5201,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.964,37.5201,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.625,
                "count": 8
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94538"
            }
        ]
    },
    {
        "guid": "91018b52-bfcc-4e82-b85d-2ca725f7d45c",
        "content": {
            "centroid": {
                "lat": 37.679011,
                "lon": -121.766865
            },
            "entity": {
                "abbreviation": "Del Valle Continuation High School",
                "alternates": {
                    "ceeb": "051422",
                    "nces": "062211002621"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "91018b52-bfcc-4e82-b85d-2ca725f7d45c",
                "isClaimed": true,
                "isPremium": false,
                "location": "Livermore, CA",
                "name": "Del Valle Continuation High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "19cd8fd6-2e3f-4241-bb82-be4e992de8bf",
                    "schoolDistrict": "19cd8fd6-2e3f-4241-bb82-be4e992de8bf",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "fc27d7f3-833b-4d0b-bced-8aa3c3c99758",
                    "zipCode": "0a020eaf-ab20-4a50-8308-d60ca74bd07f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Livermore Valley Joint Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "19cd8fd6-2e3f-4241-bb82-be4e992de8bf",
                        "location": "Livermore, CA",
                        "name": "Livermore Valley Joint Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "fc27d7f3-833b-4d0b-bced-8aa3c3c99758",
                            "zipCode": "c06482ed-5084-4a24-95f9-0ab50e7042b2"
                        },
                        "premium": false,
                        "shortName": "Livermore Valley Joint Unified School District",
                        "tagline": [
                            "School District",
                            "Livermore, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "livermore-valley-joint-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Del Valle Continuation High School",
                "tagline": [
                    "Livermore Valley Joint Unified School District, CA",
                    "7-12"
                ],
                "type": "School",
                "url": "del-valle-continuation-high-school-livermore-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 111
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 10
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.766,37.678,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.766,37.678,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94550"
            }
        ]
    },
    {
        "guid": "edfea8b7-7bf5-4974-9719-da8ab6b2e7f1",
        "content": {
            "centroid": {
                "lat": 37.78423,
                "lon": -122.216797
            },
            "entity": {
                "abbreviation": "Life Academy",
                "alternates": {
                    "ceeb": "052212",
                    "nces": "062805008676"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "edfea8b7-7bf5-4974-9719-da8ab6b2e7f1",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Life Academy",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "90731d14-c187-4264-ac2c-4b3485508684"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Life Academy",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "life-academy-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 463
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 15
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "Life Academy is smaller than most high schools and therefore teachers are more involved with each student. They have enough supplies for class sizes and enough staff to go on field trips and after school activities. The school could use more diversity in sport teams but it provides all the needs to prepare for college applications, tutoring and mentoring.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-02-10T20:25:34.79363Z",
                "guid": "d34bf8e6-9806-40af-a815-4a172be4208a",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.217,37.7853,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.217,37.7853,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.627450980392157,
                "count": 51
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94601"
            }
        ]
    },
    {
        "guid": "0a68cd10-5faa-4c2b-8eab-70ca80d19a05",
        "content": {
            "centroid": {
                "lat": 37.992162,
                "lon": -122.285463
            },
            "entity": {
                "abbreviation": "Pinole Valley High School",
                "alternates": {
                    "ceeb": "052464",
                    "nces": "063255005052"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "0a68cd10-5faa-4c2b-8eab-70ca80d19a05",
                "isClaimed": true,
                "isPremium": false,
                "location": "Pinole, CA",
                "name": "Pinole Valley High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "schoolDistrict": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "e6e40e66-eb0b-4dff-8541-44f93a7d18f6",
                    "zipCode": "a2885dae-b07c-4ed1-8b14-c35907455888"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "WCCUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "a053a637-da7b-48d7-a67d-fba014c2d452",
                        "location": "Richmond, CA",
                        "name": "West Contra Costa Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                            "zipCode": "9e563e34-37ab-4fc4-b373-ed793d877060"
                        },
                        "premium": false,
                        "shortName": "West Contra Costa Unified School District",
                        "tagline": [
                            "School District",
                            "Richmond, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "west-contra-costa-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Pinole Valley High School",
                "tagline": [
                    "West Contra Costa Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "pinole-valley-high-school-pinole-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1120
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I really liked my experience at Pinole Valley High School. I love how diverse the student body is, and they really emphasize celebrating this, with hosting multicultural rallies annually. They also have different academies that we can pick to be apart of, including Law, Health, and Engineering. I picked the Health Academy and I was able to get a Public Health internship and get CPR certified through the academy. Majority of the teachers and staff in general were respectful, and I didn't have many issues other than a few minor ones. I felt like I was thoroughly prepared for college because I was able to pass all of my AP examinations and given ample help and support from my AP teachers throughout the year to be able to do so. One thing I wish I saw was more of is representation and diversity amongst the staff. Overall my experience was relatively pleasant, and I didn't have any major issues or concerns.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-04-27T03:44:22.63469Z",
                "guid": "3a1f04a1-8042-4cda-a4bb-184888797a09",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.286,37.9905,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.286,37.9905,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.346749226006192,
                "count": 323
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94564"
            }
        ]
    },
    {
        "guid": "04cd49aa-95f6-4ab0-9956-334a6909c33a",
        "content": {
            "centroid": {
                "lat": 37.719637,
                "lon": -122.425578
            },
            "entity": {
                "abbreviation": "June Jordan School For Equity",
                "alternates": {
                    "ceeb": "053884",
                    "nces": "063441011252"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "04cd49aa-95f6-4ab0-9956-334a6909c33a",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "June Jordan School For Equity",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "a36158f8-7bdf-419a-9e51-680d947f62d9",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "67339067-3b07-488a-a8f9-c097bd4fcad2"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "June Jordan School For Equity",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "june-jordan-school-for-equity-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 233
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 17
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "June Jordan is a breath of fresh air myself and many others. There is a strong and immediate sense of community and family. The school is aimed towards helping students, specifically of Latinx or African American descent, thrive in all aspects of a academic scholar. Most schools are tied strictly towards academics but June Jordan has a different approach. They acknowledge the fact that a single being and their destiny should not be overlooked by a grade book. We build leaders at this school, we build demonstrators, organizers, and creators. At June, we are taught to fulfill our full potential. Through social and ethnic studies, generations of youth here at June Jordan are uplifted through the knowledge of systemic racism, political activism, and Youth Participatory culture.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-11-17T19:12:54.801406Z",
                "guid": "8aca37b0-0bd8-40b1-b2c1-16328db6a2ae",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.425,37.7196,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.425,37.7196,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.857142857142857,
                "count": 42
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94112"
            }
        ]
    },
    {
        "guid": "82f7cb1b-e478-4eb5-9196-6e9d50f04bf4",
        "content": {
            "centroid": {
                "lat": 37.435895,
                "lon": -121.883324
            },
            "entity": {
                "abbreviation": "Calaveras Hills",
                "alternates": {
                    "ceeb": "051973",
                    "nces": "062450003664"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "82f7cb1b-e478-4eb5-9196-6e9d50f04bf4",
                "isClaimed": false,
                "isPremium": false,
                "location": "Milpitas, CA",
                "name": "Calaveras Hills",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "b8ccd5a3-a309-4782-a213-14c30671603f",
                    "schoolDistrict": "b8ccd5a3-a309-4782-a213-14c30671603f",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "aa75a24b-3877-4c8e-9029-e2332e3f1c46",
                    "zipCode": "d68bb1dd-2a50-4ac9-af5d-a8b78944d236"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Milpitas Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "b8ccd5a3-a309-4782-a213-14c30671603f",
                        "location": "Milpitas, CA",
                        "name": "Milpitas Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "aa75a24b-3877-4c8e-9029-e2332e3f1c46",
                            "zipCode": "d68bb1dd-2a50-4ac9-af5d-a8b78944d236"
                        },
                        "premium": false,
                        "shortName": "Milpitas Unified School District",
                        "tagline": [
                            "School District",
                            "Milpitas, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "milpitas-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Calaveras Hills",
                "tagline": [
                    "Milpitas Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "calaveras-hills-milpitas-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 106
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 10
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.883,37.4385,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.883,37.4385,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 3
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95035"
            }
        ]
    },
    {
        "guid": "b01f6437-07ca-4f37-b1c6-736505abd315",
        "content": {
            "centroid": {
                "lat": 37.668898,
                "lon": -122.115054
            },
            "entity": {
                "abbreviation": "Royal Sunset (Continuation)",
                "alternates": {
                    "ceeb": "051199",
                    "nces": "063471005858"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "b01f6437-07ca-4f37-b1c6-736505abd315",
                "isClaimed": false,
                "isPremium": false,
                "location": "Hayward, CA",
                "name": "Royal Sunset (Continuation)",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "e54d426f-208e-46bc-9c03-0fc37e4b218c",
                    "schoolDistrict": "e54d426f-208e-46bc-9c03-0fc37e4b218c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "zipCode": "6933fc80-ff2d-4020-ab31-239bec481049"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "San Lorenzo Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "e54d426f-208e-46bc-9c03-0fc37e4b218c",
                        "location": "San Lorenzo, CA",
                        "name": "San Lorenzo Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "b04852e8-80bc-429e-bdfb-748588649add",
                            "zipCode": "5820f130-05d4-461d-b769-af76b2295d66"
                        },
                        "premium": false,
                        "shortName": "San Lorenzo Unified School District",
                        "tagline": [
                            "School District",
                            "San Lorenzo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-lorenzo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Royal Sunset (Continuation)",
                "tagline": [
                    "San Lorenzo Unified School District, CA",
                    "7-12"
                ],
                "type": "School",
                "url": "royal-sunset-continuation-hayward-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 105
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 13
                }
            ],
            "featuredReview": {
                "author": "High School Senior",
                "body": "This school for me i would say was a jump start. Since me being home schooled for year i was brave enough to actually get out of my house and go to a public school, so this was a great start. My favorite experience when i first started there were the teachers, few of them are very funny and love to engage and be apart of a students life not as a teacher but ore as a mentor. There were some that really didn't take the job as serious or could careless about the child's education just what comes in there wallet which was really awful from my experience because i seen a lot of kids who would give up just because of what a teacher would say in one class criticizing them instead of helping them through it. Other than that this school i could say is unique in a way because if a parent were to enroll their kid there, they wouldn't have to worry about there kid getting picked on or judge because its a lot of kids who been through what there kid possibly has been through or worse. It would just take them time to actually talk and open up to make friends.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2014-07-06T01:48:03Z",
                "guid": "48152381-ed6b-4c05-99b4-468a454e276f",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.115,37.6689,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.115,37.6689,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.875,
                "count": 8
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94541"
            }
        ]
    },
    {
        "guid": "4390afdd-a639-4c05-81f3-99b92a1bd39e",
        "content": {
            "centroid": {
                "lat": 37.829637,
                "lon": -122.272189
            },
            "entity": {
                "abbreviation": "Oakland Military Institute - College Preparatory Academy",
                "alternates": {
                    "ceeb": "053972",
                    "nces": "060197110729"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "4390afdd-a639-4c05-81f3-99b92a1bd39e",
                "isClaimed": true,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Oakland Military Institute - College Preparatory Academy",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "9b0e24bf-e5f4-4fab-becb-f9156b7b0d68"
                },
                "premium": false,
                "shortName": "OMI",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "oakland-military-institute---college-preparatory-academy-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 743
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "Oakland Military Institute is a very good school.  It ranges from the begging of junior high(6thgrade) to the end of high school(12th grade). The disciplinary and educational structure are way above average and teach the students about life and get them ready for the world.The programs and student activities are outstanding and teachers make learning fun.Unlike many Oakland schools OMI was founded by the previous Governor,  Jerry Brown who wanted to make a difference in the lives of Oakland students and e are very thankful for that selflessness and respect from him.  OMI has been funded by Gov. Jerry Brown,  but since he is no longer in office funds have been lower and resources are looking down. OMI has claimed to be sitting down in a few years,  with the last of the graduating class being in 2030, or some years before that with no funds.It is sad but, \n Overall My personal experience has been great and I would recommend anyone to go to this school if in the Bay Area if California.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-01T01:35:21.225894Z",
                "guid": "3ebe8bda-872b-40a4-a04e-3ebf65edc063",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.272737,37.829535,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.272737,37.829535,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.589041095890411,
                "count": 73
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94608"
            }
        ]
    },
    {
        "guid": "f3157fb8-2595-41be-ba40-9a99eb823c47",
        "content": {
            "centroid": {
                "lat": 37.36741,
                "lon": -121.858435
            },
            "entity": {
                "abbreviation": "Downtown College Prep - Alum Rock",
                "alternates": {
                    "ceeb": "054750",
                    "nces": "060165612827"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "f3157fb8-2595-41be-ba40-9a99eb823c47",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "DCP Alum Rock High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "bc007bff-f267-494c-b4bc-92ce588a6db6",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                },
                "premium": false,
                "shortName": "Downtown College Prep - Alum Rock",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "dcp-alum-rock-high-school-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 668
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 26
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Downtown College Prep Alum Rock High School is a small school in East side San Jose that foster the learning and academic competitiveness of its students. It grants amazing support to its first generation students and prides itself with multiple accomplishments in the community, the state and even nationwide. DCP Alum Rock High School focuses, strongly, on preparing students who want to pursue STEM based majors in college and through their careers. As a small school, DCP teachers and staff are able to connect with their students and provide various forms of support through clubs, sports and academic endeavor. This school is definitely underrated and should receive more acknowledgement for constantly preparing first generation, students of color to pursue and succeed in higher level institutions to further expand their academic experiences.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-16T21:53:30.540721Z",
                "guid": "347098ea-26da-43f5-8852-d7b6e3c90871",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.858435,37.36741,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.858435,37.36741,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.357142857142857,
                "count": 14
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95133"
            }
        ]
    },
    {
        "guid": "8246ee2c-f765-4b62-9a42-c970518fa6be",
        "content": {
            "centroid": {
                "lat": 37.357283,
                "lon": -121.995721
            },
            "entity": {
                "abbreviation": "New Valley Continuation High School",
                "alternates": {
                    "nces": "063543006053"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "8246ee2c-f765-4b62-9a42-c970518fa6be",
                "isClaimed": true,
                "isPremium": false,
                "location": "Santa Clara, CA",
                "name": "New Valley Continuation High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                    "schoolDistrict": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "44b1c9d0-0773-4aa7-aaeb-c04dda704fc1",
                    "zipCode": "d1fd4c8f-758c-4371-b58b-7ac5e13d8df8"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Santa Clara Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                        "location": "Santa Clara, CA",
                        "name": "Santa Clara Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "44b1c9d0-0773-4aa7-aaeb-c04dda704fc1",
                            "zipCode": "d1fd4c8f-758c-4371-b58b-7ac5e13d8df8"
                        },
                        "premium": false,
                        "shortName": "Santa Clara Unified School District",
                        "tagline": [
                            "School District",
                            "Santa Clara, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "santa-clara-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "New Valley Continuation High School",
                "tagline": [
                    "Santa Clara Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "new-valley-continuation-high-school-santa-clara-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 127
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 12
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "From the sound of it it sounds likable school for people who have bad qualities. But being there was an exciting experience. Wish i could turn back time to start high school all over again.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-10-31T04:21:47.243024Z",
                "guid": "ef2120ee-6c61-410a-8579-a862bc0e6532",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.996,37.3563,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.996,37.3563,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.5,
                "count": 4
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95051"
            }
        ]
    },
    {
        "guid": "c28f2ed2-78aa-45bc-97ff-1178d65c3a29",
        "content": {
            "centroid": {
                "lat": 37.735659,
                "lon": -122.401828
            },
            "entity": {
                "abbreviation": "Thurgood Marshall High",
                "alternates": {
                    "ceeb": "053066",
                    "nces": "063441003976"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "c28f2ed2-78aa-45bc-97ff-1178d65c3a29",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Thurgood Marshall High",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "757dac71-31a9-4872-b87c-a3225dec3630",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "6d9673ef-a1db-480d-bcce-79e87b94f91c"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Thurgood Marshall High",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "thurgood-marshall-high-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 452
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 17
                }
            ],
            "featuredReview": {
                "author": "Middle School Student",
                "body": "He estado estudiando por tres años por lo cual mi experiencia ha sido muy buena, la escuela me parece muy bien, los maestros en la escuela son buenos.\nEl centro de salud,  oficinas  me tratan muy bien por alguna nesecidad.\nLas clases que he recibido me parecen buenas.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-12-30T19:04:26.249955Z",
                "guid": "9ae5be4d-8fff-453d-be38-a1e825ea1ba7",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.402,37.736,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.402,37.736,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.341463414634146,
                "count": 123
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94124"
            }
        ]
    },
    {
        "guid": "621a70b1-3833-478d-ae4b-0c9b45fb6dbe",
        "content": {
            "centroid": {
                "lat": 37.736609,
                "lon": -122.1971
            },
            "entity": {
                "abbreviation": "Lighthouse Community Charter High School",
                "alternates": {
                    "ceeb": "054151",
                    "nces": "060235610726"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "621a70b1-3833-478d-ae4b-0c9b45fb6dbe",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Lighthouse Community Charter High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "e5836a73-f350-41af-a5c5-da313cd26efb"
                },
                "premium": false,
                "shortName": "Lighthouse Community Charter High School",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "lighthouse-community-charter-high-school-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 280
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Attending Lighthouse Community Charter school has been a unique experience for me. This campus is like no other, it is much smaller than other schools so the teacher to student ratio is smaller, which is something that I enjoyed about the school. Having that tight connection which each of my teachers has helped me over the past 4 years. Being in the classroom felt like I belong in the class and I was constantly pushed to excel in my academics. Not only that, but they constantly checked up on me and other students on how we were doing mentally. Something that I would change about the school is the curriculum that is being taught at school and the number of classes. Going to Lighthouse was great for one on one support, but I felt like there weren't enough rogues classes like AP or other advance classes to help students who wanted a greater challenge. I believed that would improve the great school that it is.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-01T06:00:30.101013Z",
                "guid": "a13416b9-1576-439c-a7d3-0af830921eeb",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.196,37.736,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.196,37.736,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7727272727272725,
                "count": 22
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94621"
            }
        ]
    },
    {
        "guid": "a4282a1b-f0e4-42a1-a451-94907753ff95",
        "content": {
            "centroid": {
                "lat": 37.463416,
                "lon": -122.131366
            },
            "entity": {
                "abbreviation": "East Palo Alto Academy",
                "alternates": {
                    "ceeb": "052022",
                    "nces": "060190111431"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "a4282a1b-f0e4-42a1-a451-94907753ff95",
                "isClaimed": false,
                "isPremium": false,
                "location": "East Palo Alto, CA",
                "name": "East Palo Alto Academy",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "bc4a42c3-a2f5-452a-9b9e-175d4f05cb82",
                    "zipCode": "e91bfc0c-bca1-45d4-909a-25b104b8c881"
                },
                "premium": false,
                "shortName": "East Palo Alto Academy",
                "tagline": [
                    "Public School",
                    "East Palo Alto, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "east-palo-alto-academy-east-palo-alto-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 364
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 15
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "East Palo Alto Academy is a school where students are able to get a good education and be helped by not only teachers but those within the school community. Advisory in East Palo Alto Academy is a class of students who are see each other as a big family. The school culture brings positivity into the campus and keeps students motivated to do better in their classes. Along with clubs and activities, it helps bring students, teachers, and staff members together to enjoy events and have a fun time.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-01-31T05:09:39.167852Z",
                "guid": "6696974f-a08e-4a98-a360-c6aa8939b33c",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.132,37.4629,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.132,37.4629,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.357142857142857,
                "count": 14
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94303"
            }
        ]
    },
    {
        "guid": "808b4d24-0fa7-47c9-849d-cc3bcc1d7d1d",
        "content": {
            "centroid": {
                "lat": 37.550747,
                "lon": -122.038694
            },
            "entity": {
                "abbreviation": "Bridgepoint High School",
                "alternates": {
                    "ceeb": "052118",
                    "nces": "062706004080"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "808b4d24-0fa7-47c9-849d-cc3bcc1d7d1d",
                "isClaimed": false,
                "isPremium": false,
                "location": "Newark, CA",
                "name": "Bridgepoint High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "76fb7aec-f438-42a3-82f2-6ad1f6bf15f5",
                    "schoolDistrict": "76fb7aec-f438-42a3-82f2-6ad1f6bf15f5",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "ed699caa-41e0-4b17-9bf6-cddf0a782bac",
                    "zipCode": "27c6b5a2-f312-47d3-873e-e798e3f00196"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Newark Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "76fb7aec-f438-42a3-82f2-6ad1f6bf15f5",
                        "location": "Newark, CA",
                        "name": "Newark Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "ed699caa-41e0-4b17-9bf6-cddf0a782bac",
                            "zipCode": "27c6b5a2-f312-47d3-873e-e798e3f00196"
                        },
                        "premium": false,
                        "shortName": "Newark Unified School District",
                        "tagline": [
                            "School District",
                            "Newark, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "newark-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Bridgepoint High School",
                "tagline": [
                    "Newark Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "bridgepoint-high-school-newark-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 66
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 16
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.036,37.5469,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.036,37.5469,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94560"
            }
        ]
    },
    {
        "guid": "04de526f-363b-4297-8467-3aeeca66e59e",
        "content": {
            "centroid": {
                "lat": 37.370978,
                "lon": -121.863153
            },
            "entity": {
                "abbreviation": "ACE Charter High School",
                "alternates": {
                    "ceeb": "054660",
                    "nces": "060156113023"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "04de526f-363b-4297-8467-3aeeca66e59e",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "ACE Charter High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "bc007bff-f267-494c-b4bc-92ce588a6db6",
                    "schoolNetwork": "ee0d5417-2f23-4880-821b-965ec0df6860",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                },
                "premium": false,
                "shortName": "ACE Charter High School",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "ace-charter-high-school-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 363
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 26
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "ACE is a school that makes you learn many things to go to the right way. The students that really want to learn will be highly successful. School culture is getting better every single day and it’s becoming a better school as time goes through. I recommend this school, ACE has the tools to make students to be successful.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-03-08T00:32:27.001675Z",
                "guid": "e9a3fe45-d61c-4ee1-aba0-8cd57f208971",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.858,37.3667,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.858,37.3667,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.857142857142857,
                "count": 7
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95133"
            }
        ]
    },
    {
        "guid": "3a98894b-49d8-4214-bb5b-1a90d72fdea5",
        "content": {
            "centroid": {
                "lat": 37.936107,
                "lon": -121.696318
            },
            "entity": {
                "abbreviation": "Independence High School",
                "alternates": {
                    "ceeb": "054126",
                    "nces": "062160008457"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "3a98894b-49d8-4214-bb5b-1a90d72fdea5",
                "isClaimed": false,
                "isPremium": false,
                "location": "Brentwood, CA",
                "name": "Independence High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                    "schoolDistrict": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "8c697687-c0ec-469c-98e8-e0a06e72a35a",
                    "zipCode": "fea44aef-6d39-4c1c-9267-b5b70ebd1cf5"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Liberty Union High School District (Brentwood)",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                        "location": "Brentwood, CA",
                        "name": "Liberty Union High School District (Brentwood)",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "8c697687-c0ec-469c-98e8-e0a06e72a35a",
                            "zipCode": "fea44aef-6d39-4c1c-9267-b5b70ebd1cf5"
                        },
                        "premium": false,
                        "shortName": "Liberty Union High School District (Brentwood)",
                        "tagline": [
                            "School District",
                            "Brentwood, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "liberty-union-high-school-district-brentwood-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Independence High School",
                "tagline": [
                    "Liberty Union High School District (Brentwood), CA",
                    "9-12"
                ],
                "type": "School",
                "url": "independence-high-school-brentwood-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 250
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Great school with very passionate teachers who care about their students education and for their well being and health.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-05-19T22:48:33.003451Z",
                "guid": "250a97eb-e52f-4911-b490-074e728d8213",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.696,37.9366,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.696,37.9366,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4,
                "count": 4
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94513"
            }
        ]
    },
    {
        "guid": "812ce5d5-25f7-4dfe-982a-85f6dd2e644a",
        "content": {
            "centroid": {
                "lat": 38.132882,
                "lon": -122.249218
            },
            "entity": {
                "abbreviation": "John W. Finney High School",
                "alternates": {
                    "ceeb": "053601",
                    "nces": "064074006734"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "812ce5d5-25f7-4dfe-982a-85f6dd2e644a",
                "isClaimed": false,
                "isPremium": false,
                "location": "Vallejo, CA",
                "name": "John W. Finney High School",
                "parentGUIDs": {
                    "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                    "schoolDistrict": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "cd45ba4f-972c-4537-bd0a-adc5060daf7c",
                    "zipCode": "2a6799d3-4951-4fc5-9600-781d2e0f8833"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Vallejo City Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                        "location": "Vallejo, CA",
                        "name": "Vallejo City Unified School District",
                        "parentGUIDs": {
                            "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "cd45ba4f-972c-4537-bd0a-adc5060daf7c",
                            "zipCode": "c53e25cf-e914-4ee3-aca1-03fd916fd935"
                        },
                        "premium": false,
                        "shortName": "Vallejo City Unified School District",
                        "tagline": [
                            "School District",
                            "Vallejo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "vallejo-city-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "John W. Finney High School",
                "tagline": [
                    "Vallejo City Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "john-w-finney-high-school-vallejo-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 126
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 11
                }
            ],
            "featuredReview": {
                "author": "High School Senior",
                "body": "My experience at this school was great the classes were good, the teachers were more intimate with the students. I would say this school is unique for all the resources it has so you succeed and have help, they also have a lot of options for those who want to further their education. I would do this school from my freshman year if i could do it over because ik i would have been an A student for those four years not just the las two.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2016-04-17T13:46:38Z",
                "guid": "22c38c35-2634-45c7-9f65-42c49a22d3d2",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.248,38.1327,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.248,38.1327,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.571428571428571,
                "count": 7
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94589"
            }
        ]
    },
    {
        "guid": "d9bbb02e-b6ec-4cff-8725-a5b1a51dc2bb",
        "content": {
            "centroid": {
                "lat": 37.242457,
                "lon": -121.826537
            },
            "entity": {
                "abbreviation": "Calero High School",
                "alternates": {
                    "ceeb": "054715",
                    "nces": "061182013019"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "d9bbb02e-b6ec-4cff-8725-a5b1a51dc2bb",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Calero High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "82659f7c-b7d4-4d17-b5fb-080c2a7a859c",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "656c3aa8-650d-4f5e-97c4-2c4879faa9d3"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Calero High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "10-12"
                ],
                "type": "School",
                "url": "calero-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 366
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I love this school, they help you very much. The teachers actually show effort and love and care for every student. The teachers and staff show that they want every student to succeed.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-01-09T03:53:51.565087Z",
                "guid": "6b8fe0ae-d7a4-4b6d-bcc8-ac8144281489",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.827,37.2413,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.827,37.2413,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.6,
                "count": 5
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95123"
            }
        ]
    },
    {
        "guid": "ac8bfc93-5fc2-420a-888c-6d080fe59eae",
        "content": {
            "centroid": {
                "lat": 37.719637,
                "lon": -122.425578
            },
            "entity": {
                "abbreviation": "CAT",
                "alternates": {
                    "ceeb": "054047",
                    "nces": "060210311408"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "ac8bfc93-5fc2-420a-888c-6d080fe59eae",
                "isClaimed": true,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "City Arts & Tech High School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "a36158f8-7bdf-419a-9e51-680d947f62d9",
                    "schoolNetwork": "f55e8d73-7e39-4bee-8c3f-7e814462499a",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "67339067-3b07-488a-a8f9-c097bd4fcad2"
                },
                "premium": false,
                "shortName": "City Arts & Tech High School",
                "tagline": [
                    "Public School",
                    "San Francisco, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "city-arts--and--tech-high-school-san-francisco-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 276
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 17
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "At city arts and technology high school you can create great teacher and student relationships, which is great because you get better communication than at other schools.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-11-09T00:25:13.658646Z",
                "guid": "0733fd93-88c7-48c5-8f3e-4f3589f03176",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.425,37.7196,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.425,37.7196,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5176470588235293,
                "count": 85
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94112"
            }
        ]
    },
    {
        "guid": "983287c5-b6d8-4f53-8f6d-e4c03f11c426",
        "content": {
            "centroid": {
                "lat": 37.983289,
                "lon": -122.03714
            },
            "entity": {
                "abbreviation": "Mt. Diablo High School",
                "alternates": {
                    "ceeb": "050660",
                    "nces": "062637003960"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "983287c5-b6d8-4f53-8f6d-e4c03f11c426",
                "isClaimed": false,
                "isPremium": false,
                "location": "Concord, CA",
                "name": "Mt. Diablo High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "schoolDistrict": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "187f89d7-6963-49c2-b924-426631dae88f",
                    "zipCode": "682ad26e-01a6-40ff-ab5e-ab87d7da8033"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "MDUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                        "location": "Concord, CA",
                        "name": "Mt. Diablo Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "187f89d7-6963-49c2-b924-426631dae88f",
                            "zipCode": "fca2caaa-dbcc-472c-be69-c07f58b2a359"
                        },
                        "premium": false,
                        "shortName": "Mt. Diablo Unified School District",
                        "tagline": [
                            "School District",
                            "Concord, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mt-diablo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Mt. Diablo High School",
                "tagline": [
                    "Mt. Diablo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "mt-diablo-high-school-concord-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1448
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Sophomore",
                "body": "Overall the campus is really nice. The teachers are great, available to help you, and encourage you to seek their help. There are so many clubs, and everyone encourages you to join them. There are lots of programs and college help as well. There are academies and classes for students with different interests too. One thing I would like to change though is the food. Better food that's warm and/or healthy would be nice. Most of the staff are friendly and willing to help you in anything you may need.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-14T01:56:26.998184Z",
                "guid": "a776d374-bcd9-48b6-b86a-355770f5629b",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.036,37.983,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.036,37.983,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.618556701030928,
                "count": 97
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94520"
            }
        ]
    },
    {
        "guid": "4713a170-6b40-488b-8ce5-dc181e88e327",
        "content": {
            "centroid": {
                "lat": 37.724311,
                "lon": -122.452269
            },
            "entity": {
                "abbreviation": "Gateway High School",
                "alternates": {
                    "ceeb": "052947",
                    "nces": "063441013687"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "4713a170-6b40-488b-8ce5-dc181e88e327",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Gateway High School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "99e99ecc-958d-41c7-9f98-d78249b29a98",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "61413703-2cce-42b9-a718-b28b79a1680f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Gateway High School",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "gateway-high-school-san-francisco-ca-063441013687",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 133
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 103
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "As my senior year comes to an end I will be missing this place a lot! Gateway High School has shaped me into becoming a more better and wise version of myself. I will cherish every moment I've spent on this campus. I would like to thank all my teachers for everything that they've done for us. I am truly grateful for everyone here!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-02-16T05:36:57.214378Z",
                "guid": "259633df-edeb-4694-8f07-e7d0d98c393d",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.451,37.7257,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.451,37.7257,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.9523809523809526,
                "count": 21
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94112"
            }
        ]
    },
    {
        "guid": "f11b1c05-b9c1-4f11-8b77-72a028b50afd",
        "content": {
            "centroid": {
                "lat": 37.650421,
                "lon": -122.436089
            },
            "entity": {
                "abbreviation": "Baden High School",
                "alternates": {
                    "ceeb": "053414",
                    "nces": "063753006340"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "f11b1c05-b9c1-4f11-8b77-72a028b50afd",
                "isClaimed": false,
                "isPremium": false,
                "location": "South San Francisco, CA",
                "name": "Baden High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "41a0969a-227f-49e4-989c-cce558a6963c",
                    "schoolDistrict": "41a0969a-227f-49e4-989c-cce558a6963c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "64832fba-4ed7-403d-a9bb-3c8c5210d64c",
                    "zipCode": "8c664451-0242-437f-a6d9-d577f9b17d9e"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "South San Francisco Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "41a0969a-227f-49e4-989c-cce558a6963c",
                        "location": "South San Francisco, CA",
                        "name": "South San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "64832fba-4ed7-403d-a9bb-3c8c5210d64c",
                            "zipCode": "8c664451-0242-437f-a6d9-d577f9b17d9e"
                        },
                        "premium": false,
                        "shortName": "South San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "South San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "south-san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Baden High School",
                "tagline": [
                    "South San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "baden-high-school-south-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 107
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 16
                }
            ],
            "featuredReview": {
                "author": "Recent Alumnus",
                "body": "Coming into Baden wouldn't be any other way than i asked. It's helped me prepare and open my eyes to opportunities in college, more wide and critical thinking to my own of what i want to study and major in, which is the Administration of Justice. Baden is a small continuation school that allows me to finish with all criteria met and start my academics for college at my own time, pace and level.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2014-10-22T02:53:52Z",
                "guid": "9ca3c3eb-baec-4b7c-98dc-9ef1dc87f433",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.436,37.65,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.436,37.65,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94080"
            }
        ]
    },
    {
        "guid": "f6918c16-b6c7-4d47-a608-a112592d80a3",
        "content": {
            "centroid": {
                "lat": 37.80548,
                "lon": -122.236855
            },
            "entity": {
                "abbreviation": "Oakland High School",
                "alternates": {
                    "ceeb": "052225",
                    "nces": "062805004304"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "f6918c16-b6c7-4d47-a608-a112592d80a3",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Oakland High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "151103a6-ab35-4483-a39b-6a34c254b9bd"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Oakland High School",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "oakland-high-school-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1642
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "The teachers are friendly and helpful, the staff obviously gives care towards their students. Oakland high school is a school who puts effort into their students, to give them what they need. I’ve been given opportunities to learn, and to educate others. The opportunities are endless. Oakland high also are resourceful, when needed to ask them something. They’ll manage to have an answer or at least somebody who does! Overall my experience with Oakland High School is amazing!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-05T04:53:26.461163Z",
                "guid": "fb0ab0b8-73cd-4b29-a613-29fb899c029e",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.237,37.8045,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.237,37.8045,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.397463002114165,
                "count": 473
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94610"
            }
        ]
    },
    {
        "guid": "9cd4dd4a-3eb6-4188-9245-f1ec643c8654",
        "content": {
            "centroid": {
                "lat": 37.795187,
                "lon": -122.258129
            },
            "entity": {
                "abbreviation": "Metwest High School",
                "alternates": {
                    "ceeb": "053009",
                    "nces": "062805011350"
                },
                "character": "Public, Magnet",
                "claimed": false,
                "displayable": true,
                "genus": "Magnet School",
                "guid": "9cd4dd4a-3eb6-4188-9245-f1ec643c8654",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Metwest High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "13143c54-a9b4-4958-8aec-fb1609695702"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Metwest High School",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "metwest-high-school-oakland-ca",
                "variation": 52
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 160
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 14
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "MetWest High School was the perfect school to help me transition into high school life. There is plenty of one on one support, and your advisor stays with you throughout your four years! Most or all staff know you by name, and there are many internship and volunteer opportunities. The school makes you feel heard and part of the community, and it pushes you to get out of your comfort zone and engage in meaningful work for the community that you are also interested in.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-03-26T02:11:37.884447Z",
                "guid": "9aa73c73-b97d-43c3-870b-211b58de081e",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.258,37.7951,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.258,37.7951,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.171428571428572,
                "count": 35
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94606"
            }
        ]
    },
    {
        "guid": "f1d5b2a3-0c62-4607-845e-3187c64e9b5d",
        "content": {
            "centroid": {
                "lat": 37.771754,
                "lon": -122.215622
            },
            "entity": {
                "abbreviation": "ARISE High School",
                "alternates": {
                    "ceeb": "054258",
                    "nces": "060246212040"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "f1d5b2a3-0c62-4607-845e-3187c64e9b5d",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Arise High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "90731d14-c187-4264-ac2c-4b3485508684"
                },
                "premium": false,
                "shortName": "ARISE High School",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "arise-high-school-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 317
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Arise High school encourages students to create change. Teachers are always there to check on students. If they even see one student failing teachers are always quick to set after-school appointments. One con about this school is that students don't have the spirit. When we have competitions or have games hardly anyone comes. Some of the students are just boring. But the school is very inclusive.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-04-08T05:15:30.912025Z",
                "guid": "31918c9d-e5a8-4541-a6e5-c120fe65c0cc",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.225,37.7761,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.225,37.7761,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.8450704225352115,
                "count": 71
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94601"
            }
        ]
    },
    {
        "guid": "42fd2048-f5b3-41e2-9b17-5f767e05e985",
        "content": {
            "centroid": {
                "lat": 37.2615515,
                "lon": -121.8653065
            },
            "entity": {
                "abbreviation": "Liberty High (Alternative)",
                "alternates": {
                    "nces": "063459006645"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "42fd2048-f5b3-41e2-9b17-5f767e05e985",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Liberty High (Alternative)",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "078c8917-e52e-4332-af2e-2091c6f2b825",
                    "parent": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "schoolDistrict": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "bcda0e04-4247-440c-ae7f-42454876c867"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SJUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                        "location": "San Jose, CA",
                        "name": "San Jose Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "0a781906-f3cb-42ec-b08b-9acfcaf63aaa",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "763f10c1-8ad0-4832-90b4-5bad39b6e93f"
                        },
                        "premium": false,
                        "shortName": "San Jose Unified School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-jose-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Liberty High (Alternative)",
                "tagline": [
                    "San Jose Unified School District, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "liberty-high-alternative-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 334
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.8653065,37.2615515,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.8653065,37.2615515,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95136"
            }
        ]
    },
    {
        "guid": "cf8d1e1e-e54a-4d69-b006-5d0f261baf9f",
        "content": {
            "centroid": {
                "lat": 37.671973,
                "lon": -122.099037
            },
            "entity": {
                "abbreviation": "Brenkwitz High School",
                "alternates": {
                    "ceeb": "051154",
                    "nces": "061674002123"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "cf8d1e1e-e54a-4d69-b006-5d0f261baf9f",
                "isClaimed": false,
                "isPremium": false,
                "location": "Hayward, CA",
                "name": "Brenkwitz High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "79a41c1b-d6de-4e7f-888d-c9468fac9c1c",
                    "parent": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                    "schoolDistrict": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "zipCode": "6933fc80-ff2d-4020-ab31-239bec481049"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "HUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                        "location": "Hayward, CA",
                        "name": "Hayward Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "3ee6b10e-9c9c-43c9-bee6-1755097895e1",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                            "zipCode": "72f14b46-7398-463c-a7b1-84d94dfe3a97"
                        },
                        "premium": false,
                        "shortName": "Hayward Unified School District",
                        "tagline": [
                            "School District",
                            "Hayward, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "hayward-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Brenkwitz High School",
                "tagline": [
                    "Hayward Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "brenkwitz-high-school-hayward-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 161
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 11
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.096,37.6732,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.096,37.6732,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3,
                "count": 8
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94541"
            }
        ]
    },
    {
        "guid": "84a69895-7853-4957-be2d-f51cfc357955",
        "content": {
            "centroid": {
                "lat": 38.016987,
                "lon": -121.816125
            },
            "entity": {
                "abbreviation": "Prospects High (Alternative)",
                "alternates": {
                    "ceeb": "050112",
                    "nces": "060285009517"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "84a69895-7853-4957-be2d-f51cfc357955",
                "isClaimed": false,
                "isPremium": false,
                "location": "Antioch, CA",
                "name": "Prospects High (Alternative)",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                    "schoolDistrict": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                    "zipCode": "2026ed1b-602c-43a5-859e-4d5b3ed7410b"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Antioch Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                        "location": "Antioch, CA",
                        "name": "Antioch Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                            "zipCode": "2026ed1b-602c-43a5-859e-4d5b3ed7410b"
                        },
                        "premium": false,
                        "shortName": "Antioch Unified School District",
                        "tagline": [
                            "School District",
                            "Antioch, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "antioch-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Prospects High (Alternative)",
                "tagline": [
                    "Antioch Unified School District, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "prospects-high-alternative-antioch-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 348
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "I have mental Health issues which prevented me from going to a regular school. By only going to school for once a week, I was able to graduate high school. They were really understanding and they helped me with anything I needed.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-01-08T20:45:32.868424Z",
                "guid": "5d2bc8a1-95e1-4cea-86fc-660bd9537b6f",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.816,38.0171,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.816,38.0171,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6,
                "count": 10
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94509"
            }
        ]
    },
    {
        "guid": "8a930c92-2868-4b8b-b8e2-481c29346ebf",
        "content": {
            "centroid": {
                "lat": 37.314392,
                "lon": -121.965998
            },
            "entity": {
                "abbreviation": "Boynton High School",
                "alternates": {
                    "ceeb": "053081",
                    "nces": "060723000658"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "8a930c92-2868-4b8b-b8e2-481c29346ebf",
                "isClaimed": true,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Boynton High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "2af26fb6-2239-44b4-be58-b0e8e46b2a61",
                    "parent": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                    "schoolDistrict": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "326a03e0-bc81-42e5-87ef-3cd92b018bc4"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Campbell Union High School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "75e6ea3d-0384-47df-8839-a43fca5a7337",
                        "location": "San Jose, CA",
                        "name": "Campbell Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "5750507d-5a3f-47db-a00c-b8ac64163449",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "c051b239-374c-4f96-b426-d3be11c6ef67"
                        },
                        "premium": false,
                        "shortName": "Campbell Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "campbell-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Boynton High School",
                "tagline": [
                    "Campbell Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "boynton-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 209
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 15
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "The teachers are wonderful, they just care for the students well being. Faculty are absolutely wonderful and have a lot of school spirit!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-04-30T21:27:41.630529Z",
                "guid": "9976034c-26aa-4041-b750-63b20764c955",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.967,37.3104,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.967,37.3104,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4,
                "count": 5
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95117"
            }
        ]
    },
    {
        "guid": "eba5ade1-129d-497d-a71b-6643c48cef79",
        "content": {
            "centroid": {
                "lat": 38.005137,
                "lon": -121.815573
            },
            "entity": {
                "abbreviation": "Antioch High School",
                "alternates": {
                    "ceeb": "050115",
                    "nces": "060285000207"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "eba5ade1-129d-497d-a71b-6643c48cef79",
                "isClaimed": false,
                "isPremium": false,
                "location": "Antioch, CA",
                "name": "Antioch High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                    "schoolDistrict": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                    "zipCode": "2026ed1b-602c-43a5-859e-4d5b3ed7410b"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Antioch Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                        "location": "Antioch, CA",
                        "name": "Antioch Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                            "zipCode": "2026ed1b-602c-43a5-859e-4d5b3ed7410b"
                        },
                        "premium": false,
                        "shortName": "Antioch Unified School District",
                        "tagline": [
                            "School District",
                            "Antioch, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "antioch-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Antioch High School",
                "tagline": [
                    "Antioch Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "antioch-high-school-antioch-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 2061
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "Antioch Highs staff consists mostly of pass panthers who came back to devote their time to the school that helped mold them and catapult them into their collegiate careers. I thinks its remarkable that the school has that affect on their students to where they want to come back and give back to the younger classmen. Because the bulk of the staff were past panthers, students faced opposition when traditions were questioned or trying to be changed in any way. Some staff feel like traditions that they were apart of should stay stagnant for the duration of the schools existence and others feel that as society changes, it is important to adapt to the changes in school culture which may require adjustments to old traditions. This issue made it extremely difficult to bring new and innovative ideas for events to increase school spirit.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-02-28T20:44:08.811342Z",
                "guid": "8daa03ae-c962-4729-b8c0-db9081b94614",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.816,38.0063,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.816,38.0063,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.2943722943722946,
                "count": 231
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94509"
            }
        ]
    },
    {
        "guid": "ba5711e3-6fc6-4a07-9d03-c384a1bdfcfe",
        "content": {
            "centroid": {
                "lat": 37.727742,
                "lon": -122.179277
            },
            "entity": {
                "abbreviation": "Madison Park Business & Art Academy",
                "alternates": {
                    "ceeb": "054768",
                    "nces": "062805004278"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "ba5711e3-6fc6-4a07-9d03-c384a1bdfcfe",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Madison Park Business & Art Academy",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "2668905c-77a3-478f-a15e-7d1156714023"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Madison Park Business & Art Academy",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "madison-park-business--and--art-academy-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 774
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Great school, the teachers really care.  I wish they had more afterschool classes that I was interested in OK. Me and Neighborhood is not good at all and the food is bad but the teachers and the staff there are great. It makes it worth while showing up to school every day because I know people care about me. They take the time to come in on weekends and once school is out on vacation to help me catch up on homework our capstone. They got me interested in things that I would normally not be interested in like protesting and watching sports games after school. Normally I would not be interested in things like that. Also this year I made three friends that I hang out with them every day. The kids want to show up at school every day because they like it here. I wish I would’ve found out about it sooner. I just found out about it last year and now I’m graduating this year. It would’ve been a great experience to be able to have spent all the way from kindergarten until now here.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-03-28T03:56:15.733391Z",
                "guid": "2f9cbc7a-2ebc-4612-a4d5-0cd5b3154815",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.179,37.7272,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.179,37.7272,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.3846153846153846,
                "count": 26
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94603"
            }
        ]
    },
    {
        "guid": "b2ea0a99-8444-4ae0-ba82-f88e66529a94",
        "content": {
            "centroid": {
                "lat": 37.709117,
                "lon": -122.160429
            },
            "entity": {
                "abbreviation": "Lincoln High School",
                "alternates": {
                    "ceeb": "054269",
                    "nces": "063468005835"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "b2ea0a99-8444-4ae0-ba82-f88e66529a94",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Leandro, CA",
                "name": "Lincoln High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "3ace4474-a46b-433c-807a-58f60e2991f6",
                    "parent": "703b106b-ed91-4085-98d4-5867e5f04ecb",
                    "schoolDistrict": "703b106b-ed91-4085-98d4-5867e5f04ecb",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "97147736-91ca-4fcf-8a1e-c9419d2d2593",
                    "zipCode": "0418db05-538d-429e-a8b8-8b6441797a1d"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "San Leandro Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "703b106b-ed91-4085-98d4-5867e5f04ecb",
                        "location": "San Leandro, CA",
                        "name": "San Leandro Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a2d1b6e7-6b04-4cd6-a4bf-7eadb1067cb7",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "97147736-91ca-4fcf-8a1e-c9419d2d2593",
                            "zipCode": "0418db05-538d-429e-a8b8-8b6441797a1d"
                        },
                        "premium": false,
                        "shortName": "San Leandro Unified School District",
                        "tagline": [
                            "School District",
                            "San Leandro, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-leandro-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Lincoln High School",
                "tagline": [
                    "San Leandro Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "lincoln-high-school-san-leandro-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 187
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.16,37.7087,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.16,37.7087,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94579"
            }
        ]
    },
    {
        "guid": "a4dcc0a0-0a22-49a0-bcab-244b36f487b4",
        "content": {
            "centroid": {
                "lat": 37.609657,
                "lon": -122.429996
            },
            "entity": {
                "abbreviation": "Peninsula High School",
                "alternates": {
                    "ceeb": "052812",
                    "nces": "063498005925"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "a4dcc0a0-0a22-49a0-bcab-244b36f487b4",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Bruno, CA",
                "name": "Peninsula High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "schoolDistrict": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "501fa4d3-c95b-4be7-8f45-a278b79ec201",
                    "zipCode": "2747e85f-3e2c-4bb8-a767-725ae14708a4"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SMUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "bd13963d-2117-4c17-bebc-12c9fc94d191",
                        "location": "San Mateo, CA",
                        "name": "San Mateo Union High School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "2e248a4c-74bf-4d82-8538-a83219eb322b",
                            "zipCode": "3435a379-835e-44ad-a67d-683bc7ef6fc8"
                        },
                        "premium": false,
                        "shortName": "San Mateo Union High School District",
                        "tagline": [
                            "School District",
                            "San Mateo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-mateo-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Peninsula High School",
                "tagline": [
                    "San Mateo Union High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "peninsula-high-school-san-bruno-ca-063498005925",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 186
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.428028,37.612958,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.428028,37.612958,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94066"
            }
        ]
    },
    {
        "guid": "86467748-77e6-44b7-ad36-cf31394c7847",
        "content": {
            "centroid": {
                "lat": 37.990124,
                "lon": -122.330351
            },
            "entity": {
                "abbreviation": "Aspire Richmond Ca. College Preparatory Academy",
                "alternates": {
                    "nces": "060240313890"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "86467748-77e6-44b7-ad36-cf31394c7847",
                "isClaimed": false,
                "isPremium": false,
                "location": "Richmond, CA",
                "name": "Aspire Richmond Ca. College Preparatory Academy",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "schoolNetwork": "6d55fb3e-0771-4fa6-bff7-2753f0a42065",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                    "zipCode": "a08c6674-b67b-4d2b-976e-ac88b0619d80"
                },
                "premium": false,
                "shortName": "Aspire Richmond Ca. College Preparatory Academy",
                "tagline": [
                    "Public School",
                    "Richmond, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "aspire-richmond-ca-college-preparatory-academy-richmond-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 541
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 30
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "I cant find the most eloquent word to describe my experience at Cal Prep. My mom says highschool are the best four years of your life, I cant say they were the best but they were the most educational years. At Cal prep I experienced my transition from childhood to adulthood, I've learned how it is possible to  communicate through art, and how every object in a state of motion will remain at rest unless an external force acts upon it thanks to the Newton law. One of  the most important thing my teachers have taught me is leadership, I've learned how to guide others and being able to engaged with children and teens to work together and create a safety eviroment inside and outside campus. I found my second family at Cal Prep, even though it's a small school you create a lot of memories becuase of the positive enrgy you find in every person there.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-01-23T01:39:25.513603Z",
                "guid": "cec27920-093e-4f30-beb8-aa28b0292381",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.327,37.9782,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.327,37.9782,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.9285714285714284,
                "count": 14
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94806"
            }
        ]
    },
    {
        "guid": "857848ef-0f8a-4b9b-bdff-ed955cffad50",
        "content": {
            "centroid": {
                "lat": 37.64268,
                "lon": -122.066115
            },
            "entity": {
                "abbreviation": "Tennyson High School",
                "alternates": {
                    "ceeb": "051152",
                    "nces": "061674002135"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "857848ef-0f8a-4b9b-bdff-ed955cffad50",
                "isClaimed": false,
                "isPremium": false,
                "location": "Hayward, CA",
                "name": "Tennyson High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "3de3a2d4-28e6-4c98-8658-17e58a189e75",
                    "parent": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                    "schoolDistrict": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                    "zipCode": "72f14b46-7398-463c-a7b1-84d94dfe3a97"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "HUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                        "location": "Hayward, CA",
                        "name": "Hayward Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "3ee6b10e-9c9c-43c9-bee6-1755097895e1",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                            "zipCode": "72f14b46-7398-463c-a7b1-84d94dfe3a97"
                        },
                        "premium": false,
                        "shortName": "Hayward Unified School District",
                        "tagline": [
                            "School District",
                            "Hayward, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "hayward-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Tennyson High School",
                "tagline": [
                    "Hayward Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "tennyson-high-school-hayward-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1423
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Tennyson High School is what you'd expect in the minority city of Hayward, California. Yes, its facilities are on the older end, and students are primarily of minority descent... It may look daunting, indeed.\n\nNevertheless, it is always helpful to not judge a book simply by its cover, and this is especially useful when it comes to Tennyson High School.\n\nThis high school offers many opportunities through its selection of AP and honors courses, programs and electives, and sports and clubs. Such teachers are not only limited to knowledgeable mentors, but they are also friendly and cooperative human beings. Such support is necessary in the journey through high school!\n\nFrom my three years here at Tennyson, I do not regret attending this high school. From what I can see, I have grown from my experiences here, and I hope to discover even more in my final senior year, next year.\n\nTennyson High School may not look the best. But perfection doesn't exist, after all.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-10-09T00:44:09.987298Z",
                "guid": "10aba873-e5f1-4c21-8455-f1f33ef4ec2b",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.066,37.6426,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.066,37.6426,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.112759643916914,
                "count": 337
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94544"
            }
        ]
    },
    {
        "guid": "4b43b6c5-a261-4e14-9b6b-b3ee5e89e244",
        "content": {
            "centroid": {
                "lat": 37.600499,
                "lon": -122.019562
            },
            "entity": {
                "abbreviation": "Decoto School for Independent Study",
                "alternates": {
                    "ceeb": "054656",
                    "nces": "062691013202"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "4b43b6c5-a261-4e14-9b6b-b3ee5e89e244",
                "isClaimed": true,
                "isPremium": false,
                "location": "Union City, CA",
                "name": "Decoto School for Independent Study",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "305b3896-e539-4976-95d2-a90396c3f1cf",
                    "schoolDistrict": "305b3896-e539-4976-95d2-a90396c3f1cf",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "a1a37120-c207-41c6-9193-6d1b754eb2ec",
                    "zipCode": "f865aa9f-3f3c-41d7-80c3-1df06f3db370"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "New Haven Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "305b3896-e539-4976-95d2-a90396c3f1cf",
                        "location": "Union City, CA",
                        "name": "New Haven Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "a1a37120-c207-41c6-9193-6d1b754eb2ec",
                            "zipCode": "f865aa9f-3f3c-41d7-80c3-1df06f3db370"
                        },
                        "premium": false,
                        "shortName": "New Haven Unified School District",
                        "tagline": [
                            "School District",
                            "Union City, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "new-haven-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Decoto School for Independent Study",
                "tagline": [
                    "New Haven Unified School District, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "decoto-school-for-independent-study-union-city-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 121
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "I came to this school as an incoming Junior in high school. I was a bit nervous at first but from the start, the principal and other staff kindly and happily greeted my mom and I during the interview process when I was applying to be a student here. The counselor here was very kind and informative. Every time she'd see me and other students on campus, she would pass out flyers with important information such as scholarship opportunities and job fairs. Everyone showed true interest in the students academics and welfare. Overall, I felt like this school was composed with the best staff I have ever encountered and they truly helped me better my high school experience as well as my overall academics.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-01-16T00:31:29.392012Z",
                "guid": "2b2008d8-7a81-470b-9711-f2777ea27c61",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.02,37.5995,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.02,37.5995,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.4,
                "count": 5
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94587"
            }
        ]
    },
    {
        "guid": "46feb998-4bfb-423d-8863-920f18e620c3",
        "content": {
            "centroid": {
                "lat": 37.775417,
                "lon": -122.434483
            },
            "entity": {
                "abbreviation": "Ida B. Wells High",
                "alternates": {
                    "ceeb": "052992",
                    "nces": "063441005653"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "46feb998-4bfb-423d-8863-920f18e620c3",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Ida B. Wells High",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "3c0ebfa6-7c07-40e5-b8f1-932301223fae",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "7db16a60-8255-4b6d-ac82-4ba69c978bcb"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Ida B. Wells High",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "ida-b-wells-high-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 165
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.434,37.7751,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.434,37.7751,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94117"
            }
        ]
    },
    {
        "guid": "082fa5b2-e276-45fa-92af-1f19dd6fe964",
        "content": {
            "centroid": {
                "lat": 37.721467,
                "lon": -122.44508
            },
            "entity": {
                "abbreviation": "Leadership High School",
                "alternates": {
                    "ceeb": "052968",
                    "nces": "060149107354"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "082fa5b2-e276-45fa-92af-1f19dd6fe964",
                "isClaimed": true,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Leadership High School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "95c0370c-58af-428a-98dc-478e22f3237b",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "61413703-2cce-42b9-a718-b28b79a1680f"
                },
                "premium": false,
                "shortName": "Leadership High School",
                "tagline": [
                    "Public School",
                    "San Francisco, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "leadership-high-school-san-francisco-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 324
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My experience at Leadership High School was drastically different from any other school I have been to. The school as a whole feels more like community and support system rather than just a regular high school. Usually at my other schools prior to going to Leadership, it was hard to get any support but within Leadership it's different. They have designed Leadership to revolve everything around the students and their needs. They provide support in academics and when it comes to personal support.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-05-19T19:39:24.827416Z",
                "guid": "12eba8a7-81f2-438b-975f-b4b34a4cdcbb",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.445,37.7214,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.445,37.7214,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5783132530120483,
                "count": 83
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94112"
            }
        ]
    },
    {
        "guid": "379687aa-5f86-4eef-986e-7fa1b35fa5c6",
        "content": {
            "centroid": {
                "lat": 37.320733,
                "lon": -121.848264
            },
            "entity": {
                "abbreviation": "Luis Valdez Leadership Academy",
                "alternates": {
                    "nces": "060203813815"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "379687aa-5f86-4eef-986e-7fa1b35fa5c6",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Luis Valdez Leadership Academy",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "259502ce-bdc7-4b71-89e6-a525fa78a771",
                    "schoolNetwork": "ffb11791-dbb8-4d8f-a255-fac0112c0df3",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "ac9aac5c-c77f-4b0d-8bc0-ae6dfa42a701"
                },
                "premium": false,
                "shortName": "Luis Valdez Leadership Academy",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "luis-valdez-leadership-academy-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 363
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 26
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Luis Valdez Leadership Acdemy is a charter school filled with diversity, authenticity, and college readiness. Build off of values such as En lak’ech and Sankofa. A school who choose to inspire and educate their students with their Latin roots. Teachers are dedicated to their students and provide much more then just a teacher influence. Luis Valdez is a school where the community is much more that just students and  administrators. It’s a tight net family, a family that wants to see you be successful and strive for a four year university.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-08-17T17:34:01.232964Z",
                "guid": "3ab74ad3-4e8f-4dac-a4d4-87a99a1f18b6",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.849,37.3184,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.849,37.3184,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4,
                "count": 18
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95122"
            }
        ]
    },
    {
        "guid": "545cffe9-b1a3-4010-ba21-059654bf276c",
        "content": {
            "centroid": {
                "lat": 37.980957,
                "lon": -122.027772
            },
            "entity": {
                "abbreviation": "Olympic Continuation High School",
                "alternates": {
                    "ceeb": "050661",
                    "nces": "062637003963"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "545cffe9-b1a3-4010-ba21-059654bf276c",
                "isClaimed": false,
                "isPremium": false,
                "location": "Concord, CA",
                "name": "Olympic Continuation High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "schoolDistrict": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "187f89d7-6963-49c2-b924-426631dae88f",
                    "zipCode": "fca2caaa-dbcc-472c-be69-c07f58b2a359"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "MDUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                        "location": "Concord, CA",
                        "name": "Mt. Diablo Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "187f89d7-6963-49c2-b924-426631dae88f",
                            "zipCode": "fca2caaa-dbcc-472c-be69-c07f58b2a359"
                        },
                        "premium": false,
                        "shortName": "Mt. Diablo Unified School District",
                        "tagline": [
                            "School District",
                            "Concord, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mt-diablo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Olympic Continuation High School",
                "tagline": [
                    "Mt. Diablo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "olympic-continuation-high-school-concord-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 258
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 13
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "The teachers and admin make Olympic something truly special. There was an overall feeling that they actually wanted to be there. The ease in which you could change your schedule was uncanny. Also, The leniency of the teachers made the students feel welcome and respected. The bi-weekly Graduation Status, something we didn't receive at our original high school, kept it super easy for students to keep up with, and understand, their credit situation. The shorter schedule allows students  get more sleep, which makes it easier for students to stay productive. My old teachers always talked down upon Olympic, acting as if it's just a one way stop on the way to being a dropout, But it was truly the best schooling experience I've ever recieved.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-10T18:21:23.022678Z",
                "guid": "c39c7cec-1544-4461-9439-a3d440254187",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.028,37.9798,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.028,37.9798,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.2631578947368425,
                "count": 19
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94519"
            }
        ]
    },
    {
        "guid": "8ddfef32-4a66-4bc5-8df9-7ba8719120a2",
        "content": {
            "centroid": {
                "lat": 38.006076,
                "lon": -121.812609
            },
            "entity": {
                "abbreviation": "Live Oak High School",
                "alternates": {
                    "ceeb": "050123",
                    "nces": "060285000213"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "8ddfef32-4a66-4bc5-8df9-7ba8719120a2",
                "isClaimed": false,
                "isPremium": false,
                "location": "Antioch, CA",
                "name": "Live Oak High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                    "schoolDistrict": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                    "zipCode": "2026ed1b-602c-43a5-859e-4d5b3ed7410b"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Antioch Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                        "location": "Antioch, CA",
                        "name": "Antioch Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                            "zipCode": "2026ed1b-602c-43a5-859e-4d5b3ed7410b"
                        },
                        "premium": false,
                        "shortName": "Antioch Unified School District",
                        "tagline": [
                            "School District",
                            "Antioch, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "antioch-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Live Oak High School",
                "tagline": [
                    "Antioch Unified School District, CA",
                    "10-12"
                ],
                "type": "School",
                "url": "live-oak-high-school-antioch-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 152
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 17
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "I had no idea what a continuation school was until I moved to California. It really changed my life. I started attending Live Oak High School when I was a Senior in High School and all throughout High School I worried if I was going to graduate on time. Live Oak High School made it possible for me to graduate on time. I was even a Valedictorian at graduation, got the principles award, and even finished off with a 4.0 GPA.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-03-31T06:46:23.447822Z",
                "guid": "7670410c-b2c0-480c-8a8c-0b225c09a098",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.813,38.0055,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.813,38.0055,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94509"
            }
        ]
    },
    {
        "guid": "75479418-e427-4408-b5ef-40676e4567e3",
        "content": {
            "centroid": {
                "lat": 37.329548,
                "lon": -121.830065
            },
            "entity": {
                "abbreviation": "Apollo High School",
                "alternates": {
                    "ceeb": "053147",
                    "nces": "061182006643"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "75479418-e427-4408-b5ef-40676e4567e3",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Apollo High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "259502ce-bdc7-4b71-89e6-a525fa78a771",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "ac9aac5c-c77f-4b0d-8bc0-ae6dfa42a701"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Apollo High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "11-12"
                ],
                "type": "School",
                "url": "apollo-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 151
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "What I liked about apollo high school was that there weren't many students in one class so the teacher can focus more on who needed the most help. I also liked how it was a small school so, it was easier to make friends. Apollo high school was one of the best decisions I made. The school really helped me when I needed to get my grades and credits up. Since freshman year I always struggled to like a school that really helped me and that was Apollo high school. I highly recommend it!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-28T04:39:38.073784Z",
                "guid": "c3e3c18b-50f6-4d4b-9763-ebae6b700518",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.83,37.3319,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.83,37.3319,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.4,
                "count": 10
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95122"
            }
        ]
    },
    {
        "guid": "ca3825d2-a5d3-4c9e-82e7-2da12f772129",
        "content": {
            "centroid": {
                "lat": 37.358722,
                "lon": -121.815343
            },
            "entity": {
                "abbreviation": "Latino College Preparatory Academy",
                "alternates": {
                    "ceeb": "053208",
                    "nces": "060193210402"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "ca3825d2-a5d3-4c9e-82e7-2da12f772129",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Latino College Preparatory Academy",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "259502ce-bdc7-4b71-89e6-a525fa78a771",
                    "schoolNetwork": "ffb11791-dbb8-4d8f-a255-fac0112c0df3",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "5be5c65e-b5cd-43bf-91dc-4e9af8c6c1f0"
                },
                "premium": false,
                "shortName": "Latino College Preparatory Academy",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "latino-college-preparatory-academy-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 410
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "The teachers are very dedicated to motivate students in their education as well as their personal goals. They build strong relationships with students.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-04T20:14:55.608508Z",
                "guid": "529852d5-ca57-4cfd-90d0-6668277ecde0",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.816,37.3597,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.816,37.3597,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.9886363636363638,
                "count": 88
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95127"
            }
        ]
    },
    {
        "guid": "dbf75c0f-3b16-4ad6-87f4-9d6a6cc4166b",
        "content": {
            "centroid": {
                "lat": 37.758611,
                "lon": -122.198625
            },
            "entity": {
                "abbreviation": "Aspire Golden State College Preparatory Academy",
                "alternates": {
                    "ceeb": "054260",
                    "nces": "060155212331"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "dbf75c0f-3b16-4ad6-87f4-9d6a6cc4166b",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Aspire Golden State College Preparatory Academy",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "schoolNetwork": "6d55fb3e-0771-4fa6-bff7-2753f0a42065",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "e5836a73-f350-41af-a5c5-da313cd26efb"
                },
                "premium": false,
                "shortName": "Aspire Golden State College Preparatory Academy",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "aspire-golden-state-college-preparatory-academy-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 618
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 36
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Cheap, Boring, and Dumb is how some would identify the GSP community in or outside its set up network. Nonetheless, For me I couldn't view the place where I've been most of my school career this way. At the point when traveling to the same place everyday for a span of years and continually seeing very similar things consistently you come to understand that the things said about GSP aren't always the case and there are numerous things you can gain from this community. What I appreciate most about my school is its consistency. All day every day, the GSP Community invites me into its ever-developing mission of supporting as many students as they can. Even with my school being the focal point of a once broken and wrongdoing stricken zone which some still consider to be dangerous, I have had the option to observe the well thought out actions of my school, where students, for example, myself have had the opportunity to thrive.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-03-30T07:17:14.535353Z",
                "guid": "405f4fd7-debb-4e35-bff6-ed6ea216a497",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.199,37.7597,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.199,37.7597,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.409090909090909,
                "count": 44
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94610"
            }
        ]
    },
    {
        "guid": "705cc98f-6088-4f5b-9f0f-c6634b2b06c2",
        "content": {
            "centroid": {
                "lat": 37.261912,
                "lon": -121.879721
            },
            "entity": {
                "abbreviation": "Broadway High School",
                "alternates": {
                    "ceeb": "053085",
                    "nces": "063459005709"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "705cc98f-6088-4f5b-9f0f-c6634b2b06c2",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Broadway High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "5750507d-5a3f-47db-a00c-b8ac64163449",
                    "parent": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "schoolDistrict": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "cfe32ecb-646c-4ac4-8146-97a3f348c00e"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SJUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                        "location": "San Jose, CA",
                        "name": "San Jose Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "0a781906-f3cb-42ec-b08b-9acfcaf63aaa",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "763f10c1-8ad0-4832-90b4-5bad39b6e93f"
                        },
                        "premium": false,
                        "shortName": "San Jose Unified School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-jose-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Broadway High School",
                "tagline": [
                    "San Jose Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "broadway-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 201
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 14
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Overall I believe Broadway High school does an amazing job providing students an environment where they feel welcomed and supported with their every decision. Even though it is a well known school in San Jose, this high school is not one that everyone attends. It is a continuation school that has a bad reputation even though the majority are false. When I first came as a junior, I was coming in from Willow Glen High School; a traditional school. My ideas of Broadway were far from reality. I was told that BHS was for the kids that were \"dumb\", \"pregnant\", or \"gang bangers\". I was scared and nervous. Upon arrival, I shortly realize everyone was wrong. The students all had the same goal which was to graduate. The staff is amazing. They never let you fail even if you want to with all your heart. I believe broadway is and will always be better than any traditional school",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-01-03T05:57:11.583707Z",
                "guid": "9c23c972-40b0-4199-8577-e7faf0ea3965",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.88,37.2616,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.88,37.2616,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 4
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95118"
            }
        ]
    },
    {
        "guid": "2de38e4a-65d2-4ef4-b179-d6e98530a876",
        "content": {
            "centroid": {
                "lat": 37.764878,
                "lon": -122.195668
            },
            "entity": {
                "abbreviation": "Alternatives In Action",
                "alternates": {
                    "ceeb": "050013",
                    "nces": "060163508674"
                },
                "character": "Public, Charter, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "2de38e4a-65d2-4ef4-b179-d6e98530a876",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Alternatives In Action",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "e5836a73-f350-41af-a5c5-da313cd26efb"
                },
                "premium": false,
                "shortName": "Alternatives In Action",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "alternatives-in-action-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 202
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "I love school now! Used to want to drop out before coming to Alternatives In Action. Gave school one more chance by coming here, for my parents, and so glad I did. I look forward to graduating soon and college after that.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2017-09-24T07:33:12.889499Z",
                "guid": "f5f27fa3-1b99-4243-b25f-0d91837fff00",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.195,37.7644,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.195,37.7644,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.814814814814815,
                "count": 27
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94621"
            }
        ]
    },
    {
        "guid": "572951cc-a80d-45c0-abfc-e79ac36f0087",
        "content": {
            "centroid": {
                "lat": 37.796705,
                "lon": -122.258246
            },
            "entity": {
                "abbreviation": "Dewey Academy",
                "alternates": {
                    "ceeb": "052193",
                    "nces": "062805004255"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "572951cc-a80d-45c0-abfc-e79ac36f0087",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Dewey Academy",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "13143c54-a9b4-4958-8aec-fb1609695702"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Dewey Academy",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "dewey-academy-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 229
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 15
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "The school needs to work a bit more on student-involved activities. The administration is great and resources are great!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-06-24T05:16:40.87399Z",
                "guid": "1b75577d-4f14-4c38-89a5-75825295d603",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.258,37.7969,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.258,37.7969,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.25,
                "count": 8
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94606"
            }
        ]
    },
    {
        "guid": "7f64aadb-3bc1-4aa4-b963-5e62127520ef",
        "content": {
            "centroid": {
                "lat": 37.316384,
                "lon": -121.873932
            },
            "entity": {
                "abbreviation": "Downtown College Preparatory",
                "alternates": {
                    "ceeb": "053164",
                    "nces": "060159708632"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "7f64aadb-3bc1-4aa4-b963-5e62127520ef",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Downtown College Prep",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "b3810c50-1d1b-4a15-8c27-36f244515bfd",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "e055b5f7-d1e6-491d-9e73-e54d691a3326"
                },
                "premium": false,
                "shortName": "Downtown College Preparatory",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "downtown-college-prep-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 488
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "This school holds a very special place in my heart. Previously I had went to their middle school and it was amazing the teachers were so nice and caring as well as the students. The school also gives you classes they know you can handle like if they know you’re a bit more advanced they will put you in a more advanced class likewise if they see that you are struggling too much they will offer you so much help like after school tutoring or some teachers have office hours you can go to. I went to another school for my freshman year of high school and it was just terrible. They didn’t give students the classes they needed and they just kind of ignored you when you had a question but then I came back to DCP and it was like suddenly everything was so perfect! The students are very caring and friendly, they love to joke around and play music and games. It’s just fun all over the place! I honestly would recommend this school a thousand times because I just love it so much!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-03-11T05:09:50.634504Z",
                "guid": "a78cea29-4d74-4e47-b961-e6b66ae4dc30",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.914,37.3342,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.914,37.3342,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6825396825396823,
                "count": 63
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95110"
            }
        ]
    },
    {
        "guid": "55d47f7f-68f7-44d0-8068-4db69c1214c3",
        "content": {
            "centroid": {
                "lat": 37.813022,
                "lon": -122.286784
            },
            "entity": {
                "abbreviation": "Ralph J. Bunche High School",
                "alternates": {
                    "nces": "062805012325"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "55d47f7f-68f7-44d0-8068-4db69c1214c3",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Ralph J. Bunche High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Ralph J. Bunche High School",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "ralph-j-bunche-high-school-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 124
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 16
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "As a student of Ralph J. Bunche Academy I appreciate what the school has to offer. They help students to receive the education  we needed that we could not get from other high schools. Because of this, I am able to succeed in my academics, go to college and continue further my education. I was not doing so well in my  classes at my previous high school, but as a transfered to Bunche, I was given the opportunity to continue my curriculum and graduate as a valedictorian. They gave me the opportunity to move forward with my  education so that I may strive  and succeed in the future.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-03-08T20:04:20.199004Z",
                "guid": "91fd024e-b96f-467c-ba56-d91521eb1e5f",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.287,37.813,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.287,37.813,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.5,
                "count": 2
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94607"
            }
        ]
    },
    {
        "guid": "98a76108-19b3-4163-b8a4-fc6189ab9757",
        "content": {
            "centroid": {
                "lat": 37.25783,
                "lon": -121.830965
            },
            "entity": {
                "abbreviation": "Phoenix High School",
                "alternates": {
                    "ceeb": "053171",
                    "nces": "061182010318"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "98a76108-19b3-4163-b8a4-fc6189ab9757",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Phoenix High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "078c8917-e52e-4332-af2e-2091c6f2b825",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "656c3aa8-650d-4f5e-97c4-2c4879faa9d3"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Phoenix High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "11-12"
                ],
                "type": "School",
                "url": "phoenix-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 78
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "I loved the teachers and how they push you to finish school the classes weren’t too difficult and it made me want to change as a person as well, one thing that should change is for them to be more on top of credits and letting students know more how many more credits they new to graduate.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-06-07T23:39:47.984318Z",
                "guid": "0f9f86fa-25cd-4ec3-99fb-ea76e2486a0c",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.829,37.2356,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.829,37.2356,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95123"
            }
        ]
    },
    {
        "guid": "001c1a6e-4dad-4d8a-819f-8ce0f3f5c106",
        "content": {
            "centroid": {
                "lat": 37.955857,
                "lon": -121.985633
            },
            "entity": {
                "abbreviation": "La Paloma High School",
                "alternates": {
                    "ceeb": "054323",
                    "nces": "062160002572"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "001c1a6e-4dad-4d8a-819f-8ce0f3f5c106",
                "isClaimed": false,
                "isPremium": false,
                "location": "Brentwood, CA",
                "name": "La Paloma High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                    "schoolDistrict": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "187f89d7-6963-49c2-b924-426631dae88f",
                    "zipCode": "64ec8361-307f-4c60-8518-5e08e7cc3cb0"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Liberty Union High School District (Brentwood)",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6456d682-46f6-44ce-823a-747a75d6d2a9",
                        "location": "Brentwood, CA",
                        "name": "Liberty Union High School District (Brentwood)",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "8c697687-c0ec-469c-98e8-e0a06e72a35a",
                            "zipCode": "fea44aef-6d39-4c1c-9267-b5b70ebd1cf5"
                        },
                        "premium": false,
                        "shortName": "Liberty Union High School District (Brentwood)",
                        "tagline": [
                            "School District",
                            "Brentwood, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "liberty-union-high-school-district-brentwood-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "La Paloma High School",
                "tagline": [
                    "Liberty Union High School District (Brentwood), CA",
                    "9-12"
                ],
                "type": "School",
                "url": "la-paloma-high-school-brentwood-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 169
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 15
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.681,37.9205,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.681,37.9205,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94513"
            }
        ]
    },
    {
        "guid": "fd79abd2-312f-475b-8b8d-ad8228f1ba42",
        "content": {
            "centroid": {
                "lat": 37.347106,
                "lon": -121.955407
            },
            "entity": {
                "abbreviation": "Wilson Alternative School",
                "alternates": {
                    "ceeb": "053283",
                    "nces": "063543008984"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "fd79abd2-312f-475b-8b8d-ad8228f1ba42",
                "isClaimed": true,
                "isPremium": false,
                "location": "Santa Clara, CA",
                "name": "Wilson Alternative School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                    "schoolDistrict": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "44b1c9d0-0773-4aa7-aaeb-c04dda704fc1",
                    "zipCode": "91f8ca89-1d96-436a-8a3f-5e45a8940ad1"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Santa Clara Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                        "location": "Santa Clara, CA",
                        "name": "Santa Clara Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "44b1c9d0-0773-4aa7-aaeb-c04dda704fc1",
                            "zipCode": "d1fd4c8f-758c-4371-b58b-7ac5e13d8df8"
                        },
                        "premium": false,
                        "shortName": "Santa Clara Unified School District",
                        "tagline": [
                            "School District",
                            "Santa Clara, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "santa-clara-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Wilson Alternative School",
                "tagline": [
                    "Santa Clara Unified School District, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "wilson-alternative-school-santa-clara-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 254
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "I had a great experience at Wilson Alternative. I would probably change the academics to make the STEM department stronger so the students could be more challenged.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-01-11T15:14:45.256819Z",
                "guid": "36658b65-6fe3-4f68-89c5-a9458ac0a2ec",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.955,37.3466,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.955,37.3466,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 2.8333333333333335,
                "count": 6
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95050"
            }
        ]
    },
    {
        "guid": "ed656f38-c262-42db-b5fc-5e6d7a0beaeb",
        "content": {
            "centroid": {
                "lat": 37.760917,
                "lon": -122.404091
            },
            "entity": {
                "abbreviation": "Downtown High School",
                "alternates": {
                    "ceeb": "052991",
                    "nces": "063441005602"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "ed656f38-c262-42db-b5fc-5e6d7a0beaeb",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Downtown High School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "0e7feade-1234-4a78-b9a6-f0a08b901e7c",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "781604ff-cae4-4ff7-8bc5-30889e25ac1f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Downtown High School",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "downtown-high-school-san-francisco-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 171
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 26
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "It is a great school that teach youth through hands on learning and creates positive experiences. Makes learning fun!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2017-11-17T06:18:04.180447Z",
                "guid": "c1e41fd4-4150-46a4-aba1-de166f465b56",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.42,37.7548,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.42,37.7548,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.6,
                "count": 5
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94107"
            }
        ]
    },
    {
        "guid": "7d4571ec-e565-47ca-b957-d86f3922fec3",
        "content": {
            "centroid": {
                "lat": 37.77368,
                "lon": -122.209463
            },
            "entity": {
                "abbreviation": "Fremont High School",
                "alternates": {
                    "ceeb": "052205",
                    "nces": "062805013062"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "7d4571ec-e565-47ca-b957-d86f3922fec3",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Fremont High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "90731d14-c187-4264-ac2c-4b3485508684"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Fremont High School",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "fremont-high-school-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 771
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 15
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "I like how supportive the teachers try to be, even though the students don't accept the offer. I feel like, at this school, they really care about the students and want it to be a safe, happy place for students. It's a somewhat small school, a bunch of students, but the smaller it is, the easier it is to interact with teachers and get the help you need. Because it's so small, I feel like here, I was able to get more help and connect with the teachers better. We're like one big family.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-10-02T04:32:37.90706Z",
                "guid": "cbb2add6-ceaa-4b12-9937-e83731e3b12f",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.21,37.7744,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.21,37.7744,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.2,
                "count": 15
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94601"
            }
        ]
    },
    {
        "guid": "dd92d6fa-7067-43b0-a245-0c9b1f600d57",
        "content": {
            "centroid": {
                "lat": 37.99985,
                "lon": -121.793693
            },
            "entity": {
                "abbreviation": "Bidwell Continuation High School",
                "alternates": {
                    "nces": "060285011573"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "dd92d6fa-7067-43b0-a245-0c9b1f600d57",
                "isClaimed": false,
                "isPremium": false,
                "location": "Antioch, CA",
                "name": "Bidwell Continuation High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                    "schoolDistrict": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                    "zipCode": "2026ed1b-602c-43a5-859e-4d5b3ed7410b"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Antioch Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "007aef6d-07b5-49c0-aac8-9cadec204a65",
                        "location": "Antioch, CA",
                        "name": "Antioch Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                            "zipCode": "2026ed1b-602c-43a5-859e-4d5b3ed7410b"
                        },
                        "premium": false,
                        "shortName": "Antioch Unified School District",
                        "tagline": [
                            "School District",
                            "Antioch, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "antioch-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Bidwell Continuation High School",
                "tagline": [
                    "Antioch Unified School District, CA",
                    "10-12"
                ],
                "type": "School",
                "url": "bidwell-continuation-high-school-antioch-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 151
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 15
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.792,37.9999,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.792,37.9999,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.2,
                "count": 5
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94509"
            }
        ]
    },
    {
        "guid": "c959d5e0-7b3e-4e21-b2f2-1fdd7d670d30",
        "content": {
            "centroid": {
                "lat": 37.817842,
                "lon": -122.278703
            },
            "entity": {
                "abbreviation": "McClymonds High School",
                "alternates": {
                    "ceeb": "052220",
                    "nces": "062805011555"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "c959d5e0-7b3e-4e21-b2f2-1fdd7d670d30",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "McClymonds High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "McClymonds High School",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "mcclymonds-high-school-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 383
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 15
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "At McClymonds, we're very small. The school is a one time experience. The vibe you get there is the vibe you won't get anywhere else. Everyone in the hallway wanting to look their best. Once you get a friend at our school, that friend truly has your back through whatever. The staff at my school is very supportive in any way possible. If you need any help with any work or even personal things outside of school, staff is willing to help you anyway possible. They keep things confidential and they are almost like Best friends. The school is majority African American, but we welcome every nationality as if they were one of us. I highly recommend the school to anyone that is needing an small (300- students). We have the highest African American male graduation rate in Oakland. We are an excelling high school with students that have high standards. I love my high school!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2017-01-13T00:28:44.460231Z",
                "guid": "fe0af98f-91b0-4092-89ec-bd8607b1d63a",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.279,37.8182,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.279,37.8182,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6818181818181817,
                "count": 22
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94607"
            }
        ]
    },
    {
        "guid": "71aa2422-4661-4d1b-a00d-480f8298fc96",
        "content": {
            "centroid": {
                "lat": 38.118686,
                "lon": -122.203469
            },
            "entity": {
                "abbreviation": "Jesse M. Bethel High School",
                "alternates": {
                    "ceeb": "053690",
                    "nces": "064074007861"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "71aa2422-4661-4d1b-a00d-480f8298fc96",
                "isClaimed": false,
                "isPremium": false,
                "location": "Vallejo, CA",
                "name": "Jesse M. Bethel High School",
                "parentGUIDs": {
                    "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                    "schoolDistrict": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "cd45ba4f-972c-4537-bd0a-adc5060daf7c",
                    "zipCode": "7391debd-91b4-4c97-b9a8-e5afb448b4b2"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Vallejo City Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                        "location": "Vallejo, CA",
                        "name": "Vallejo City Unified School District",
                        "parentGUIDs": {
                            "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "cd45ba4f-972c-4537-bd0a-adc5060daf7c",
                            "zipCode": "c53e25cf-e914-4ee3-aca1-03fd916fd935"
                        },
                        "premium": false,
                        "shortName": "Vallejo City Unified School District",
                        "tagline": [
                            "School District",
                            "Vallejo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "vallejo-city-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Jesse M. Bethel High School",
                "tagline": [
                    "Vallejo City Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "jesse-m-bethel-high-school-vallejo-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1624
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 28
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "I attended Jesse Bethel for all four years of high school. I think compared to the other schools in Vallejo, Jesse Bethel was probably the best school to attend. The campus was much bigger than the others and our sports teams were pretty good. I was an athlete coming into high school, doing tennis and my main sport, wrestling. I really liked our girls team, we were one of the biggest and the best teams in our section. Also, my coaches are who made my sports career such a success. Other than sports, I enjoyed being apart of leadership and helping with class decisions. One aspect that I would change about my high school, is more extracurricular activities and college prep classes.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-06-26T05:25:35.370268Z",
                "guid": "2ad9b7d0-53bd-4482-932d-edcb94d4379b",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 2
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.204,38.1205,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.204,38.1205,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.0708661417322833,
                "count": 381
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94591"
            }
        ]
    },
    {
        "guid": "d2e4d25d-791b-4f11-a60b-b3ed897901c2",
        "content": {
            "centroid": {
                "lat": 37.76856,
                "lon": -122.154338
            },
            "entity": {
                "abbreviation": "Rudsdale Continuation",
                "alternates": {
                    "ceeb": "052196",
                    "nces": "062805007326"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "d2e4d25d-791b-4f11-a60b-b3ed897901c2",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Rudsdale Continuation",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "3816271d-bf9c-431c-9e92-8f63ddf53940"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Rudsdale Continuation",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "rudsdale-continuation-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 255
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 17
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 1.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.154,37.7662,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.154,37.7662,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94605"
            }
        ]
    },
    {
        "guid": "72cc44ed-7232-4825-9674-b8d3f18fe8ae",
        "content": {
            "centroid": {
                "lat": 37.951917,
                "lon": -122.34746
            },
            "entity": {
                "abbreviation": "Richmond High School",
                "alternates": {
                    "ceeb": "052636",
                    "nces": "063255005055"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "72cc44ed-7232-4825-9674-b8d3f18fe8ae",
                "isClaimed": true,
                "isPremium": false,
                "location": "Richmond, CA",
                "name": "Richmond High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "schoolDistrict": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "09d2e73c-0f8b-4efa-9c26-447cdb858242",
                    "zipCode": "a08c6674-b67b-4d2b-976e-ac88b0619d80"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "WCCUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "a053a637-da7b-48d7-a67d-fba014c2d452",
                        "location": "Richmond, CA",
                        "name": "West Contra Costa Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                            "zipCode": "9e563e34-37ab-4fc4-b373-ed793d877060"
                        },
                        "premium": false,
                        "shortName": "West Contra Costa Unified School District",
                        "tagline": [
                            "School District",
                            "Richmond, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "west-contra-costa-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Richmond High School",
                "tagline": [
                    "West Contra Costa Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "richmond-high-school-richmond-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1567
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "The teachers are great! The stigma on the school is not true. Students are aiming for success and they have all the resources they need to be academically successful, graduate, and be admitted to a top college. As a current college student, I was able to get all the help I needed, every step of the way.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-01T18:13:33.24321Z",
                "guid": "937acb14-4c1d-4813-a3af-9363be117286",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 1.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.346,37.9524,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.346,37.9524,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5113636363636362,
                "count": 264
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94804"
            }
        ]
    },
    {
        "guid": "8da75797-75da-4a31-82bd-c1db1a7e03d1",
        "content": {
            "centroid": {
                "lat": 37.3590308,
                "lon": -121.8161362
            },
            "entity": {
                "abbreviation": "B. Roberto Cruz Leadership Academy",
                "alternates": {
                    "nces": "060147413927"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "8da75797-75da-4a31-82bd-c1db1a7e03d1",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "B. Roberto Cruz Leadership Academy",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                    "schoolNetwork": "ffb11791-dbb8-4d8f-a255-fac0112c0df3",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "5be5c65e-b5cd-43bf-91dc-4e9af8c6c1f0"
                },
                "premium": false,
                "shortName": "B. Roberto Cruz Leadership Academy",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "b-roberto-cruz-leadership-academy-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 270
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 40
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "RCLA is the type of school that truly cares about its students and their academic success. Although the students themselves aren’t very motivated because of their cultural background, the faculty members shine through the stiff structures of other high schools by offering great amounts of assistance in their subjects. Those who truly want success are given leeway in visiting other campuses and courses outside of the RCLA campus and paid for by the foundation.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-11-12T00:18:35.593399Z",
                "guid": "a83b5257-75f2-43ad-8ff5-bcc3a6966e57",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 1.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.8161362,37.3590308,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.8161362,37.3590308,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.454545454545454,
                "count": 11
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95127"
            }
        ]
    },
    {
        "guid": "26447f5f-455a-4c83-96f7-7694e97fc195",
        "content": {
            "centroid": {
                "lat": 37.925437,
                "lon": -122.328912
            },
            "entity": {
                "abbreviation": "Kennedy High School",
                "alternates": {
                    "ceeb": "052630",
                    "nces": "063255005037"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "26447f5f-455a-4c83-96f7-7694e97fc195",
                "isClaimed": true,
                "isPremium": false,
                "location": "Richmond, CA",
                "name": "John F. Kennedy High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "schoolDistrict": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                    "zipCode": "ce8bebad-32ac-45ac-bd87-076119b2c0fa"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "WCCUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "a053a637-da7b-48d7-a67d-fba014c2d452",
                        "location": "Richmond, CA",
                        "name": "West Contra Costa Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                            "zipCode": "9e563e34-37ab-4fc4-b373-ed793d877060"
                        },
                        "premium": false,
                        "shortName": "West Contra Costa Unified School District",
                        "tagline": [
                            "School District",
                            "Richmond, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "west-contra-costa-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Kennedy High School",
                "tagline": [
                    "West Contra Costa Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "john-f-kennedy-high-school-richmond-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 851
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 20
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I liked John  F. Kennedy because of it's diversity within students, students were able to get along and relate to one other because of their ethnicity and experience in life. Teachers were helpful but resources were/are very limited. If I were to make a change it'd be the financial support for new and not used text book, more paper, pencils provided to teachers. Most of the time teachers have to pick into their own pockets for class supplies on their low income because lets be fair teachers do not make enough. Teachers and students deserve help.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-07-12T02:10:26.559724Z",
                "guid": "8a5f1cfb-cc7a-4971-bb5a-e70828f76883",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 1.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.329,37.9254,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.329,37.9254,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.1294117647058823,
                "count": 85
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94804"
            }
        ]
    },
    {
        "guid": "d7581f79-c2d2-41a3-8d8d-9c85d86793f2",
        "content": {
            "centroid": {
                "lat": 37.368046,
                "lon": -121.838671
            },
            "entity": {
                "abbreviation": "Foothill High School",
                "alternates": {
                    "ceeb": "053086",
                    "nces": "061182001300"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "d7581f79-c2d2-41a3-8d8d-9c85d86793f2",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Foothill High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                    "parent": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "schoolDistrict": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "5be5c65e-b5cd-43bf-91dc-4e9af8c6c1f0"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "ESUHSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "ef302b2c-ec30-4470-afa5-55d6ba208652",
                        "location": "San Jose, CA",
                        "name": "East Side Union High School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "e3304317-8ec0-4ec2-a735-ae02c9650a81"
                        },
                        "premium": false,
                        "shortName": "East Side Union High School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "east-side-union-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Foothill High School",
                "tagline": [
                    "East Side Union High School District, CA",
                    "11-12"
                ],
                "type": "School",
                "url": "foothill-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 274
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 15
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "I was a troubled kid , foothill high school helped change my behavior and focus more on my school work. Foothill gives students many opportunities for growth and the staff is phenomenal in every way.  What I would like to see change is the colors of the uniform , but that's what makes the school great .",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-02-16T17:36:06.646753Z",
                "guid": "1ca69d40-e0d6-4207-8e7c-a4e7b4744b62",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 1.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.838,37.3687,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.838,37.3687,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.6666666666666665,
                "count": 15
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95127"
            }
        ]
    },
    {
        "guid": "a2817e15-3879-4cdf-a2a4-6425cdf87479",
        "content": {
            "centroid": {
                "lat": 37.817762,
                "lon": -122.265395
            },
            "entity": {
                "abbreviation": "Street Academy",
                "alternates": {
                    "nces": "062805007804"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "a2817e15-3879-4cdf-a2a4-6425cdf87479",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Street Academy",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "60b359f6-6160-41a8-9d11-3415c3143417"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Street Academy",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "street-academy-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 107
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Parent",
                "body": "Street Academy is a caring, safe environment where the staff goes to unusual lengths to involve parents and community.    Students have the opportunity to do interesting electives and internships, and the classes are very small compared to other high schools.  Teachers get to know students and genuinely care about them.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-01-22T14:14:53.332927Z",
                "guid": "6aecde85-7de9-4fae-8815-a9010e2faff6",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 1.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.266,37.8182,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.266,37.8182,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.764705882352941,
                "count": 17
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94609"
            }
        ]
    },
    {
        "guid": "7827001e-39c6-413a-8120-004c9558a83d",
        "content": {
            "centroid": {
                "lat": 37.759718,
                "lon": -122.163003
            },
            "entity": {
                "abbreviation": "Castlemont High School",
                "alternates": {
                    "ceeb": "052190",
                    "nces": "062805012992"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "7827001e-39c6-413a-8120-004c9558a83d",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Castlemont High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "3816271d-bf9c-431c-9e92-8f63ddf53940"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Castlemont High School",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "castlemont-high-school-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 835
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 15
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My experience at Castlemon has been very good. I am an international student who came with a purpose and a dream to this country and Castlemon opened its doors to me and I will never forget that. Castlemont gave me the opportunity and provided me with the necessary resources to excel and learn English. What I liked most about Castlemon is the way in which they try to help each student be successful and reach their goals as well as provide resources and help us understand how everything works. What I would change about Castlemont would be the way they integrate general education students with newcomers, because even though I am already part of general education I feel that international or newcomer students are being left out. Castlemon is a home for many students that have a dream.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-03-02T21:56:10.413561Z",
                "guid": "0c3f106b-631b-4f8d-8ca7-cf9103769242",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 1.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.163,37.7583,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.163,37.7583,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.55,
                "count": 20
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94605"
            }
        ]
    },
    {
        "guid": "95042ad3-2238-4a8b-98bf-66cd6451cd90",
        "content": {
            "centroid": {
                "lat": 37.384174,
                "lon": -121.901449
            },
            "entity": {
                "abbreviation": "Santa Clara County Special Education",
                "alternates": {
                    "nces": "069103509250"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "95042ad3-2238-4a8b-98bf-66cd6451cd90",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Santa Clara County Special Education",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "bc007bff-f267-494c-b4bc-92ce588a6db6",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "782e20d7-90eb-4994-919f-95fc800744f4"
                },
                "premium": false,
                "shortName": "Santa Clara County Special Education",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "santa-clara-county-special-education-san-jose-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1190
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 8
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 1.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.9,37.3837,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.9,37.3837,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95131"
            }
        ]
    },
    {
        "guid": "1e968fd3-38a5-4a68-b55e-3218fac016c1",
        "content": {
            "centroid": {
                "lat": 37.932537,
                "lon": -122.361576
            },
            "entity": {
                "abbreviation": "Gompers (Samuel) Continuation",
                "alternates": {
                    "nces": "063255005031"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "1e968fd3-38a5-4a68-b55e-3218fac016c1",
                "isClaimed": true,
                "isPremium": false,
                "location": "Richmond, CA",
                "name": "Greenwood Academy",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "schoolDistrict": "a053a637-da7b-48d7-a67d-fba014c2d452",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                    "zipCode": "9e563e34-37ab-4fc4-b373-ed793d877060"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "WCCUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "a053a637-da7b-48d7-a67d-fba014c2d452",
                        "location": "Richmond, CA",
                        "name": "West Contra Costa Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                            "zipCode": "9e563e34-37ab-4fc4-b373-ed793d877060"
                        },
                        "premium": false,
                        "shortName": "West Contra Costa Unified School District",
                        "tagline": [
                            "School District",
                            "Richmond, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "west-contra-costa-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Gompers (Samuel) Continuation",
                "tagline": [
                    "West Contra Costa Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "greenwood-academy-richmond-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 313
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 25
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I really like the environment there and teachers are so nice and chill and they support their student and the work is more easier. I don't think that i need to see any changes there.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-10-12T07:10:37.027146Z",
                "guid": "eb718ca1-285c-48ca-9a55-f5dc1e6af691",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 1.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.361,37.9333,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.361,37.9333,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94801"
            }
        ]
    },
    {
        "guid": "11e2688a-e563-49e8-9b82-dff4f90e74e3",
        "content": {
            "centroid": {
                "lat": 37.729393,
                "lon": -122.180565
            },
            "entity": {
                "abbreviation": "Aspire Lionel Wilson College Preparatory Academy",
                "alternates": {
                    "ceeb": "051761",
                    "nces": "060221210459"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "11e2688a-e563-49e8-9b82-dff4f90e74e3",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Aspire Lionel Wilson College Preparatory Academy",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "schoolNetwork": "6d55fb3e-0771-4fa6-bff7-2753f0a42065",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "2668905c-77a3-478f-a15e-7d1156714023"
                },
                "premium": false,
                "shortName": "Aspire Lionel Wilson College Preparatory Academy",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "aspire-lionel-wilson-college-preparatory-academy-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 525
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 29
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My over all experience in this charter school Lionel Wilson has made me the person who I am today because I've learned so many useful things that are going to prepare me after I graduate. I've been in Lionel since 6th grade and now I'm a senior.All these year that I've been here I've had great teachers that had helped me to reach my goals and for me to be prepared for the college.This school mostly wants students to be academically and mentally prepared for college because college is no easy route.For example, one of my weaknesses was that I didn't read a lot, but since the school has enforced us to read more during class and home my reading has improved.Also, I used to have bad grades but with the help that I've gotten from my teachers my grades have changed for good, which I'm glad about it.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2016-12-08T23:32:43.558579Z",
                "guid": "e5274b33-fd20-4f75-8664-bd64d069ec1a",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 1.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.18,37.7295,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.18,37.7295,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.2229299363057327,
                "count": 157
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94603"
            }
        ]
    },
    {
        "guid": "b0c3c577-d18f-4c9d-8fa3-31930d5431ba",
        "content": {
            "centroid": {
                "lat": 37.833397,
                "lon": -122.260186
            },
            "entity": {
                "abbreviation": "Oakland International High School",
                "alternates": {
                    "ceeb": "054232",
                    "nces": "062805012049"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "b0c3c577-d18f-4c9d-8fa3-31930d5431ba",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Oakland International High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "60b359f6-6160-41a8-9d11-3415c3143417"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Oakland International High School",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "oakland-international-high-school-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 369
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 14
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Oakland International High School is a school with a lot of diversity. It´s a school where they support and help newcomers.  It has classes specifics for them to learn English. They also have extracurricular classes, just like College Courses after school for English and Math. The school has clubs for the different cultures that are part of the community. As well, sports like soccer and basketball teams for both boys and girls.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2021-03-23T04:56:28.745415Z",
                "guid": "7cf279ce-ceeb-4fce-ad92-919494ba80d3",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 1.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.26,37.8336,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.26,37.8336,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.526315789473684,
                "count": 19
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94609"
            }
        ]
    },
    {
        "guid": "3785326e-898e-49a9-9d82-f084723643c1",
        "content": {
            "centroid": {
                "lat": 37.7771,
                "lon": -122.401855
            },
            "entity": {
                "abbreviation": "Five Keys Independence Hs (Sf Sheriff's)",
                "alternates": {
                    "nces": "060211812256"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "3785326e-898e-49a9-9d82-f084723643c1",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Five Keys Independence High School (SF Sheriff's)",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "cb7bbf0b-a5ba-41c0-97b4-93adedb95bdd",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "781604ff-cae4-4ff7-8bc5-30889e25ac1f"
                },
                "premium": false,
                "shortName": "Five Keys Independence Hs (Sf Sheriff's)",
                "tagline": [
                    "Public School",
                    "San Francisco, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "five-keys-independence-high-school-sf-sheriffs-san-francisco-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 3417
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 30
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "It was experimental and great the teachers were awesome and they supported every decision we made. They never let you down and they were always in your corner to help you when you were stuck in my learning better than more exciting to do",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-01-10T08:44:26.562047Z",
                "guid": "279cf044-fd02-414c-b10c-54772c9ad9f1",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 1.66
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.402,37.7772,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.402,37.7772,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4,
                "count": 2
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94107"
            }
        ]
    },
    {
        "guid": "36e3afc6-7094-4107-8c8b-a25ac01001dc",
        "content": {
            "centroid": {
                "lat": 38.113725,
                "lon": -122.245711
            },
            "entity": {
                "abbreviation": "Vallejo High School",
                "alternates": {
                    "ceeb": "053610",
                    "nces": "064074006739"
                },
                "character": "Public, Magnet",
                "claimed": false,
                "displayable": true,
                "genus": "Magnet School",
                "guid": "36e3afc6-7094-4107-8c8b-a25ac01001dc",
                "isClaimed": false,
                "isPremium": false,
                "location": "Vallejo, CA",
                "name": "Vallejo High School",
                "parentGUIDs": {
                    "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                    "schoolDistrict": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "cd45ba4f-972c-4537-bd0a-adc5060daf7c",
                    "zipCode": "42b11530-5650-4c55-89ce-3430b89a4ffb"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Vallejo City Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                        "location": "Vallejo, CA",
                        "name": "Vallejo City Unified School District",
                        "parentGUIDs": {
                            "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "cd45ba4f-972c-4537-bd0a-adc5060daf7c",
                            "zipCode": "c53e25cf-e914-4ee3-aca1-03fd916fd935"
                        },
                        "premium": false,
                        "shortName": "Vallejo City Unified School District",
                        "tagline": [
                            "School District",
                            "Vallejo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "vallejo-city-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Vallejo High School",
                "tagline": [
                    "Vallejo City Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "vallejo-high-school-vallejo-ca",
                "variation": 52
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 1643
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 26
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "My experience at Vallejo High School was pretty good. I take pride in my school even if it is not perfect and it has this bad reputation. I would say that meeting people from the programs, extracurricular classes, and school events really highlighted my high school experience. It made me want to encourage others to do more than just go to school, What I would like to see change is the students energy during an event the school plans for them, it is their effort to welcome new students and it's important they also one day are proud to call Vallejo High their home.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-02-06T04:35:50.177616Z",
                "guid": "4567a589-bb23-469b-baf7-a96cb760c6f9",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade",
                    "value": 1.33
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.246,38.1154,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.246,38.1154,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 2.7683397683397684,
                "count": 259
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94590"
            }
        ]
    },
    {
        "guid": "29a2cf39-ce01-4c93-ac1b-d425c607ee41",
        "content": {
            "centroid": {
                "lat": 37.369932,
                "lon": -121.83138
            },
            "entity": {
                "abbreviation": "Escuela Popular",
                "alternates": {
                    "nces": "060239211449"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "29a2cf39-ce01-4c93-ac1b-d425c607ee41",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Escuela Popular/Center For Training And Careers",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "f8784487-8b53-41b7-95dc-6783200d8ac4",
                    "zipCode": "5be5c65e-b5cd-43bf-91dc-4e9af8c6c1f0"
                },
                "premium": false,
                "shortName": "Escuela Popular",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "escuela-popular-san-jose-ca-061182011449",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 643
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 70
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.832,37.3701,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.832,37.3701,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95127"
            }
        ]
    },
    {
        "guid": "d735b244-5e4f-431b-937c-b64721885371",
        "content": {
            "centroid": {
                "lat": 37.786189,
                "lon": -122.219053
            },
            "entity": {
                "abbreviation": "Lighthouse Community Charter School",
                "alternates": {
                    "nces": "060175514027"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "d735b244-5e4f-431b-937c-b64721885371",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Lighthouse Community Charter School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "90731d14-c187-4264-ac2c-4b3485508684"
                },
                "premium": false,
                "shortName": "Lighthouse Community Charter School",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "lighthouse-community-charter-school-oakland-ca-060175514027",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 522
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 27
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Lighthouse is a great school for low income and minorities to come and get a decent learning experience because the teachers are caring of the students understanding more than how much work is complete. The school also helps students learn to make a community within the classrooms and assist each other out. It does have less resources and certain students do push back lessons but overall, it is a great school to have teachers who actually care for the students and wish for them to succeed.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-04-30T00:47:01.538361Z",
                "guid": "fc5d58e0-a34a-4db2-9825-8e46ac0aeb37",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {},
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4,
                "count": 2
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94603"
            }
        ]
    },
    {
        "guid": "bdb6a322-9763-4d99-800b-e6512fc88ca6",
        "content": {
            "centroid": {
                "lat": 37.759718,
                "lon": -122.163003
            },
            "entity": {
                "abbreviation": "Oakland Research & Development Campus",
                "alternates": {
                    "ceeb": "054704",
                    "nces": "060196713155"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "bdb6a322-9763-4d99-800b-e6512fc88ca6",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Oakland Research & Development Campus",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "schoolNetwork": "b417dc33-d284-4a75-aa5f-71849ab590fa",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "3816271d-bf9c-431c-9e92-8f63ddf53940"
                },
                "premium": false,
                "shortName": "Oakland Research & Development Campus",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "oakland-research--and--development-campus-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 483
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.163,37.7583,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.163,37.7583,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94605"
            }
        ]
    },
    {
        "guid": "3edaa049-7d21-4b3e-81ce-2f39964eb12c",
        "content": {
            "centroid": {
                "lat": 37.8674073,
                "lon": -122.2948945
            },
            "entity": {
                "abbreviation": "Realm Charter School",
                "alternates": {
                    "nces": "060215814246"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "3edaa049-7d21-4b3e-81ce-2f39964eb12c",
                "isClaimed": false,
                "isPremium": false,
                "location": "Berkeley, CA",
                "name": "Realm Charter School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "8c486372-b77d-4fd6-b272-01f7715363a3",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "4eb8fec9-8de0-46a9-b898-75cc913b8cef",
                    "zipCode": "39b2df86-684a-467f-9c95-5540b32110f5"
                },
                "premium": false,
                "shortName": "Realm Charter School",
                "tagline": [
                    "Public School",
                    "Berkeley, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "realm-charter-school-berkeley-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 383
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.2948945,37.8674073,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.2948945,37.8674073,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94710"
            }
        ]
    },
    {
        "guid": "9debd960-223a-41ea-a3e5-dbf69ba5b560",
        "content": {
            "centroid": {
                "lat": 37.558144,
                "lon": -121.964263
            },
            "entity": {
                "abbreviation": "California School For The Deaf-Fremont",
                "alternates": {
                    "ceeb": "050292",
                    "nces": "060000310347"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "9debd960-223a-41ea-a3e5-dbf69ba5b560",
                "isClaimed": false,
                "isPremium": false,
                "location": "Fremont, CA",
                "name": "California School For The Deaf-Fremont",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "928f3013-0c8c-46e8-895e-ce2c3a431f1f",
                    "schoolDistrict": "928f3013-0c8c-46e8-895e-ce2c3a431f1f",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "36041593-134d-436a-b83b-4c4244f6a447",
                    "zipCode": "4dc14d8f-c3ed-4d52-abca-3f8a107886e5"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "California School for the Deaf-Fremont",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "928f3013-0c8c-46e8-895e-ce2c3a431f1f",
                        "location": "Fremont, CA",
                        "name": "California School for the Deaf-Fremont",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "36041593-134d-436a-b83b-4c4244f6a447",
                            "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                        },
                        "premium": false,
                        "shortName": "California School for the Deaf-Fremont",
                        "tagline": [
                            "School District",
                            "Fremont, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "california-school-for-the-deaf-fremont-ca",
                        "variation": 65
                    }
                },
                "premium": false,
                "shortName": "California School For The Deaf-Fremont",
                "tagline": [
                    "California School for the Deaf-Fremont, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "california-school-for-the-deaf-fremont-fremont-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 372
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 5
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I joined this school 6th grade which I was from mainstream school, I was having terrible grades and quiet person before I transfer to this school.  This school gave me new life and made me know who am I and I joined several sports and also I join some club, leadership organization, also they taught me well about American Sign Language. I traveled so many place for  multi- reason as represent this school. It was greatest experience and challenging that  I ever have. I would recommend this school for many deaf children including preschool to 12th.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-10-04T17:57:47.23103Z",
                "guid": "f371ccd9-1370-49ad-8457-70c6cedaabab",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.963,37.5596,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.963,37.5596,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.333333333333333,
                "count": 6
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94538"
            }
        ]
    },
    {
        "guid": "8aad26a6-69a6-4e58-889f-dddf31b428d5",
        "content": {
            "centroid": {
                "lat": 37.3690293,
                "lon": -121.8317074
            },
            "entity": {
                "abbreviation": "Escuela Popular",
                "alternates": {
                    "ceeb": "054747",
                    "nces": "060190610666"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "8aad26a6-69a6-4e58-889f-dddf31b428d5",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Escuela Popular",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "b030291a-fe78-43a8-9531-fb4e469f97c5",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "5be5c65e-b5cd-43bf-91dc-4e9af8c6c1f0"
                },
                "premium": false,
                "shortName": "Escuela Popular",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "escuela-popular-san-jose-ca-061182010666",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 369
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.8317074,37.3690293,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.8317074,37.3690293,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95127"
            }
        ]
    },
    {
        "guid": "d524471a-a7c0-41ee-9683-5284585cfcf1",
        "content": {
            "centroid": {
                "lat": 37.99002,
                "lon": -122.329483
            },
            "entity": {
                "abbreviation": "Summit Public School: Tamalpais",
                "alternates": {
                    "nces": "060202613986"
                },
                "character": "Public, Charter",
                "claimed": true,
                "displayable": true,
                "genus": "Charter School",
                "guid": "d524471a-a7c0-41ee-9683-5284585cfcf1",
                "isClaimed": true,
                "isPremium": false,
                "location": "Richmond, CA",
                "name": "Summit Public School: Tamalpais",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "schoolNetwork": "2ed1eb64-2cd2-4b6a-8f49-20b86f2fe1ca",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7208b7a9-edaf-4196-afb5-f951fad37422",
                    "zipCode": "a08c6674-b67b-4d2b-976e-ac88b0619d80"
                },
                "premium": false,
                "shortName": "Summit Public School: Tamalpais",
                "tagline": [
                    "Public School",
                    "Richmond, CA",
                    "7-12"
                ],
                "type": "School",
                "url": "summit-public-school--tamalpais-richmond-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 352
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Parent",
                "body": "The Mentorship program and the self direct learning are amazing tools that my kids have learned to appreciate and to develop long-life skills that would help them beyond high school.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-11-08T17:26:32.904861Z",
                "guid": "7a64852a-cc29-4357-aa58-73aef2a6e296",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {},
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.5,
                "count": 2
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94806"
            }
        ]
    },
    {
        "guid": "d8fe9739-c5e8-43f6-a056-7bfc02c159d6",
        "content": {
            "centroid": {
                "lat": 37.628422,
                "lon": -122.453235
            },
            "entity": {
                "abbreviation": "Five Keys Charter (Sf Sheriff's)",
                "alternates": {
                    "nces": "060199811407"
                },
                "character": "Public, Charter, All-Boys",
                "claimed": false,
                "displayable": true,
                "genus": "All-Boys School",
                "guid": "d8fe9739-c5e8-43f6-a056-7bfc02c159d6",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Bruno, CA",
                "name": "Five Keys Charter (SF Sheriff's)",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6"
                },
                "premium": false,
                "shortName": "Five Keys Charter (Sf Sheriff's)",
                "tagline": [
                    "Public School",
                    "San Bruno, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "five-keys-charter-sf-sheriffs-san-bruno-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 348
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 29
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.458,37.6268,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.458,37.6268,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94066"
            }
        ]
    },
    {
        "guid": "7ab3560e-6034-4661-af93-eafa89d74c08",
        "content": {
            "centroid": {
                "lat": 37.384174,
                "lon": -121.901449
            },
            "entity": {
                "abbreviation": "Opportunity Youth Academy",
                "alternates": {
                    "nces": "069103514054"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "7ab3560e-6034-4661-af93-eafa89d74c08",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Opportunity Youth Academy",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "bc007bff-f267-494c-b4bc-92ce588a6db6",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "782e20d7-90eb-4994-919f-95fc800744f4"
                },
                "premium": false,
                "shortName": "Opportunity Youth Academy",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "opportunity-youth-academy-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 291
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 32
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {},
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 2,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95131"
            }
        ]
    },
    {
        "guid": "567a3e26-1a50-4dd5-9351-3d450add7a0b",
        "content": {
            "centroid": {
                "lat": 37.372531,
                "lon": -121.897481
            },
            "entity": {
                "abbreviation": "San Jose Conservation Corps Charter School",
                "alternates": {
                    "ceeb": "053944",
                    "nces": "060169710664"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "567a3e26-1a50-4dd5-9351-3d450add7a0b",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "San Jose Conservation Corps Charter School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "bc007bff-f267-494c-b4bc-92ce588a6db6",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "4f21b3d8-c120-45e6-9be7-52738c1baade"
                },
                "premium": false,
                "shortName": "San Jose Conservation Corps Charter School",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "12"
                ],
                "type": "School",
                "url": "san-jose-conservation-corps-charter-school-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 214
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 24
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "I had the nicest teachers here. The staff was great and were very eager and strict with their teaching. They also had a prom night for the students, I attended, but there wasn't much of anybody there. What I noticed when I was attending there was that people who were going there were high school drop outs or people older than me, yet they were still young enough that I could relate to.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2018-06-08T04:59:49.013775Z",
                "guid": "3d09dfa9-480a-44dd-98d9-474719dae204",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.897,37.3727,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.897,37.3727,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.588235294117647,
                "count": 17
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95112"
            }
        ]
    },
    {
        "guid": "a1329c5c-b88d-43c6-8bc1-c9eef57bc79b",
        "content": {
            "centroid": {
                "lat": 38.013242,
                "lon": -122.549489
            },
            "entity": {
                "abbreviation": "Marin County Special Education",
                "alternates": {
                    "nces": "069101807135"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "a1329c5c-b88d-43c6-8bc1-c9eef57bc79b",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Rafael, CA",
                "name": "Marin County Special Education",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "dc30ba2a-37d6-4766-b90c-517b11b7cdde",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "03b49160-d1e2-4a70-8c58-319b241306a8",
                    "zipCode": "a84b9cf7-0228-401b-85bd-1497a6685ebb"
                },
                "premium": false,
                "shortName": "Marin County Special Education",
                "tagline": [
                    "Public School",
                    "San Rafael, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "marin-county-special-education-san-rafael-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 201
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 7
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.55,38.0135,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.55,38.0135,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94903"
            }
        ]
    },
    {
        "guid": "3c99554a-0662-43cf-84de-cd0d9d7ed834",
        "content": {
            "centroid": {
                "lat": 37.801594,
                "lon": -122.273018
            },
            "entity": {
                "abbreviation": "Young Adult Program",
                "alternates": {
                    "nces": "062805012611"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "3c99554a-0662-43cf-84de-cd0d9d7ed834",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Young Adult Program",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Young Adult Program",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "12"
                ],
                "type": "School",
                "url": "young-adult-program-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 165
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 13
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.289,37.8073,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.289,37.8073,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94607"
            }
        ]
    },
    {
        "guid": "46c36785-288a-4b9d-8550-6f5b99465c8e",
        "content": {
            "centroid": {
                "lat": 38.0081872,
                "lon": -122.0958988
            },
            "entity": {
                "abbreviation": "Golden Gate Community",
                "alternates": {
                    "nces": "060206710472"
                },
                "character": "Public, Charter, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "46c36785-288a-4b9d-8550-6f5b99465c8e",
                "isClaimed": false,
                "isPremium": false,
                "location": "Martinez, CA",
                "name": "Golden Gate Community",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "c0e1c8ee-bf4e-4c6d-bea3-53837f6f98ee",
                    "zipCode": "2c9a56d6-f5d7-43ae-90db-4fab4497e4a2"
                },
                "premium": false,
                "shortName": "Golden Gate Community",
                "tagline": [
                    "Public School",
                    "Martinez, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "golden-gate-community-martinez-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 144
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.0958988,38.0081872,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.0958988,38.0081872,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94553"
            }
        ]
    },
    {
        "guid": "76a282cd-dbce-4078-b15c-778ef2067e9d",
        "content": {
            "centroid": {
                "lat": 37.526295,
                "lon": -122.263646
            },
            "entity": {
                "abbreviation": "San Mateo County Special Education",
                "alternates": {
                    "nces": "069103309043"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "76a282cd-dbce-4078-b15c-778ef2067e9d",
                "isClaimed": false,
                "isPremium": false,
                "location": "Redwood City, CA",
                "name": "San Mateo County Special Education",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "f063d7b2-cbfb-4b65-b8b7-03f2d9f5a9dc",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "5ca486a6-52a6-4b83-aeda-db4b437b4d7f",
                    "zipCode": "80b04c41-59c1-4587-8f7c-24efc88eaf9a"
                },
                "premium": false,
                "shortName": "San Mateo County Special Education",
                "tagline": [
                    "Public School",
                    "Redwood City, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "san-mateo-county-special-education-redwood-city-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 136
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 8
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.263,37.5259,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.263,37.5259,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94065"
            }
        ]
    },
    {
        "guid": "0deb8ebf-661f-4b09-9837-e019415347df",
        "content": {
            "centroid": {
                "lat": 37.658113,
                "lon": -122.096968
            },
            "entity": {
                "abbreviation": "Alameda County Community",
                "alternates": {
                    "nces": "069105106830"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "0deb8ebf-661f-4b09-9837-e019415347df",
                "isClaimed": false,
                "isPremium": false,
                "location": "Hayward, CA",
                "name": "Alameda County Community",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "3ee6b10e-9c9c-43c9-bee6-1755097895e1",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                    "zipCode": "72f14b46-7398-463c-a7b1-84d94dfe3a97"
                },
                "premium": false,
                "shortName": "Alameda County Community",
                "tagline": [
                    "Public School",
                    "Hayward, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "alameda-county-community-hayward-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 133
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 16
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.097,37.6582,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.097,37.6582,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94544"
            }
        ]
    },
    {
        "guid": "6741321c-b0e2-4836-a1fa-7d79b7fcc0c1",
        "content": {
            "centroid": {
                "lat": 37.384174,
                "lon": -121.901449
            },
            "entity": {
                "abbreviation": "Santa Clara County Juvenile Hall",
                "alternates": {
                    "nces": "069103509045"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "6741321c-b0e2-4836-a1fa-7d79b7fcc0c1",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Santa Clara County Court",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "bc007bff-f267-494c-b4bc-92ce588a6db6",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "782e20d7-90eb-4994-919f-95fc800744f4"
                },
                "premium": false,
                "shortName": "Santa Clara County Juvenile Hall",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "santa-clara-county-court-san-jose-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 117
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 5
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "More safe environment for kids to not smoke around the areas because through all my high school experience I have walked into bathrooms and there are always kids smoking in the bathroom all lunch period without any teacher to kick them out or get them in trouble and they offer other kids as well it's not something that should be done especially not forced to other students.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-03-04T17:48:45.786009Z",
                "guid": "9cf1dc21-f095-47b7-8dea-35790e2fa1b0",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.9,37.3837,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.9,37.3837,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.25,
                "count": 4
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95131"
            }
        ]
    },
    {
        "guid": "29e228a2-9994-4244-9424-6dd839a21e64",
        "content": {
            "centroid": {
                "lat": 37.977281,
                "lon": -121.991278
            },
            "entity": {
                "abbreviation": "Summit High School",
                "alternates": {
                    "ceeb": "050861",
                    "nces": "062637000185"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "29e228a2-9994-4244-9424-6dd839a21e64",
                "isClaimed": false,
                "isPremium": false,
                "location": "Concord, CA",
                "name": "Summit High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "schoolDistrict": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "187f89d7-6963-49c2-b924-426631dae88f",
                    "zipCode": "64ec8361-307f-4c60-8518-5e08e7cc3cb0"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "MDUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                        "location": "Concord, CA",
                        "name": "Mt. Diablo Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "187f89d7-6963-49c2-b924-426631dae88f",
                            "zipCode": "fca2caaa-dbcc-472c-be69-c07f58b2a359"
                        },
                        "premium": false,
                        "shortName": "Mt. Diablo Unified School District",
                        "tagline": [
                            "School District",
                            "Concord, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mt-diablo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Summit High School",
                "tagline": [
                    "Mt. Diablo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "summit-high-school-concord-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 117
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.988,37.9778,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.988,37.9778,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94521"
            }
        ]
    },
    {
        "guid": "02a3294b-c939-4832-ab6f-e5f187eb648f",
        "content": {
            "centroid": {
                "lat": 37.7771,
                "lon": -122.401855
            },
            "entity": {
                "abbreviation": "Five Keys Charter School",
                "alternates": {
                    "nces": "060158312373"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "02a3294b-c939-4832-ab6f-e5f187eb648f",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Five Keys Charter School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "cb7bbf0b-a5ba-41c0-97b4-93adedb95bdd",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "781604ff-cae4-4ff7-8bc5-30889e25ac1f"
                },
                "premium": false,
                "shortName": "Five Keys Charter School",
                "tagline": [
                    "Public School",
                    "San Francisco, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "five-keys-charter-school-san-francisco-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 109
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 38
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.402,37.7772,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.402,37.7772,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94107"
            }
        ]
    },
    {
        "guid": "b8fb245d-692a-41da-a2ca-951822e69b9e",
        "content": {
            "centroid": {
                "lat": 37.3912164,
                "lon": -121.9820461
            },
            "entity": {
                "abbreviation": "Mission Early College High",
                "alternates": {
                    "nces": "063543014067"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "b8fb245d-692a-41da-a2ca-951822e69b9e",
                "isClaimed": true,
                "isPremium": false,
                "location": "Santa Clara, CA",
                "name": "Mission Early College High",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                    "schoolDistrict": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "44b1c9d0-0773-4aa7-aaeb-c04dda704fc1",
                    "zipCode": "5e59747f-8fae-4054-a7a1-457bbce26323"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Santa Clara Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                        "location": "Santa Clara, CA",
                        "name": "Santa Clara Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "44b1c9d0-0773-4aa7-aaeb-c04dda704fc1",
                            "zipCode": "d1fd4c8f-758c-4371-b58b-7ac5e13d8df8"
                        },
                        "premium": false,
                        "shortName": "Santa Clara Unified School District",
                        "tagline": [
                            "School District",
                            "Santa Clara, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "santa-clara-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Mission Early College High",
                "tagline": [
                    "Santa Clara Unified School District, CA",
                    "10-12"
                ],
                "type": "School",
                "url": "mission-early-college-high-santa-clara-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 101
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers."
                }
            ],
            "featuredReview": {
                "author": "Junior",
                "body": "Absolutely amazing school! The teachers actually care about students' success and do everything in their power to help students achieve their goals. And, the classes are small, which is amazing! Most teachers provide meaningful work that'll help students later in life. The office is super helpful in schedule changes and any problems you have. My academic counselor is super helpful in picking out colleges and helping me construct my college path. The campus itself is clean and nice, and the students are all very welcoming. I wish there were more clubs and awards like the larger schools in the area. For example, we don't have NHS, or any organized varsity and JV teams. But, you are always welcome to start your own club if you want! This school has really prepared me for college, as I've gotten a taste of college classes. The school culture is positive, and everyone pushes you to do your best. I haven't seen much parent involvement, but there wasn't a need for any.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-05-16T23:47:22.117778Z",
                "guid": "3695aebe-2c46-464e-bc26-4aab1bae8408",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.9820461,37.3912164,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.9820461,37.3912164,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.428571428571429,
                "count": 7
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95054"
            }
        ]
    },
    {
        "guid": "fe0c3417-2b3b-4d86-b634-0e773c906207",
        "content": {
            "centroid": {
                "lat": 37.4658693,
                "lon": -122.1327113
            },
            "entity": {
                "abbreviation": "Oxford Day Academy",
                "alternates": {
                    "nces": "060201614082"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "fe0c3417-2b3b-4d86-b634-0e773c906207",
                "isClaimed": false,
                "isPremium": false,
                "location": "East Palo Alto, CA",
                "name": "Oxford Day Academy",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "bc4a42c3-a2f5-452a-9b9e-175d4f05cb82",
                    "zipCode": "e91bfc0c-bca1-45d4-909a-25b104b8c881"
                },
                "premium": false,
                "shortName": "Oxford Day Academy",
                "tagline": [
                    "Public School",
                    "East Palo Alto, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "oxford-day-academy-east-palo-alto-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 98
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 19
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "For a beginning school, they do a great job with the academic portion of their school and would explain why the school does not have sports since it is primarily a more academic based school.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2020-08-12T02:20:34.236695Z",
                "guid": "992c7934-511e-442e-9ac4-5a3a25184ba1",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.1327113,37.4658693,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.1327113,37.4658693,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94303"
            }
        ]
    },
    {
        "guid": "27952cc1-1d66-49a3-ad37-1ec40c9a6304",
        "content": {
            "centroid": {
                "lat": 37.828502,
                "lon": -122.008937
            },
            "entity": {
                "abbreviation": "Del Amigo High School",
                "alternates": {
                    "ceeb": "050731",
                    "nces": "063513005946"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "27952cc1-1d66-49a3-ad37-1ec40c9a6304",
                "isClaimed": false,
                "isPremium": false,
                "location": "Danville, CA",
                "name": "Del Amigo High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                    "schoolDistrict": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "fcc57eee-ebde-443a-b77d-e10bbde2f779",
                    "zipCode": "bd3e7c23-836c-470d-ab71-7f4963ad582c"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SRVUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "0eb0d278-7f40-4d95-af46-a98f9faf3402",
                        "location": "Danville, CA",
                        "name": "San Ramon Valley Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "fcc57eee-ebde-443a-b77d-e10bbde2f779",
                            "zipCode": "bd3e7c23-836c-470d-ab71-7f4963ad582c"
                        },
                        "premium": false,
                        "shortName": "San Ramon Valley Unified School District",
                        "tagline": [
                            "School District",
                            "Danville, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-ramon-valley-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Del Amigo High School",
                "tagline": [
                    "San Ramon Valley Unified School District, CA",
                    "7-12"
                ],
                "type": "School",
                "url": "del-amigo-high-school-danville-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 97
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 9
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.009,37.8267,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.009,37.8267,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94526"
            }
        ]
    },
    {
        "guid": "3d43fd44-2869-4bac-8ac8-a9455c939c01",
        "content": {
            "centroid": {
                "lat": 37.79717,
                "lon": -122.263869
            },
            "entity": {
                "abbreviation": "Gateway to College at Laney College",
                "alternates": {
                    "nces": "062805012506"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "3d43fd44-2869-4bac-8ac8-a9455c939c01",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Gateway to College at Laney College",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Gateway to College at Laney College",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "gateway-to-college-at-laney-college-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 94
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 90
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "There was always someone ready and willing to help me when I needed it. Each guidance counselor served as a mentor, a guide, and even as a friend. They were lenient when necessary, but always kept their standards high enough to push us to do more than we ever thought possible. So many of us came into Gateway to College feeling like losers, but in the end, we graduated feeling proud of ourselves and ready to face the world. I even graduated on the dean's list!",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-10-01T22:59:34.925228Z",
                "guid": "0752f3aa-3e3a-42bb-b9e8-9fa0591e1466",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.261,37.7961,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.261,37.7961,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.055555555555555,
                "count": 18
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94607"
            }
        ]
    },
    {
        "guid": "b2fc2add-b751-4f61-b1d2-6fd9b70f03f6",
        "content": {
            "centroid": {
                "lat": 37.2518604,
                "lon": -121.8191133
            },
            "entity": {
                "abbreviation": "KIPP Navigate College Prep",
                "alternates": {
                    "nces": "060218414282"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "b2fc2add-b751-4f61-b1d2-6fd9b70f03f6",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "KIPP Navigate College Prep",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "078c8917-e52e-4332-af2e-2091c6f2b825",
                    "schoolNetwork": "a310ca2b-9585-4429-96b5-bd4924a4c483",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "656c3aa8-650d-4f5e-97c4-2c4879faa9d3"
                },
                "premium": false,
                "shortName": "KIPP Navigate College Prep",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "9"
                ],
                "type": "School",
                "url": "kipp-navigate-college-prep-san-jose-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 89
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 11
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.8191133,37.2518604,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.8191133,37.2518604,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95123"
            }
        ]
    },
    {
        "guid": "ba1383b1-4f4c-42b6-9c87-2189a358ea27",
        "content": {
            "centroid": {
                "lat": 37.9857338,
                "lon": -122.3076513
            },
            "entity": {
                "abbreviation": "Invictus Academy of Richmond",
                "alternates": {
                    "nces": "060203714304"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "ba1383b1-4f4c-42b6-9c87-2189a358ea27",
                "isClaimed": false,
                "isPremium": false,
                "location": "El Sobrante, CA",
                "name": "Invictus Academy of Richmond",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "b19cd8fc-f59d-4064-9f5d-0f7ec539e6a1",
                    "zipCode": "f094286d-e04c-4e46-ab0c-2fc0dfc376dd"
                },
                "premium": false,
                "shortName": "Invictus Academy of Richmond",
                "tagline": [
                    "Public School",
                    "El Sobrante, CA",
                    "7-12"
                ],
                "type": "School",
                "url": "invictus-academy-of-richmond-el-sobrante-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 78
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 16
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.3076513,37.9857338,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.3076513,37.9857338,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94803"
            }
        ]
    },
    {
        "guid": "56a897a2-51b9-4832-9083-dc4e31b5f76d",
        "content": {
            "centroid": {
                "lat": 38.013242,
                "lon": -122.549489
            },
            "entity": {
                "abbreviation": "Marin's Community School",
                "alternates": {
                    "nces": "069101809230"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "56a897a2-51b9-4832-9083-dc4e31b5f76d",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Rafael, CA",
                "name": "Marin's Community School",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "dc30ba2a-37d6-4766-b90c-517b11b7cdde",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "03b49160-d1e2-4a70-8c58-319b241306a8",
                    "zipCode": "a84b9cf7-0228-401b-85bd-1497a6685ebb"
                },
                "premium": false,
                "shortName": "Marin's Community School",
                "tagline": [
                    "Public School",
                    "San Rafael, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "marins-community-school-san-rafael-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 77
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 27
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.55,38.0136,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.55,38.0136,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94903"
            }
        ]
    },
    {
        "guid": "a3c1738f-41bb-4c06-b060-5c62bedf0e81",
        "content": {
            "centroid": {
                "lat": 37.789982,
                "lon": -122.168372
            },
            "entity": {
                "abbreviation": "Conservatory of Vocal/Instrumental Arts High School",
                "alternates": {
                    "nces": "060181913888"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "a3c1738f-41bb-4c06-b060-5c62bedf0e81",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Conservatory of Vocal/Instrumental Arts High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "b96fa3ea-8713-4581-93cb-036864769ed5"
                },
                "premium": false,
                "shortName": "Conservatory of Vocal/Instrumental Arts High School",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "conservatory-of-vocal-instrumental-arts-high-school-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 74
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I came to COVAH after having been homeschooled since Kindergarten. My overall academic experience has been exceptional. I excelled in all my courses and my peers did provide a genuine support group. However, socially, my growth has been stunted. Typical high school experiences such as prom, homecoming, and field trips have been missed. I became extremely wanting at periods and alone. My administration has not always been helpful or supportive due to a lack of resources and variety. I had to grow up fast and become independent which has its pros, but I often wondered if it really was too much to ask for the livelihood witnessed in TV shows and movies. I rate my school very good because I made an honest group of friends. The size of the school helped me thrive academically because I could get one-on-one attention. The college courses challenged me to be more and allowed me to venture into different subject matters. From my experience, I know exactly where I am and where I want to be.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2019-10-15T17:43:14.358823Z",
                "guid": "451879f7-df6b-4fa6-bbcf-4bd46a51b52b",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.2,37.7934,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.2,37.7934,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.5,
                "count": 2
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94619"
            }
        ]
    },
    {
        "guid": "d6fbbcc2-8cd8-4482-9a39-a2c597df8f91",
        "content": {
            "centroid": {
                "lat": 37.995254,
                "lon": -122.047414
            },
            "entity": {
                "abbreviation": "Floyd I. Marchus",
                "alternates": {
                    "nces": "069100509217"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "d6fbbcc2-8cd8-4482-9a39-a2c597df8f91",
                "isClaimed": false,
                "isPremium": false,
                "location": "Concord, CA",
                "name": "Floyd I. Marchus",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "187f89d7-6963-49c2-b924-426631dae88f",
                    "zipCode": "682ad26e-01a6-40ff-ab5e-ab87d7da8033"
                },
                "premium": false,
                "shortName": "Floyd I. Marchus",
                "tagline": [
                    "Public School",
                    "Concord, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "floyd-i-marchus-concord-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 74
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 6
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.047,37.995,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.047,37.995,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94520"
            }
        ]
    },
    {
        "guid": "43e07daf-fb22-4135-a10b-5d00b27ae223",
        "content": {
            "centroid": {
                "lat": 37.743783,
                "lon": -122.499769
            },
            "entity": {
                "abbreviation": "S.F. County Special Education",
                "alternates": {
                    "nces": "069111109473"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "43e07daf-fb22-4135-a10b-5d00b27ae223",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "S.F. County Special Education",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "47575dee-023f-4a2f-8c52-61e4471bda57",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "dfff3cae-3a03-46a7-b060-62db0e2af199"
                },
                "premium": false,
                "shortName": "S.F. County Special Education",
                "tagline": [
                    "Public School",
                    "San Francisco, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "sf-county-special-education-san-francisco-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 74
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 74
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.484,37.7753,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.484,37.7753,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94116"
            }
        ]
    },
    {
        "guid": "93bcb992-6b1c-4406-b979-0c8a913f8101",
        "content": {
            "centroid": {
                "lat": 37.780691,
                "lon": -122.42242
            },
            "entity": {
                "abbreviation": "Civic Center Seconary School",
                "alternates": {
                    "nces": "069111110647"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "93bcb992-6b1c-4406-b979-0c8a913f8101",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Civic Center Seconary School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                },
                "premium": false,
                "shortName": "Civic Center Seconary School",
                "tagline": [
                    "Public School",
                    "San Francisco, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "civic-center-seconary-school-san-francisco-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 73
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 10
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.423,37.7806,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.423,37.7806,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94102"
            }
        ]
    },
    {
        "guid": "8a446930-601d-42cf-81d4-204a8a28450f",
        "content": {
            "centroid": {
                "lat": 37.935726,
                "lon": -121.695827
            },
            "entity": {
                "abbreviation": "Far East County Student Programs",
                "alternates": {
                    "nces": "069100510748"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "8a446930-601d-42cf-81d4-204a8a28450f",
                "isClaimed": false,
                "isPremium": false,
                "location": "Brentwood, CA",
                "name": "Far East County Student Programs",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "8c697687-c0ec-469c-98e8-e0a06e72a35a",
                    "zipCode": "fea44aef-6d39-4c1c-9267-b5b70ebd1cf5"
                },
                "premium": false,
                "shortName": "Far East County Student Programs",
                "tagline": [
                    "Public School",
                    "Brentwood, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "far-east-county-student-programs-brentwood-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 71
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 8
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.694,37.9359,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.694,37.9359,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94513"
            }
        ]
    },
    {
        "guid": "9c3774ce-bf65-4390-8504-05c1ab3ea177",
        "content": {
            "centroid": {
                "lat": 38.098507,
                "lon": -122.576736
            },
            "entity": {
                "abbreviation": "Marin Oaks High School",
                "alternates": {
                    "ceeb": "052173",
                    "nces": "062772004190"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "9c3774ce-bf65-4390-8504-05c1ab3ea177",
                "isClaimed": false,
                "isPremium": false,
                "location": "Novato, CA",
                "name": "Marin Oaks High School",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "b9ce499b-3724-477a-89d8-5d6372cb9484",
                    "schoolDistrict": "b9ce499b-3724-477a-89d8-5d6372cb9484",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "2122e23f-f26c-4604-9180-d896f31c483d",
                    "zipCode": "7cf6b53c-a89f-46d8-a63f-d6f897c0dd65"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Novato Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "b9ce499b-3724-477a-89d8-5d6372cb9484",
                        "location": "Novato, CA",
                        "name": "Novato Unified School District",
                        "parentGUIDs": {
                            "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "2122e23f-f26c-4604-9180-d896f31c483d",
                            "zipCode": "bff8a774-e3f4-4cfd-8ffa-8c5dfbf869ab"
                        },
                        "premium": false,
                        "shortName": "Novato Unified School District",
                        "tagline": [
                            "School District",
                            "Novato, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "novato-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Marin Oaks High School",
                "tagline": [
                    "Novato Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "marin-oaks-high-school-novato-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 71
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 10
                }
            ],
            "featuredReview": {
                "author": "Niche User",
                "body": "I never felt out of place. No one judged me or made me feel not welcome. The teachers, the environment and the students were all enjoyable. ",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2013-10-21T22:07:41Z",
                "guid": "ff6a7915-b9e1-4f73-b9e5-ab04def4bfc6",
                "rating": 4
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.576,38.0978,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.576,38.0978,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.7,
                "count": 10
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94947"
            }
        ]
    },
    {
        "guid": "9aca1835-9da9-4bed-bbba-839b2d678b48",
        "content": {
            "centroid": {
                "lat": 37.7834368,
                "lon": -122.2353429
            },
            "entity": {
                "abbreviation": "Opportunity Charter",
                "alternates": {
                    "nces": "069105114090"
                },
                "character": "Public, Charter, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "9aca1835-9da9-4bed-bbba-839b2d678b48",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Opportunity Charter",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "37e7f9a4-600a-4ef0-b69f-325c0f5370da",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "90731d14-c187-4264-ac2c-4b3485508684"
                },
                "premium": false,
                "shortName": "Opportunity Charter",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "10-12"
                ],
                "type": "School",
                "url": "opportunity-charter-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 71
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.2353429,37.7834368,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.2353429,37.7834368,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94601"
            }
        ]
    },
    {
        "guid": "239c3e09-064d-4428-b544-a579aa33b55c",
        "content": {
            "centroid": {
                "lat": 37.646436,
                "lon": -122.119949
            },
            "entity": {
                "abbreviation": "Heritage Cccoe Special Education Programs",
                "alternates": {
                    "nces": "069100512255"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "239c3e09-064d-4428-b544-a579aa33b55c",
                "isClaimed": false,
                "isPremium": false,
                "location": "Brentwood, CA",
                "name": "Heritage Cccoe Special Education Programs",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "c7e723f0-78fc-4ba9-aa90-a97d95040134",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                    "zipCode": "e8c32215-6d14-4b33-82bd-2d41b6b32206"
                },
                "premium": false,
                "shortName": "Heritage Cccoe Special Education Programs",
                "tagline": [
                    "Public School",
                    "Brentwood, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "heritage-cccoe-special-education-programs-brentwood-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 70
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 7
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.756,37.9218,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.756,37.9218,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94513"
            }
        ]
    },
    {
        "guid": "5157f984-abc0-4cec-b546-9ef832114948",
        "content": {
            "centroid": {
                "lat": 37.563144,
                "lon": -121.964869
            },
            "entity": {
                "abbreviation": "California School For The Blind",
                "alternates": {
                    "nces": "060000210346"
                },
                "character": "Public, Magnet",
                "claimed": false,
                "displayable": true,
                "genus": "Magnet School",
                "guid": "5157f984-abc0-4cec-b546-9ef832114948",
                "isClaimed": false,
                "isPremium": false,
                "location": "Fremont, CA",
                "name": "California School For The Blind",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "c6ea15ac-9c90-49e2-a91a-3ac5e9ec5295",
                    "schoolDistrict": "c6ea15ac-9c90-49e2-a91a-3ac5e9ec5295",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "36041593-134d-436a-b83b-4c4244f6a447",
                    "zipCode": "4dc14d8f-c3ed-4d52-abca-3f8a107886e5"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "California School for the Blind",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "c6ea15ac-9c90-49e2-a91a-3ac5e9ec5295",
                        "location": "Fremont, CA",
                        "name": "California School for the Blind",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "36041593-134d-436a-b83b-4c4244f6a447",
                            "zipCode": "4dc14d8f-c3ed-4d52-abca-3f8a107886e5"
                        },
                        "premium": false,
                        "shortName": "California School for the Blind",
                        "tagline": [
                            "School District",
                            "Fremont, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "california-school-for-the-blind-ca",
                        "variation": 65
                    }
                },
                "premium": false,
                "shortName": "California School For The Blind",
                "tagline": [
                    "California School for the Blind, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "california-school-for-the-blind-fremont-ca",
                "variation": 52
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 66
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 5
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.963,37.5626,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.963,37.5626,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94536"
            }
        ]
    },
    {
        "guid": "cc724475-5240-401f-ae7c-21a80f830acb",
        "content": {
            "centroid": {
                "lat": 38.000911,
                "lon": -122.130842
            },
            "entity": {
                "abbreviation": "Briones (Alternative)",
                "alternates": {
                    "ceeb": "054157",
                    "nces": "062403007071"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "cc724475-5240-401f-ae7c-21a80f830acb",
                "isClaimed": false,
                "isPremium": false,
                "location": "Martinez, CA",
                "name": "Briones (Alternative)",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "bb309258-c416-4193-9d2e-072248ea2ba6",
                    "schoolDistrict": "bb309258-c416-4193-9d2e-072248ea2ba6",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "5aa2a0dd-3537-4cd9-817a-24409c06ce5d",
                    "zipCode": "2c9a56d6-f5d7-43ae-90db-4fab4497e4a2"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Martinez Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "bb309258-c416-4193-9d2e-072248ea2ba6",
                        "location": "Martinez, CA",
                        "name": "Martinez Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "5aa2a0dd-3537-4cd9-817a-24409c06ce5d",
                            "zipCode": "2c9a56d6-f5d7-43ae-90db-4fab4497e4a2"
                        },
                        "premium": false,
                        "shortName": "Martinez Unified School District",
                        "tagline": [
                            "School District",
                            "Martinez, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "martinez-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Briones (Alternative)",
                "tagline": [
                    "Martinez Unified School District, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "briones-alternative-martinez-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 63
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 30
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.131,38.0006,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.131,38.0006,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94553"
            }
        ]
    },
    {
        "guid": "870a1206-99d0-475a-916b-02502bb14a91",
        "content": {
            "centroid": {
                "lat": 37.971633,
                "lon": -122.513318
            },
            "entity": {
                "abbreviation": "Madrone High Continuation",
                "alternates": {
                    "ceeb": "053213",
                    "nces": "063511005937"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "870a1206-99d0-475a-916b-02502bb14a91",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Rafael, CA",
                "name": "Madrone High Continuation",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "40ad174f-166d-4d99-a58a-bb82f378e20f",
                    "parent": "d6dc2987-9315-432d-bc69-a6b31ad35c7a",
                    "schoolDistrict": "d6dc2987-9315-432d-bc69-a6b31ad35c7a",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "03b49160-d1e2-4a70-8c58-319b241306a8",
                    "zipCode": "218cd2f0-f326-4a8e-a957-02117d51d241"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "San Rafael City High School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "d6dc2987-9315-432d-bc69-a6b31ad35c7a",
                        "location": "San Rafael, CA",
                        "name": "San Rafael City High School District",
                        "parentGUIDs": {
                            "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "dc30ba2a-37d6-4766-b90c-517b11b7cdde",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "03b49160-d1e2-4a70-8c58-319b241306a8",
                            "zipCode": "a84b9cf7-0228-401b-85bd-1497a6685ebb"
                        },
                        "premium": false,
                        "shortName": "San Rafael City High School District",
                        "tagline": [
                            "School District",
                            "San Rafael, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-rafael-city-high-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Madrone High Continuation",
                "tagline": [
                    "San Rafael City High School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "madrone-high-continuation-san-rafael-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 62
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 18
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.514,37.9714,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.514,37.9714,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94901"
            }
        ]
    },
    {
        "guid": "6972b273-9faf-4068-b91c-3d59ff70a16d",
        "content": {
            "centroid": {
                "lat": 37.798468,
                "lon": -122.28565
            },
            "entity": {
                "abbreviation": "Civicorps Corpsmember Academy",
                "alternates": {
                    "nces": "060171712056"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "6972b273-9faf-4068-b91c-3d59ff70a16d",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Civicorps Corpsmember Academy",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                },
                "premium": false,
                "shortName": "Civicorps Corpsmember Academy",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "civicorps-corpsmember-academy-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 60
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 21
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.286,37.7988,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.286,37.7988,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94607"
            }
        ]
    },
    {
        "guid": "2a955096-c0ee-4b9a-b43f-ba27ab61c348",
        "content": {
            "centroid": {
                "lat": 37.709283,
                "lon": -121.921776
            },
            "entity": {
                "abbreviation": "Valley High School",
                "alternates": {
                    "nces": "060001909274"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "2a955096-c0ee-4b9a-b43f-ba27ab61c348",
                "isClaimed": true,
                "isPremium": false,
                "location": "Dublin, CA",
                "name": "Valley High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "1eb7d1e3-3645-4686-b9c1-1f8cde48db34",
                    "schoolDistrict": "1eb7d1e3-3645-4686-b9c1-1f8cde48db34",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "9b40368d-b46b-4aea-bc65-0b503ad7997e",
                    "zipCode": "bdff8a37-efb0-409f-87de-4220f60652e9"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "DUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "1eb7d1e3-3645-4686-b9c1-1f8cde48db34",
                        "location": "Dublin, CA",
                        "name": "Dublin Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "9b40368d-b46b-4aea-bc65-0b503ad7997e",
                            "zipCode": "bdff8a37-efb0-409f-87de-4220f60652e9"
                        },
                        "premium": false,
                        "shortName": "Dublin Unified School District",
                        "tagline": [
                            "School District",
                            "Dublin, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "dublin-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Valley High School",
                "tagline": [
                    "Dublin Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "valley-high-school-dublin-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 60
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 9
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.921,37.7097,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.921,37.7097,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94568"
            }
        ]
    },
    {
        "guid": "d94e3a59-3e42-464d-b822-c955d31caad0",
        "content": {
            "centroid": {
                "lat": 37.935766,
                "lon": -122.068072
            },
            "entity": {
                "abbreviation": "Prospect High School",
                "alternates": {
                    "ceeb": "052494",
                    "nces": "062637010197"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "d94e3a59-3e42-464d-b822-c955d31caad0",
                "isClaimed": false,
                "isPremium": false,
                "location": "Pleasant Hill, CA",
                "name": "Prospect High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "schoolDistrict": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "454e8dd6-f26e-4493-a281-1f2250e8bae9",
                    "zipCode": "c02f3379-b7e4-421d-8daf-40132890b3fd"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "MDUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                        "location": "Concord, CA",
                        "name": "Mt. Diablo Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "187f89d7-6963-49c2-b924-426631dae88f",
                            "zipCode": "fca2caaa-dbcc-472c-be69-c07f58b2a359"
                        },
                        "premium": false,
                        "shortName": "Mt. Diablo Unified School District",
                        "tagline": [
                            "School District",
                            "Concord, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mt-diablo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Prospect High School",
                "tagline": [
                    "Mt. Diablo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "prospect-high-school-pleasant-hill-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 54
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 27
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.068,37.9336,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.068,37.9336,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94523"
            }
        ]
    },
    {
        "guid": "6088b603-ca8f-46e2-9cf2-ce2d08cecddd",
        "content": {
            "centroid": {
                "lat": 37.7770644,
                "lon": -122.2298469
            },
            "entity": {
                "abbreviation": "Latitude 37.8 High",
                "alternates": {
                    "nces": "060151414257"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "6088b603-ca8f-46e2-9cf2-ce2d08cecddd",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Latitude 37.8 High",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "286e9fe8-40b7-4621-9295-5d8c20746bca",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "90731d14-c187-4264-ac2c-4b3485508684"
                },
                "premium": false,
                "shortName": "Latitude 37.8 High",
                "tagline": [
                    "Public School",
                    "Oakland, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "latitude-378-high-oakland-ca",
                "variation": 56
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 52
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 14
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.2298469,37.7770644,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.2298469,37.7770644,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94601"
            }
        ]
    },
    {
        "guid": "b56ad229-6cc3-49eb-8c91-d6aa576f8ad5",
        "content": {
            "centroid": {
                "lat": 37.8594,
                "lon": -122.271
            },
            "entity": {
                "abbreviation": "Berkeley Technology Academy",
                "alternates": {
                    "ceeb": "050300",
                    "nces": "060474011300"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "b56ad229-6cc3-49eb-8c91-d6aa576f8ad5",
                "isClaimed": false,
                "isPremium": false,
                "location": "Berkeley, CA",
                "name": "Berkeley Technology Academy",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "4870ba36-d978-42b8-9459-d6834bf05892",
                    "parent": "a80d0954-768b-4a61-af13-29460f542800",
                    "schoolDistrict": "a80d0954-768b-4a61-af13-29460f542800",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "4eb8fec9-8de0-46a9-b898-75cc913b8cef",
                    "zipCode": "ea9f890c-9568-4762-a2f4-771a4f369e28"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "BUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "a80d0954-768b-4a61-af13-29460f542800",
                        "location": "Berkeley, CA",
                        "name": "Berkeley Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "62e9b88d-c1c2-4def-a030-dd9fa0106676",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "4eb8fec9-8de0-46a9-b898-75cc913b8cef",
                            "zipCode": "40657545-f7b8-4dad-aab4-1f71e29d13b4"
                        },
                        "premium": false,
                        "shortName": "Berkley Public Schools",
                        "tagline": [
                            "School District",
                            "Berkeley, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "berkeley-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Berkeley Technology Academy",
                "tagline": [
                    "Berkeley Unified School District, CA",
                    "10-12"
                ],
                "type": "School",
                "url": "berkeley-technology-academy-berkeley-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 47
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 9
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.271,37.8594,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.271,37.8594,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 3.142857142857143,
                "count": 14
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94704"
            }
        ]
    },
    {
        "guid": "5171784a-b2a3-462a-9137-511b15bc2c41",
        "content": {
            "centroid": {
                "lat": 37.550747,
                "lon": -122.038694
            },
            "entity": {
                "abbreviation": "Crossroads High (Alternative)",
                "alternates": {
                    "nces": "062706001921"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "5171784a-b2a3-462a-9137-511b15bc2c41",
                "isClaimed": false,
                "isPremium": false,
                "location": "Newark, CA",
                "name": "Crossroads High (Alternative)",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "76fb7aec-f438-42a3-82f2-6ad1f6bf15f5",
                    "schoolDistrict": "76fb7aec-f438-42a3-82f2-6ad1f6bf15f5",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "ed699caa-41e0-4b17-9bf6-cddf0a782bac",
                    "zipCode": "27c6b5a2-f312-47d3-873e-e798e3f00196"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Newark Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "76fb7aec-f438-42a3-82f2-6ad1f6bf15f5",
                        "location": "Newark, CA",
                        "name": "Newark Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "ed699caa-41e0-4b17-9bf6-cddf0a782bac",
                            "zipCode": "27c6b5a2-f312-47d3-873e-e798e3f00196"
                        },
                        "premium": false,
                        "shortName": "Newark Unified School District",
                        "tagline": [
                            "School District",
                            "Newark, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "newark-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Crossroads High (Alternative)",
                "tagline": [
                    "Newark Unified School District, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "crossroads-high-alternative-newark-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 43
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.036,37.5469,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.036,37.5469,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94560"
            }
        ]
    },
    {
        "guid": "df138ac2-a6e9-43b0-85eb-94b96e700ac9",
        "content": {
            "centroid": {
                "lat": 37.316338,
                "lon": -121.928821
            },
            "entity": {
                "abbreviation": "Middle College High School",
                "alternates": {
                    "nces": "063459008633"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "df138ac2-a6e9-43b0-85eb-94b96e700ac9",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Middle College High School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "9bed7cde-76c6-4ed3-9076-f48cade709d3",
                    "parent": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "schoolDistrict": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "zipCode": "bf537caa-7876-4936-b0a8-98add2dd3610"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SJUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5443587e-2779-4f77-878e-9ddcb0ce3422",
                        "location": "San Jose, CA",
                        "name": "San Jose Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "0a781906-f3cb-42ec-b08b-9acfcaf63aaa",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                            "zipCode": "763f10c1-8ad0-4832-90b4-5bad39b6e93f"
                        },
                        "premium": false,
                        "shortName": "San Jose Unified School District",
                        "tagline": [
                            "School District",
                            "San Jose, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-jose-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Middle College High School",
                "tagline": [
                    "San Jose Unified School District, CA",
                    "11-12"
                ],
                "type": "School",
                "url": "middle-college-high-school-san-jose-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 43
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 22
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.93,37.3156,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.93,37.3156,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95128"
            }
        ]
    },
    {
        "guid": "3318e4b5-b331-4372-bba1-6b51b945e790",
        "content": {
            "centroid": {
                "lat": 37.464128,
                "lon": -122.434262
            },
            "entity": {
                "abbreviation": "Pilarcitos Alternative High School",
                "alternates": {
                    "nces": "060678000602"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "3318e4b5-b331-4372-bba1-6b51b945e790",
                "isClaimed": false,
                "isPremium": false,
                "location": "Half Moon Bay, CA",
                "name": "Pilarcitos Alternative High School",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "d9dbf94b-adf8-4619-931e-ebcff1d6649f",
                    "schoolDistrict": "d9dbf94b-adf8-4619-931e-ebcff1d6649f",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "6f401739-fe70-4434-8602-b2cdb57c2074",
                    "zipCode": "cfe7994d-8a48-4529-b312-78d0deacfe27"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Cabrillo Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "d9dbf94b-adf8-4619-931e-ebcff1d6649f",
                        "location": "Half Moon Bay, CA",
                        "name": "Cabrillo Unified School District",
                        "parentGUIDs": {
                            "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "6f401739-fe70-4434-8602-b2cdb57c2074",
                            "zipCode": "cfe7994d-8a48-4529-b312-78d0deacfe27"
                        },
                        "premium": false,
                        "shortName": "Cabrillo Unified School District",
                        "tagline": [
                            "School District",
                            "Half Moon Bay, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "cabrillo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Pilarcitos Alternative High School",
                "tagline": [
                    "Cabrillo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "pilarcitos-alternative-high-school-half-moon-bay-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 42
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 28
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.435,37.463,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.435,37.463,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94019"
            }
        ]
    },
    {
        "guid": "405ef723-4bec-4bcb-a527-8c5804fdf461",
        "content": {
            "centroid": {
                "lat": 37.750759,
                "lon": -122.40981
            },
            "entity": {
                "abbreviation": "San Francisco Opportunity School",
                "alternates": {
                    "nces": "069111109472"
                },
                "character": "Public, Alternative, All-Girls",
                "claimed": false,
                "displayable": true,
                "genus": "All-Girls School",
                "guid": "405ef723-4bec-4bcb-a527-8c5804fdf461",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "San Francisco Opportunity School",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "0cac67cc-9c02-4a4c-8cd6-5714b7fda8b7",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "c568e3a2-4c27-4503-a9f7-85276a6ec461"
                },
                "premium": false,
                "shortName": "San Francisco Opportunity School",
                "tagline": [
                    "Public School",
                    "San Francisco, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "san-francisco-opportunity-school-san-francisco-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 41
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 7
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.41,37.7504,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.41,37.7504,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94110"
            }
        ]
    },
    {
        "guid": "e2788336-bee9-4160-b263-385bf297c5b4",
        "content": {
            "centroid": {
                "lat": 37.537956,
                "lon": -121.991933
            },
            "entity": {
                "abbreviation": "Young Adult Program",
                "alternates": {
                    "nces": "061440013083"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "e2788336-bee9-4160-b263-385bf297c5b4",
                "isClaimed": false,
                "isPremium": false,
                "location": "Fremont, CA",
                "name": "Young Adult Program",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "schoolDistrict": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "36041593-134d-436a-b83b-4c4244f6a447",
                    "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                        "location": "Fremont, CA",
                        "name": "Fremont Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "36041593-134d-436a-b83b-4c4244f6a447",
                            "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                        },
                        "premium": false,
                        "shortName": "Fremont Unified School District",
                        "tagline": [
                            "School District",
                            "Fremont, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Young Adult Program",
                "tagline": [
                    "Fremont Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "young-adult-program-fremont-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 41
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 14
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.991,37.5383,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.991,37.5383,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94538"
            }
        ]
    },
    {
        "guid": "a2d7b765-3327-4921-bef7-37ddcbf8a1ad",
        "content": {
            "centroid": {
                "lat": 37.384174,
                "lon": -121.901449
            },
            "entity": {
                "abbreviation": "County Community",
                "alternates": {
                    "nces": "069103507782"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "a2d7b765-3327-4921-bef7-37ddcbf8a1ad",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Jose, CA",
                "name": "Santa Clara County Community School",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "bc007bff-f267-494c-b4bc-92ce588a6db6",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "24bc23a3-5a80-4c8d-9929-5eb10c2bfa6b",
                    "zipCode": "782e20d7-90eb-4994-919f-95fc800744f4"
                },
                "premium": false,
                "shortName": "County Community",
                "tagline": [
                    "Public School",
                    "San Jose, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "santa-clara-county-community-school-san-jose-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 39
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 4
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.901,37.3841,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.901,37.3841,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95131"
            }
        ]
    },
    {
        "guid": "79318724-efbc-4c24-8f6c-ca54ebba3882",
        "content": {
            "centroid": {
                "lat": 37.5133,
                "lon": -122.337
            },
            "entity": {
                "abbreviation": "Hillcrest at Youth Services Center",
                "alternates": {
                    "nces": "069103309248"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "79318724-efbc-4c24-8f6c-ca54ebba3882",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Mateo, CA",
                "name": "Hillcrest at Youth Services Center",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "zipCode": "062f4806-af97-4d46-8d31-2a26304d0e2f"
                },
                "premium": false,
                "shortName": "Hillcrest at Youth Services Center",
                "tagline": [
                    "Public School",
                    "San Mateo, CA",
                    "5-12"
                ],
                "type": "School",
                "url": "hillcrest-at-youth-services-center-san-mateo-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 37
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 5
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.337,37.5133,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.337,37.5133,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94402"
            }
        ]
    },
    {
        "guid": "6ab060db-1f4d-45f9-8350-1d9f055cf562",
        "content": {
            "centroid": {
                "lat": 38.048393,
                "lon": -122.221186
            },
            "entity": {
                "abbreviation": "Willow High School",
                "alternates": {
                    "nces": "061899002303"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "6ab060db-1f4d-45f9-8350-1d9f055cf562",
                "isClaimed": false,
                "isPremium": false,
                "location": "Crockett, CA",
                "name": "Willow High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "8dd379c5-017b-4b7f-8485-4543a3c9761d",
                    "schoolDistrict": "8dd379c5-017b-4b7f-8485-4543a3c9761d",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "f0624f6f-b23a-41f4-b431-0766074a6e92",
                    "zipCode": "e3c1c7a6-1f75-4afc-98bd-08e6b48fe731"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "John Swett Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "8dd379c5-017b-4b7f-8485-4543a3c9761d",
                        "location": "Rodeo, CA",
                        "name": "John Swett Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "362b3980-b744-46dc-a22d-af772d04f66f",
                            "zipCode": "b246fcf7-0c1e-4866-8773-4baa7b3add25"
                        },
                        "premium": false,
                        "shortName": "John Swett Unified School District",
                        "tagline": [
                            "School District",
                            "Rodeo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "john-swett-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Willow High School",
                "tagline": [
                    "John Swett Unified School District, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "willow-high-school-crockett-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 35
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 16
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.22,38.0463,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.22,38.0463,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94525"
            }
        ]
    },
    {
        "guid": "5868884d-b026-4cb7-9771-4d4ce179ef14",
        "content": {
            "centroid": {
                "lat": 38.1483,
                "lon": -122.249014
            },
            "entity": {
                "abbreviation": "Vallejo Adult Transition",
                "alternates": {
                    "nces": "064074007889"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "5868884d-b026-4cb7-9771-4d4ce179ef14",
                "isClaimed": false,
                "isPremium": false,
                "location": "Vallejo, CA",
                "name": "Vallejo Adult Transition",
                "parentGUIDs": {
                    "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                    "schoolDistrict": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "cd45ba4f-972c-4537-bd0a-adc5060daf7c",
                    "zipCode": "2a6799d3-4951-4fc5-9600-781d2e0f8833"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Vallejo City Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                        "location": "Vallejo, CA",
                        "name": "Vallejo City Unified School District",
                        "parentGUIDs": {
                            "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "cd45ba4f-972c-4537-bd0a-adc5060daf7c",
                            "zipCode": "c53e25cf-e914-4ee3-aca1-03fd916fd935"
                        },
                        "premium": false,
                        "shortName": "Vallejo City Unified School District",
                        "tagline": [
                            "School District",
                            "Vallejo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "vallejo-city-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Vallejo Adult Transition",
                "tagline": [
                    "Vallejo City Unified School District, CA",
                    "12"
                ],
                "type": "School",
                "url": "vallejo-adult-transition-vallejo-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 34
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 34
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.246,38.1504,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.246,38.1504,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94589"
            }
        ]
    },
    {
        "guid": "318349ca-ea2a-40e3-8f65-b692eb4f2e4f",
        "content": {
            "centroid": {
                "lat": 37.518879,
                "lon": -121.964486
            },
            "entity": {
                "abbreviation": "Vista Alternative School",
                "alternates": {
                    "ceeb": "050952",
                    "nces": "061440009369"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "318349ca-ea2a-40e3-8f65-b692eb4f2e4f",
                "isClaimed": false,
                "isPremium": false,
                "location": "Fremont, CA",
                "name": "Vista Alternative School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "schoolDistrict": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "36041593-134d-436a-b83b-4c4244f6a447",
                    "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "FUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "409b0789-8963-4ffa-9fdd-ca61850d3ef0",
                        "location": "Fremont, CA",
                        "name": "Fremont Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "36041593-134d-436a-b83b-4c4244f6a447",
                            "zipCode": "132ece3d-4f68-42cf-badb-1c281d1efddd"
                        },
                        "premium": false,
                        "shortName": "Fremont Unified School District",
                        "tagline": [
                            "School District",
                            "Fremont, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "fremont-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Vista Alternative School",
                "tagline": [
                    "Fremont Unified School District, CA",
                    "7-12"
                ],
                "type": "School",
                "url": "vista-alternative-school-fremont-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 34
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 11
                }
            ],
            "featuredReview": {
                "author": "Alum",
                "body": "I attended vista alternative school for my last semester of high school for independent study. With this new format for learning, I was given the opportunity to undertake internships and even begin working! If I had stayed with a tradition school format I would have not gotten my head start on the world and would not be where I am today without the help of those teachers.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2017-10-05T20:15:37.200773Z",
                "guid": "80e792d4-5fdc-4e74-a684-0c2890b554f3",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.964,37.5201,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.964,37.5201,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94538"
            }
        ]
    },
    {
        "guid": "1bd0b970-48d0-4315-a113-3ebf531c16ce",
        "content": {
            "centroid": {
                "lat": 37.995208,
                "lon": -121.769235
            },
            "entity": {
                "abbreviation": "Crossroads High School",
                "alternates": {
                    "ceeb": "050753",
                    "nces": "062637000183"
                },
                "character": "Public, Alternative, All-Girls",
                "claimed": false,
                "displayable": true,
                "genus": "All-Girls School",
                "guid": "1bd0b970-48d0-4315-a113-3ebf531c16ce",
                "isClaimed": false,
                "isPremium": false,
                "location": "Concord, CA",
                "name": "Crossroads High (Alternative)",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "schoolDistrict": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                    "zipCode": "a67a738f-0765-4797-b0e3-4c395ccd760b"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "MDUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                        "location": "Concord, CA",
                        "name": "Mt. Diablo Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "187f89d7-6963-49c2-b924-426631dae88f",
                            "zipCode": "fca2caaa-dbcc-472c-be69-c07f58b2a359"
                        },
                        "premium": false,
                        "shortName": "Mt. Diablo Unified School District",
                        "tagline": [
                            "School District",
                            "Concord, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mt-diablo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Crossroads High School",
                "tagline": [
                    "Mt. Diablo Unified School District, CA",
                    "7-12"
                ],
                "type": "School",
                "url": "crossroads-high-alternative-concord-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 33
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 11
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "Crossroads High School is the best high school I have ever attended. Before Crossroads, I attended Berean Christian and College Park High School, and none of them can compare to Crossroads. Crossroads High School is such a special school because they are able to make you feel like you are a part of their family. There is no one who cares more about their students than Crossroads High School.",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2017-10-09T15:35:35.738369Z",
                "guid": "2fb39004-058c-4dcd-b925-f45dc87c42aa",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.027,37.9689,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.027,37.9689,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 4.5,
                "count": 2
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94519"
            }
        ]
    },
    {
        "guid": "7248e443-5c06-4825-aa41-3da54274b125",
        "content": {
            "centroid": {
                "lat": 38.003666,
                "lon": -121.849546
            },
            "entity": {
                "abbreviation": "East County Elementary Special Education",
                "alternates": {
                    "nces": "069100510750"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "7248e443-5c06-4825-aa41-3da54274b125",
                "isClaimed": false,
                "isPremium": false,
                "location": "Antioch, CA",
                "name": "East County Elementary Special Education",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "775a411e-1de8-46d4-aa54-28cb004cae6f",
                    "zipCode": "2026ed1b-602c-43a5-859e-4d5b3ed7410b"
                },
                "premium": false,
                "shortName": "East County Elementary Special Education",
                "tagline": [
                    "Public School",
                    "Antioch, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "east-county-elementary-special-education-antioch-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 30
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 7
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.851,38.0024,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.851,38.0024,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94509"
            }
        ]
    },
    {
        "guid": "7ac3a094-49e7-42a2-a4e9-3049d64da3af",
        "content": {
            "centroid": {
                "lat": 37.824965,
                "lon": -122.367545
            },
            "entity": {
                "abbreviation": "Life Learning Academy",
                "alternates": {
                    "ceeb": "052969",
                    "nces": "063441007721"
                },
                "character": "Public, Charter",
                "claimed": false,
                "displayable": true,
                "genus": "Charter School",
                "guid": "7ac3a094-49e7-42a2-a4e9-3049d64da3af",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Life Learning Academy",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "97f056ae-a5d2-45a3-a5a9-f6df3af537f6",
                    "parent": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "schoolDistrict": "6739ad45-3827-4000-998c-fdd4f5029e17",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "e0175d8b-477f-425d-849b-0ffbbbdfa97f"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "SFUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "6739ad45-3827-4000-998c-fdd4f5029e17",
                        "location": "San Francisco, CA",
                        "name": "San Francisco Unified School District",
                        "parentGUIDs": {
                            "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "a71ff0b7-9aab-4061-8668-29c022d4c89e",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                            "zipCode": "a181afc3-605d-4817-a50e-5d1a3d969668"
                        },
                        "premium": false,
                        "shortName": "San Francisco Unified School District",
                        "tagline": [
                            "School District",
                            "San Francisco, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "san-francisco-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Life Learning Academy",
                "tagline": [
                    "San Francisco Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "life-learning-academy-san-francisco-ca",
                "variation": 52
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 30
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 5
                }
            ],
            "featuredReview": {
                "author": "Senior",
                "body": "I absolutely love this school. Ms. Terri Delane is so sweet, she cares for her students more than just any regular principal ",
                "categories": [
                    "Overall Experience"
                ],
                "created": "2016-10-13T00:42:51.696332Z",
                "guid": "40f316e5-564c-498c-907f-1ba048239fe1",
                "rating": 5
            },
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.369,37.8246,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.369,37.8246,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 5,
                "count": 1
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94130"
            }
        ]
    },
    {
        "guid": "67bf4a89-2bd3-4d82-af9e-296ad3a57fa7",
        "content": {
            "centroid": {
                "lat": 37.85816,
                "lon": -122.020122
            },
            "entity": {
                "abbreviation": "Central County Special Education Programs",
                "alternates": {
                    "nces": "069100510749"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "67bf4a89-2bd3-4d82-af9e-296ad3a57fa7",
                "isClaimed": false,
                "isPremium": false,
                "location": "Alamo, CA",
                "name": "Central County Special Education Programs",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "6cd2db24-61d9-4c4b-9dba-1b8592c736a6",
                    "zipCode": "70fa1630-e849-423c-9be9-dcec4af8d465"
                },
                "premium": false,
                "shortName": "Central County Special Education Programs",
                "tagline": [
                    "Public School",
                    "Alamo, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "central-county-special-education-programs-alamo-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 25
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 7
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.019,37.8597,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.019,37.8597,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94507"
            }
        ]
    },
    {
        "guid": "709fcf5b-4912-42c0-8c42-a46aea47ce30",
        "content": {
            "centroid": {
                "lat": 37.788176,
                "lon": -122.17781
            },
            "entity": {
                "abbreviation": "Community Day",
                "alternates": {
                    "nces": "062805010718"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "709fcf5b-4912-42c0-8c42-a46aea47ce30",
                "isClaimed": false,
                "isPremium": false,
                "location": "Oakland, CA",
                "name": "Community Day High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "schoolDistrict": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                    "zipCode": "b96fa3ea-8713-4581-93cb-036864769ed5"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "OUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "5aaa7c32-c827-4643-b21a-b4473bb067ef",
                        "location": "Oakland, CA",
                        "name": "Oakland Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "fa4528ca-02a8-4cce-8e37-9eee2f1d949b",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "23bac116-2d1e-45f1-83be-a674bca9da64",
                            "zipCode": "cd2934bf-5aad-4119-93ca-694736677a7a"
                        },
                        "premium": false,
                        "shortName": "Oakland Unified School District",
                        "tagline": [
                            "School District",
                            "Oakland, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "oakland-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Community Day",
                "tagline": [
                    "Oakland Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "community-day-high-school-oakland-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 25
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 7
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.178,37.788,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.178,37.788,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94619"
            }
        ]
    },
    {
        "guid": "0461622e-86f2-46db-8000-76f99a579050",
        "content": {
            "centroid": {
                "lat": 38.034023,
                "lon": -121.963818
            },
            "entity": {
                "abbreviation": "Gateway High School",
                "alternates": {
                    "nces": "062637010195"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "0461622e-86f2-46db-8000-76f99a579050",
                "isClaimed": false,
                "isPremium": false,
                "location": "Bay Point, CA",
                "name": "Gateway High School",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "schoolDistrict": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "f9f5dffb-08a5-4880-bd3e-08161072e69b",
                    "zipCode": "3da768f4-2aba-4f43-8fa3-a9f7e92a82d1"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "MDUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                        "location": "Concord, CA",
                        "name": "Mt. Diablo Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "187f89d7-6963-49c2-b924-426631dae88f",
                            "zipCode": "fca2caaa-dbcc-472c-be69-c07f58b2a359"
                        },
                        "premium": false,
                        "shortName": "Mt. Diablo Unified School District",
                        "tagline": [
                            "School District",
                            "Concord, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mt-diablo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Gateway High School",
                "tagline": [
                    "Mt. Diablo Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "gateway-high-school-bay-point-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 23
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 23
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.966,38.0332,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.966,38.0332,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94565"
            }
        ]
    },
    {
        "guid": "8c206488-586c-425e-9304-45ec02dd8a73",
        "content": {
            "centroid": {
                "lat": 37.661993,
                "lon": -122.057935
            },
            "entity": {
                "abbreviation": "Highland",
                "alternates": {
                    "nces": "061674013823"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "8c206488-586c-425e-9304-45ec02dd8a73",
                "isClaimed": false,
                "isPremium": false,
                "location": "Hayward, CA",
                "name": "Highland",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "b2051729-ac46-4f26-bd3d-a0e7c2dbe5ea",
                    "parent": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                    "schoolDistrict": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                    "zipCode": "a7825b9a-2257-4576-b01d-a61f12fa5f8e"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "HUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "0cc8e0c8-9c30-4a76-a806-7e6c803dbcba",
                        "location": "Hayward, CA",
                        "name": "Hayward Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "neighborhood": "3ee6b10e-9c9c-43c9-bee6-1755097895e1",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "846df0d5-65fc-4f5e-95de-2bd95424c1ff",
                            "zipCode": "72f14b46-7398-463c-a7b1-84d94dfe3a97"
                        },
                        "premium": false,
                        "shortName": "Hayward Unified School District",
                        "tagline": [
                            "School District",
                            "Hayward, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "hayward-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Highland",
                "tagline": [
                    "Hayward Unified School District, CA",
                    "K-12"
                ],
                "type": "School",
                "url": "highland-hayward-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 23
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 8
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.056,37.6617,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.056,37.6617,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94540"
            }
        ]
    },
    {
        "guid": "b29ba5de-8d0e-4a5b-a16d-056d941a8c85",
        "content": {
            "centroid": {
                "lat": 38.0329219,
                "lon": -122.5340213
            },
            "entity": {
                "abbreviation": "WPSSFN",
                "alternates": {
                    "nces": "0"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "b29ba5de-8d0e-4a5b-a16d-056d941a8c85",
                "isClaimed": true,
                "isPremium": true,
                "location": "San Rafael, CA",
                "name": "Winston Preparatory School",
                "parentGUIDs": {
                    "county": "1ab3b2c8-3335-4bba-900f-776c4fd0f935",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "schoolNetwork": "8f1d5617-6aba-4f37-9e96-0fb05225daf7",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "zipCode": "a84b9cf7-0228-401b-85bd-1497a6685ebb"
                },
                "premium": true,
                "shortName": "Winston Prep",
                "tagline": [
                    "Public School",
                    "San Rafael, CA",
                    "3-12"
                ],
                "type": "School",
                "url": "winston-preparatory-school-san-rafael-ca",
                "variation": 1048
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 22
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 2
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "default": {
                    "crops": {
                        "DesktopHeader": "https://s3.amazonaws.com/photos.niche.com/62f53acaa7b5874e11d87c4b713d3c53d68a573a",
                        "MobileHeader": "https://s3.amazonaws.com/photos.niche.com/aa44ad6c0e98be52ffe37a43fad22799f996a464",
                        "Thumbnail": "https://s3.amazonaws.com/photos.niche.com/66a6f2cecdc6c77d9219b73869777619ff6a98a8"
                    },
                    "licenseName": "UNLICENSED"
                },
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.5340213,38.0329219,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.5340213,38.0329219,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94903"
            }
        ]
    },
    {
        "guid": "fa1ccd6b-d019-4fd7-a2ba-20029b21a191",
        "content": {
            "centroid": {
                "lat": 37.944468,
                "lon": -122.044953
            },
            "entity": {
                "abbreviation": "Diablo Community Day",
                "alternates": {
                    "nces": "062637008458"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "fa1ccd6b-d019-4fd7-a2ba-20029b21a191",
                "isClaimed": false,
                "isPremium": false,
                "location": "Concord, CA",
                "name": "Diablo Community Day",
                "parentGUIDs": {
                    "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "schoolDistrict": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "187f89d7-6963-49c2-b924-426631dae88f",
                    "zipCode": "6b58b2cc-6f28-4ab5-9cae-5d07eb3c2450"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "MDUSD",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "80e3741c-fddd-4dc8-a675-bbfc31ff630c",
                        "location": "Concord, CA",
                        "name": "Mt. Diablo Unified School District",
                        "parentGUIDs": {
                            "county": "249f98b3-c049-4987-8321-944e69ef7f01",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "187f89d7-6963-49c2-b924-426631dae88f",
                            "zipCode": "fca2caaa-dbcc-472c-be69-c07f58b2a359"
                        },
                        "premium": false,
                        "shortName": "Mt. Diablo Unified School District",
                        "tagline": [
                            "School District",
                            "Concord, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "mt-diablo-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Diablo Community Day",
                "tagline": [
                    "Mt. Diablo Unified School District, CA",
                    "7-12"
                ],
                "type": "School",
                "url": "diablo-community-day-concord-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 20
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 8
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.044,37.9449,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.044,37.9449,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94518"
            }
        ]
    },
    {
        "guid": "11e4cbee-a5c7-4fc3-9734-a4155c538bae",
        "content": {
            "centroid": {
                "lat": 37.7096087,
                "lon": -121.9212219
            },
            "entity": {
                "abbreviation": "Dublin Unified Transition Program",
                "alternates": {
                    "nces": "060001914338"
                },
                "character": "Public",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "11e4cbee-a5c7-4fc3-9734-a4155c538bae",
                "isClaimed": true,
                "isPremium": false,
                "location": "Dublin, CA",
                "name": "Dublin Unified Transition Program",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "1eb7d1e3-3645-4686-b9c1-1f8cde48db34",
                    "schoolDistrict": "1eb7d1e3-3645-4686-b9c1-1f8cde48db34",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "9b40368d-b46b-4aea-bc65-0b503ad7997e",
                    "zipCode": "bdff8a37-efb0-409f-87de-4220f60652e9"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "DUSD",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "1eb7d1e3-3645-4686-b9c1-1f8cde48db34",
                        "location": "Dublin, CA",
                        "name": "Dublin Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "9b40368d-b46b-4aea-bc65-0b503ad7997e",
                            "zipCode": "bdff8a37-efb0-409f-87de-4220f60652e9"
                        },
                        "premium": false,
                        "shortName": "Dublin Unified School District",
                        "tagline": [
                            "School District",
                            "Dublin, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "dublin-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Dublin Unified Transition Program",
                "tagline": [
                    "Dublin Unified School District, CA",
                    "12"
                ],
                "type": "School",
                "url": "dublin-unified-transition-program-dublin-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 20
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers."
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.9212219,37.7096087,13/900x340@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.9212219,37.7096087,13/400x175@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94568"
            }
        ]
    },
    {
        "guid": "4059fa11-6c75-4b6b-9eec-a981db462489",
        "content": {
            "centroid": {
                "lat": 37.745766,
                "lon": -122.452596
            },
            "entity": {
                "abbreviation": "Woodside Learning Center",
                "alternates": {
                    "nces": "069111109270"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "4059fa11-6c75-4b6b-9eec-a981db462489",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Francisco, CA",
                "name": "Woodside Learning Center",
                "parentGUIDs": {
                    "county": "506117e3-01cc-459e-ba28-9730208c9e5d",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "neighborhood": "93bfc817-30ac-4400-9e2b-9dfc7cab75e1",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "7fd0342c-7bda-410e-9b78-296b4fa3472b",
                    "zipCode": "50a82c65-04cd-4b00-bb26-c5f015b369e3"
                },
                "premium": false,
                "shortName": "Woodside Learning Center",
                "tagline": [
                    "Public School",
                    "San Francisco, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "woodside-learning-center-san-francisco-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 19
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 3
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.453,37.7459,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.453,37.7459,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94127"
            }
        ]
    },
    {
        "guid": "7c1b995e-a1f7-4f23-81e0-35ac2c2497c0",
        "content": {
            "centroid": {
                "lat": 37.712818,
                "lon": -122.093035
            },
            "entity": {
                "abbreviation": "Roy A. Johnson High School",
                "alternates": {
                    "nces": "060780000750"
                },
                "character": "Public",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "7c1b995e-a1f7-4f23-81e0-35ac2c2497c0",
                "isClaimed": false,
                "isPremium": false,
                "location": "Castro Valley, CA",
                "name": "Roy A. Johnson High School",
                "parentGUIDs": {
                    "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "3707b90b-92ee-4fe1-b360-2afce14889fb",
                    "schoolDistrict": "3707b90b-92ee-4fe1-b360-2afce14889fb",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "3b63d4f5-8c5d-4908-9952-1529e9a9dcee",
                    "zipCode": "ca87fa67-ecae-4bbb-a27b-22324f3483bc"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Castro Valley Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "3707b90b-92ee-4fe1-b360-2afce14889fb",
                        "location": "Castro Valley, CA",
                        "name": "Castro Valley Unified School District",
                        "parentGUIDs": {
                            "county": "9b5c7e66-a434-4dcc-ae52-40a6a254e757",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "3b63d4f5-8c5d-4908-9952-1529e9a9dcee",
                            "zipCode": "ca87fa67-ecae-4bbb-a27b-22324f3483bc"
                        },
                        "premium": false,
                        "shortName": "Castro Valley Unified School District",
                        "tagline": [
                            "School District",
                            "Castro Valley, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "castro-valley-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Roy A. Johnson High School",
                "tagline": [
                    "Castro Valley Unified School District, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "roy-a-johnson-high-school-castro-valley-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 17
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 8
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.093,37.713,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.093,37.713,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94546"
            }
        ]
    },
    {
        "guid": "d1240011-e785-41f7-81ab-513b24dd5bbe",
        "content": {
            "centroid": {
                "lat": 38.112271,
                "lon": -122.262486
            },
            "entity": {
                "abbreviation": "Vallejo Education Academy",
                "alternates": {
                    "nces": "064074011224"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "d1240011-e785-41f7-81ab-513b24dd5bbe",
                "isClaimed": false,
                "isPremium": false,
                "location": "Vallejo, CA",
                "name": "Vallejo Education Academy",
                "parentGUIDs": {
                    "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                    "schoolDistrict": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "cd45ba4f-972c-4537-bd0a-adc5060daf7c",
                    "zipCode": "42b11530-5650-4c55-89ce-3430b89a4ffb"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Vallejo City Unified School District",
                        "claimed": false,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "12daabca-43eb-495c-85dc-c7e2a1984d6b",
                        "location": "Vallejo, CA",
                        "name": "Vallejo City Unified School District",
                        "parentGUIDs": {
                            "county": "0584ee6e-08a1-46b2-9361-4d0339bae0ef",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "cd45ba4f-972c-4537-bd0a-adc5060daf7c",
                            "zipCode": "c53e25cf-e914-4ee3-aca1-03fd916fd935"
                        },
                        "premium": false,
                        "shortName": "Vallejo City Unified School District",
                        "tagline": [
                            "School District",
                            "Vallejo, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "vallejo-city-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Vallejo Education Academy",
                "tagline": [
                    "Vallejo City Unified School District, CA",
                    "7-12"
                ],
                "type": "School",
                "url": "vallejo-education-academy-vallejo-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 14
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 4
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.261,38.1122,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.261,38.1122,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94590"
            }
        ]
    },
    {
        "guid": "5c381a84-11d5-4ebd-95b1-df1bdfb3f679",
        "content": {
            "centroid": {
                "lat": 37.512547,
                "lon": -122.333256
            },
            "entity": {
                "abbreviation": "Gateway Center",
                "alternates": {
                    "nces": "069103311960"
                },
                "character": "Public, Alternative",
                "claimed": false,
                "displayable": true,
                "genus": "Public School",
                "guid": "5c381a84-11d5-4ebd-95b1-df1bdfb3f679",
                "isClaimed": false,
                "isPremium": false,
                "location": "San Mateo, CA",
                "name": "Gateway Center",
                "parentGUIDs": {
                    "county": "c112eefc-a8d3-4aec-8cb3-4aafdf868567",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "zipCode": "062f4806-af97-4d46-8d31-2a26304d0e2f"
                },
                "premium": false,
                "shortName": "Gateway Center",
                "tagline": [
                    "Public School",
                    "San Mateo, CA",
                    "9-12"
                ],
                "type": "School",
                "url": "gateway-center-san-mateo-ca",
                "variation": 48
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 12
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 12
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.334,37.514,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-122.334,37.514,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/94402"
            }
        ]
    },
    {
        "guid": "eee02f97-77c2-4f11-bb9c-e655d2b3460e",
        "content": {
            "centroid": {
                "lat": 37.341707,
                "lon": -121.988591
            },
            "entity": {
                "abbreviation": "Santa Clara Community Day",
                "alternates": {
                    "nces": "063543012999"
                },
                "character": "Public, Alternative",
                "claimed": true,
                "displayable": true,
                "genus": "Public School",
                "guid": "eee02f97-77c2-4f11-bb9c-e655d2b3460e",
                "isClaimed": true,
                "isPremium": false,
                "location": "Santa Clara, CA",
                "name": "Santa Clara Community Day",
                "parentGUIDs": {
                    "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                    "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                    "parent": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                    "schoolDistrict": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                    "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                    "town": "44b1c9d0-0773-4aa7-aaeb-c04dda704fc1",
                    "zipCode": "d1fd4c8f-758c-4371-b58b-7ac5e13d8df8"
                },
                "parents": {
                    "parent": {
                        "abbreviation": "Santa Clara Unified School District",
                        "claimed": true,
                        "displayable": true,
                        "genus": "School District",
                        "guid": "1e193417-ee2a-496f-942d-2bd1fec225a9",
                        "location": "Santa Clara, CA",
                        "name": "Santa Clara Unified School District",
                        "parentGUIDs": {
                            "county": "52fc30ae-f66a-467e-a244-bd6ad255388a",
                            "metroArea": "d8ccf170-f072-4180-977c-a91f914ebcfe",
                            "state": "b56d7c2d-d07e-4aa2-bcf6-925ecb0890f6",
                            "town": "44b1c9d0-0773-4aa7-aaeb-c04dda704fc1",
                            "zipCode": "d1fd4c8f-758c-4371-b58b-7ac5e13d8df8"
                        },
                        "premium": false,
                        "shortName": "Santa Clara Unified School District",
                        "tagline": [
                            "School District",
                            "Santa Clara, CA"
                        ],
                        "type": "SchoolDistrict",
                        "url": "santa-clara-unified-school-district-ca",
                        "variation": 61
                    }
                },
                "premium": false,
                "shortName": "Santa Clara Community Day",
                "tagline": [
                    "Santa Clara Unified School District, CA",
                    "6-12"
                ],
                "type": "School",
                "url": "santa-clara-community-day-santa-clara-ca",
                "variation": 44
            },
            "facts": [
                {
                    "config": {
                        "format": [
                            "comma"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Students",
                    "value": 11
                },
                {
                    "config": {
                        "format": [
                            "ratio"
                        ],
                        "rounding": [
                            "whole"
                        ]
                    },
                    "label": "Student-Teacher Ratio",
                    "tooltip": "Student-Teacher Ratio may not be indicative of class size. It is calculated using the reported number of students and full-time equivalent teachers.",
                    "value": 6
                }
            ],
            "grades": [
                {
                    "description": "Based on quality of academics, teachers, student life, and outcomes.",
                    "guid": "54945c65-04ee-445d-9310-3090bd1f1f0a",
                    "label": "Overall Niche Grade"
                }
            ],
            "photos": {
                "mapbox_header": {
                    "author": "© Mapbox",
                    "crops": {
                        "DesktopHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.991,37.3421,13/900x471@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg",
                        "MobileHeader": "https://api.mapbox.com/styles/v1/niche-admin/citg1y6rj00312inu917d7y1o/static/-121.991,37.3421,13/400x250@2x?access_token=pk.eyJ1IjoibmljaGUtYWRtaW4iLCJhIjoiY2lyODF1YnR6MDB3bGcybTNhdDQxY3pkZCJ9.NQ0kRtM21uVhwbzjSAridg"
                    },
                    "licenseName": "© OpenStreetMap",
                    "licenseUrl": "http://www.openstreetmap.org/copyright",
                    "sourceUrl": "https://www.mapbox.com/about/maps/"
                }
            },
            "reviewAverage": {
                "average": 0,
                "count": 0
            },
            "virtualTour": [
                {
                    "label": "Virtual Tour"
                }
            ]
        },
        "ctas": [
            {
                "label": "View Nearby Homes",
                "type": "realEstateListings",
                "url": "https://www.realtor.com/realestateandhomes-search/95051"
            }
        ]
    }
]

export default HIGH_SCHOOL_RANKS